export const FORM_VALUES_DEGREE = [
  { label: 'Advanced Diploma Courses', value: 'Advanced Diploma Courses' },
  {
    label: 'Advanced Program (Advanced Program)',
    value: 'Advanced Program (Advanced Program)',
  },
  {
    label: 'Animation, Graphics and Multimedia',
    value: 'Animation, Graphics and Multimedia',
  },
  { label: 'Aviation Courses', value: 'Aviation Courses' },
  { label: 'B.Com (Hons.)', value: 'B.Com (Hons.)' },
  { label: 'BA (Hons.) in Economics', value: 'BA (Hons.) in Economics' },
  { label: 'BA in History', value: 'BA in History' },
  {
    label: 'Bachelor in Foreign Language',
    value: 'Bachelor in Foreign Language',
  },
  {
    label: 'Bachelor of Architecture (B.Arch)',
    value: 'Bachelor of Architecture (B.Arch)',
  },
  {
    label: 'Bachelor of Ayurvedic Medicine and Surgery',
    value: 'Bachelor of Ayurvedic Medicine and Surgery',
  },
  {
    label: 'Bachelor of Business Administration (BBA)',
    value: 'Bachelor of Business Administration (BBA)',
  },
  {
    label: 'Bachelor of Business Studies (BBS)',
    value: 'Bachelor of Business Studies (BBS)',
  },
  {
    label: 'Bachelor of Commerce (B.Com)',
    value: 'Bachelor of Commerce (B.Com)',
  },
  {
    label: 'Bachelor of Computer Applications (BCA)',
    value: 'Bachelor of Computer Applications (BCA)',
  },
  {
    label: 'Bachelor of Dental Surgery (BDS)',
    value: 'Bachelor of Dental Surgery (BDS)',
  },
  {
    label: 'Bachelor of Design (B. Design)',
    value: 'Bachelor of Design (B. Design)',
  },
  {
    label: 'Bachelor of Engineering (BE)',
    value: 'Bachelor of Engineering (BE)',
  },
  {
    label: 'Bachelor of Event Management (BEM)',
    value: 'Bachelor of Event Management (BEM)',
  },
  {
    label: 'Bachelor of Fashion Designing (BFD)',
    value: 'Bachelor of Fashion Designing (BFD)',
  },
  {
    label: 'Bachelor of Fine Arts (BFA)',
    value: 'Bachelor of Fine Arts (BFA)',
  },
  {
    label: 'Bachelor of Homeopathic Medicine and Surgery',
    value: 'Bachelor of Homeopathic Medicine and Surgery',
  },
  {
    label: 'Bachelor of Journalism and Mass Communication (BJMC)',
    value: 'Bachelor of Journalism and Mass Communication (BJMC)',
  },
  {
    label: 'Bachelor of Management Science (BMS)',
    value: 'Bachelor of Management Science (BMS)',
  },
  {
    label: 'Bachelor of Medicine ( M.B.B.S)',
    value: 'Bachelor of Medicine ( M.B.B.S)',
  },
  {
    label: 'Bachelor of Performing Arts',
    value: 'Bachelor of Performing Arts',
  },
  {
    label: 'Bachelor of Pharmacy (BPharma)',
    value: 'Bachelor of Pharmacy (BPharma)',
  },
  {
    label: 'Bachelor of Physiotherapy (BPT)',
    value: 'Bachelor of Physiotherapy (BPT)',
  },
  { label: 'Bachelor of Science (BSc)', value: 'Bachelor of Science (BSc)' },
  {
    label: 'Bachelor of Technology (B.Tech)',
    value: 'Bachelor of Technology (B.Tech)',
  },
  {
    label: 'Bachelor of Travel and Tourism Management (BTTM)',
    value: 'Bachelor of Travel and Tourism Management (BTTM)',
  },
  {
    label: "Certificate Courses Certificate Courses'",
    value: "Certificate Courses Certificate Courses'",
  },
  { label: 'Chartered Accountancy (CA)', value: 'Chartered Accountancy (CA)' },
  { label: 'Company Secretary (CS)', value: 'Company Secretary (CS)' },
  {
    label: "Diploma Courses Diploma Courses'",
    value: "Diploma Courses Diploma Courses'",
  },
  {
    label: 'Executive Fellow Program In Management (E.F.P.M)',
    value: 'Executive Fellow Program In Management (E.F.P.M)',
  },
  {
    label: 'Executive Management Programme (E.M.P)',
    value: 'Executive Management Programme (E.M.P)',
  },
  {
    label: 'Fellow Programme (Fellow Programme)',
    value: 'Fellow Programme (Fellow Programme)',
  },
  {
    label: 'Integarted Law Program- BBA LL.B',
    value: 'Integarted Law Program- BBA LL.B',
  },
  {
    label: 'Integrated Law Course- BA + LL.B',
    value: 'Integrated Law Course- BA + LL.B',
  },
  {
    label: 'Integrated Law Program- B.Com LL.B.',
    value: 'Integrated Law Program- B.Com LL.B.',
  },
  {
    label: 'International Programme (International Programme)',
    value: 'International Programme (International Programme)',
  },
  { label: 'Others', value: 'Others' },
];

export const FORM_VALUES_LANGUAGE = [
  {
    label: 'Abkhazian',
    value: 'Abkhazian',
  },
  {
    label: 'Afar',
    value: 'Afar',
  },
  {
    label: 'Afrikaans',
    value: 'Afrikaans',
  },
  {
    label: 'Akan',
    value: 'Akan',
  },
  {
    label: 'Albanian',
    value: 'Albanian',
  },
  {
    label: 'Amharic',
    value: 'Amharic',
  },
  {
    label: 'Arabic',
    value: 'Arabic',
  },
  {
    label: 'Aragonese',
    value: 'Aragonese',
  },
  {
    label: 'Armenian',
    value: 'Armenian',
  },
  {
    label: 'Assamese',
    value: 'Assamese',
  },
  {
    label: 'Asturian',
    value: 'Asturian',
  },
  {
    label: 'Avaric',
    value: 'Avaric',
  },
  {
    label: 'Avestan',
    value: 'Avestan',
  },
  {
    label: 'Aymara',
    value: 'Aymara',
  },
  {
    label: 'Azerbaijani',
    value: 'Azerbaijani',
  },
  {
    label: 'Bambara',
    value: 'Bambara',
  },
  {
    label: 'Bashkir',
    value: 'Bashkir',
  },
  {
    label: 'Basque',
    value: 'Basque',
  },
  {
    label: 'Belarusian',
    value: 'Belarusian',
  },
  {
    label: 'Bengali',
    value: 'Bengali',
  },
  {
    label: 'Bihari',
    value: 'Bihari',
  },
  {
    label: 'Bislama',
    value: 'Bislama',
  },
  {
    label: 'Bosnian',
    value: 'Bosnian',
  },
  {
    label: 'Breton',
    value: 'Breton',
  },
  {
    label: 'Bulgarian',
    value: 'Bulgarian',
  },
  {
    label: 'Burmese',
    value: 'Burmese',
  },
  {
    label: 'Catalan',
    value: 'Catalan',
  },
  {
    label: 'Cebuano',
    value: 'Cebuano',
  },
  {
    label: 'Chamorro',
    value: 'Chamorro',
  },
  {
    label: 'Chechen',
    value: 'Chechen',
  },
  {
    label: 'Chichewa',
    value: 'Chichewa',
  },
  {
    label: 'Chinese',
    value: 'Chinese',
  },
  {
    label: 'Church Slavic',
    value: 'Church Slavic',
  },
  {
    label: 'Chuvash',
    value: 'Chuvash',
  },
  {
    label: 'Cornish',
    value: 'Cornish',
  },
  {
    label: 'Corsican',
    value: 'Corsican',
  },
  {
    label: 'Cree',
    value: 'Cree',
  },
  {
    label: 'Croatian',
    value: 'Croatian',
  },
  {
    label: 'Czech',
    value: 'Czech',
  },
  {
    label: 'Danish',
    value: 'Danish',
  },
  {
    label: 'Dari',
    value: 'Dari',
  },
  {
    label: 'Divehi',
    value: 'Divehi',
  },
  {
    label: 'Dutch',
    value: 'Dutch',
  },
  {
    label: 'Dzongkha',
    value: 'Dzongkha',
  },
  {
    label: 'English',
    value: 'English',
  },
  {
    label: 'Esperanto',
    value: 'Esperanto',
  },
  {
    label: 'Estonian',
    value: 'Estonian',
  },
  {
    label: 'Ewe',
    value: 'Ewe',
  },
  {
    label: 'Faroese',
    value: 'Faroese',
  },
  {
    label: 'Fijian',
    value: 'Fijian',
  },
  {
    label: 'Filipino',
    value: 'Filipino',
  },
  {
    label: 'Finnish',
    value: 'Finnish',
  },
  {
    label: 'Flemish',
    value: 'Flemish',
  },
  {
    label: 'French',
    value: 'French',
  },
  {
    label: 'French',
    value: 'French',
  },
  {
    label: 'Fulah',
    value: 'Fulah',
  },
  {
    label: 'Galician',
    value: 'Galician',
  },
  {
    label: 'Ganda',
    value: 'Ganda',
  },
  {
    label: 'Georgian',
    value: 'Georgian',
  },
  {
    label: 'German',
    value: 'German',
  },
  {
    label: 'Greek',
    value: 'Greek',
  },
  {
    label: 'Guarani',
    value: 'Guarani',
  },
  {
    label: 'Gujarati',
    value: 'Gujarati',
  },
  {
    label: 'Haitian Creole',
    value: 'Haitian Creole',
  },
  {
    label: 'Hausa',
    value: 'Hausa',
  },
  {
    label: 'Hawaiian',
    value: 'Hawaiian',
  },
  {
    label: 'Hebrew',
    value: 'Hebrew',
  },
  {
    label: 'Herero',
    value: 'Herero',
  },
  {
    label: 'Hindi',
    value: 'Hindi',
  },
  {
    label: 'Hiri Motu',
    value: 'Hiri Motu',
  },
  {
    label: 'Hungarian',
    value: 'Hungarian',
  },
  {
    label: 'Icelandic',
    value: 'Icelandic',
  },
  {
    label: 'Ido',
    value: 'ido',
  },
  {
    label: 'Igbo',
    value: 'Igbo',
  },
  {
    label: 'Indonesian',
    value: 'Indonesian',
  },
  {
    label: 'Interlingua',
    value: 'Interlingua',
  },
  {
    label: 'Interlingue',
    value: 'Interlingue',
  },
  {
    label: 'Inuktitut',
    value: 'Inuktitut',
  },
  {
    label: 'Inupiaq',
    value: 'Inupiaq',
  },
  {
    label: 'Irish',
    value: 'Irish',
  },
  {
    label: 'Italian',
    value: 'Italian',
  },
  {
    label: 'Jamaican Patois',
    value: 'Jamaican Patois',
  },
  {
    label: 'Japanese',
    value: 'Japanese',
  },
  {
    label: 'Javanese',
    value: 'Javanese',
  },
  {
    label: 'Kabyle',
    value: 'Kabyle',
  },
  {
    label: 'Kalaallisut',
    value: 'Kalaallisut',
  },
  {
    label: 'Kannada',
    value: 'Kannada',
  },
  {
    label: 'Kanuri',
    value: 'Kanuri',
  },
  {
    label: 'Kashmiri',
    value: 'Kashmiri',
  },
  {
    label: 'Kazakh',
    value: 'Kazakh',
  },
  {
    label: 'Khmer',
    value: 'Khmer',
  },
  {
    label: 'Kikuyu',
    value: 'Kikuyu',
  },
  {
    label: 'Kinyarwanda',
    value: 'Kinyarwanda',
  },
  {
    label: 'Kirghiz',
    value: 'Kirghiz',
  },
  {
    label: 'Komi',
    value: 'Komi',
  },
  {
    label: 'Kongo',
    value: 'Kongo',
  },
  {
    label: 'Korean',
    value: 'Korean',
  },
  {
    label: 'Kuanyama',
    value: 'Kuanyama',
  },
  {
    label: 'Kurdish',
    value: 'Kurdish',
  },
  {
    label: 'Lao',
    value: 'Lao',
  },
  {
    label: 'Latin',
    value: 'Latin',
  },
  {
    label: 'Latvian',
    value: 'Latvian',
  },
  {
    label: 'Limburgish',
    value: 'Limburgish',
  },
  {
    label: 'Lingala',
    value: 'Lingala',
  },
  {
    label: 'Lithuanian',
    value: 'Lithuanian',
  },
  {
    label: 'Lojban',
    value: 'Lojban',
  },
  {
    label: 'Luba-Katanga',
    value: 'Luba-Katanga',
  },
  {
    label: 'Luxembourgish',
    value: 'Luxembourgish',
  },
  {
    label: 'Macedonian',
    value: 'Macedonian',
  },
  {
    label: 'Malagasy',
    value: 'Malagasy',
  },
  {
    label: 'Malay',
    value: 'Malay',
  },
  {
    label: 'Malayalam',
    value: 'Malayalam',
  },
  {
    label: 'Maltese',
    value: 'Maltese',
  },
  {
    label: 'Manx',
    value: 'Manx',
  },
  {
    label: 'Marathi',
    value: 'Marathi',
  },
  {
    label: 'Marshallese',
    value: 'Marshallese',
  },
  {
    label: 'Moldavian',
    value: 'Moldavian',
  },
  {
    label: 'Mongolian',
    value: 'Mongolian',
  },
  {
    label: 'Montenegrin',
    value: 'Montenegrin',
  },
  {
    label: 'Nauru',
    value: 'Nauru',
  },
  {
    label: 'Navajo',
    value: 'Navajo',
  },
  {
    label: 'Ndonga',
    value: 'Ndonga',
  },
  {
    label: 'Nepali',
    value: 'Nepali',
  },
  {
    label: 'North Ndebele',
    value: 'North Ndebele',
  },
  {
    label: 'Northern Sami',
    value: 'Northern Sami',
  },
  {
    label: 'Norwegian',
    value: 'Norwegian',
  },
  {
    label: 'Occitan',
    value: 'Occitan',
  },
  {
    label: 'Ojibwa',
    value: 'Ojibwa',
  },
  {
    label: 'Oriya',
    value: 'Oriya',
  },
  {
    label: 'Oromo',
    value: 'Oromo',
  },
  {
    label: 'Ossetian',
    value: 'Ossetian',
  },
  {
    label: 'Pali',
    value: 'Pali',
  },
  {
    label: 'Punjabi',
    value: 'Punjabi',
  },
  {
    label: 'Persian',
    value: 'Persian',
  },
  {
    label: 'Polish',
    value: 'Polish',
  },
  {
    label: 'Portuguese',
    value: 'Portuguese',
  },
  {
    label: 'Pashto',
    value: 'Pashto',
  },
  {
    label: 'Quechua',
    value: 'Quechua',
  },
  {
    label: 'Romani',
    value: 'Romani',
  },
  {
    label: 'Romanian',
    value: 'Romanian',
  },
  {
    label: 'Romansh',
    value: 'Romansh',
  },
  {
    label: 'Rundi',
    value: 'Rundi',
  },
  {
    label: 'Russian',
    value: 'Russian',
  },
  {
    label: 'Rusyn',
    value: 'Rusyn',
  },
  {
    label: 'Samoan',
    value: 'Samoan',
  },
  {
    label: 'Sango',
    value: 'Sango',
  },
  {
    label: 'Sanskrit',
    value: 'Sanskrit',
  },
  {
    label: 'Santali',
    value: 'Santali',
  },
  {
    label: 'Sardinian',
    value: 'Sardinian',
  },
  {
    label: 'Scottish Gaelic',
    value: 'Scottish Gaelic',
  },
  {
    label: 'Serbian',
    value: 'Serbian',
  },
  {
    label: 'Shona',
    value: 'Shona',
  },
  {
    label: 'Sichuan Yi',
    value: 'Sichuan Yi',
  },
  {
    label: 'Sicilian',
    value: 'Sicilian',
  },
  {
    label: 'Sindhi',
    value: 'Sindhi',
  },
  {
    label: 'Sinhalese',
    value: 'Sinhalese',
  },
  {
    label: 'Slovak',
    value: 'Slovak',
  },
  {
    label: 'Slovenian',
    value: 'Slovenian',
  },
  {
    label: 'Somali',
    value: 'Somali',
  },
  {
    label: 'Southern',
    value: 'Southern',
  },
  {
    label: 'South Ndebele',
    value: 'South Ndebele',
  },
  {
    label: 'Spanish',
    value: 'Spanish',
  },
  {
    label: 'Sundanese',
    value: 'Sundanese',
  },
  {
    label: 'Swahili',
    value: 'Swahili',
  },
  {
    label: 'Swati',
    value: 'Swati',
  },
  {
    label: 'Swedish',
    value: 'Swedish',
  },
  {
    label: 'Tagalog',
    value: 'Tagalog',
  },
  {
    label: 'Tahitian',
    value: 'Tahitian',
  },
  {
    label: 'Tajik',
    value: 'Tajik',
  },
  {
    label: 'Tamil',
    value: 'Tamil',
  },
  {
    label: 'Tatar',
    value: 'Tatar',
  },
  {
    label: 'Telugu',
    value: 'Telugu',
  },
  {
    label: 'Thai',
    value: 'Thai',
  },
  {
    label: 'Tibetan',
    value: 'Tibetan',
  },
  {
    label: 'Tigrinya',
    value: 'Tigrinya',
  },
  {
    label: 'Tonga',
    value: 'Tonga',
  },
  {
    label: 'Tsonga',
    value: 'Tsonga',
  },
  {
    label: 'Tswana',
    value: 'Tswana',
  },
  {
    label: 'Turkish',
    value: 'Turkish',
  },
  {
    label: 'Turkmen',
    value: 'Turkmen',
  },
  {
    label: 'Twi',
    value: 'Twi',
  },
  {
    label: 'Ukrainian',
    value: 'Ukrainian',
  },
  {
    label: 'Urdu',
    value: 'Urdu',
  },
  {
    label: 'Uyghur',
    value: 'Uyghur',
  },
  {
    label: 'Uzbek',
    value: 'Uzbek',
  },
  {
    label: 'Venda',
    value: 'Venda',
  },
  {
    label: 'Vietnamese',
    value: 'Vietnamese',
  },
  {
    label: 'Volapük',
    value: 'Volapük',
  },
  {
    label: 'Walloon',
    value: 'Walloon',
  },
  {
    label: 'Welsh',
    value: 'Welsh',
  },
  {
    label: 'Western Frisian',
    value: 'Western Frisian',
  },
  {
    label: 'Wolof',
    value: 'Wolof',
  },
  {
    label: 'Xhosa',
    value: 'Xhosa',
  },
  {
    label: 'Yiddish',
    value: 'Yiddish',
  },
  {
    label: 'Yoruba',
    value: 'Yoruba',
  },
  {
    label: 'Zhuang',
    value: 'Zhuang',
  },
  {
    label: 'Zulu',
    value: 'Zulu',
  },
  {
    label: 'Others',
    value: 'Others',
  },
];

export const FORM_VALUES_BOARD_10 = [
  {
    label: 'CBSE- Central Board of Secondary Education',
    value: 'CBSE- Central Board of Secondary Education',
  },
  {
    label: 'ICSE- Indian Certificate of Secondary Education',
    value: 'ICSE- Indian Certificate of Secondary Education',
  },
  {
    label: 'IB- International Baccalaureate',
    value: 'IB- International Baccalaureate',
  },
  {
    label: 'NIOS- National Institute of Open Schooling',
    value: 'NIOS- National Institute of Open Schooling',
  },
  { label: 'State Board', value: 'State Board' },
  {
    label: 'International General Certificate of Secondary Education',
    value: 'International General Certificate of Secondary Education',
  },
  { label: 'Others', value: 'Others' },
];
export const FORM_VALUES_BOARD_12 = [
  {
    label: 'CBSE- Central Board of Secondary Education',
    value: 'CBSE- Central Board of Secondary Education',
  },
  {
    label: 'ICSE- Indian Certificate of Secondary Education',
    value: 'ICSE- Indian Certificate of Secondary Education',
  },
  {
    label: 'IB- International Baccalaureate',
    value: 'IB- International Baccalaureate',
  },
  {
    label: 'IGCSE- International General Certificate of Secondary Education',
    value: 'IGCSE- International General Certificate of Secondary Education',
  },
  {
    label: 'ISC- Indian School Certificate',
    value: 'ISC- Indian School Certificate',
  },
  {
    label: 'NIOS- National Institute of Open Schooling',
    value: 'NIOS- National Institute of Open Schooling',
  },
  { label: 'State Board', value: 'State Board' },
  { label: 'Others', value: 'Others' },
];

export const FORM_VALUES_INDUSTRY_TYPE = [
  { label: 'Accounting', value: 'Accounting' },
  { label: 'Airlines/Aviation', value: 'Airlines/Aviation' },
  {
    label: 'Alternative Dispute Resolution',
    value: 'Alternative Dispute Resolution',
  },
  { label: 'Alternative Medicine', value: 'Alternative Medicine' },
  { label: 'Animation', value: 'Animation' },
  { label: 'Apparel & Fashion', value: 'Apparel & Fashion' },
  { label: 'Architecture & Planning', value: 'Architecture & Planning' },
  { label: 'Arts and Crafts', value: 'Arts and Crafts' },
  { label: 'Automotive', value: 'Automotive' },
  { label: 'Aviation & Aerospace', value: 'Aviation & Aerospace' },
  { label: 'Banking', value: 'Banking' },
  { label: 'Biotechnology', value: 'Biotechnology' },
  { label: 'Broadcast Media', value: 'Broadcast Media' },
  { label: 'Building Materials', value: 'Building Materials' },
  {
    label: 'Business Supplies and Equipment',
    value: 'Business Supplies and Equipment',
  },
  { label: 'Capital Markets', value: 'Capital Markets' },
  { label: 'Chemicals', value: 'Chemicals' },
  {
    label: 'Civic & Social Organization',
    value: 'Civic & Social Organization',
  },
  { label: 'Civil Engineering', value: 'Civil Engineering' },
  { label: 'Commercial Real Estate', value: 'Commercial Real Estate' },
  {
    label: 'Computer & Network Security',
    value: 'Computer & Network Security',
  },
  { label: 'Computer Games', value: 'Computer Games' },
  { label: 'Computer Hardware', value: 'Computer Hardware' },
  { label: 'Computer Networking', value: 'Computer Networking' },
  { label: 'Computer Software', value: 'Computer Software' },
  { label: 'Construction', value: 'Construction' },
  { label: 'Consumer Electronics', value: 'Consumer Electronics' },
  { label: 'Consumer Goods', value: 'Consumer Goods' },
  { label: 'Consumer Services', value: 'Consumer Services' },
  { label: 'Cosmetics', value: 'Cosmetics' },
  { label: 'Dairy', value: 'Dairy' },
  { label: 'Defense & Space', value: 'Defense & Space' },
  { label: 'Design', value: 'Design' },
  { label: 'Education Management', value: 'Education Management' },
  { label: 'E-Learning', value: 'E-Learning' },
  {
    label: 'Electrical/Electronic Manufacturing',
    value: 'Electrical/Electronic Manufacturing',
  },
  { label: 'Entertainment', value: 'Entertainment' },
  { label: 'Environmental Services', value: 'Environmental Services' },
  { label: 'Events Services', value: 'Events Services' },
  { label: 'Executive Office', value: 'Executive Office' },
  { label: 'Facilities Services', value: 'Facilities Services' },
  { label: 'Farming', value: 'Farming' },
  { label: 'Financial Services', value: 'Financial Services' },
  { label: 'Fine Art', value: 'Fine Art' },
  { label: 'Fishery', value: 'Fishery' },
  { label: 'Food & Beverages', value: 'Food & Beverages' },
  { label: 'Food Production', value: 'Food Production' },
  { label: 'Fund-Raising', value: 'Fund-Raising' },
  { label: 'Furniture', value: 'Furniture' },
  { label: 'Gambling & Casinos', value: 'Gambling & Casinos' },
  { label: 'Glass, Ceramics & Concrete', value: 'Glass, Ceramics & Concrete' },
  { label: 'Government Administration', value: 'Government Administration' },
  { label: 'Government Relations', value: 'Government Relations' },
  { label: 'Graphic Design', value: 'Graphic Design' },
  {
    label: 'Health, Wellness and Fitness',
    value: 'Health, Wellness and Fitness',
  },
  { label: 'Higher Education', value: 'Higher Education' },
  { label: 'Hospital & Health Care', value: 'Hospital & Health Care' },
  { label: 'Hospitality', value: 'Hospitality' },
  { label: 'Human Resources', value: 'Human Resources' },
  { label: 'Import and Export', value: 'Import and Export' },
  {
    label: 'Individual & Family Services',
    value: 'Individual & Family Services',
  },
  { label: 'Industrial Automation', value: 'Industrial Automation' },
  { label: 'Information Services', value: 'Information Services' },
  {
    label: 'Information Technology and Services',
    value: 'Information Technology and Services',
  },
  { label: 'Insurance', value: 'Insurance' },
  { label: 'International Affairs', value: 'International Affairs' },
  {
    label: 'International Trade and Development',
    value: 'International Trade and Development',
  },
  { label: 'Internet', value: 'Internet' },
  { label: 'Investment Banking', value: 'Investment Banking' },
  { label: 'Investment Management', value: 'Investment Management' },
  { label: 'Judiciary', value: 'Judiciary' },
  { label: 'Law Enforcement', value: 'Law Enforcement' },
  { label: 'Law Practice', value: 'Law Practice' },
  { label: 'Legal Services', value: 'Legal Services' },
  { label: 'Legislative Office', value: 'Legislative Office' },
  { label: 'Leisure, Travel & Tourism', value: 'Leisure, Travel & Tourism' },
  { label: 'Libraries', value: 'Libraries' },
  { label: 'Logistics and Supply Chain', value: 'Logistics and Supply Chain' },
  { label: 'Luxury Goods & Jewelry', value: 'Luxury Goods & Jewelry' },
  { label: 'Machinery', value: 'Machinery' },
  { label: 'Management Consulting', value: 'Management Consulting' },
  { label: 'Maritime', value: 'Maritime' },
  { label: 'Market Research', value: 'Market Research' },
  { label: 'Marketing and Advertising', value: 'Marketing and Advertising' },
  {
    label: 'Mechanical or Industrial Engineering',
    value: 'Mechanical or Industrial Engineering',
  },
  { label: 'Media Production', value: 'Media Production' },
  { label: 'Medical Devices', value: 'Medical Devices' },
  { label: 'Medical Practice', value: 'Medical Practice' },
  { label: 'Mental Health Care', value: 'Mental Health Care' },
  { label: 'Military', value: 'Military' },
  { label: 'Mining & Metals', value: 'Mining & Metals' },
  { label: 'Motion Pictures and Film', value: 'Motion Pictures and Film' },
  { label: 'Museums and Institutions', value: 'Museums and Institutions' },
  { label: 'Music', value: 'Music' },
  { label: 'Nanotechnology', value: 'Nanotechnology' },
  { label: 'Newspapers', value: 'Newspapers' },
  {
    label: 'Non-Profit Organization Management',
    value: 'Non-Profit Organization Management',
  },
  { label: 'Oil & Energy', value: 'Oil & Energy' },
  { label: 'Online Media', value: 'Online Media' },
  { label: 'Outsourcing/Offshoring', value: 'Outsourcing/Offshoring' },
  { label: 'Package/Freight Delivery', value: 'Package/Freight Delivery' },
  { label: 'Packaging and Containers', value: 'Packaging and Containers' },
  { label: 'Paper & Forest Products', value: 'Paper & Forest Products' },
  { label: 'Performing Arts', value: 'Performing Arts' },
  { label: 'Pharmaceuticals', value: 'Pharmaceuticals' },
  { label: 'Philanthropy', value: 'Philanthropy' },
  { label: 'Photography', value: 'Photography' },
  { label: 'Plastics', value: 'Plastics' },
  { label: 'Political Organization', value: 'Political Organization' },
  {
    label: 'Primary/Secondary Education',
    value: 'Primary/Secondary Education',
  },
  { label: 'Printing', value: 'Printing' },
  {
    label: 'Professional Training & Coaching',
    value: 'Professional Training & Coaching',
  },
  { label: 'Program Development', value: 'Program Development' },
  { label: 'Public Policy', value: 'Public Policy' },
  {
    label: 'Public Relations and Communications',
    value: 'Public Relations and Communications',
  },
  { label: 'Public Safety', value: 'Public Safety' },
  { label: 'Publishing', value: 'Publishing' },
  { label: 'Railroad Manufacture', value: 'Railroad Manufacture' },
  { label: 'Ranching', value: 'Ranching' },
  { label: 'Real Estate', value: 'Real Estate' },
  {
    label: 'Recreational Facilities and Services',
    value: 'Recreational Facilities and Services',
  },
  { label: 'Religious Institutions', value: 'Religious Institutions' },
  { label: 'Renewables & Environment', value: 'Renewables & Environment' },
  { label: 'Research', value: 'Research' },
  { label: 'Restaurants', value: 'Restaurants' },
  { label: 'Retail', value: 'Retail' },
  {
    label: 'Security and Investigations',
    value: 'Security and Investigations',
  },
  { label: 'Semiconductors', value: 'Semiconductors' },
  { label: 'Shipbuilding', value: 'Shipbuilding' },
  { label: 'Sporting Goods', value: 'Sporting Goods' },
  { label: 'Sports', value: 'Sports' },
  { label: 'Staffing and Recruiting', value: 'Staffing and Recruiting' },
  { label: 'Supermarkets', value: 'Supermarkets' },
  { label: 'Telecommunications', value: 'Telecommunications' },
  { label: 'Textiles', value: 'Textiles' },
  { label: 'Think Tanks', value: 'Think Tanks' },
  { label: 'Tobacco', value: 'Tobacco' },
  {
    label: 'Translation and Localization',
    value: 'Translation and Localization',
  },
  {
    label: 'Transportation/Trucking/Railroad',
    value: 'Transportation/Trucking/Railroad',
  },
  { label: 'Utilities', value: 'Utilities' },
  {
    label: 'Venture Capital & Private Equity',
    value: 'Venture Capital & Private Equity',
  },
  { label: 'Veterinary', value: 'Veterinary' },
  { label: 'Warehousing', value: 'Warehousing' },
  { label: 'Wholesale', value: 'Wholesale' },
  { label: 'Wine and Spirits', value: 'Wine and Spirits' },
  { label: 'Wireless', value: 'Wireless' },
  { label: 'Writing and Editing', value: 'Writing and Editing' },
  { label: 'Others', value: 'Others' },
];

export const FORM_VALUES_NATIONALITY = [
  { label: 'Afghan', value: 'Afghan' },
  { label: 'Albanian', value: 'Albanian' },
  { label: 'Algerian', value: 'Algerian' },
  { label: 'American', value: 'American' },
  { label: 'Andorran', value: 'Andorran' },
  { label: 'Angolan', value: 'Angolan' },
  { label: 'Antiguans', value: 'Antiguans' },
  { label: 'Argentinean', value: 'Argentinean' },
  { label: 'Armenian', value: 'Armenian' },
  { label: 'Australian', value: 'Australian' },
  { label: 'Austrian', value: 'Austrian' },
  { label: 'Azerbaijani', value: 'Azerbaijani' },
  { label: 'Bahamian', value: 'Bahamian' },
  { label: 'Bahraini', value: 'Bahraini' },
  { label: 'Bangladeshi', value: 'Bangladeshi' },
  { label: 'Barbadian', value: 'Barbadian' },
  { label: 'Barbudans', value: 'Barbudans' },
  { label: 'Batswana', value: 'Batswana' },
  { label: 'Belarusian', value: 'Belarusian' },
  { label: 'Belgian', value: 'Belgian' },
  { label: 'Belizean', value: 'Belizean' },
  { label: 'Beninese', value: 'Beninese' },
  { label: 'Bhutanese', value: 'Bhutanese' },
  { label: 'Bolivian', value: 'Bolivian' },
  { label: 'Bosnian', value: 'Bosnian' },
  { label: 'Brazilian', value: 'Brazilian' },
  { label: 'British', value: 'British' },
  { label: 'Bruneian', value: 'Bruneian' },
  { label: 'Bulgarian', value: 'Bulgarian' },
  { label: 'Burkinabe', value: 'Burkinabe' },
  { label: 'Burmese', value: 'Burmese' },
  { label: 'Burundian', value: 'Burundian' },
  { label: 'Cambodian', value: 'Cambodian' },
  { label: 'Cameroonian', value: 'Cameroonian' },
  { label: 'Canadian', value: 'Canadian' },
  { label: 'Cape Verdean', value: 'Cape Verdean' },
  { label: 'Central African', value: 'Central African' },
  { label: 'Chadian', value: 'Chadian' },
  { label: 'Chilean', value: 'Chilean' },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'Colombian', value: 'Colombian' },
  { label: 'Comoran', value: 'Comoran' },
  { label: 'Congolese', value: 'Congolese' },
  { label: 'Costa Rican', value: 'Costa Rican' },
  { label: 'Croatian', value: 'Croatian' },
  { label: 'Cuban', value: 'Cuban' },
  { label: 'Cypriot', value: 'Cypriot' },
  { label: 'Czech', value: 'Czech' },
  { label: 'Danish', value: 'Danish' },
  { label: 'Djibouti', value: 'Djibouti' },
  { label: 'Dominican', value: 'Dominican' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'East Timorese', value: 'East Timorese' },
  { label: 'Ecuadorean', value: 'Ecuadorean' },
  { label: 'Egyptian', value: 'Egyptian' },
  { label: 'Emirian', value: 'Emirian' },
  { label: 'Equatorial Guinean', value: 'Equatorial Guinean' },
  { label: 'Eritrean', value: 'Eritrean' },
  { label: 'Estonian', value: 'Estonian' },
  { label: 'Ethiopian', value: 'Ethiopian' },
  { label: 'Fijian', value: 'Fijian' },
  { label: 'Filipino', value: 'Filipino' },
  { label: 'Finnish', value: 'Finnish' },
  { label: 'French', value: 'French' },
  { label: 'Gabonese', value: 'Gabonese' },
  { label: 'Gambian', value: 'Gambian' },
  { label: 'Georgian', value: 'Georgian' },
  { label: 'German', value: 'German' },
  { label: 'Ghanaian', value: 'Ghanaian' },
  { label: 'Greek', value: 'Greek' },
  { label: 'Grenadian', value: 'Grenadian' },
  { label: 'Guatemalan', value: 'Guatemalan' },
  { label: 'Guinea-Bissauan', value: 'Guinea-Bissauan' },
  { label: 'Guinean', value: 'Guinean' },
  { label: 'Guyanese', value: 'Guyanese' },
  { label: 'Haitian', value: 'Haitian' },
  { label: 'Herzegovinian', value: 'Herzegovinian' },
  { label: 'Honduran', value: 'Honduran' },
  { label: 'Hungarian', value: 'Hungarian' },
  { label: 'I-Kiribati', value: 'I-Kiribati' },
  { label: 'Icelander', value: 'Icelander' },
  { label: 'Indian', value: 'Indian' },
  { label: 'Indonesian', value: 'Indonesian' },
  { label: 'Iranian', value: 'Iranian' },
  { label: 'Iraqi', value: 'Iraqi' },
  { label: 'Irish', value: 'Irish' },
  { label: 'Israeli', value: 'Israeli' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Ivorian', value: 'Ivorian' },
  { label: 'Jamaican', value: 'Jamaican' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Jordanian', value: 'Jordanian' },
  { label: 'Kazakhstani', value: 'Kazakhstani' },
  { label: 'Kenyan', value: 'Kenyan' },
  { label: 'Kittian and Nevisian', value: 'Kittian and Nevisian' },
  { label: 'Kuwaiti', value: 'Kuwaiti' },
  { label: 'Kyrgyz', value: 'Kyrgyz' },
  { label: 'Laotian', value: 'Laotian' },
  { label: 'Latvian', value: 'Latvian' },
  { label: 'Lebanese', value: 'Lebanese' },
  { label: 'Liberian', value: 'Liberian' },
  { label: 'Libyan', value: 'Libyan' },
  { label: 'Liechtensteiner', value: 'Liechtensteiner' },
  { label: 'Lithuanian', value: 'Lithuanian' },
  { label: 'Luxembourger', value: 'Luxembourger' },
  { label: 'Macedonian', value: 'Macedonian' },
  { label: 'Malagasy', value: 'Malagasy' },
  { label: 'Malawian', value: 'Malawian' },
  { label: 'Malaysian', value: 'Malaysian' },
  { label: 'Maldivian', value: 'Maldivian' },
  { label: 'Malian', value: 'Malian' },
  { label: 'Maltese', value: 'Maltese' },
  { label: 'Marshallese', value: 'Marshallese' },
  { label: 'Mauritanian', value: 'Mauritanian' },
  { label: 'Mauritian', value: 'Mauritian' },
  { label: 'Mexican', value: 'Mexican' },
  { label: 'Micronesian', value: 'Micronesian' },
  { label: 'Moldovan', value: 'Moldovan' },
  { label: 'Monacan', value: 'Monacan' },
  { label: 'Mongolian', value: 'Mongolian' },
  { label: 'Moroccan', value: 'Moroccan' },
  { label: 'Mosotho', value: 'Mosotho' },
  { label: 'Motswana', value: 'Motswana' },
  { label: 'Mozambican', value: 'Mozambican' },
  { label: 'Namibian', value: 'Namibian' },
  { label: 'Nauruan', value: 'Nauruan' },
  { label: 'Nepalese', value: 'Nepalese' },
  { label: 'New Zealander', value: 'New Zealander' },
  { label: 'Ni-Vanuatu', value: 'Ni-Vanuatu' },
  { label: 'Nicaraguan', value: 'Nicaraguan' },
  { label: 'Nigerian', value: 'Nigerian' },
  { label: 'Nigerien', value: 'Nigerien' },
  { label: 'North Korean', value: 'North Korean' },
  { label: 'Northern Irish', value: 'Northern Irish' },
  { label: 'Norwegian', value: 'Norwegian' },
  { label: 'Omani', value: 'Omani' },
  { label: 'Pakistani', value: 'Pakistani' },
  { label: 'Palauan', value: 'Palauan' },
  { label: 'Panamanian', value: 'Panamanian' },
  { label: 'Papua New Guinean', value: 'Papua New Guinean' },
  { label: 'Paraguayan', value: 'Paraguayan' },
  { label: 'Peruvian', value: 'Peruvian' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Qatari', value: 'Qatari' },
  { label: 'Romanian', value: 'Romanian' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Rwandan', value: 'Rwandan' },
  { label: 'Saint Lucian', value: 'Saint Lucian' },
  { label: 'Salvadoran', value: 'Salvadoran' },
  { label: 'Samoan', value: 'Samoan' },
  { label: 'San Marinese', value: 'San Marinese' },
  { label: 'Sao Tomean', value: 'Sao Tomean' },
  { label: 'Saudi', value: 'Saudi' },
  { label: 'Scottish', value: 'Scottish' },
  { label: 'Senegalese', value: 'Senegalese' },
  { label: 'Serbian', value: 'Serbian' },
  { label: 'Seychellois', value: 'Seychellois' },
  { label: 'Sierra Leonean', value: 'Sierra Leonean' },
  { label: 'Singaporean', value: 'Singaporean' },
  { label: 'Slovakian', value: 'Slovakian' },
  { label: 'Slovenian', value: 'Slovenian' },
  { label: 'Solomon Islander', value: 'Solomon Islander' },
  { label: 'Somali', value: 'Somali' },
  { label: 'South African', value: 'South African' },
  { label: 'South Korean', value: 'South Korean' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'Sri Lankan', value: 'Sri Lankan' },
  { label: 'Sudanese', value: 'Sudanese' },
  { label: 'Surinamer', value: 'Surinamer' },
  { label: 'Swazi', value: 'Swazi' },
  { label: 'Swedish', value: 'Swedish' },
  { label: 'Swiss', value: 'Swiss' },
  { label: 'Syrian', value: 'Syrian' },
  { label: 'Taiwanese', value: 'Taiwanese' },
  { label: 'Tajik', value: 'Tajik' },
  { label: 'Tanzanian', value: 'Tanzanian' },
  { label: 'Thai', value: 'Thai' },
  { label: 'Togolese', value: 'Togolese' },
  { label: 'Tongan', value: 'Tongan' },
  { label: 'Trinidadian or Tobagonian', value: 'Trinidadian or Tobagonian' },
  { label: 'Tunisian', value: 'Tunisian' },
  { label: 'Turkish', value: 'Turkish' },
  { label: 'Tuvaluan', value: 'Tuvaluan' },
  { label: 'Ugandan', value: 'Ugandan' },
  { label: 'Ukrainian', value: 'Ukrainian' },
  { label: 'Uruguayan', value: 'Uruguayan' },
  { label: 'Uzbekistani', value: 'Uzbekistani' },
  { label: 'Venezuelan', value: 'Venezuelan' },
  { label: 'Welsh', value: 'Welsh' },
  { label: 'Yemenite', value: 'Yemenite' },
  { label: 'Zambian', value: 'Zambian' },
  { label: 'Zimbabwean', value: 'Zimbabwean' },
];

export const FORM_VALUES_DEGREE_PG = [
  { label: 'Doctor of Medicine (M.D)', value: 'Doctor of Medicine (M.D)' },
  {
    label: 'Doctor of Philosophy (Ph.D)',
    value: 'Doctor of Philosophy (Ph.D)',
  },
  {
    label: 'Management Development Programme (M.D.P)',
    value: 'Management Development Programme (M.D.P)',
  },
  {
    label: 'Master of Architecture (M.Arch)',
    value: 'Master of Architecture (M.Arch)',
  },
  { label: 'Master of Arts (M.A)', value: 'Master of Arts (M.A)' },
  {
    label: 'Master of Arts in Management (M.A.M)',
    value: 'Master of Arts in Management (M.A.M)',
  },
  {
    label: 'Master of Arts in Personal Management (M.A.P.M)',
    value: 'Master of Arts in Personal Management (M.A.P.M)',
  },
  {
    label: 'Master of Business Administration (M.B.A)',
    value: 'Master of Business Administration (M.B.A)',
  },
  {
    label: 'Master of Business Administration (MBA)',
    value: 'Master of Business Administration (MBA)',
  },
  {
    label: 'Master of Business Economics (M.B.E)',
    value: 'Master of Business Economics (M.B.E)',
  },
  {
    label: 'Master of Business Laws (M.B.L)',
    value: 'Master of Business Laws (M.B.L)',
  },
  {
    label: 'Master of Business Management (M.B.M)',
    value: 'Master of Business Management (M.B.M)',
  },
  {
    label: 'Master of Business Studies (M.B.S)',
    value: 'Master of Business Studies (M.B.S)',
  },
  {
    label: 'Master of Chirurgical (M.Ch)',
    value: 'Master of Chirurgical (M.Ch)',
  },
  { label: 'Master of Commerce (M.Com)', value: 'Master of Commerce (M.Com)' },
  {
    label: 'Master Of Communication And Journalism (M.C.J)',
    value: 'Master Of Communication And Journalism (M.C.J)',
  },
  {
    label: 'Master of Comparative Laws (M.C.L)',
    value: 'Master of Comparative Laws (M.C.L)',
  },
  {
    label: 'Master of Computer Applications (M.C.A)',
    value: 'Master of Computer Applications (M.C.A)',
  },
  {
    label: 'Master of Computer Management (M.C.M)',
    value: 'Master of Computer Management (M.C.M)',
  },
  {
    label: 'Master of Corporate Secretaryship (M.C.S)',
    value: 'Master of Corporate Secretaryship (M.C.S)',
  },
  {
    label: 'Master of Dental Surgery (M.D.S)',
    value: 'Master of Dental Surgery (M.D.S)',
  },
  { label: 'Master of Education (M.Ed)', value: 'Master of Education (M.Ed)' },
  {
    label: 'Master of education in Artificial Intelligence (M.Ed AI)',
    value: 'Master of education in Artificial Intelligence (M.Ed AI)',
  },
  {
    label: 'Master of Engineering (M.E)',
    value: 'Master of Engineering (M.E)',
  },
  {
    label: 'Master of Film Management (M.F.M)',
    value: 'Master of Film Management (M.F.M)',
  },
  {
    label: 'Master of Finance And Control (M.F.C)',
    value: 'Master of Finance And Control (M.F.C)',
  },
  {
    label: 'Master of Financial Services (M.F.S)',
    value: 'Master of Financial Services (M.F.S)',
  },
  {
    label: 'Master of Fine Arts (M.F.A)',
    value: 'Master of Fine Arts (M.F.A)',
  },
  {
    label: 'Master of Fishery Sciences (M.F.Sc)',
    value: 'Master of Fishery Sciences (M.F.Sc)',
  },
  {
    label: 'Master of Foreign Trade (M.F.T)',
    value: 'Master of Foreign Trade (M.F.T)',
  },
  {
    label: 'Master Of Health Science (M.H.Sc)',
    value: 'Master Of Health Science (M.H.Sc)',
  },
  {
    label: 'Master of Hospital Administration (M.H.A)',
    value: 'Master of Hospital Administration (M.H.A)',
  },
  {
    label: 'Master of Hospitality And Hotel Management (M.H.H.M)',
    value: 'Master of Hospitality And Hotel Management (M.H.H.M)',
  },
  {
    label: 'Master of Hospitality Management (M.H.M)',
    value: 'Master of Hospitality Management (M.H.M)',
  },
  {
    label: 'Master of Human Resource Management (M.H.R.M)',
    value: 'Master of Human Resource Management (M.H.R.M)',
  },
  {
    label:
      'Master of Industrial Relation and Personnel Management (MIR and PM)',
    value:
      'Master of Industrial Relation and Personnel Management (MIR and PM)',
  },
  {
    label: 'Master of International Business (M.I.B)',
    value: 'Master of International Business (M.I.B)',
  },
  {
    label: "Master of Journalism (M.J) Master of Journalism (M.J)'",
    value: "Master of Journalism (M.J) Master of Journalism (M.J)'",
  },
  {
    label: 'Master of Labour Management (M.L.M)',
    value: 'Master of Labour Management (M.L.M)',
  },
  { label: 'Master of Law (LL.M)', value: 'Master of Law (LL.M)' },
  { label: 'Master of Laws (M.L)', value: 'Master of Laws (M.L)' },
  {
    label: 'Master of Library and Information Science (M.L.I.Sc)',
    value: 'Master of Library and Information Science (M.L.I.Sc)',
  },
  {
    label: 'Master of Library Science (M.L.Sc)',
    value: 'Master of Library Science (M.L.Sc)',
  },
  {
    label: 'Master of Management Program (M.M.P)',
    value: 'Master of Management Program (M.M.P)',
  },
  {
    label: 'Master of Management Studies (M.M.S)',
    value: 'Master of Management Studies (M.M.S)',
  },
  {
    label: 'Master of Marketing Management (M.M.M)',
    value: 'Master of Marketing Management (M.M.M)',
  },
  {
    label: 'Master of Occupational Theraphy (M.O.T)',
    value: 'Master of Occupational Theraphy (M.O.T)',
  },
  {
    label: 'Master of Performance Management (M.P.M)',
    value: 'Master of Performance Management (M.P.M)',
  },
  {
    label: 'Master of Performing Arts (M.P.A)',
    value: 'Master of Performing Arts (M.P.A)',
  },
  {
    label: 'Master of Personnel Management (MPM)',
    value: 'Master of Personnel Management (MPM)',
  },
  {
    label:
      'Master of Personnel Management and Industrial Relation (MPM and IR)',
    value:
      'Master of Personnel Management and Industrial Relation (MPM and IR)',
  },
  {
    label: 'Master of Pharmacy (M.Pharma)',
    value: 'Master of Pharmacy (M.Pharma)',
  },
  {
    label: 'Master of Philosophy (M.Phil)',
    value: 'Master of Philosophy (M.Phil)',
  },
  {
    label: 'Master Of Physical Education (M.P.Ed)',
    value: 'Master Of Physical Education (M.P.Ed)',
  },
  {
    label: 'Master of Physiotheraphy (M.P.T)',
    value: 'Master of Physiotheraphy (M.P.T)',
  },
  {
    label: 'Master of Psychiatric Epidemiology (M.P.E)',
    value: 'Master of Psychiatric Epidemiology (M.P.E)',
  },
  {
    label: 'Master of Public Health (M.P.H)',
    value: 'Master of Public Health (M.P.H)',
  },
  {
    label: "Master of Science (M.S) Master of Science (M.S)'",
    value: "Master of Science (M.S) Master of Science (M.S)'",
  },
  {
    label: "Master of Science (M.Sc) Master of Science (M.Sc)'",
    value: "Master of Science (M.Sc) Master of Science (M.Sc)'",
  },
  {
    label: 'Master of Social Dynamics (M.S.D)',
    value: 'Master of Social Dynamics (M.S.D)',
  },
  {
    label: 'Master of Social Work (M.S.W)',
    value: 'Master of Social Work (M.S.W)',
  },
  {
    label: 'Master of Technology (M.Tech)',
    value: 'Master of Technology (M.Tech)',
  },
  {
    label: "Master of Theology (M.Th) Master of Theology (M.Th)'",
    value: "Master of Theology (M.Th) Master of Theology (M.Th)'",
  },
  {
    label: 'Master of Tourism Administrations (M.T.A)',
    value: 'Master of Tourism Administrations (M.T.A)',
  },
  {
    label: 'Master of Tourism Management (M.T.M)',
    value: 'Master of Tourism Management (M.T.M)',
  },
  {
    label: 'Master of Veterinary Science (M.V.Sc)',
    value: 'Master of Veterinary Science (M.V.Sc)',
  },
  {
    label: 'Master of Visual Arts (M.V.A)',
    value: 'Master of Visual Arts (M.V.A)',
  },
  {
    label: 'Master of Vocational (M.Voc)',
    value: 'Master of Vocational (M.Voc)',
  },
  { label: 'Masters in Design (M.Des)', value: 'Masters in Design (M.Des)' },
  {
    label: 'Masters in International Management (M.I.M)',
    value: 'Masters in International Management (M.I.M)',
  },
  {
    label: 'Masters in Public Systems Management (M.P.S.M)',
    value: 'Masters in Public Systems Management (M.P.S.M)',
  },
  {
    label: 'Masters of Hospitality and Tourism Management (M.H.T.M)',
    value: 'Masters of Hospitality and Tourism Management (M.H.T.M)',
  },
  {
    label: 'Masters Programme in International Business (M.P.I.B)',
    value: 'Masters Programme in International Business (M.P.I.B)',
  },
  {
    label: 'Post Graduate Programme (PG Programme)',
    value: 'Post Graduate Programme (PG Programme)',
  },
  {
    label: 'Others',
    value: 'Others',
  },
];

export const FORM_VALUES_CURRENCY = [
  { label: 'ADB Unit of Account', value: 'ADB Unit of Account' },
  { label: 'Afghani', value: 'Afghani' },
  { label: 'Afghani', value: 'Afghani' },
  { label: 'Algerian Dinar', value: 'Algerian Dinar' },
  { label: 'Andorran Peseta', value: 'Andorran Peseta' },
  { label: 'Argentine Peso', value: 'Argentine Peso' },
  { label: 'Ariary', value: 'Ariary' },
  { label: 'Armenian Dram', value: 'Armenian Dram' },
  { label: 'Aruban Guilder', value: 'Aruban Guilder' },
  { label: 'Australian Dollar', value: 'Australian Dollar' },
  { label: 'Azerbaijanian Manat', value: 'Azerbaijanian Manat' },
  { label: 'Bahamian Dollar', value: 'Bahamian Dollar' },
  { label: 'Bahraini Dinar', value: 'Bahraini Dinar' },
  { label: 'Baht', value: 'Baht' },
  { label: 'Balboa', value: 'Balboa' },
  { label: 'Barbados Dollar', value: 'Barbados Dollar' },
  { label: 'Belarussian Ruble', value: 'Belarussian Ruble' },
  { label: 'Belgian Franc', value: 'Belgian Franc' },
  { label: 'Belize Dollar', value: 'Belize Dollar' },
  { label: 'Bermudian Dollar', value: 'Bermudian Dollar' },
  { label: 'Bolivar Fuerte', value: 'Bolivar Fuerte' },
  { label: 'Boliviano', value: 'Boliviano' },
  { label: 'Brazilian Real', value: 'Brazilian Real' },
  { label: 'Brunei Dollar', value: 'Brunei Dollar' },
  { label: 'Bulgarian LEV', value: 'Bulgarian LEV' },
  { label: 'Burundi Franc', value: 'Burundi Franc' },
  { label: 'Canadian Dollar', value: 'Canadian Dollar' },
  { label: 'Cape Verde Escudo', value: 'Cape Verde Escudo' },
  { label: 'Cayman Islands dollar', value: 'Cayman Islands dollar' },
  { label: 'Cedi', value: 'Cedi' },
  { label: 'CFA Franc BCEAO', value: 'CFA Franc BCEAO' },
  { label: 'CFA Franc BEAC', value: 'CFA Franc BEAC' },
  { label: 'CFP Franc', value: 'CFP Franc' },
  { label: 'Chilean Peso', value: 'Chilean Peso' },
  { label: 'Colombian Peso', value: 'Colombian Peso' },
  { label: 'Comoro Franc', value: 'Comoro Franc' },
  { label: 'Convertible Marks', value: 'Convertible Marks' },
  { label: 'Cordoba Oro', value: 'Cordoba Oro' },
  { label: 'Costa Rican Colon', value: 'Costa Rican Colon' },
  { label: 'Cuban Peso', value: 'Cuban Peso' },
  { label: 'Czech Koruna', value: 'Czech Koruna' },
  { label: 'Dalasi', value: 'Dalasi' },
  { label: 'Danish Krone', value: 'Danish Krone' },
  { label: 'Denar', value: 'Denar' },
  { label: 'Deutsche Mark', value: 'Deutsche Mark' },
  { label: 'Djibouti Franc', value: 'Djibouti Franc' },
  { label: 'Dobra', value: 'Dobra' },
  { label: 'Dominican Peso', value: 'Dominican Peso' },
  { label: 'Dong', value: 'Dong' },
  { label: 'Drachma', value: 'Drachma' },
  { label: 'East Caribbean Dollar', value: 'East Caribbean Dollar' },
  { label: 'Egyptian Pound', value: 'Egyptian Pound' },
  { label: 'El Salvador Colon', value: 'El Salvador Colon' },
  { label: 'Ethiopian Birr', value: 'Ethiopian Birr' },
  { label: 'euro', value: 'euro' },
  { label: 'European Composite Unit', value: 'European Composite Unit' },
  { label: 'European Monetary Unit', value: 'European Monetary Unit' },
  {
    label: 'European Unit of Account 17',
    value: 'European Unit of Account 17',
  },
  { label: 'European Unit of Account 9', value: 'European Unit of Account 9' },
  { label: 'Falklands Isl. Pound', value: 'Falklands Isl. Pound' },
  { label: 'Fiji Dollar', value: 'Fiji Dollar' },
  { label: 'For Testing Purposes', value: 'For Testing Purposes' },
  { label: 'Forint', value: 'Forint' },
  { label: 'Franc Congolais', value: 'Franc Congolais' },
  { label: 'French Franc', value: 'French Franc' },
  { label: 'Gibraltar Pound', value: 'Gibraltar Pound' },
  { label: 'GOLD', value: 'GOLD' },
  { label: 'Gold-Franc', value: 'Gold-Franc' },
  { label: 'Gourde', value: 'Gourde' },
  { label: 'Guarani', value: 'Guarani' },
  { label: 'Guinea Franc', value: 'Guinea Franc' },
  { label: 'Guinea-Bissau Peso', value: 'Guinea-Bissau Peso' },
  { label: 'Guyana Dollar', value: 'Guyana Dollar' },
  { label: 'Hong Kong Dollar', value: 'Hong Kong Dollar' },
  { label: 'Hryvnia', value: 'Hryvnia' },
  { label: 'Iceland Krona', value: 'Iceland Krona' },
  { label: 'Indian Rupee', value: 'Indian Rupee' },
  { label: 'Iranian Rial', value: 'Iranian Rial' },
  { label: 'Iraqi Dinar', value: 'Iraqi Dinar' },
  { label: 'Irish Pound', value: 'Irish Pound' },
  { label: 'Italian Lira', value: 'Italian Lira' },
  { label: 'Jamaican Dollar', value: 'Jamaican Dollar' },
  { label: 'Jordanian Dinar', value: 'Jordanian Dinar' },
  { label: 'Kenyan Shilling', value: 'Kenyan Shilling' },
  { label: 'Kina', value: 'Kina' },
  { label: 'Kip', value: 'Kip' },
  { label: 'Kroon', value: 'Kroon' },
  { label: 'Kuna', value: 'Kuna' },
  { label: 'Kuwaiti Dinar', value: 'Kuwaiti Dinar' },
  { label: 'Kwanza', value: 'Kwanza' },
  { label: 'Kyat', value: 'Kyat' },
  { label: 'Lari', value: 'Lari' },
  { label: 'Latvian Lats', value: 'Latvian Lats' },
  { label: 'Lebanese Pound', value: 'Lebanese Pound' },
  { label: 'Lek', value: 'Lek' },
  { label: 'Lempira', value: 'Lempira' },
  { label: 'Leone', value: 'Leone' },
  { label: 'Lev', value: 'Lev' },
  { label: 'Liberian Dollar', value: 'Liberian Dollar' },
  { label: 'Libyan Dinar', value: 'Libyan Dinar' },
  { label: 'Lilangeni', value: 'Lilangeni' },
  { label: 'Lithuanian Litas', value: 'Lithuanian Litas' },
  { label: 'Loti', value: 'Loti' },
  { label: 'Luxembourg Franc', value: 'Luxembourg Franc' },
  { label: 'Malawian Kwacha', value: 'Malawian Kwacha' },
  { label: 'Malaysian Ringgit', value: 'Malaysian Ringgit' },
  { label: 'Manat', value: 'Manat' },
  { label: 'Markka', value: 'Markka' },
  { label: 'Mauritius Rupee', value: 'Mauritius Rupee' },
  { label: 'Metical', value: 'Metical' },
  { label: 'Mexican Peso', value: 'Mexican Peso' },
  { label: 'Mexican UDI', value: 'Mexican UDI' },
  { label: 'Moldovan Leu', value: 'Moldovan Leu' },
  { label: 'Moroccan Dirham', value: 'Moroccan Dirham' },
  { label: 'Mvdol', value: 'Mvdol' },
  { label: 'Naira', value: 'Naira' },
  { label: 'Nakfa', value: 'Nakfa' },
  { label: 'Namibia Dollar', value: 'Namibia Dollar' },
  { label: 'Nepalese Rupee', value: 'Nepalese Rupee' },
  {
    label: 'Netherlands Antilles Guilder',
    value: 'Netherlands Antilles Guilder',
  },
  { label: 'Netherlands Guilder', value: 'Netherlands Guilder' },
  { label: 'New Dinar', value: 'New Dinar' },
  { label: 'New Israeli Sheqel', value: 'New Israeli Sheqel' },
  { label: 'New Romanian Leu', value: 'New Romanian Leu' },
  { label: 'New Taiwan Dollar', value: 'New Taiwan Dollar' },
  { label: 'New Turkish Lira', value: 'New Turkish Lira' },
  { label: 'New Zealand Dollar', value: 'New Zealand Dollar' },
  { label: 'Ngultrum', value: 'Ngultrum' },
  { label: 'Non Currency Transaction', value: 'Non Currency Transaction' },
  { label: 'North Korean Won', value: 'North Korean Won' },
  { label: 'Norwegian Krone', value: 'Norwegian Krone' },
  { label: 'Nuevo Sol', value: 'Nuevo Sol' },
  { label: 'Ouguiya', value: 'Ouguiya' },
  { label: "Pa'anga", value: "Pa'anga" },
  { label: 'Pakistan Rupee', value: 'Pakistan Rupee' },
  { label: 'Palladium', value: 'Palladium' },
  { label: 'Pataca', value: 'Pataca' },
  { label: 'Peso Convertible', value: 'Peso Convertible' },
  { label: 'Peso Uruguayo', value: 'Peso Uruguayo' },
  { label: 'Philippine Peso', value: 'Philippine Peso' },
  { label: 'Platinum', value: 'Platinum' },
  { label: 'Portuguese Escudo', value: 'Portuguese Escudo' },
  { label: 'Pound Sterling', value: 'Pound Sterling' },
  { label: 'Pula', value: 'Pula' },
  { label: 'Qatari Rial', value: 'Qatari Rial' },
  { label: 'Quetzal', value: 'Quetzal' },
  { label: 'Rand', value: 'Rand' },
  { label: 'Rial Omani', value: 'Rial Omani' },
  { label: 'Riel', value: 'Riel' },
  { label: 'Rufiyaa', value: 'Rufiyaa' },
  { label: 'Rupiah', value: 'Rupiah' },
  { label: 'Russian Federation Rouble', value: 'Russian Federation Rouble' },
  { label: 'Russian Ruble', value: 'Russian Ruble' },
  { label: 'Rwanda Franc', value: 'Rwanda Franc' },
  { label: 'Saudi Riyal', value: 'Saudi Riyal' },
  { label: 'Schilling', value: 'Schilling' },
  { label: 'SDR', value: 'SDR' },
  { label: 'Serbian Dinar', value: 'Serbian Dinar' },
  { label: 'Seychelles Rupee', value: 'Seychelles Rupee' },
  { label: 'Silver', value: 'Silver' },
  { label: 'Singapore Dollar', value: 'Singapore Dollar' },
  { label: 'Slovak Koruna', value: 'Slovak Koruna' },
  { label: 'Solomon Islands', value: 'Solomon Islands' },
  { label: 'Som', value: 'Som' },
  { label: 'Somali Shilling', value: 'Somali Shilling' },
  { label: 'Somoni', value: 'Somoni' },
  { label: 'South Sudanese Pound', value: 'South Sudanese Pound' },
  { label: 'Spanish Peseta', value: 'Spanish Peseta' },
  { label: 'Sri Lanka Rupee', value: 'Sri Lanka Rupee' },
  { label: 'St Helena Pound', value: 'St Helena Pound' },
  { label: 'Sucre', value: 'Sucre' },
  { label: 'Sudanese Dinar', value: 'Sudanese Dinar' },
  { label: 'Surinam Dollar', value: 'Surinam Dollar' },
  { label: 'Surinam Guilder', value: 'Surinam Guilder' },
  { label: 'Swedish Krona', value: 'Swedish Krona' },
  { label: 'Swiss Franc', value: 'Swiss Franc' },
  { label: 'Syrian Pound', value: 'Syrian Pound' },
  { label: 'Taka', value: 'Taka' },
  { label: 'Tala', value: 'Tala' },
  { label: 'Tanzanian Shilling', value: 'Tanzanian Shilling' },
  { label: 'Tenge', value: 'Tenge' },
  { label: 'Timor Escudo', value: 'Timor Escudo' },
  { label: 'Trinidad Dollar', value: 'Trinidad Dollar' },
  { label: 'Tugrik', value: 'Tugrik' },
  { label: 'Tunisian Dinar', value: 'Tunisian Dinar' },
  { label: 'Turkmenistan New Manat', value: 'Turkmenistan New Manat' },
  { label: 'Uganda Shilling', value: 'Uganda Shilling' },
  { label: 'UIC-Franc', value: 'UIC-Franc' },
  { label: 'Unidad de Valor Real', value: 'Unidad de Valor Real' },
  { label: 'Unidades de fomento', value: 'Unidades de fomento' },
  {
    label: 'United Arab Emirates Dirham',
    value: 'United Arab Emirates Dirham',
  },
  {
    label: 'Uruguay Peso Unidad Indexada',
    value: 'Uruguay Peso Unidad Indexada',
  },
  { label: 'US Dollar', value: 'US Dollar' },
  { label: 'US Dollar (Next day)', value: 'US Dollar (Next day)' },
  { label: 'US Dollar (Same day)', value: 'US Dollar (Same day)' },
  { label: 'Uzbekistan Sum', value: 'Uzbekistan Sum' },
  { label: 'Vatu', value: 'Vatu' },
  { label: 'WIR Euro', value: 'WIR Euro' },
  { label: 'WIR Franc', value: 'WIR Franc' },
  { label: 'Won', value: 'Won' },
  { label: 'Yemeni Rial', value: 'Yemeni Rial' },
  { label: 'Yen', value: 'Yen' },
  { label: 'Yuan Renminbi', value: 'Yuan Renminbi' },
  { label: 'Zambian Kwacha', value: 'Zambian Kwacha' },
  { label: 'Zambian Kwacha', value: 'Zambian Kwacha' },
  { label: 'Zimbabwe Dollar', value: 'Zimbabwe Dollar' },
  { label: 'Zimbabwe Dollar', value: 'Zimbabwe Dollar' },
  { label: 'Zloty', value: 'Zloty' },
];

export const FORM_VALUES_GENDER = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
  {
    label: 'Pefer not to say',
    value: 'Pefer not to say',
  },
];

export const FORM_VALUES_SPJAIN_HEAR = [
  {
    label: 'Alumnus of SP Jain',
    value: 'Alumnus of SP Jain',
  },
  {
    label: 'EDM Invite',
    value: 'EDM Invite',
  },
  {
    label: 'Email Promotion',
    value: 'Email Promotion',
  },
  {
    label: 'Info Session',
    value: 'Info Session',
  },
  {
    label: 'Newpaper / Magazine Article or Advertisement',
    value: 'Newpaper / Magazine Article or Advertisement',
  },
  {
    label: 'SP Jain Representative',
    value: 'SP Jain Representative',
  },
  {
    label: 'SP Jain Website',
    value: 'SP Jain Website',
  },
  {
    label: 'Social Media',
    value: 'Social Media',
  },
  {
    label: 'TV / Radio',
    value: 'TV / Radio',
  },
];

export const FORM_VALUES_JOBTYPE = [
  {
    label: 'Full Time',
    value: 'Full Time',
  },
  {
    label: 'Part Time',
    value: 'Part Time',
  },
  {
    label: 'Internship',
    value: 'Internship',
  },
  {
    label: 'Articleship',
    value: 'Articleship',
  },
  {
    label: 'Full Time (Still Working)',
    value: 'Full Time (Still Working)',
  },
];

export const FROM_VALUES_BATCH = [
  { label: '1991', value: '1991' },
  { label: '1992', value: '1992' },
  { label: '1993', value: '1993' },
  { label: '1994', value: '1994' },
  { label: '1995', value: '1995' },
  { label: '1996', value: '1996' },
  { label: '1997', value: '1997' },
  { label: '1998', value: '1998' },
  { label: '1999', value: '1999' },
  { label: '2000', value: '2000' },
  { label: '2001', value: '2001' },
  { label: '2002', value: '2002' },
  { label: '2003', value: '2003' },
  { label: '2004', value: '2004' },
  { label: '2005', value: '2005' },
  { label: '2006', value: '2006' },
  { label: '2007', value: '2007' },
  { label: '2008', value: '2008' },
  { label: '2010', value: '2010' },
  { label: '2011', value: '2011' },
  { label: '2012', value: '2012' },
  { label: '2013', value: '2013' },
  { label: '2014', value: '2014' },
  { label: '2015', value: '2015' },
  { label: '2016', value: '2016' },
  { label: '2017', value: '2017' },
  { label: '2018', value: '2018' },
  { label: '2019', value: '2019' },
  { label: '2020', value: '2020' },
  { label: '2021', value: '2021' },
  { label: '2022', value: '2022' },
];

export const FORM_VALUES_YESNO = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
];

export const FORM_VALUES_COLLEGE = [
  'Jawaharlal Nehru Rajkeeya Mahavidyalaya, Port Blair – 744104 (First Cycle)',
  'Dr. B. R. Ambedkar Institute of Technology (First Cycle)',
  'Aditya College of Engineering and Technology Kakinada – 533437 (First Cycle)',
  'Aditya Engineering College Dist. East Godavari, 533437 (First Cycle)',
  'Amrita Sai Institute of Science and Technology Krishna District – 521180 (First Cycle)',
  'Andhra Lutheran College of Education Guntur – 522002 (First Cycle)',
  'Annamacharya Institute of Technology and Sciences, Tirupati – 517520 (First Cycle)',
  'Baba Institute of Technology and Sciences, Visakhapatnam – 530048 (First Cycle)',
  'Bapatla College of Arts & Sciences,Dist. Guntur, 522101 (Second Cycle)',
  'Bapatla Engineering College (Autonomous), Guntur Dist, 522102 (First Cycle)',
  'Bonam Venkata Chalamayya Institute of Technology & Science, Dist. East Godavari, 533201 (First Cycle)',
  'Chaitanya Bharathi Institute of Technology, YSR (Kadapa) Dist, 516360 (First Cycle)',
  'Chalapathi Institute of Pharmaceutical Sciences, Guntur, 522034 (First Cycle)',
  'Chalapathi Institute of Technology, A R Nagar, Mothadaka, Guntur – 522016 (First Cycle)',
  'Chirala Engineering College, Chirala – 523157 (First Cycle)',
  'Dadi Institute of Engineering and Technology, Anakapalle, Visakhapatnam – 531002 (First Cycle)',
  'Dhanekula Institute of Engineering and Technology, Ganguru, Penamaluru Mandalam Vijayawada, Krishna – 521139 (First Cycle)',
  'Dr. Lankapalli Bullayya College Visakhapatnam – 530013 (Second Cycle)',
  'Duvvuru Ramananmma Women’s College (Autonomous), S.P.S.R. Nellore Dist, 524101 (Third Cycle)',
  'G. Pulla Reddy Engineering College, Kurnool – 518002 (Third Cycle)',
  'G. V. R. S. Government Degree College, Dronachalam, Kurnool – 518222 (First Cycle)',
  'Gayatri Vidya Parishad College of Engineering (Autonomous), Visakhapatnam – 530048 (Second Cycle)',
  'GIET School of Pharmacy, Chaitanya Knowledge City, Rajamundry – 533296 (First Cycle)',
  'GMR Institute of Technology,Srikakulam, Rajam – 532127 (Second Cycle)',
  'Government Degree College for Women, Madanapalle, Chittoor – 517325 (Second Cycle)',
  'Government Degree College, Amadalavalasa, Srikakulam – 532185 (First Cycle)',
  'Government Degree College, Avanigadda, Krishna – 521121 (Second Cycle)',
  'Government Degree College, Ichapuram, Srikakulam – 532312 (First Cycle)',
  'Government Degree College, Kadapa Dist, 516101 (Second Cycle)',
  'Government Degree College, Kadapa Dist, 516115 (Second Cycle)',
  'Government Degree College, Kadapa Dist, 516193 (First Cycle)',
  'Government Degree College, Karvetinagaram, Chittoor, Puttur – 517582 (First Cycle)',
  'Government Degree College, Krishna, Tiruvuru – 521235 (Second Cycle)',
  'Government Degree College, Kurnool Dist, 518401 (Second Cycle)',
  'Government Degree College, Mandapeta, East Godavari – 533308 (First Cycle)',
  'Government Degree College, Narsipatnam, Visakhapatnam – 531116 (Second Cycle)',
  'Government Degree College, Nellore District, Naidupet – 524126 (Second Cycle)',
  'Government Degree College, Pattikonda, Kurnool – 518380 (Second Cycle)',
  'Government Degree College, Seethanagaram, East Godavari, Rajahmundry – 533287 (First Cycle)',
  'Government Degree College, Srikakulam Dist, 532201 (Second Cycle)',
  'Government Degree College, Srikakulam Dist, 532421 (Second Cycle)',
  'Government Degree College, Uravakonda, Anantapur – 515812 (First Cycle)',
  'Government Degree College, Vizianagaram, Salur – 535591 (Second Cycle)',
  'Government Degree College, West Godavari, 534460 (Second Cycle)',
  'Gudlavalleru Engineering College, Krishna – 521356 (First Cycle, Re-assessment)',
  'K.H. Government Degree College, Anantapuram Dist, 515671 (First Cycle)',
  'Krishna Chaitanya Institute of Technology and Sciences,Peddaraveedu Mandal, Prakasam, Markapur – 523320 (First Cycle',
  'KVR,KVR & MKR College, Guntur – 522329 (Second Cycle)',
  'M V R College of Engineering and Technology, Vijayawada – 521180 (First Cycle)',
  'Maharaj Vijayaram Gajapathi Raj College of Engineering, Vizianagaram - 535005 (Second Cycle)',
  'Montessori Mahila Kalasala,Vijayawada – 520010 (Third Cycle)',
  'Mrs. A. V. N. College, I Town, Visakhapatnam – 530001 (Third Cycle)',
  'MVN., JS and RVR College of Arts and Science, Malikipuram, East Godavari – 533253 (Second Cycle)',
  'N. S. P. R. Government College for Women, Hindupur, Anantapur – 515201 (First Cycle)',
  'N.T.R. Government Degree College, Chittoor Dist, 517299 (Second Cycle)',
  'Nadimpalli Satyanarayana Raju Institute of Technology, Sonytyam, Anandapuram, Visakhapatnam – 531173 (First Cycle)',
  'Narasaraopeta Engineering College,Guntur Dist, 522601 (First Cycle)',
  'Narayana Dental College, Chinthareddypalem, Nellore – 524003 (First Cycle)',
  'Narayana Medical College, Nellore – 524003 (First Cycle)',
  'Nirmala College of Pharmacy, Atmakuru, Mangalagiri, Guntur – 522503 (First Cycle)',
  'P. R. R. & V. S. Government College Vidavalur SPSR, Nellore – 524318 (Second Cycle)',
  'P.S.C. & K.V.S.C. Government College, Kurnool Dist, 518502 (Second Cycle)',
  'PACE Institute of Technology and Sciences, Ongole – 523272 (First Cycle)',
  'Parvathareddy Babul Reddy Visvodaya Institute of Technology and Science, Kavali – 524201 (First Cycle)',
  'Pragati Engineering College, East Godavari, 533437 (First Cycle)',
  'Priyadarshini College of Engineering and Technology, Kanuparthipadu, Nellore – 524004 (First Cycle)',
  'R.R.D.S. Government Degree College, Bhimavaram, West Goda vari Dist, 534202 (First Cycle)',
  'Raghavendra Institute of Pharmaceutical Education and Research (RIPER), Anantapur – 515721 (First Cycle)',
  'Raghu Engineering College, Visakhapatnam – 531162 (First Cycle)',
  'Raghu Institute of Technology, Dakamarri, Bheemunipatnam, Visakhapatnam – 531162 (First Cycle)',
  'S. B. V. R. Degree College, Badvel, Kadapa – 516227 (First Cycle)',
  'S. C. N. R. Government Degree College, Kadapa – 510360 (Second Cycle)',
  'S. T. S. N. Government Degree College Kadiri - 515591 (Second Cycle)',
  'S.G.A. Government Degree College, Visakhapatnam Dist, 531005 (Second Cycle)',
  'S.V.C.R. Government Degree College, Dist. Chittoor, 517408 (Second Cycle)',
  'Sagi Rama Krishnam Raju Engineering College, Bhimavaram – 534204 (First Cycle)',
  'Shri Vishnu Engineering College (Women) (Autonomous), West Godavari Dist, 534202 (First Cycle)',
  'Siddartha Institute of Science and Technology,',
  'Siddharth Institute of Engineering and Technology, Puttur – 517583 (First Cycle)',
  'Smt. N.P. Savithramma Government College for Women, Chittoor Dist, 517002 (Second Cycle)',
  'Sree Vasavi Kanyaka Parameswari Arts, Science & Commerce College, Prakasam Dist, 523316 (Second Cycle)',
  'Sreenivasa Institute of Technology & Management Studies (Autonomous),Chittoor, 517127 (First Cycle)',
  'Sri A. B. R. Government Degree College Repalle, Guntur – 522265 (Second Cycle)',
  'Sri Chintalapati Varaprasada Murthy Raju Government Degree College, West Godavari – 534198 (Second Cycle)',
  'Sri Dasari Narayana Rao Government Degree College for Women, West Godavari, Palacole – 534260 (Second Cycle)',
  'Sri Ramakrishna Degree College (Autonomous), Kurnool Dist, 518501 (Second Cycle)',
  'Sri V.S. Sivalingam Chettiar Government Degree College, Sullurpet, 524121 (Second Cycle)',
  'Sri Vasavi Engineering College, Tadepalligudem – 534101 (First Cycle)',
  'Sri Venkateswara College of Engineering And Technology (Autonomous), Chittoor, 517127 (First Cycle, Re-assessment)',
  'Sri Venkateswara College of Engineering and Technology, Srikakulam – 532410 (First Cycle)',
  'Srinivasa Ramanujan Institute of Technology, Rotarypuram, B. K. Samudram, Anantapur – 515701 (First Cycle)',
  'St. Mary’s Group of Institutions Guntur, Chebrolu (V&M), Guntur – 522212 (First Cycle',
  'St. Mary’s Women’s Engineering College, Budampadu, Guntur – 522017 (First Cycle)',
  'Subharam Government Degree College, Chittoor – 517247 (Second Cycle)',
  'Usha Rama College of Engineering and Technology, Telaprolu, Krishna, Vijayawada – 521109 (First Cycle)',
  'V. R. S. and Y. R. N. College, Chirala – 523157 (Second Cycle)',
  'Vasireddy Venkatadri Institute of Technology, Guntur – 522508 (First Cycle)',
  'Vemu Institute of Technology, P. Kothakota, Pakala, Chittoor – 517112 (First Cycle)',
  'Vidyalaya College of Education, Chittoor Dist, 517507 (First Cycle)',
  'Visakha Government Degree College for Women, Visakhapatnam – 530020 (Second Cycle)',
  'Vishnu Institute of Technology,Bhimavaram, 534202 (First Cycle)',
  'VSM College of Engineering, Ramachandrapuram – 533255 (First Cycle)',
  'A. J. College of Education, Rajupeta, Machilipatnam, Krishna – 521001 (First Cycle)',
  'Aditya Degree College, Kakinada – 533003 (First Cycle)',
  'Adusumilli Gopalakrishnaiah and Sugarcane Growers Siddhartha Degree College of Arts and Science, Vuyyuru, Krishna – 521165 (Second Cycle)',
  'Akkineni Nageswara Rao College, Gudivada, Krishna – 521301 (Second Cycle)',
  'Andhra Christian College, Sambasivapet, Guntur – 522001 (Second Cycle)',
  'Andhra Loyola College, Vijayawada – 520008 (Third Cycle)',
  'Andhra Pradesh Residential Degree College, Guntur – 522439 (First Cycle, assessed as per old methodology)',
  'Annamacharya College of Pharmacy, New Boyanapalli, Rajampet, Kadapa – 516216 (First Cycle)',
  'Audisankara College of Engineering and Technology, Gudur, Nellore – 524101 (Second Cycle)',
  'Audisankara Institute of Technology, Gudur, Nellore – 524101 (First Cycle)',
  'Avanthi Institute of Engineering and Technology, Tamaram, Makavarapalem, Visakhapatnam – 531113 (First Cycle)',
  'B. V. K. College, Dwarakanagar, Visakhapatnam – 530016 (First Cycle)',
  'Balaji Institute of Engineering and Management Studies, Ramannapalem, Kodavuluru, Nellore – 524366 (First Cycle)',
  'Bhagawan Sri Satyasai Baba Degree College, Tadikonda, Guntur – 522236 (First Cycle)',
  "Ch. S. D. St. Theresa's Autonomous College for Women, Gavaravaram, Sanivarapupeta, West Godavari, Eluru – 534003 (Fourth Cycle)",
  'Chalapathi Institute of Engineering and Technology, Guntur – 522034 (First Cycle)',
  'CSSR and SRRM Degree and PG College, Kamalapuram, Cuddapah – 516289 (First Cycle)',
  'Devineni Venkata Ramana and Dr. Himasekhar MIC College of Technology, Kanchikacherla, Krishna, Vijayawada – 521180 (First Cycle)',
  'Dharma Apparao College, Nuzvid, Krishna – 521201 (First Cycle)',
  'Dr. B. V. Raju Institute of Computer Education, Vishnupur, Bhimavaram, West Godavari – 534202 (First Cycle)',
  'Dr. V. S. Krishna Government Degree College, Maddilapalem, Visakhapatnam – 530013 (Third Cycle)',
  'G. Pullaiah College of Engineering and Technology, Pasupula, Kurnool – 518452 (First Cycle)',
  "Government College for Women, Women's College Road, Srikakulam – 532001 (Third Cycle)",
  'Government College, Anantapur – 515001 (Third Cycle)',
  'Government Degree College (Men), Srikakulam – 532001 (Third Cycle)',
  'Government Degree College, Chebrole Post, Guntur – 522212 (First Cycle)',
  'Government Degree College, Kurnool, Banaganapalle – 518124 (First Cycle)',
  'Government Degree College, Palakonda, Srikakulam – 532440 (Second Cycle)',
  'Government Degree College, Srisailam Project (Right Flank Colony) Township, Kurnool – 518102 (First Cycle)',
  'Hindu College, Guntur – 522003 (Third Cycle)',
  'Jagarlamudi Kuppuswamy Choudary College, Guntur - 522006 (Second Cycle)',
  'Kakinada Institute of Technology and Science, Tirupathi Village, Divili, Peddapuram, East Godavari – 533433 (First Cycle)',
  'Kallam Haranadhareddy Institute of Technology, Chowdavaram, Guntur – 522019 (First Cycle)',
  'KKR and KSR Institute of Technology and Sciences, Guntur – 522017 (First Cycle)',
  'Lendi Institute of Engineering and Technology, Jonnada, Denkada, Vizianagaram – 535005 (First Cycle)',
  'Lenora Institute of Dental Sciences, Rajanagaram, Rajamundry, East Godavari – 533294 (First Cycle)',
  'Loyola Institute of Technology and Management, Dhulipalla, Satenapalle, Guntur – 522412 (First Cycle)',
  'Madanapalle Institute of Technology and Science, Angallu, Madanapalle, Chittoor – 517325 (First Cycle)',
  'Noble College, Machilipatnam – 521001 (Second Cycle)',
  'NRI Institute of Technology, Pothavarappadu, Agiripalli, Krishna, Vijayawada – 521212 (First Cycle)',
  'Osmania College, Peta, Kurnool – 518001 (Second Cycle)',
  'P. B. N. College, Ponnur, Guntur – 522124 (Second Cycle)',
  'P. V. K. N. Government College, Greamspet, Chittoor – 517002 (Third Cycle)',
  'Paritala Sriramulu Government Degree College, Penukonda – 515110 (First Cycle)',
  "Pithapur Rajah's Government College (Autonomous), Kakinada East, Godavari – 533003 (Third Cycle)",
  'QIS College of Engineering and Technology, Vengamukkapalem, Ongole – 523272 (First Cycle)',
  'Rajeev Gandhi Memorial College of Engineering and Technology (Autonomous), Nandyal, Kurnool – 518501 (Second Cycle)',
  'Ramachandra College of Engineering, Eluru – 534007 (First Cycle)',
  'Rayapati Venkata Ranga Rao College of Education, Pattabhipuram, Guntur – 522006 (Second Cycle)',
  'S. G. K. Government Degree College, Vinukonda, Guntur – 522001 (Second Cycle)',
  'S. K. B. R. Government Degree College, Macherla, Guntur – 522426 (Second Cycle)',
  'S. K. V. T. College, Rajahmundry – 533103 (First Cycle)',
  'S. R. R. and C. V. R. Government Degree College, Machavaram, Krishna, Vijayawada – 520004 (Third Cycle)',
  'S. V. Arts and Science College, Giddalur, Prakasam – 523357 (First Cycle)',
  'S. V. B. Government Degree College, Kurnool – 518134 (Second Cycle)',
  'S. V. L. N. S. Government Degree College, Bheemunipatnam – 531163 (Second Cycle)',
  'SDS (A) College of Arts and Applied Sciences, Shreeramnagar, Garividi Mandal, Vizianagaram – 535101 (Second Cycle)',
  'Seven Hills College of Pharmacy, Venkatramapuram, Tanepally, Ramachandrapuram, Tirupati, Chittoor – 517561 (First Cycle)',
  'Shri Vishnu College of Pharmacy, Vishnupur, Bhimavaram, West Godavari – 534202 (Second Cycle)',
  'Sir C. R. Reddy Autonomous College, Eluru, West Godavari – 534007 (Third Cycle)',
  'Sir C. R. Reddy College of Engineering, Vatluru, Eluru – 534007 (First Cycle)',
  'Smt. Gentela Sakuntalamma College, Vidyanagar, Jaggaiahpet, Krishna – 521175 (Second Cycle)',
  'Smt. Kandukuri Rajyalakshmi College for Women, East Godavari, Rajahmundry – 533103 (Second Cycle)',
  'Sree Konaseema Bhanoji Ramars College, Amalapuram – 533201 (Second Cycle)',
  'Sri Neelam Sanjeeva Reddy Arts, Science and Commerce College, Velgode, Kurnool – 518533 (First Cycle)',
  'Sri Vasavi Kanyaka Parameswari and Dr. Kalidindi Suryanarayana Raju Arts and Science College, Penugonda, West Godavari – 534320 (Third Cycle)',
  'Sri Venkateswara College of Engineering, Tirupati – 517507 (First Cycle)',
  'Sri Venkateswara College of Nursing, Murukambattu, Chittoor – 517127 (First Cycle)',
  'Sri Venkateswara College of Pharmacy, Chittoor – 517127 (First Cycle)',
  'Sri Yerramilli Narayana Murthy College, Narsapur, West Godavari – 534275 (Third Cycle)',
  'Srinivasa Institute of Engineering and Technology, Krapa Chintalapudi, Cheyyeru, East Godavari – 533216 (First Cycle)',
  'St. Ann’s College of Engineering and Technology, Chirala – 523187 (Second Cycle)',
  'Tirumala Engineering College, Narasaraopet, Guntur – 522601 (First Cycle)',
  'Vemuri Sundara Ramaiah Government Degree and P. G. College, Krishna, Movva, Machilipatnam – 521135 (Third Cycle)',
  'Vignan’s Institute of Information Technology, Duvvada, Gajuwaka, Visakhapatnam – 530049 (Second Cycle)',
  'Y. V. N. R. Government Degree College, Kaikaluru, Krishna – 521333 (Second Cycle)',
  'GIET Engineering College, Chaitanya Knowledge City, Velugubanda, Rajanagaram, Rajahmundry, East Godavari – 533296 (First Cycle)',
  'Nova College of Engineering and Technology, Jupudi, Ibrahimpatnam, Vijayawada – 521456 (First Cycle)',
  'Nova College of Pharmaceutical Education and Research, Jupudi, Krishna, Vijayawada – 521456 (First Cycle)',
  'Nova PG College, Jupudi, Ibrahimpatnam, Vijayawada – 521456 (First Cycle)',
  'Sanketika Vidya Parishad Engineering College (First Cycle)',
  'Srinivasarao College of Pharmacy (First Cycle)',
  'KBN COLLEGE, Kothapeta, Vijayawada-520 001 (Third Cycle)',
  'KAKANI VENKATA RATNAM COLLEGE,Kakani Nagar, Nandigama, Krishna - Dist. 521185,Nandigama , 521185 (Second Cycle)',
  'PRASAD V POTLURI SIDDHARTHA INSTITUTE OF TECHNOLOGY, Devabhakthuni Ramalingeswara Rao Road, Kanuru, Vijayawada - 520 007,Vijayawada , 520007 (Second Cycle)',
  'GOVERNMENT COLLEGE (AUTONOMOUS),D. NO. 26-1-10 NEAR Y-JUNCTION, CENTRAL JAIL ROAD,,RAJAHMUNDRY , 533105 (Third Cycle)',
  'SAI TIRUMALA NALABOTHU VENKATA RAO ENGINEERING COLLEGE,Oppo - Sai Baba Temple, Jonnalagadda Village, Narasaraopet Guntur dist, Andhra Pradesh , 522601, NARASARAOPET , 522601 (First Cycle)',
  'SRI VENKATESWARA ENGINEERING COLLEGE FOR WOMEN,OPPOSITE TO LIC TRAINING CENTRE,KARAKAMBADI ROAD, Tirupathi , 517507 (First Cycle)',
  'ADITYA INSTITUTE OF TECHNOLOGY AND MANAGEMENT,Tekkali, Srikakulam-Dist,Tekkali , 532201 (Second Cycle)',
  'CHEBROLU ENGINEERING COLLEGE,NEAR POWER STATION CHEBROLU,Guntur , 522212 (First Cycle)',
  'M.S.NAICKER DEGREE COLLEGE, Yanam Road, Turangi, East Godavari District., Kakinada , 533016 (Second Cycle)',
  'S.V.A. GOVT. COLLEGE, SRIKALAHASTI,Pichatur Road, Srikalahasti - 517644, Chittoor District, Andhra Pradesh, India.,Srikalahasti , 517644 (Third Cycle)',
  'GATES INSTITUTE OF TECHNOLOGY,NH 44, Gootyanantapuram Village, Gooty, Anantapuramu Dist Andhra Pradesh,Gooty , 515401 (First Cycle)',
  'SRI SUNFLOWER COLLEGE OF ENGINEERING AND TECHNOLOGY,LANKAPALLI, GHANTALASALA MANDAL, KRISHNA DISTRICT ANDHRA PRADESH, Lankapalli , 531131 (First Cycle)',
  'ANNAMACHARYA INSTITUTE OF TECHNOLOGY AND SCIENCES,Tallapaka Panchayath, New Boyanapalli (post) Rajampet-516126, RAJAMPET , 516126 (Re-assessment, Second Cycle)',
  'NARAYANA ENGINEERING COLLEGE,Gudur , 524101 , Durjati Nagar,Gudur, Nellore dist,Gudur , 524101 (First Cycle)',
  'GOVERNMENT COLLEGE FOR WOMEN,Government College for Women (A), Sambasivapeta, Guntur, 522001,Guntur,Andhra Pradesh,522001 (Third Cycle)',
  'GOVERNMENT COLLEGE FOR MEN KURNOOL,AP Housing Board Colony, B-Camp, Kurnool. Andhra Pradesh,Kurnool,Andhra Pradesh,518002 (Third Cycle)',
  'C.S.T.S.GOVERNMENT KALASALA,Srinivasapuram Road, Near Govt. Hospital,JANGAREDDIGUDEM,Andhra Pradesh,534447 (Second Cycle)',
  'K. T. S. GOVT. DEGREE COLLEGE,Near Maddaneswara Swamy Temple 74 Udegolam Rayadurg,Rayadurg,Andhra Pradesh,515867 (First Cycle)',
  'S.Y.T.R. GOVERNMENT DEGREE COLLEGE,MADAKASIRA,S.Y.T.R. Government Degree College, Madakasira,Ananthapur(Dist),A.P-515301,Madakasira,Andhra Pradesh,515301 (First Cycle)',
  'PARVATHANENI BRAHMAYYA SIDDHARTHA COLLEGE OF ARTS AND SCIENCE (AUTONOMOUS), D.No.60-1-2/3 Siddhartha Nagar Moghalrajpuram,Vijayawada,Andhra Pradesh,520010 (Third Cycle)',
  'GOVERNMENT DEGREE COLLEGE, RAYACHOTI, Chittoor Road, Rayachoty, Kadapa Dist. AP,Rayachoty,Andhra Pradesh,516269 (First Cycle)',
  'SRI KAMISETTY SUBBA RAO CHENNAMMA DEGREE COLLEGE, D. NO .7/101, KORRAPADU ROAD,PRODDATUR,Andhra Pradesh,516361 (First Cycle)',
  'K.G.R.L. COLLEGE, DIRUSUMARRU ROAD, BHIMAVARAM,WEST GODAVARI DISTRICT, ANDHRA PRADESH, PIN CODE- 534201,BHIMAVARAM,Andhra Pradesh,534201 (Second Cycle)',
  'GOVERNMENT DEGREE COLLEGE FOR WOMEN , D/NO-979, TGP COLONY, SRIKALAHASTI, CHITTOOR DISTIRICT,SRIKALAHASTI,Andhra Pradesh,517644 (Second Cycle)',
  'GOVERNMENT COLLEGE FOR MEN , RIMS ROAD BESIDE NEW COLLECTORATE KADAPA,KADAPA,Andhra Pradesh,516004 (Third Cycle)',
  'MOTHER THERESA INSTITUTE OF ENGINEERING AND TECHNOLOGY , Melumoi Post, Palamaner, Chittoor Dist,PALAMANER,Andhra Pradesh,517408 (First Cycle)',
  'VISAKHA INSTITUTE OFENGINEERING AND TECHNOLOGY , VISAKHA INSTITUTE OF ENGINEERING AND TECHNOLOGY 57th DIVISION,NARAVA,VISAKHAPATNAM,530027,VISAKHAPATNAM,Andhra Pradesh,530027 (First Cycle)',
  'SRI VASAVI INSTITUTE OF ENGINEERING AND TECHNOLOGY , Nandamuru Pedana Mandal Krishna District,NANDAMURU PEDANA MANDAL KRISHNA DIST,Andhra Pradesh,521369 (First Cycle)',
  'SEICOM DEGREE COLLEGE,Maruthi Nagar, AIR Bypass Road, Tirupati, Andhra Pradesh,517502 (First Cycle)',
  'K.T.R.WOMENS COLLEGE,KONDAPALLI THATHI REDDY WOMENS COLLEGE, 17/320 CHOWDARY PETA GUDIVADA KRISHNA DISTRICT ANDHRA PRADESH PIN 521301 (Second Cycle)',
  'N B K R SCIENCE AND ARTS COLLEGE,COLLEGE ROAD, VIDYANAGAR, GUDALI PANCHAYATH, KOTA MANDAL, SPSR.NELLORE DISTRICT, ANDHRA PRADESH-524413 (Third Cycle)',
  'SRI MITTAPALLI COLLEGE OF ENGINEERING,NH-16, THUMMALAPALEM,GUNTUR,Andhra Pradesh,522233 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE PADERU,GOVERNMENT DEGREE COLLEGE, SUNDRUPUTTU, PADERU VISAKHAPATNAM ANDHRA PRADESH -531024(Second Cycle)',
  'NARAYANA ENGINEERING COLLEGE,Narayana Avenue, Muthukur Road, Nellore,Nellore,Andhra Pradesh,524004 (First Cycle)',
  'DANTULURI NARAYANA RAJU COLLEGE(D.N.R) AUTONOMOUS,BALUSUMUDI, BHIMAVARAM, WEST GODAVARI DISTRICT, ANDHRA PRADESH, INDIA PIN - 534202,BHIMAVARAM,Andhra Pradesh,534202 (Third Cycle)',
  'DNR COLLEGE OF ENGINEERING AND TECHNOLOGY,BALUSUMUDI BHIMAVARAM WESTGODAVARI DISTRICT,BHIMAVARAM,Andhra Pradesh,534202 (First Cycle)',
  'GDMM COLLEGE OF ENGINEERING AND TECHNOLOGY,OPPOSITE DVR COLONY,RAMANAPETA ROAD NANDIGAMA KRISHNA DISTRICT ANDHRA PRADESH-521185,NANDIGAMA,Andhra Pradesh,521185 (First Cycle)',
  'BESANT THEOSOPHICAL COLLEGE,Besant Theosophical College, 1-555, Bandameeda Kammapalle, Opp. MRO Office, Giri Rao Street, Madanapalle, Chittoor District.,MADANAPALLE,Andhra Pradesh,517325 (First Cycle)',
  "ST. JOSEPH'S COLLEGE FOR WOMEN(AUTONOMOUS),D.No.34-3-42 Gnanapuram Visakhapatnam,VISAKHAPATNAM,Andhra Pradesh,530004 (Fourth Cycle)",
  'MARIS STELLA COLLEGE (AUTONOMOUS),MARIS STELLA COLLEGE (AUTONOMOUS), OPP GOVT POLYTECHNIC COLLEGE, NEAR BENZ CIRCLE.,VIJAYAWADA,Andhra Pradesh,520008 (Fourth Cycle)',
  'PRAKASAM ENGINEERING COLLEGE,O V ROAD KANDUKUR PRAKASAM DISTRICT,KANDUKUR,Andhra Pradesh,523105 (First Cycle)',
  'SWARNANDHRA INSTITUTE OF ENGINEERING AND TECHNOLOGY,Seetharampuram, WEST GODAVARI,NARSAPUR,Andhra Pradesh,534280 (Second Cycle)',
  'GAYATRI VIDYA PARISHAD COLLEGE FOR DEGREE AND PG COURSES (AUTONOMOUS),Sector 8 MVP Colony,VISAKHAPATNAM,Andhra Pradesh,530017 (Second Cycle)',
  'SATYA INSTITUTE OF TECHNOLOGY AND MANAGEMENT,GAJULAREGA,,KONDAKARAKAM (PO), VIZIANAGARAM,Andhra Pradesh,535001 (First Cycle)',
  'PEDANANDIPADU COLLEGE OF ARTS AND SCIENCES,MRO OFFICE ROAD PEDANANDIPADU (POST MANDAL) GUNTUR(DT) - 522 235,Andhra Pradesh,522235 (Second Cycle)',
  'Rajamahendri Institute of Engineering and Technology,Bhoopla Patnam, Near Pidim Goyyi, Rajanagaram Mandal, Rajamahendravaram,East Godavari - 533107 (First Cycle)',
  'J.M.J. College for Women,(Autonomous), 32-1-20, Sarala Nagar, Morispet,Tenali - 522202 (Fourth Cycle)',
  'Avanthi Institute of Engineering and Technology,Cherukupalli(V), Near Tagarapuvalasa Bridge, Bhogapuram(M),Vizianagaram - 531162 (First Cycle)',
  'Kakinada Institute of Engineering and Technology,Yanam Road, Korangi Tallarevu Madal, East Godavari,Kakinada - 533461 (First Cycle)',
  'Annamacharya Institute of Technology and Sciences, Tirupati (Re-assessment),Karakambadi Road, Venkatapuram (Village), Renigunta (Mandal), Tirupati,Chittoor - 517520 (First Cycle)',
  'Aditya College of Engineering,Aditya Nagar, ADB Road, Surampalem, East Godavari ,Surampalem - 533437 (First Cycle)',
  'Godavari Institute of Engineering and Technology,NH-16, Chaitanya Knowledge City,Rajamahendravaram - 533296 (Second Cycle)',
  'Sri Venkatesa Perumal College of Engineering and Technology,R V S Nagar, K N Road, Puttur,Chittoor - 517583 (Second Cycle)',
  'Bonam Venkata Chalamayya Engineering College,Odalarevu, Allavaram Mandal,East Godavari - 533210 (Second Cycle)',
  'Loyola Degree College (YSRR),3-7-7, Bakarapuram, Near YSR Park,Pulivendla - 516390 (Third Cycle)',
  'Viswanadha Institute of Technology and Management,Mindivanipalem (Village), Sontyam(Post), Anandapuram(Mandal),Visakhapatnam - 531173 (First Cycle)',
  'S.M.B.T.A.V. and S.N. Degree College,D.No. 4-121, Indira Malaya Maruthi Mahal, P.P. Road, Veeravasaram,West Godavari - 534245 (First Cycle)',
  'Sree Vidyanikethan Engineering College (Autonomous),Sree Sainath Nagar, A Rangampet, Chandragiri Mandal, Chittoor District,Tirupati - 517102 (Second Cycle)',
  'Krishna Teja Pharmacy College,Chadalawada Nagar Renigunta Road Tirupathi ,Chittoor - 517506 (Second Cycle)',
  'Ideal College of Arts and Sciences,D.No. 9-1-66 Near Indrapalem Locks Samalkot Road,Kakinada - 533004 (Second Cycle)',
  'K.S.R.M. College of Engineering,Yerramasu Palli, C. K. Dinne Mandal ,Kadapa - 516003 (Second Cycle)',
  'Lakireddy Bali Reddy College of Engineering,L.B. Reddy Nagar, Mylavaram,Krishna - 521230 (Second Cycle)',
  'SKSD Mahila Kalasala UG and PG (Autonomous),Old Town, Peravali Road,Tanuku - 534211 (Third Cycle)',
  'A. S. D. Government Degree College for Women,Jagannaickpur,Kakinada- 533002 (Third Cycle)',
  'Adarsh College of Engineering, Chebrolu,NH-216, Chebrolu, Gollaprolu Mandal,East Godavari - 533449',
  'V.S.R and N.V.R College,D.No.29-1-1 Ithanagar Tenali,Guntur - 522201 (Third Cycle)',
  'Rang Frah Government College, Changlang – 792120 (Second Cycle)',
  'Indira Gandhi Government College, Lohit, Tezu – 792001 (Second Cycle)',
  'Saint Claret College, Ziro – 791120 (First Cycle, assessed as per old methodology)',
  'DERA NATUNG GOVERNMENT COLLEGE,VIVEK VIHAR, PO-R. K. MISSION, ITANAGAR , 791113 (Third Cycle)',
  'JAWAHARLAL NEHRU COLLEGE, PASIGHAT,P.O. Hill Top, East Siang District,Pasighat , 791103 (Third Cycle)',
  'Abhayapuri College, Bongaigaon – 783384 (Second Cycle)',
  'Anandaram Dhekial Phookan College, Haibargaon, Nagaon – 782002 (Second Cycle)',
  'B. H. College, Howly, Barpeta – 781316 (Second Cycle)',
  'B. P. Chaliha College, Kamrupp, Nagabera – 781127 (Second Cycle)',
  'Bahona College, P. O. Bahona, Jorhat – 785101 (Second Cycle)',
  'Barnagar College, Sorbhog, Barpeta – 781317 (Second Cycle)',
  'Bengtol College, Bengtol, Chirang, Btad, Bongaigaon – 783394 (First Cycle)',
  'Bhawanipur Anchalik College, Barpeta – 781352 (Second Cycle)',
  'Birjhora Mahavidyalaya, Bongaigaon – 783380 (Second Cycle)',
  'Biswanath College, Dist. Sonitpur, Biswanath Chariali – 784176 (Second Cycle)',
  'Chhaygaon College, Kamrup, Chhaygaon – 781124 (Second Cycle)',
  'Chilarai College, Golakganj, Dhubri – 783334 (Second Cycle)',
  'Dakha Devi Rasiwala College, Chabua, Dibrugarh – 786184 (Second Cycle)',
  'Dhubri Law College, Dhubri – 783324 (First Cycle)',
  'Digboi College, Tinsukia, Digboi – 786171 (Second Cycle)',
  'Dispur College, Dispur, Guwahati – 781006 (Second Cycle)',
  'Dudhnoi College, Guwahati – 783124 (Second Cycle)',
  'Gogamukh College, P.O. Gogamukh, Dhemaji – 787034 (Second Cycle)',
  'Goreswar College, Baksa (Btad), Rangia – 781366 (Second Cycle)',
  'Gossaigaon College, Kokrajhar – 783360 (Second Cycle)',
  'Guwahati College, Kamrup Metro, 781021 (Second Cycle)',
  'Haji Anfor Ali College, Nagaon, Doboka – 782440 (Second Cycle)',
  'Hojai College, Nagaon, Hojai – 782435 (Second Cycle)',
  'Janata College, Serfanguri, Kokrajhar – 783346 (Second Cycle)',
  'Jhanji Hemnath Sarma College, Sibsagar – 785683 (Second Cycle)',
  'Jnanadabhiram Borooah Law College, Chandmari, Guwahati – 781003 (First Cycle)',
  "K. R. B. Girl's College, Fatashil, P.O. Bharalumukh, Guwahati – 781009 (Second Cycle)",
  'Kaliabor College, Kuwaritol, Nagaon – 782137 (Second Cycle)',
  'Kharupetia College, Darrang, P.O. Kharupetia, Mangaldoi – 784115 (Second Cycle)',
  'Khowang College, Khowang Ghat, Dibrugarh – 785676 (Second Cycle)',
  'Kokrajhar Government College, Kokrajhar – 783370 (Second Cycle)',
  'Lanka Mahavidyalaya, Rongmahal, Dist. Nagaon, Lanka – 782446 (Second Cycle)',
  'Madhab Choudhury College, Barpeta, 781301 (Second Cycle)',
  'Margherita College, Dist. Tinsukia, 786181 (Second Cycle)',
  'Moridhal College, Dist. Dhemaji, 787057 (Second Cycle)',
  'Murkong Selek College, Dhemaji, Jonai – 787060 (Second Cycle)',
  'Nabajyoti College, Kalgachia, Barpeta – 781319 (Second Cycle)',
  'Naharkatiya College, Naharkatia, Dibrugarh – 786610 (Second Cycle)',
  'Nanda Nath Saikia College, Titabar, Jorhat – 785630 (Second Cycle)',
  'Nehru College, Cachar, Pailapool – 788098 (Second Cycle)',
  'North Gauhati College, P. O. College Nagar, Guwahati – 781031 (Second Cycle)',
  "Nowgong Girls' College, Nagaon, 782002 (Second Cycle)",
  'Paschim Guwahati Mahavidyalaya, Dharapur, Azara, Kamrup, Guwahati – 781133 (Second Cycle)',
  'Pramathesh Barua College, Gauripur, Dhubri – 783331 (Second Cycle)',
  'Pub-Kamrup College, Kamrup, 781381 (Second Cycle)',
  'Purbanchal College, Silapathar, Dhemaji – 787059 (First Cycle)',
  'Radha Govinda Baruah College, Guwahati – 781025 (Second Cycle)',
  'Radhamadhab College, Silchar – 788006 (Second Cycle)',
  'Raha College, Nagaon, Raha – 782103 (Second Cycle)',
  'Rupahi College, Rupahi, Nagaon – 782125 (Second Cycle)',
  'S. B. Deorah College, Ulubari, Guwahati – 781007 (Second Cycle)',
  'Sapatgram College, Dhubri, Sapatgram – 783337 (Second Cycle)',
  'Saraighat College, Kamrup – 781101(Second Cycle)',
  'Science College, Kokrajpur – 783370 (First Cycle)',
  'Sibsagar Commerce College, Dist. Sivasagar, 785640 (Second Cycle)',
  'Silapathar College, Dhemaji, Silapathar – 787059 (Second Cycle)',
  'Sonapur College, Sonapur, Guwahati, 782402 (Second Cycle)',
  'Sualkuchi Budram Madhab Satradhikar College, Kamrup, Guwahati – 781103 (Second Cycle)',
  'Suren Das College, P.O. Hajo, Kamrup, 781102 (Second Cycle)',
  'Swahid Peoli Phukan College, Sivasagar, 785684 (Second Cycle)',
  'Teok - C. K. B. College, Dist. Jorhat, Teok – 785112 (Second Cycle)',
  'Tingkhong College, Dibrugarh – 786612 (Second Cycle)',
  'Amguri College, Sibsagar – 785680 (Second Cycle)',
  'Arya Vidyapeeth College, Guwahati – 781016 (Second Cycle)',
  'B. H. B. College, Barpeta, Sarupeta – 781318 (Second Cycle)',
  'Bajali College, Pathsala, Barpeta – 781325 (Second Cycle)',
  'Baosi Banikanta Kakati College, Nagaon, Barpeta – 781311 (Second Cycle)',
  'Bapujee College, Sarukshetri, Sarthebari, Barpeta – 781307 (Second Cycle)',
  'Barama College, Nalbari – 781346 (Second Cycle)',
  "Barpeta Girls' College, Barpeta – 781301 (Second Cycle)",
  'Bholanath College, Dhubri – 783324 (Third Cycle)',
  'Bijni College, Chirang, Bijni – 783390 (Second Cycle)',
  'Bikali College, Dhupdhara, Gioalpara – 783123 (Third Cycle)',
  'Chandra Kamal Bezbaruah Commerce College, Jorhat – 785001 (Second Cycle)',
  'Cotton College, Guwahati – 781001 (Third Cycle)',
  'Dakshin Kamrup Girls’ College, Kamrup – 781125 (Second Cycle)',
  'Demow College, Demow, Sivasagar, Sibsagar – 785662 (Second Cycle)',
  'Dhakuakhana College, North Lakhimpur – 787055 (Second Cycle)',
  'Dhing College, Dhing, Nagaon -782123 (Second Cycle)',
  'Dibru College, Boiragimoth, Dibrugarh – 786003 (Second Cycle)',
  'Dibrugarh H. S. Kanoi College, K. C. Gogoi Path, Dibrugarh – 786001 (Second Cycle)',
  'Furkating College, Jorhat – 785610 (Third Cycle)',
  'G. L. Choudhury College, Barpeta – 781315 (First Cycle)',
  'Gurucharan College, Silchar – 788004 (Second Cycle)',
  'Habraghat Mahavidyalaya, Goalpara – 783126 (Second Cycle)',
  'Hem Chandra Dev Goswami College, Nitaipukhuri, Sivasagar – 785671 (Second Cycle)',
  'Jagiroad College, Morigaon , Jagiroad – 782410 (Second Cycle)',
  'Jengraimukh College, Jorhat – 785105 (Second Cycle)',
  'Jorhat Kendriya Mahavidyalaya, Jorhat – 785010 (Second Cycle)',
  'Kakojan College, Jorhat – 785107 (Second Cycle)',
  'Kamrup College, Nalbari – 781306 (Second Cycle)',
  'Khagarijan College, Chotahaibor, Nagaon Sadar, Nagaon – 782003 (Second Cycle)',
  'Kherajkhat College, Deotola, North Lakhimpur – 787033 (First Cycle)',
  'L. T. K. College, North Lakhimpur – 787031 (Second Cycle)',
  'Madhab Chandra Das College, Sonaimukh, Silchar – 788119 (Second Cycle)',
  'Madhya Kamrup College, Barpeta – 781305 (Second Cycle)',
  'Mahendra Narayan Choudhury Balika Mahavidyalaya, Nalbari – 781335 (Second Cycle)',
  'Mankachar College, Dhubri – 783131 (Second Cycle)',
  'Mariani College, Mariani, Jorhat – 785634 (Second Cycle)',
  'Moirabari College, Marigaon – 782126 (Second Cycle)',
  'Nagaon G. N. D. G. Commerce College, Nagaon – 782001 (Second Cycle)',
  'Nalbari Commerce College, Nalbari – 781335 (Second Cycle)',
  'Nirmal Haloi College, Patacharkuchi, Barpeta – 781326 (Second Cycle)',
  'North Bank College, Ghilamara, North Lakhimpur – 787053 (Second Cycle)',
  'North Kamrup College, Baghmara, Barpeta – 781328 (Second Cycle)',
  'Nowgong College, Nagaon – 782001 (Third Cycle)',
  'Panigaon Omprakash Dinodia College, North Lakhimpur – 787052 (Second Cycle)',
  'Rangachahi College, Majuli, Jorhat – 785104 (Second Cycle)',
  'Ratnapith College, Chapar, Dhubri – 783371(Second Cycle)',
  'Sibsagar College, Joysagar, Sivasagar, Sibsagar – 785665 (Second Cycle)',
  'Sipajhar College, Mangaldoi – 784145 (Second Cycle)',
  'Tengakhat College, Dibrugarh - 786103 (Second Cycle)',
  'Tihu College, Nalbari – 781371 (Second Cycle)',
  'Tinsukia College, Tinsukia – 786125 (Second Cycle)',
  'Tinsukia Commerce College, Sripuria, Tinsukia – 786145 (Second Cycle)',
  'Udalguri College, Udalguri – 784509 (Second Cycle)',
  'West Goalpara College, Ambari, Balarbhita, Goalpara – 783129 (Second Cycle)',
  'Women’s College, Durgabari, Tinsukia – 786125 (Second Cycle)',
  'Chaiduar College, Gohpur, Biswanath (Sonitpur) – 784168 (Third Cycle)',
  'Digboi Mahila Mahavidyalaya (Second Cycle)',
  'Madhabdev College (Second Cycle)',
  'Mangaldai College ,Upahupara, Mangaldai ,Darrang - 784125 (Second Cycle)',
  'D. H. S. K. Commerce College,K.C. Gogoi Path ,Dibrugarh - 786001 (Second Cycle)',
  'Majuli College ,Kamalabari,Majuli - 785106 (Second Cycle)',
  'Harhi College,Gobindapur,Lakhimpur - 787055 (First Cycle)',
  'Lumding College,Lumding,Hojai - 782447 (Second Cycle)',
  'Dhemaji Commerce College,Aradhal ,Dhemaji - 787057 (Second Cycle)',
  'Jagannath Barooah College,Barpatra Ali,Jorhat - 785001 (Third Cycle)',
  "Manohari Devi Kanoi Girls' College,K.C.Gogoi Path, Kadamoni,Dibrugarh - 786001 (Third Cycle)",
  'MORIGAON COLLEGE,Jyotinagar, Ward no. 8,Morigaon , 782105 (Third Cycle)',
  'DARRANG COLLEGE,MAHABHAIRAB ROAD, TEZPUR,TEZPUR , 784001 (Third Cycle)',
  'THE GARGAON COLLEGE,Gargaon College. P.O. Simaluguri.,SIVASAGAR , 785686 (Third Cycle)',
  "GIRLS' COLLEGE, KOKRAJHAR, Kokrajhar, Narabari, PO, Dist- Kokrajhar, BTC, Assam,Kokrajhar , 783370 (First Cycle)",
  'BILASIPARA COLLEGE,Bilasipara w.no. 14 PO- Bilasipara PS- Bilasipara,Dhubri , 783348 (Second Cycle)',
  'KAMARGAON COLLEGE, KAMARGAON COLLEGE, P.O.-KAMARGAON, P.S.-KAMARGAON, SUB DIVISION-BOKAKHAT,GOLAGHAT , 785619 (Third Cycle)',
  'NALBARI COLLEGE,Nalbari P.O. Dist Nalbari Assam,NALBARI , 781335 (Second Cycle)',
  'LEDO COLLEGE, P.O.- LEDO DISTRICT- TINSUKIA, Ledo , 786182 , LEDO (First Cycle)',
  'PANDU COLLEGE,Pandu Guwahati Kamrup Metro,Guwahati , 781012 (Third Cycle)',
  'BONGAIGAON COLLEGE, P.O. DIST. BONGAIGAON,Bongaigaon,Assam,783380 (Third Cycle)',
  'LAKHIMPUR KENDRIYA MAHAVIDYALAYA,Lakhimpur Kendriya Mahavidyalaya ,P.O. Charaimoria, North Lakhimpur, Pin- 787032, Dist- Lakhimpur, Assam,LAKHIMPUR,Assam,787032 (Second Cycle)',
  'DEVICHARAN BARUA GIRLS COLLEGE,K. K. Barooah Road, Tarajan,JORHAT,Assam,785001 (Third Cycle)',
  'HAFLONG GOVERNMENT COLLEGE,College Road, Haflong, Dist- Dima Hasao,HAFLONG,Assam,788819 (First Cycle)',
  'TEZPUR COLLEGE,Tezpur College Kalibari Road, Near Central Jail Dist- Sonitpur,Tezpur,Assam,784001 (Third Cycle)',
  'JOGANANDA DEVA SATRADHIKAR GOSWAMI(J.D.S.G.) COLLEGE,P.O. Bokakhat, District-Golaghat,Bokakhat Golaghat,Assam,785612 (Third Cycle)',
  'North Lakhimpur College,P.O. Khelmati, Dist. Lakhimpur,North Lakhimpur - 787031 (Third Cycle)',
  'A. P. Singh Memorial College, Barauni, Begusarai – 851112 (Second Cycle)',
  'Acharya Narendra Dev College, Samastipur – 848504 (Second Cycle)',
  'B.M.D. College, Vaishali, 844502 (First Cycle)',
  'Bali Ram Bhagat College, Samastipur – 848101 (Second Cycle)',
  'Bilat Mahtha Adarsh Mahavidyalaya, Darbhanga – 847105 (Second Cycle)',
  'C.M. College (Arts & Commerce), Darbhanga, 846004 (Second Cycle)',
  'College of Arts & Crafts, Patna, 800001 (First Cycle)',
  'College of Commerce, Patna – 800020 (Second Cycle)',
  'Dharma Samaj Sanskrit College, Muzaffarpur – 842001 (First Cycle)',
  'Dr. Ram Manohar Lohia Smarak Mahavidyalaya, Muzaffarpur – 842002 (First Cycle)',
  'Gajadhar Bhagat College, Naugachia, Bhagalpur – 853204 (First Cycle)',
  'Government Sanskrit College, Rajendra Nagar, Patna – 800004 (First Cycle)',
  'Hotilal Ram Nath College, Amnour, Saran – 841401 (First Cycle)',
  'Jhumak Mahaseth Dr. Dharampriya Lal Mahila College, Madhubani – 847211 (First Cycle)',
  'Kedar Sant Ramasharya College, Samastipur, 848127 (First Cycle)',
  'Krishak College, Nawada – 805124 (First Cycle)',
  'Lakshmi Narayan College, Vaishali, 844114 (First Cycle)',
  'M. R. Mahila Mahavidyalaya, Darbhanga – 846004 (First Cycle)',
  'Magadh College of Education, Gaya – 823001 (First Cycle)',
  'Mahadeo Singh College, Bhagalpur, 812002 (First Cycle)',
  'Maharaj Lakshmishwar Singh Memorial College, Darbhanga – 846004 (First Cycle)',
  'Mahila College, Dehri-on-Sone (Rohtas) – 821307 (First Cycle)',
  'Marwari College, Bhagalpur, 812007 (Second Cycle)',
  'Marwari College, Darbhanga – 846004 (Second Cycle)',
  "Mithila Teachers' Training College, Darbhanga – 847223 (First Cycle)",
  'Narayan Mahavidyalaya, Goreakothi, Siwan – 841434 (First Cycle)',
  'Pandit Ugam Pandey College, Motihari – 845401 (First Cycle)',
  'Patna Training College, Patna – 800004 (First Cycle)',
  "Patna Women's College, Patna – 800001 (Third Cycle)",
  'Raj Narain College, Vaishali, 844101 (First Cycle)',
  'Rajendra College, Chapra – 841301 (First Cycle)',
  'Rajkiya Mahila Mahavidyalaya, Patna – 800007 (First Cycle)',
  'Ram Krishna Dwarika College, Patna, 800020 (First Cycle)',
  'Ram Lakhan Singh Yadav College, Bettiah Industrial Area, Bettiah – 845438 (First Cycle)',
  'Ramashray Baleshwar College, Dalsingsarai, Samastipur – 848114 (Second Cycle)',
  'Rameshwarlata Sanskrit College, Darbhanga, 846004 (First Cycle)',
  'S. Sinha College, Aurangabad – 824101 (First Cycle)',
  'Satyendra Narain Sinha College, Tekari, Gaya – 824236 (First Cycle)',
  'Sheodeni Ram Ayodhya Prasad College, Bara Chakia, Barmadia, East Champaran, Motihari - 845412 (First Cycle)',
  'Sheodeni Sao College, Kaler, Arwal – 824127 (First Cycle)',
  "St. Xavier's College of Education, Patna – 800011 (Third Cycle)",
  'Swami Sahjanand College, Jehanabad, 804408 (First Cycle)',
  'T. P. S. College, Chirayatand, Patna – 800001 (First Cycle)',
  'Tej Narain Banaili Law College, Bhagalpur – 812001 (First Cycle)',
  'Vaishali Mahila Mahavidyalaya, Hajipur – 844101 (First Cycle)',
  "Women's College, Opposite Sadar Thana, Samastipur, 848101 (Second Cycle)",
  'Anugrah Narayan College, Patna – 800013 (Third Cycle)',
  'Araria College, Jaiprakash Nagar, Araria – 854311 (First Cycle)',
  'Badri Narayan Mukteshwar College, Barhiya, Lakhisarai – 811302 (First Cycle)',
  'Baijnath Pandey Arya Sanskrit College, Siwan – 841226 (First Cycle)',
  'Bharti Mandan College, Rahika, Madhubani – 847238 (Second Cycle)',
  'C. M. Science College, Darbhanga – 846004 (Second Cycle)',
  'Dr. L. K. V. D. College, Tajpur, Samastipur – 848130 (Second Cycle)',
  'Ganga Devi Mahila Mahavidyalaya, Kankarbagh, Patna – 800020 (First Cycle)',
  'Gautam Buddha Mahila College, Murarpur, Gaya – 823001 (First Cycle)',
  'H. D. Jain College, Ara, Bhojpur – 802301 (First Cycle)',
  'Hari Narain Singh Institute of Teachers Education, Rohtas, Sasaram – 821113 (First Cycle)',
  'Jagjiwan College, Chandwa, Ara, Bhojpur – 802301 (First Cycle)',
  'Jamunilal Mahavidyalaya, Hajipur, Vaishali – 844101 (First Cycle)',
  'Janta Koshi College, Biraul, Darbhanga – 847203 (First Cycle)',
  'Khem Chand Tara Chand College, Kaurihar, Raxaul, East Champaran – 845405 (First Cycle)',
  'Kunwar Singh College, Laheriasarai, Darbhanga – 846003 (Second Cycle)',
  'Lalit Narain Tirhut Mahavidyalaya, Muzaffarpur – 842002 (First Cycle)',
  'M. P. Sinha Science College, Gobasahi, Muzaffarpur – 843146 (First Cycle)',
  'Madhepura College, Koshaulya, Madhepura, Patna – 852113 (First Cycle)',
  'Mahakavi Kalidas Suryadev College, Trimuhan, Chandauna, Jale, Darbhanga – 847303 (First Cycle)',
  'Mahanth Mahadevanand Mahila Mahavidyalaya, Arrah – 802301 (First Cycle)',
  'Mahanth Sheo Shankar Giri College, Areraj, Govindganj, East Champaran – 845411 (First Cycle)',
  'Maharani Janki Kuwar College, Bettiah – 845438 (First Cycle)',
  'Mahila Shilp Kala Bhawan College, Muzaffarpur – 842001 (First Cycle)',
  'Mata Manjharo Ajab Dayal Singh Teacher’s Training College, Dulour, Baradparawna, Jagdishpur, Bhojpur – 802158 (First Cycle)',
  'Millat Teachers’ Training College, Madhubani – 847212 (Second Cycle)',
  "Mirza Ghalib Teacher's Training College, Patna – 800014 (First Cycle)",
  'Muneshwar Singh Muneshwari Samta Mahavidyalaya, Jandaha, Vaishali, Muzaffarpur – 844505 (First Cycle)',
  'Munshi Lal Arya College, Akshay Nagar, Kasba, Purnia – 854330 (First Cycle)',
  'Nagendra Jha Mahila Mahavidyalaya, Laheriasarai, Darbhanga – 846003 (First Cycle)',
  'Nalanda College, Bihar Sharif, Nalanda – 803101 (First Cycle)',
  'Purnea College, Purnia – 854301 (First Cycle)',
  'R. D. and D. J. College, Shastri Nagar, Munger – 811201 (First Cycle)',
  'R. P. S. Teachers Training College, Danapur, Patna – 801503 (First Cycle)',
  'Ram Bahadur Singh College, Andour, Mohiuddin Nagar, Samastipur – 848502 (First Cycle)',
  'Ram Jaipal College, Chhapra, Saran – 841301(First Cycle)',
  'Ram Ratan Singh College, Mokama, Patna – 803302(First Cycle)',
  'Rameshwar Mahavidyalaya, Sikandarpur Kundal, Muzaffarpur – 842001 (First Cycle)',
  'Ramrup Prasad College, Bhergawan, Masaurhi, Patna – 804451 (First Cycle)',
  'S. B. College, Maulabagh, Bhojpur, Arrah – 802301 (First Cycle)',
  'Sabour College, Sabour, Bhagalpur – 813210 (First Cycle)',
  'Sachidanand College, Shahmal Khaira Deo, Balthari, Rohtas – 804453 (First Cycle)',
  'Sardar Vallabhbhai Patel College, Bhabua, Kaimur – 821101 (First Cycle)',
  'Shershah College, Kuaraich, Sasaram – 821115 (First Cycle)',
  'Shree Raghav Prasad Singh College, Jaintpur Estate, Muzaffarpur – 843123 (First Cycle)',
  'Shri Mahanth Shatanand Giri College, Sherghati, Gaya – 824211 (First Cycle)',
  'Somavati Mehtab Das College, Sripalpur, Punpun, Patna – 804453 (First Cycle)',
  'Sri Arvind Mahila College, Kazipur, Patna – 800004 (First Cycle)',
  'Sri Gadadhar Acharya Janta College, Rambagh, Bihta – 801103 (First Cycle)',
  'Sri Krishna Jubilee Law College, Gannipur, Muzaffarpur – 842001 (First Cycle)',
  'Sri Narayan Singh College, Motihari – 845401 (First Cycle)',
  'Sukdeo Mahto Janta Mahavidyalaya, Khajedih, Ladania, Madhubani – 847232 (First Cycle)',
  'Sunderwati Mahila Mahavidyalaya, Chhoti Khanjarpur, Bhagalpur - 812001 (Second Cycle)',
  'Swargiya Bishwanath Singh Sharma Mahavidyalaya, Begusarai – 851101 (First Cycle)',
  'T. P. Varma College, Narkatiaganj, West Champaran – 845455 (First Cycle)',
  'Udayanacharya Vidyakar Kavi College, Karama, Alamnagar, Madhepura – 852219 (First Cycle)',
  'Gautam Teachers Training College, Bihar Sharif, Nalanda – 803118 (First Cycle)',
  'Laxmi Narain Dubey College, Motihari – 845401 (First Cycle)',
  'Maharaja Bahadur Ram Ran Vijay Prasad Singh College (Maharaja College), Ara – 802301 (First Cycle)',
  'Mahatma Gandhi College, Sundarpur, Darbhanga – 846004 (First Cycle)',
  'Parwati Science College, Madhepura, 852113 (First Cycle)',
  'Ram Bilas Singh College, Teyai, Teghra, Begusarai – 851133 (First Cycle)',
  'S. N. S. Y. Degree College, Rambagh, Purnia – 854301 (First Cycle)',
  'Udayanacharya Rosera College, Rosera, Samastipur – 848210 (First Cycle)',
  'Mirza Ghalib College (First Cycle)',
  'Rohtas Mahila College,Kali Asthan, G. T. Road ,Sasaram - 821115 (First Cycle)',
  'Ramesh Jha Mahila College,Near Veer Kunwar Singh Chowk,Saharsa - 852201 (First Cycle)',
  'RAJA SINGH COLLEGE SIWAN,ANDAR ROAD , NEAR ADITYA FILLING STATION,SIWAN , 841226 (First Cycle)',
  'NITISHWAR MAHAVIDYALAYA,CLUB ROAD, RAMNA, MUZAFFARPUR,Muzaffarpur,Bihar,842002 (First Cycle)',
  'GAYA COLLEGE , Gaya College Rampur Gaya,Gaya,Bihar,823001 (Third Cycle)',
  'PATNA COLLEGE,Office of the Principal, Patna College, Patna University, Ashok Rajpath, Patna,PATNA,Bihar,800005 (First Cycle)',
  'Murarka College, Sultanganj, Bhagalpur,Bhagalpur,Bihar,813213 (First Cycle)',
  'SRI UGRATARA BHARTI MANDAN SANSKRIT COLLEGE,Sri Ugratara Bharti Mandan Sanskrit College, Mahishi, Saharsa,Mahishi (Saharsa),Bihar,852216 (First Cycle)',
  "JANAKI DEVI WOMEN'S COLLEGE,Bailey Road, Patna - 800023,PATNA,Bihar,800023 (Second Cycle)",
  'MUNSHI SINGH COLLEGE,Munshi singh college,chandmari,Motihari.,MOTIHARI,Bihar,845401 (Second Cycle)',
  'ANUGRAH MEMORIAL COLLEGE GAYA,Anugrah Memorial College Katari Hill Road Gaya-823001,Gaya,Bihar,823001 (First Cycle)',
  'PATNA LAW COLLEGE,Ranighat, Mahendru, Sultanganj,Patna,Bihar,800006 (First Cycle)',
  'MAGADH MAHILA COLLEGE, NORTH GANDHI MAIDAN,PATNA,Bihar,800001 (Third Cycle)',
  'PATNA SCIENCE COLLEGE,Ashok Rajpath, PATNA,Bihar,800005 (Second Cycle)',
  'ORIENTAL COLLEGE,Guzri Bazar, Patnacity,Patna,Bihar,800008 (First Cycle)',
  'R.B.B.M COLLEGE, B.R.A. Bihar University Campus, Muzaffarpur,Bihar,842001 (First Cycle)',
  'Dayanand Anglo Vedic College, Sector 10, Chandigarh – 160011 (Second Cycle)',
  'Dev Samaj College For Women, Sector 45-B, 160047 (Second Cycle)',
  'Government College of Commerce and Business Administration, Sector-42, 160036 (First Cycle)',
  'Post Graduate Government College for Girls, Sector 11, Chandigarh – 160011 (Second Cycle)',
  'Post Graduate Government College for Girls, Sector 42, Chandigarh – 160036 (Second Cycle',
  'Post Graduate Government College, Sector 46, Chandigarh – 160047 (Second Cycle)',
  'Regional Institute of English, Sector 32-C, Chandigarh – 160031 (First Cycle)',
  'Sri Guru Gobind Singh College, Sector 26, Chandigarh – 160019 (Second Cycle)',
  'Dev Samaj College of Education, Sector 36 B, Chandigarh – 160036 (Third Cycle)',
  'Goswami Ganesh Dutta Sanatan Dharma College, Sector 32-C, Chandigarh – 160030 (Third Cycle)',
  'Government College of Education, Sector 20-D, Chandigarh – 160020 (Second Cycle)',
  'Government Home Science College, Sector 10 – 160001 (Second Cycle)',
  'Mehr Chand Mahajan D. A. V. College for Women, Sector 36-A, Chandigarh – 160036 (Second Cycle)',
  'Post Graduate Government College, Sector 11, Chandigarh – 160011 (Second Cycle)',
  'GURU GOBIND SINGH COLLEGE FOR WOMEN,SECTOR-26, CHANDIGARH 160019,CHANDIGARH , 160019  (Third Cycle)',
  'B.C.S. Government P.G. College, Dhamtari, 493003 (Second Cycle)',
  'Bhilai Institute of Technology, Bhilai Nagar, Durg – 491001 (First Cycle',
  'Bhilai Mahila Mahavidyalaya, Bhilai – 490006 (First Cycle)',
  'Chhatrapati Shivaji Institute of Technology, Durg, 491001 (First Cycle)',
  'College of Education, Meduka, Bilaspur, 495117 (Second Cycle)',
  'Dr. Radhabai Government Navin Kanya Mahavidyalaya, Raipur, 492001 (First Cycle)',
  'Government College, Dist. Balod, 491225 (Second Cycle)',
  "Government D.B. Girls' P.G. College (Autonomous), Raipur, 492001 (Second Cycle)",
  'Government Danveer Tularam College, Dist. Durg, 491107 (First Cycle)',
  'Government Dr. Waman Wasudev Patankar Girls P.G. College, Durg, 491001 (Second Cycle)',
  'Government E. Raghavendra Rao Post Graduate Science College (Autonomous), Bilaspur, 495006 (Second Cycle)',
  'Government J.M.P. College, Dist. Bilaspur, 495330 (First Cycle)',
  'Government Jamuna Prasad Verma P. G. Arts and Commerce College, Bilaspur – 495001 (Second Cycle)',
  'Government M. M. R. Post Graduate College, Champa – 495671 (Second Cycle)',
  'Government Madan Lal Shukla College, Dist. Bilaspur, 495 555 (First Cycle)',
  'Government Mata Shabari Naveen Girls College, Bilaspur – 495006 (Second Cycle)',
  'Government Nehru College, Dist-Rajnandgaon, Dongargarh – 491445 (First Cycle)',
  'Government Niranjan Kesharwani College, Kota, Bilaspur – 495113 (Second Cycle)',
  'Gracious College of Education, Dist. Raipur, 493661 (First Cycle)',
  'Holy Cross Women’s College, Dist. Surguja, 497001 (Third Cycle)',
  'JES College, Bilaspur – 495550 (First Cycle)',
  'Konark College of Education, Dist. Janjgir-Champa, 495668 (First Cycle)',
  'Loyola College, Dist. Jashpur, 496225 (First Cycle)',
  'M.J. College, Bhilai, 490023 (First Cycle)',
  'Mansa College of Education, Kurud, Durg-Bhilai Nagar – 490024 (First Cycle)',
  'Shri Agrasen Girls College, Korba, 495678 (First Cycle)',
  'Shri Sandipani Shiksha Mahavidyalaya, Dist. Janjgir-Champa, 495556 (First Cycle)',
  'Shyam Shiksha Mahavidyalaya, Janjgir-Champa Dist, 495689 (First Cycle)',
  'St. Xavier’s College of Education, Surguja Dist, 497001 (First Cycle)',
  'Swami Shri Swaroopanand Saraswati Mahavidyalaya, Durg - Bhilai Nagar Dist, 490009 (First Cycle)',
  "The Vidhya Protsahan Sangh's, St. Vincent Pallotti College, Raipur, 492005 (Second Cycle)",
  'Agrasen College, Dhanora, Hanoda, Durg-Bhilai Nagar – 491001 (First Cycle)',
  'Ayush College of Education, Bilaspur – 495118 (First Cycle)',
  'Chhattisgarh Vanijya Avam Vignan Mahavidyalay, Bhilai – 490006 (First Cycle)',
  'CLC Government Arts and Commerce College, Sirnabhata, Dhamdha, Durg-Bhilai Nagar – 491331 (First Cycle)',
  'D. P. Vipra College, Bilaspur – 495001 (First Cycle)',
  'Dr. B. S. Porte Government College, Pendra, Bilaspur – 495119 (First Cycle)',
  'Dr. B. S. Porte Government College, Pendra, Bilaspur – 495119 (First Cycle)',
  'G. D. Rungta College of Science and Technology, Bhilai – 490024 (First Cycle)',
  'Government Agrasen College, Mandi Road, Bilha, Bilaspur – 495224 (First Cycle)',
  'Government College of Education, Shankar Nagar, Raipur – 492007 (First Cycle)',
  'Government College, Bhaisma, Korba – 495674(First Cycle)',
  'Government D. S. V. Sanskrit College, Raipur – 492001 (First Cycle)',
  'Government Danteshwari P. G. College, Chitalanka, Teknar, Dantewada – 494449 (First Cycle)',
  'Government Dr. Baba Saheb Bhimrao Ambedkar College, Dongargaon – 491661 (First Cycle)',
  'Government Dr. Indrajeet Singh College, Khisora Road, Akaltara – 495552 (First Cycle)',
  'Government Engineer Vishwesarraiya Post Graduate College, Korba – 495677 (Second Cycle)',
  'Government G. N. A. P. G. College, Baloda Bazar, Bhatapara – 493118 (First Cycle)',
  'Government Kamla Devi Rathi Mahila Mahavidyalaya, Kaurinbhata, Rajnandgaon – 491441 (First Cycle)',
  'Government Lahiri College, Bada Bazar, Chirmiri – 497449 (First Cycle)',
  'Government Lal Chakradhar Shah College, Ambagarh Chowki, Rajnandgaon – 477227 (Second Cycle)',
  'Government Minimata Girls College, Korba – 495677 (First Cycle)',
  'Government N. C. J. College, Dalli Rajhara, Balod – 491228 (First Cycle)',
  'Government Pataleshwar College, Masturi, Bilaspur – 495551 (First Cycle)',
  'Government Pt. Madhav Rao Sapre College, Bilaspur – 495117 (First Cycle)',
  'Government Rajmohini Devi Girls P. G. College, Ambikapur – 497001 (Second Cycle)',
  'Government Ram Bhajan Rai N. E. S. Post Graduate College, Jashpurnagar – 496331 (First Cycle)',
  'Government Rewati Raman Mishra College, Surajpur – 497229 (First Cycle)',
  'Government Shivnath Science College, Gaurav Path, Rajnandgaon – 491441 (First Cycle)',
  'Government V. Y. T. P. G. Autonomous College, Durg-Bhilai Nagar – 491001 (Third Cycle)',
  'Government Vijay Bhushan Singhdeo Girls College, Jashpur Nagar, Jashpur – 496331 (First Cycle)',
  'Indira Gandhi Government Arts and Commerce College, Bhilai – 490023 (Second Cycle)',
  'Institute of Advanced Studies in Education (IASE), Bilaspur – 495001 (First Cycle)',
  'Jagrani Devi College of Education, Baradwar, Sakti, Janjgir, Champa – 495687 (First Cycle)',
  'Janki College of Education, Raigarh – 496001 (First Cycle)',
  'K. D. Rungta College of Science and Technology, Raipur – 492099 (First Cycle)',
  'Pt. Harishankar Shukla Memorial College, Raipur – 492007 (First Cycle)',
  'Rahod Education Society, Kharod, Pamgarh, Janjgir-Champa, Rahod – 495556 (First Cycle)',
  'Rungta College of Science and Technology, Bhilai Nagar, Durg – 491001 (First Cycle)',
  'Sant Guru Ghasidas Government Post Graduate College, Sanjay Nagar, Kurud, Dhamtari – 493663 (Second Cycle)',
  'Seth Phoolchand Agrawal Smriti Mahavidyalaya, Nawapara-Rajim, Raipur – 493881 (First Cycle)',
  'Seth R. C. S. Arts and Commerce College, Durg-Bhilai Nagar – 491001 (First Cycle)',
  'St. Thomas College, Ruabandha, Bhilai, Durg – 490006 (Third Cycle)',
  'Gyanroshini Lok Kalyan Sanstha, Khokhara, Janjgir, Champa – 495668 (First Cycle)',
  'Maharaja Agrasen International College, Raipur – 492001 (First Cycle)',
  'D. L. S. P. G. College, Ashok Nagar, Sarkanda, Bilaspur – 495006 (Re-Visit) (First Cycle)',
  'Shaskiya Mahaprabhu Vallabhacharya Snatkottar Mahavidyalaya (First Cycle)',
  'Rungta College of Engineering Technology, Raipur,Near Nandan Van, Veer Sawarkar Nagar,Raipur - 492099 (First Cycle)',
  'Shri Shankaracharya Technical Campus (Shri Shankaracharya Group of Institutions),Junwani,Bhilai - 490020 (First Cycle)',
  'Rungta College of Engineering and Technology,Rungta Educational Campus, Kohka Kurud Road,Bhilai - 490024 (First Cycle)',
  'Bhanupratapdeo Govt. P. G. College ,Main Road N.H.- 30,Kanker - 494334 (First Cycle)',
  'Govt. B.P. Arts Commerce College, Arang,Arang College Square,Arang - 493441 (First Cycle)',
  'Government Kavyopadhyay Hiralal College,On Rajim Road, Kathiya Mod Post Office- Abhanpur,Raipur - 493661 (First Cycle)',
  'Mahant Laxminarayan Das College,C/O Shiksha Pracharak Samiti, Gandhi Chowk,Raipur - 492001 (First Cycle)',
  'Rungta College of Pharmaceutical Science and Research,Kohka, Kurud Road, Bhilai ,Durg - 490024 (First Cycle)',
  'Kalyan Mahavidyalaya (Autonomous),Sector-7, Bhilai Nagar,Durg - 490006 (Third Cycle)',
  'Netaji Subhas College ,Belbhatha, Po.-P.Jamgaon, Abhanpur,Raipur - 493661 (First Cycle)',
  'Durga Mahavidyalya, Raipur,K.K. Road, Moudha Para,Raipur - 492001 (First Cycle)',
  'GOVERNMENT J. YOGANANDAM CHHATTISGARH COLLEGE, BYRAN BAZAR, RAIPUR,YRAN BAZAR, RAIPUR,RAIPUR , 492001 (Second Cycle)',
  'GOVT. PT. SHYAMACHARAN SHUKLA COLLEGE, DHARSIWA, RAIPUR , DIST-RAIPUR(C.G.),Dharsiwa , Raipur (C.G.),Dharsiwa Raipur , 493221 (First Cycle)',
  'RAJIV GANDHI GOVERNMENT ARTS AND COMMERCE COLLEGE, LORMI,Lormi, District-Mungeli,LORMI , 495115 (First Cycle)',
  'RAJEEV GANDHI GOVERNMENT POST GRADUATE COLLEGE AMBIKAPUR CHHATTISGARH,MANENDRAGARH ROAD AMBIKAPUR, SURGUJA, CHHATTISHGARH,AMBIKAPUR , 497001 (Second Cycle)',
  'GOVERNMENT DIGVIJAY COLLEGE (AUTONOMOUS),Kila Para, Ward No. 21, Rajnandgaon Chhattisgarh,Rajnandgaon,Chhattisgarh,491441 (Third Cycle)',
  'SHASKIYA MATAKARMA GIRLS COLLEGE, MAHSAMUND,Chhattisgarh,493445 (First Cycle)',
  'Shree Macchi Mahajan Education Society’s College of Education, Kathiria – 396210 (Second Cycle)',
  'Government College, Bhenslore, Kunta Road, Nani Daman - 396210 (First Cycle)',
  'Acharya Narendra Dev College, Kalkaji – 110019 (First Cycle)',
  'Bhagini Nivedita College, Delhi – 110043 (First Cycle)',
  'Bharati College, University of Delhi, Janakpuri,Delhi – 110058 (First Cycle)',
  'Fairfield Institute of Management and Technology, Delhi – 110037 (First Cycle)',
  'Gargi College, New Delhi – 110049 (First Cycle)',
  'Indraprastha College for Women, Delhi – 110054 (First Cycle)',
  'Institute of Innovation in Technology and Management, Janakpuri – 110058 (First Cycle)',
  'Jagannath International Management School, Kalkaji – 110019 (First Cycle)',
  'Jesus and Mary College, Chanakyapuri ,110021 (First Cycle)',
  'Keshav Mahavidyalaya, Pitampura – 110034 (First Cycle)',
  'Lady Shri Ram College for Women, Delhi – 110024 (First Cycle)',
  'Maharshi Valmiki College of Education, Delhi – 110031 (First Cycle)',
  'Mata Sundri College for Women, Delhi – 110002 (First Cycle)',
  'Motilal Nehru College, Delhi – 110021 (First Cycle)',
  'Northern India Engineering College,Shastri Park, 110053 (First Cycle)',
  'P. G. D. A. V. College, New Delhi – 110065 (First Cycle)',
  'Ramanujan College, Kalkaji – 110059 (First Cycle)',
  'Shaheed Rajguru College of Applied Sciences for Women, Delhi – 110096 (First Cycle)',
  'Shaheed Sukhdev College of Business Studies,Delhi – 110095 (First Cycle)',
  'Shivaji College, Delhi – 110027 (First Cycle)',
  'Sri Guru Gobind Singh College of Commerce,Delhi – 110034 (First Cycle)',
  'Sri Venkateswara College, Dhaula Kuan – 110021 (First Cycle)',
  "St. Stephen's College, Delhi – 110007 (First Cycle)",
  'Vivekananda Institute of Professional Studies, Pitampura – 110034 (First Cycle)',
  'Atma Ram Sanatan Dharma College, Dhaula Kuan, Delhi – 110021 (First Cycle)',
  'Banarsidas Chandiwala Institute of Hotel Management and Catering Technology, Delhi - 110019 (Second Cycle)',
  'Bhim Rao Ambedkar College, Yamuna Vihar, Delhi – 110094 (First Cycle)',
  'College of Vocational Studies, Triveni, Sheikh Sarai Phase – II, New Delhi – 110017 (First Cycle)',
  'Daulat Ram College, Patel Marg, Maurice Nagar – 110007 (First Cycle)',
  'Delhi College of Arts and Commerce, Netaji Nagar – 110023 (First Cycle)',
  'Delhi School of Professional Studies and Research, Sector 25, Rohini – 110085 (First Cycle)',
  'Deshbandhu College, Kalkaji, Delhi – 110019 (First Cycle)',
  'Dyal Singh College, Delhi – 110003 (First Cycle)',
  'Gitarattan Institute of Advanced Studies and Training, Sector-7, Rohini, Delhi – 110085 (First Cycle)',
  'Hansraj College, Malka Ganj, Delhi – 110007 (First Cycle)',
  'Hindu College, Delhi – 110007 (First Cycle)',
  'Institute of Home Economics, Delhi – 110016 (First Cycle)',
  'Institute of Vocational Studies, Delhi – 110017 (Second Cycle)',
  'Jagannath International Management School (J.I.M.S.), Vasant Kunj, Delhi – 110070 (Second Cycle)',
  'Janki Devi Memorial College, Delhi – 110060 (First Cycle)',
  'Kalindi College, Delhi – 110008 (First Cycle)',
  'Kamala Nehru College, Delhi – 110049 (First Cycle)',
  'Kasturi Ram College of Higher Education, Narela, Delhi – 110040 (First Cycle)',
  'Kirori Mal College, Delhi – 110007 (First Cycle)',
  'Maharaja Agrasen College, Delhi – 110096 (First Cycle)',
  'Maharaja Surajmal Institute of Technology, Delhi – 110058 (First Cycle)',
  'Maitreyi College, Delhi – 110021 (First Cycle)',
  'Miranda House, Delhi – 110007 (First Cycle)',
  'P. G. D. A. V. College (Evening), Nehru Nagar, Delhi – 110065 (First Cycle)',
  'Sant Hari Dass College of Higher Education, Bani Camp, Najafgarh – 110043 (First Cycle)',
  'Satyawati College, Ashok Vihar Phase-III, Delhi – 110052 (First Cycle)',
  'Shaheed Bhagat Singh College, Sheikh Sarai, Phase II, (Triveni), Delhi – 110017 (First Cycle)',
  'Shaheed Bhagat Singh Evening College, Triveni, Delhi – 110017 (First Cycle)',
  'Shri Ram College of Commerce, Delhi – 110007 (First Cycle)',
  'Shyam Lal College (Day), Shahdara – 110032 (First Cycle)',
  'Sri Guru Nanak Dev Khalsa College, Karol Bagh – 110005 (First Cycle)',
  'Sri Guru Tegh Bahadur Khalsa College, Delhi – 110007 (First Cycle)',
  'Tecnia Institute of Advanced Studies, Rohini, Delhi – 110085 (First Cycle)',
  'University College of Medical Sciences, Delhi – 110095 (First Cycle)',
  'Vivekananda College, Vivek Vihar, Delhi – 110095 (First Cycle)',
  'Zakir Husain Delhi College, Delhi – 110002(First Cycle)',
  'Shyam Lal College (Evening), Shahdara, Delhi – 110032 (First Cycle)',
  'Trinity Institute of Professional Studies, Sector-9, Dwarka, Delhi – 110075 (First Cycle)',
  'Maharaja Surajmal Institute, Janak Puri, Delhi – 110058 (Second Cycle)',
  'Bhaskaracharya College of Applied Sciences, Sector-2, Phase-1, Dwarka, Delhi – 110075 (First Cycle)',
  'Jagan Institute of Management Studies, Sector 5, Rohini, Delhi – 110085 (First Cycle)',
  'Lingaya’s Lalita Devi Institute of Management and Sciences, Delhi – 110047 (Second Cycle)',
  'Amity Institute of Education, Saket, Delhi – 110017 (Second Cycle)',
  'Rukmini Devi Institute of Advanced Studies, Delhi – 110085 (Second Cycle)',
  'Loknayak Jayaprakash Narayan National Institute of Criminology and Forensic Science, Rohini, Delhi – 110085 (First Cycle)',
  'Sri Aurobindo College - Evening (First Cycle)',
  'Gitarattan International Business School (Second Cycle)',
  'Sri Aurobindo College ,University of Delhi,Malviya Nagar - 110017 (First Cycle)',
  'IDEAL INSTITUTE OF MANAGEMENT AND TECHNOLOGY,6 X, Karkardooma Institutional Area (Near Telephone Exchange),,Delhi - 110092 (First Cycle)',
  'SHYAMA PRASAD MUKHERJI COLLEGE (FOR WOMEN),Road No. 57 , Punjabi Bagh (West),New Delhi , 110026 (First Cycle)',
  'Lady Irwin College,Sikandra Road,Delhi - 110001 (First Cycle)',
  'Management Education and Research Institute,53-54, Institutional Area (Opposite D Block) ,Janakpuri - 110058 (First Cycle)',
  'RAJDHANI COLLEGE,RAJA GARDEN, RING ROAD, NEW DELHI - 110015,NEW DELHI , 110015 (First Cycle)',
  'Ram Lal Anand College,Benito Juarez Marg,New Delhi - 110021 (First Cycle)',
  'Carmel College of Arts, Science and Commerce for Women, Salcete, Margao – 403604 (Third Cycle)',
  'Dempo Charities Trust Dhempe College of Arts and Science, Miramar, Panaji – 403001 (Third Cycle)',
  'Dnyan Prabodhini Mandal’s Shree Mallikarjun College of Arts & Commerce, Canacona, 403702 (First Cycle)',
  "Dnyanprasarak Mandal's College of Arts, Sou. Sheela Premanand Vaidya College of Science and V.N.S. Bandekar College of Commerce, Mapusa – 403507 (Third Cycle)",
  "Goa Vidyaprasarak Mandal's Gopal Govind Poy Raiturcar College of Commerce and Economics, Panda, 403401 (Second Cycle)",
  'Government College of Arts, Science and Commerce, Quepem – 403705 (Second Cycle',
  'Government College of Arts, Science and Commerce, Sanquelim, Ponda – 403505 (Second Cycle)',
  'Murgaon Education Society’s College of Arts & Commerce, Zuarinagar, 403726 (Third Cycle)',
  'Narayan Zantye College of Commerce, Bicholim – 403529 (First Cycle)',
  "Ponda Education Society's College of Arts & Science, Ponda, 403401 (Second Cycle)",
  'Sant Sohirobanath Ambiye Government College of Arts & Commerce, Pernem, 403512 (Second Cycle)',
  'Vidya Vikas Mandal’s Shree Damodar College of Commerce & Economics, Margao, 403601 (Third Cycle)',
  'Fr. Agnel College of Arts and Commerce, Panaji – 403203 (Second Cycle)',
  "Goa Vidyaprasarak Mandal's Dr. Dada Vaidya College of Education, Farmagudi, Ponda – 403401 (Second Cycle)",
  'Government College of Arts, Science and Commerce, Khandola, Marcela, Ponda – 403107 (Second Cycle)',
  'Rosary College of Commerce and Arts, Navelim, Salcete, Madgaon – 403707 (Third Cycle)',
  'S. S. Dempo College of Commerce and Economics, Altinho, Panaji – 403001 (Third Cycle)',
  'Vidya Prabodhini College of Commerce, Education, Computer and Management,Vidya Nagar, Alto Porvorim,Bardez - 403521 (First Cycle)',
  "The Cuncolim Educational Society's College of Arts and Commerce,Shri. Pio F. Lawrence Complex, Cuncolim,Salcete - 403703 (Second Cycle)",
  'Devi Sharvani Education Society’s V. M. Salgaocar College of Law,Miramar Caranzalem (Post),Panaji - 403002 (Third Cycle)',
  "ST. XAVIER'S COLLEGE, St Xaviers College Xaviernagar,Mapusa,Goa,403507 (Fourth Cycle)",
  'A G. Teachers College, Ahmedabad – 380009 (Second Cycle)',
  'Anand Education College,Anand – 388001(Second Cycle)',
  'Anand Pharmacy College,Anand, 388001 (Second Cycle)',
  'Anjuman Education Trust M.Ed. College, Balasinor, Kheda, 388255 (First Cycle)',
  'B.D. Arts College, Ahmedabad, 380001 (Second Cycle)',
  'B.D. Shah College of Education, Dist. Sabarkantha, 383315 (Second Cycle)',
  'Ballubhai Krishnalal Majmudar Science College, Valsad – 396001 (Second Cycle)',
  'Bhagwan Mahavir Education Foundation Managed, Shikshan Bharti & Bhagwan Mahavir College of Education, Surat, 395007 (First Cycle)',
  "Bharat Education Trust's B. J. Patel College of Education,Surat – 394601 (Second Cycle)",
  "Bharatiya Vidya Bhavan's Sheth Ranchhodlal Acharatlal College of Science, Ahmedabad, 380001 (Second Cycle)",
  "Bhavan's Shree A. K. Doshi Mahila College, Jamnagar – 361008 (Second Cycle)",
  'Bhikhabhai Jivabhai Vanijya Mahavidyalaya, Dist. Anand, 388120 (Second Cycle)',
  'Charutar Vidya Mandal’s Natubhai V. Patel College of Pure and Applied Sciences, Anand – 388120 (Second Cycle)',
  "Charutar Vidya Mandal's Sardar Gunj Merchantile Co-op Bank Limited (Anand) English Medium College of Commerce and Management, Vallabh Vidyanagar – 388120 (Second Cycle)",
  'Chaudhari College of Education (M.Ed.), Sector 7, Gandhinagar – 382007 (First Cycle)',
  'City C.U. Shah Commerce College, Ahmedabad, 380001 (Second Cycle)',
  "Dr. B. R. Ambedkar Education Society's Siddharth Law College, Gandhinagar – 382016 (Second Cycle)",
  'Experimental College of Education (B.Ed. & M.Ed.), Sabarkantha District, Prantij – 383205 (First Cycle)',
  'GLS (Induben & Ratilal K. Desai) Institute of Computer Applications, Ahmedabad – 380006 (First Cycle)',
  'GLS (J.P. Shah) Institute of Business Administration, Ahmedabad, 380006 (First Cycle)',
  'GLS (Shailesh R. Parikh) Institute of Computer Technology, Ahmedabad – 380006 (First Cycle)',
  'Government Commerce College, Gandhinagar, 382016 (Second Cycle)',
  'Grow More College of Education, Himatnagar – 383001 (First Cycle)',
  'Gujarat Arts and Science College, Ahmedabad – 380006 (Second Cycle)',
  'H.L. Patel Arts & Commerce College, Dist. Rajkot, 360450 (Second Cycle)',
  'Institute of Rural Management, Anand, 388001 (First Cycle)',
  'J. G. College of Education for Women (PG), Ahmedabad – 380061 (First Cycle)',
  'J. M. Shah Arts and Commerce College, Bharuch – 392150 (Second Cycle)',
  'Jethiba K. Patel Arts College & B.A. Patel & D.B. Vyas Commerce College, Dist. Patan, 384220 (Second Cycle)',
  'Karjan Taluka Kelavani Mandal Smt. Harshaben Chhaganbhai Patel (Kandari) Arts and Commerce College, Baroda – 391240 (Second Cycle)',
  'L.D. Arts College, Ahmedabad, 380009 (Second Cycle)',
  'L.R. Valia Arts & P.R. Mehta Commerce College, Bhavnagar, 364002 (Second Cycle)',
  'Laxmi Institute of Commerce and Computer Application,Sarigam, Valsad – 396155 (First Cycle)',
  'M. B. Patel College of Education,Vallabh Vidyanagar, Anand – 388120 (Second Cycle)',
  'Mahamandleshwar Shri Krishnanandji College of Commerce,Bharuch, 392001 (Second Cycle)',
  'Matrushree S.S. Govinda and Shrimati R.K.D. Khanushiya College of Education, Dist. Banaskantha, 385001 (First Cycle)',
  'Municipal Arts & Commerce College, Dist. Rajkot, 360490 (Second Cycle)',
  'N.P. Arts & Commerce College, Keshod, Dist. Junagadh,362220 (Second Cycle',
  'N.R. Institute of Business Management (GLS-MBA), Ahmedabad, 380006 (First Cycle)',
  'Nalini-Arvind and T. V. Patel Arts College, Anand – 388120 (Second Cycle)',
  'Narmada College of Science and Commerce, Bharuch – 392011 (Second Cycle)',
  "Navyug Education Society's Sheth Shree N. K. Mehta Trust Maharshi Dayanand Science College, Porbandar – 360575 (Second Cycle)",
  'North Gujarat Kelavani Mandal Managed Vidhyasagar B.Ed./M.Ed College, Dist. Patan, 384225 (First Cycle)',
  'P.T. Sarvajanik College of Science, Surat, 395001 (Second Cycle)',
  'Prakash College of Education, Ahmedabad – 380054 (Second Cycle)',
  'R. G. Barot College of Education, Bhiloda, Aravalli – 383245 (First Cycle)',
  'Rajpur Kelvani Mandal Sanchalit Vijaynagar Arts College, Vijaynagar, Idar, Sabarkantha – 383460 (Second Cycle)',
  'S. M. Patel Institute of Commerce,Ahmedabad – 380006 (First Cycle)',
  'S. N. M. Shah M.Ed. College, Kakanpur, Godhra,Panchmahal – 388713 (First Cycle)',
  'Sabar Gram Seva Mahavidyalaya,Sonasan, Sabarkantha – 383210 (First Cycle)',
  'Sanskarbharti College of Education,Dist. Vadodara, 391780 (First Cycle)',
  'Sardar Vallabhbhai Patel Education & Charitable Trust Shree V.M. Sakariya Mahila Arts College, Dist. Bhavnagar, 364710 (Second Cycle)',
  'Sarvajanik Education Society V. T. Choksi Sarvajanik College of Education, Surat – 395007 (Second Cycle)',
  'Sarvoday Higher Education Society - Mansa S. D. Arts and B. R. Commerce College, Mansa – 382845 (Second Cycle)',
  'Shah Narottamdas Harjivandas Commerce College, Valsad, 396001 (Second Cycle)',
  'Sheth Motilal Nathabhai Contractor College of Education, Dist. Vadodara, 391110 (Second Cycle)',
  "Shree Aradhana Educational and Charitable Trust's Aradhana B.Ed. And Smt. Savitaben J. Sabva Shikshan Mahavidyalaya (M.Ed.), Botad – 364710 (First Cycle)",
  'Shree Bhartiya Vidyamandal Sanchalit Shrimati Vasantiben Ranchhodbhai Bhakta, (Panama) Vav College of Education, Dist. Surat, 394185 (Second Cycle)',
  'Shree Bhikhabhai Patel Arts College, Anand, 388001 (Second Cycle)',
  'Shree Jayendrapuri Arts and Science College, Bharuch – 392001 (Second Cycle)',
  'Shree Kanya Kelvani Mandal, Unjha Sanchalit, Shri J. M. Patel Arts and Smt. M. N. Patel Commerce Mahila College, Dist. Mehsana, Unjha – 384170 (Second Cycle)',
  'Shree Lalshankar Umiya Shankar Arts and Shree Harivadan and Padmaben Thakore Commerce College for Women, Ahmedabad, 380006 (Second Cycle)',
  'Shree Meghmani Parivar and Shree Bhailalbhai A. Patel (Detrojwala) Umiya Arts and Commerce College for Girls, Ahmedabad, 380060 (Second Cycle)',
  'Shree P. M. Patel Institute of P. G. Studies and Research in Science, Anand – 388001 (First Cycle)',
  'Shree P. N. Pandya Arts, M. P. Pandya Science and Smt. D. P. Pandya Commerce College, Lunawada – 389230 (Second Cycle)',
  'Shree Patel Vidhyarthi Ashram Sanchalit, U.K. Vachhani Mahila Arts & Homescience College, Kehsod, 362220 (Second Cycle)',
  'Shree Purushottamdas Motibhai Patel College of Education (B.Ed.), Anand – 388001 (First Cycle)',
  'Shree Sarvajanik College of Education, Panchmahals, Godhra – 389001 (First Cycle)',
  'Shri Chanasma-Patan Taluka Gram Vikas Higher Education Trust Smt. P. R. Patel Arts College, Patan – 384235 (Second Cycle)',
  'Shri Chunibhai Nagjibhai Patel Fartikuiwala Arts & Dabhoi Nagarpalika Science College, Dist. Vadodara, 391110 (Second Cycle)',
  'Shri K.O. Shah Municipal Arts & Commerce College, Dist. Rajkot, 360410 (Second Cycle)',
  'Shri M. P. Shah Municipal Commerce College, Jamnagar – 361001 (Second Cycle)',
  'Shri P. H. G. Municipal Arts and Science College, Gandhinagar, Kalol – 382721 (Second Cycle)',
  'Shri Ramkrishna Seva Mandal, Anand Institute of Information Science, Anand, 388001 (Second Cycle)',
  "Shri Ramkrishna Seva Mandal's Anand Arts College, Anand – 388001 (Second Cycle)",
  'Shri Rang Shikshan Mahavidyalaya, Navsari, Bilimora – 396321 (Second Cycle)',
  'Shri Sadgurudev Shri Ranchhoddasji Babu Mahila Home Science College & Lt. Meenaben Jayantilal Kundaliya English Medium Mahila Commerce College, Rajkot, 360001 (First Cycle)',
  'Shri Surat Jilla Sahakari Bank Commerce College and Shri Sayan Sahakari Khand Udhyog Arts College, Olpad, Surat – 394540 (Second Cycle)',
  'Smt. B. C. J. College of Education, Dist. Anand, Khambhat – 388620 (Second Cycle)',
  'Smt. Dudhiben Ambalal Gondalia Education Foundation Sanchalit Saurastra Gnanpith Arts and Commerce College, Barwala – 362020 (Second Cycle)',
  'Smt. Jarbanu Phirosha Shroff Arts College, Valsad, 396001 (Second Cycle)',
  'Smt. K.C.M. Shah B.Ed. College, Kakanpur, Dist. Panchmahals, 388713 (First Cycle)',
  'Smt. Laxmiben & Shri Chimanlal Mehta Arts College, Ahmedabad, 380006 (Second Cycle)',
  'Smt. M. T. Dhamasania Commerce College, Rajkot – 360001 (Second Cycle)',
  'Smt. M.M. Shah College of Education, Dist. Surendranagar, 363035 (Second Cycle)',
  'Smt. N. C. Gandhi and Smt. B. V. Gandhi Mahila Arts and Commerce College, Bhavnagar – 364001 (Third Cycle)',
  'Smt. R. P. Bhalodia Mahila Arts, Commerce and Shree N. P. Bhalodia Home Science College, Rajkot – 360490 (Second Cycle)',
  'Smt. R.P. Chauhan Arts & Smt. J.K. Shah & Shri K.D. Shah Commerce College, Dist. Tapi, 394650 (Second Cycle)',
  'Smt. Sadguna C.U. Arts College for Girls, Ahmedabad, 380001 (Second Cycle)',
  'St. Xavier’s College, Ahmedabad, Gujarat(Third Cycle)',
  'The Patidar Gin Science College, Surat – 394601 (Second Cycle)',
  "The Sarvodaya Education Society's Shree U. N. Mehta Arts College, Morbi – 363642 (Second Cycle)",
  'V. N. S. Bank Ltd. Arts and Commerce College, Vadnagar – 384355 (First Cycle)',
  'V. S. Patel College of Arts and Science, Bilimora – 396321 (Second Cycle)',
  "Vidya Bharati's Kavishree Botadkar Arts and Commerce College, Botad – 364710 (Second Cycle)",
  'Vidyotejak Samaj Sanchalit Smt. H. B. Jasani Arts and Shri N. K. Jasani Commerce College, Rajkot – 360002 (Second Cycle)',
  'Vivekanand Education Trust, Daramali Managed College of Education, Dist. Sabarkantha, 383110 (Second Cycle)',
  'Anand Commerce College, Anand – 388001',
  'Atmiya Institute of Technology and Science, Rajkot – 360005 (First Cycle)',
  "Bharatiya Vidya Bhavan's Shri Ishvarlal L. P. Arts, Science and J. Shah Commerce College, Dakor, Kheda – 388225 (Second Cycle)",
  'College of Education, Vijaynagar, Sabarkantha, Idar – 383460 (First Cycle)',
  'Desai Chandulal Manilal Arts and Commerce College, Ahmedabad – 382150 (Second Cycle)',
  'Government Science College, Sector 15, Gandhinagar – 382016 (Second Cycle)',
  'H. A. College of Commerce, Ahmedabad – 380006 (Third Cycle)',
  'Idar Anjana Patidar H. K. M. Arts and P. N. Patel Commerce College, Jawanpura, Sabarkantha, Idar – 383430 (Second Cycle)',
  'J. G. College of Commerce, Ahmedabad – 380054 (Second Cycle)',
  'L. J. Institute of Management Studies, Ahmedabad – 382210 (First Cycle)',
  'M. J. College of Commerce, Vidyanagar, Bhavnagar – 364002(Second Cycle)',
  'Manavadar Kelavani Mandal Sanchalit Arts and Commerce College, Manavadar, Junagadh – 362630 (Second Cycle)',
  'Matushree Monghiba Mahila Arts College, Amreli – 365601 (Second Cycle)',
  'Navjivan Arts and Commerce College, Dahod – 389151 (Second Cycle)',
  'Nilkanth College of Education (M.Ed.), Visnagar – 384315 (First Cycle)',
  'Patel Raman Bros. Arts and Patel Gopalbhai Ranchhodji Commerce College, Surat – 394601 (Second Cycle)',
  'Peoples Welfare Society Sanchalit B. R. S. College, Upleta, Dumiyani, Rajkot – 360440 (Second Cycle)',
  'R. R. Lalan College, Bhuj – 370001 (Second Cycle)',
  'Shah K. S. Arts and V. M. Parekh Commerce College, Kheda – 387620 (Second Cycle)',
  'Shree J. M. Patel Arts College, Anand – 388001 (First Cycle)',
  'Shree P. M. Patel Institute of Business Administration, Anand – 388001 (First Cycle)',
  "Shree Somnath Education Society's Smt. C. P. Choksi Arts and Shree P. L. Choksi Commerce College, Veraval – 362265 (Second Cycle)",
  'Shreemati Meenakshiben Shantibhai Dave College of Education, Jamnagar – 361006 (First Cycle)',
  'Shri Gosar Hansraj Gosrani Commerce and Shri Dharamshi Devraj Nagda B. B. A. College, Jamnagar – 361004 (Second Cycle)',
  'Shri J. H. Bhalodia Women’s College, Rajkot – 360007 (Second Cycle)',
  'Shri J. S. Bhakta and Shri K. M. Bhakta Arts, Shri A. N. Shah Science and Shri N. F. Shah Commerce College, Surat – 394185 (Second Cycle)',
  'Shri Kantibhai Hirabhai Patel M.Ed. Institute, Modasa – 383315 (First Cycle)',
  'Shri M. P. Shah Education Society, Kadi C. N. Arts and B. D. Commerce College, Kadi – 382715 (Second Cycle)',
  'Shri M. R. Desai Arts and Shri E. E. L. Kosadia Commerce College, Khundh, Navsari – 396521 (Second Cycle)',
  'Shri R. K. Parikh Arts and Science College, Petlad, Anand – 388450 (Second Cycle',
  'Sir P. T. Science College, Modasa – 383315(Second Cycle)',
  'Smt. Champaben Vasantbhai Gajera Pharmacy Mahila College, Amreli – 365601 (First Cycle)',
  'Smt. J. C. Dhanak Arts and Commerce College, Bagasara, Amreli – 365440 (Second Cycle)',
  'Smt. M. M. Shah Mahila Arts College, Mehsana, Kadi – 382715 (Second Cycle)',
  'Smt. Sarlaben Babubhai Patel Arts and Shri Rambhai Nathabhai Amin Commerce College, Nadiad, Vaso, Kheda – 387380 (Second Cycle)',
  'The Broach District Adivasi Seva Sangh Kelavani Mandal M. R. Arts and Science College, Narmada, Rajpipla – 393145 (Second Cycle)',
  'The Sarvoday Nagrik Sahkari Bank Ltd., S. B. Mahila Arts College, Himatnagar, Sabarkantha – 383001 (Second Cycle)',
  'Uma Arts and Nathiba Commerce Mahila College, Sector 23, Gandhinagar – 382023 (Third Cycle)',
  "Vidyamandir Society's Z. F. Wadia Women’s College and N. K. Jhota College of Commerce, Surat – 395001 (Second Cycle)",
  'Waymade College of Education, Anand – 388120 (Second Cycle)',
  'C. U. Shah Medical College, Surendranagar – 363001 (First Cycle)',
  'C. U. Shah Physiotherapy College, Surendranagar – 363001 (First Cycle)',
  'Marwadi Education Foundation’s Group of Institutions, Rajkot – 360003 (First Cycle)',
  'Sheth C. D. Barfiwala College of Commerce, Surat – 395008 (First Cycle)',
  'Shri Vanraj Arts and Commerce College, Dharampur (Bamti), Valsad – 396050 (First Cycle)',
  'Dr. Virambhai Rajabhai Godhaniya College of Arts, Commerce, Home Science and Information Technology for Girls, Porbandar – 360575 (Third Cycle)',
  'M. P. Arts and M. H. Commerce College for Women, Ahmedabad – 380022 (Third Cycle)',
  'I.M. Nanavati law College, Ellisbridge, Ahmedabad, Gujarat-380006 (Second Cycle)',
  'Smt. D. H. Kabariya Arts, R. K. Vaghasiya Commerce and U. B. Bhagat Science Mahila College (First Cycle)',
  'Shree K. P. Dholakiya Infotech Mahila College,Smt. Shantaben Haribhai Gajera Shaikshanik Sankul, Chakkargadh Road,Amreli - 365601 (Second Cycle)',
  'Government Arts and Commerce College, Kachhal,Kachhal, Karcheliya, Mahuva ,Surat - 394240 (First Cycle)',
  'Shree Leuva Patel Trust B.B.A. Mahila College,Smt.Shantaben Haribhai Gajera Shaikshanik Sankul, Chakkargadh Road,Amreli - 365601 (First Cycle)',
  'Shri M M Ghodasara Mahila Arts and Commerce College,Opp. Motibaug, Vanthali Road,Junagadh - 362001 (Second Cycle)',
  'Tolani Commerce College,Nr. Post Office, P. Box No. 27,Adipur - 370205 (Third Cycle)',
  'GOVERNMENT ARTS COLLEGE, AMIRGADH,At. - Amirgadh, Ta. - Amirgadh, Dist. - Banaskantha State - Gujarat,Amirgadh , 385130 (First Cycle)',
  'SHRI P.K. CHAUDHARI MAHILA ARTS COLLEGE,Sector-7, Near S.T.Depot, Gandhinagar. Pin - 382007,Gandhinagar , 382007 (Second Cycle)',
  'VITTHALBHAI PATEL & RAJRATNA P.T. PATEL SCIENCE COLLEGE,Near Post office, Mota Bazar,Vallabh Vidyanagar, Anand , 388120 (Third Cycle)',
  'SHRI AND SMT. P. K. KOTAWALA ARTS COLLEGE, NGES CAMPUS, RAJMAHEL ROAD, PATAN , 384265 (Third Cycle)',
  'GOVERNMENT ARTS COLLEGE MANINAGAR,GOVERNMENT ARTS COLLEGE, K.K. SHASTRI EDUCATIONAL CAMPUS, KHOKHRA, MANINAGAR (EAST),,AHMEDABAD,Gujarat,380008 (First Cycle)',
  'SHRI CHUNILAL HIMMATBHAI BHIL GOVERNMENT ARTS AND COMMERCE COLLEGE, NASWADI,Shri Chunnilal Himmatbhai Bhil Government Arts Commerce College At and Post Naswadi Taluka Naswadi,NASWADI DIST CHOTAUDEPUR,Gujarat,391150 (First Cycle)',
  'SHRI K.K. SHASTRI GOVERNMENT COMMERCE COLLEGE,SHRI K.K SHASTRI EDUCATIONAL CAMPUS, KHOKHRA ROAD, MANINAGAR, AHMEDABAD,AHMEDABAD,Gujarat,380008 (First Cycle)',
  'BAHAUDDIN GOVT. ARTS COLLEGE,NEAR BHUTNATH TEMPLE, COLLEGE ROAD, JUNAGADH,JUNAGADH,Gujarat,362001 (Second Cycle)',
  'GOVERNMENT ARTS AND COMMERCE COLLEGE, PADDHARI,Near Court, Bus stand Road, Paddhari. Dist Rajkot.,Paddhari,Gujarat,360110 (First Cycle)',
  'M.N.COLLEGE, VISNAGAR,Near Bus stop, Station road,Visnagar,Gujarat,384315 (Second Cycle)',
  'R R MEHTA COLLEGE OF SCIENCE AND C L PARIKH COLLEGE OF COMMERCE PALANPUR,G.D. MODI VIDYA SANKUL, OPP. S.T. WORKSHOP, HIGHWAY, PALANPUR(B.K.),PALANPUR,Gujarat,385001 (Third Cycle)',
  'YOGIJI MAHARAJ MAHAVIDHYALAYA MAHILA ARTS AND COMMERCE COLLEGE, DHARI,YOGI NAGAR, NAVI VASAHAT, DHARI,DHARI,Gujarat,365640 (Third Cycle)',
  'SHRI TRIKAMJIBHAI CHATWANI ARTS & J.V.GOKAL TRUST COMMERCE COLLEGE, RADHANPUR,HIMMAT VIDHYANAGAR, HIMMATLAL MULANI MARG, KANDLA HIGHWAY, RADHANPUR-385340, DIST. PATAN, GUJARAT,RADHANPUR,Gujarat,385340 (Third Cycle)',
  'GURUKUL MAHILA ARTS AND COMMERCE COLLEGE,Post Box No. 21 Jubilee Bokhira Vistar Porbandar,Porbandar,Gujarat,360575 (Second Cycle)',
  'GOVERNMENT ARTS AND COMMERCE COLLEGE VANSDA, GOVERNMENT ARTS AND COMMERCE COLLEGE, VANSDA TA-VANSDA DIST- NAVSARI,VANSDA,Gujarat,396580 (First Cycle)',
  'GOVERNMENT ARTS AND COMMERCE COLLEGE KHERGAM, AT POST KHERGAM TA KHERGAM DIST NAVSARI,KHERGAM,Gujarat,396040 (First Cycle)',
  'GOVERNMENT SCIENCE COLLEGE CHIKHLI, At/Po Satpipla, Opp. ITI, Vansda Road, Ta. Chikhli, Di. Navsari,Navsari,Gujarat,396521 (First Cycle)',
  'GOVERNMENT ARTS AND COMMERCE COLLEGE, SAMI, Nr. U.G.V.C.L SUB-STATION APPROACH ROAD SAMI DIST PATAN PIN CODE 384245,SAMI,Gujarat,384245 (First Cycle)',
  'H. AND H. B. KOTAK INSTITUTE OF SCIENCE, Dr. Yagnik Road, Dh. College Campus, Rajkot,Rajkot,Gujarat,360001 (Second Cycle)',
  'GOVERNMENT ARTS AND COMMERCE COLLEGE, SONGADH, Government Arts and Commerce College, Songadh, District Tapi,SONGADH,Gujarat,394670 (First Cycle)',
  'GUJARAT ARTS AND COMMERCE COLLEGE (EVENING), GUJARAT ARTS AND COMMERCE COLLEGE (EVENING), ELLISBRIDGE, AHMEDABAD - 380006, GUJARAT,AHMEDABAD,Gujarat,380006 (Second Cycle)',
  'GOVERNMENT ARTS AND COMMERCE COLLEGE KATHLAL, GACCKATHLAL, NEAR DIET CAMPUS, BEHIND BUS STATION, KATHLAL, DIST- KHEDA PIN- 387630,Kathlal Dist Kheda,Gujarat,387630 (First Cycle)',
  'GOVERNMENT SCIENCE COLLEGE,AHWA,DIST DANG(GUJARAT) , NEAR CIVIL HOSPITAL, GOVERNMENT HIGHER SECONDARY SCHOOL ROAD, BESIDES I. T. I., COLLEGE CAMPUS, AT POST AHWA, TA AHWA, DIST DANG, PIN 394710,AHWA,Gujarat,394710 (First Cycle)',
  'GUJARAT COMMERCE COLLEGE, ELLISBRIDGE, AHMEDABAD , Ellisbridge, Ahmedabad,Ahmedabad,Gujarat,380006 (First Cycle)',
  'GOVERNMENT ARTS COLLEGE,ZAGHADIYA,DISTRICT-BHARUCH,STATE-GUJARAT , NEAR KASTURBA GANDHI BALIKA VIDYALAYA ,AT AND POST-RANIPURA,,ZAGHADIYA,Gujarat,393110 (First Cycle)',
  'BAHAUDDIN GOVERNMENT SCIENCE COLLEGE , Near Bhutnath Temple, College Road,Junagadh,Gujarat,362001 (Second Cycle)',
  'GOVERNMENT ARTS COLLEGE , Sector 15, Near Mahatma Mandir, Gandhinagar,Gandhinagar,Gujarat,382016 (Second Cycle)',
  'MUNICIPAL ARTS AND URBAN BANK SCIENCE COLLEGE, MEHSANA , Municipal Arts and Urban Bank Science College, Nagalpur, Highway Mehsana,Mehsana,Gujarat,384002 (Third Cycle)',
  'J.ZSHAH ARTS AND H.P.DESAI COMMERCE COLLEGE, AMROLI , At and Post - Amroli , Station- Utran, Ta.-Choryasi, Dist. - Surat , Gujarat , (India),Surat,Gujarat,394107 (Third Cycle)',
  'SHRI U P ARTS, SMT. M G. PANCHAL SCIENCE AND SHRI V. L. SHAH COMMERCE COLLEGE , PILVAI COLLEGE CAMPUS, AT POST - PILVAI TA - VIJAPUR DIST - MEHSANA,Pilvai,Gujarat,384550 (Third Cycle)',
  'H L COLLEGE OF COMMERCE , Late Prin S V Desai Road Navrangpura,Ahmedabad,Gujarat,380009 (Third Cycle)',
  'PRAMUKH SWAMI SCIENCE AND H. D. PATEL ARTS COLLEGE,Sarva Vidyalaya Campus, Behind Railway Station, Kadi Dist. Mehsana,Kadi,Gujarat,382715 (Third Cycle)',
  'M. B.PATEL SCIENCE COLLEGE,Behind D. N. High School, Near Sardar Gunj, Anand-388001, Gujarat,Anand,Gujarat,388001 (Third Cycle)',
  'GOVERNMENT ARTS COLLEGE, Village- Kakri, Post/ Taluka- Shahera Dis- Panchmahal,Shahera,Gujarat,389210 (First Cycle)',
  'Shree Sardar Patel Education Trust - Junagadh, Shree Mahila Arts and Commerce College,Near Railway Station, Joshipura,Junagadh - 362002 (Second Cycle)',
  'GANDHINAGAR CHARITABLE TRUST SANCHALIT SAMARPAN ARTS AND COMMERCE COLLEGE,amarpan Education and Research Campus, Nr.Kh-07 Circle, Sector-28, Gandhinagar-382028 Gujarat.,Gandhinagar , 382028 (First Cycle)',
  'J.P.P. ARTS AND COMMERCE COLLEGE,Station Road, Killa- Pardi, Dist-Valsad,Killa Pardi , 396125',
  'Ahir College, Rewari – 123401 (Second Cycle)',
  'Arya Kanya Mahavidyalaya, Dist. Kurukshetra, 136135 (Second Cycle)',
  'Babu Anant Ram Janta College, Kaul, Kaithal – 136021 (Second Cycle)',
  'Banwari Lal Jindal Suiwala College, Tosham, Bhiwani – 127040 (Second Cycle)',
  'Bhagwan Shri Krishan College of Education, Sirsa Dist, 125104 (Second Cycle)',
  'Brahmrishi College of Education, Pinjore, Kalka, Panchkula – 134104 (First Cycle)',
  'C.R. Kisan College, Jind, 126102',
  'Ch. Ishwar Singh Kanya Mahavidyalaya, Fatehpur-Pundri, District Kaithal, Pundri – 136026 (Second Cycle)',
  'D. A. V. College, Dayanand Marg, Karnal – 132001 (Second Cycle)',
  'DAV Centenary College, Faridabad – 121001 (Second Cycle)',
  'Dr. Ganesh Dass D.A.V. College of Education For Women, Karnal, 132001 (Second Cycle)',
  'Dronacharya Government College, Gurgaon, 121001 (Second Cycle)',
  'Fateh Chand College for Women, Hisar – 125001 (Second Cycle)',
  'Government College for Women, Faridabad, 121002 (Second Cycle)',
  'Government College for Women, Mahendergarh District, Narnaul – 123001 (Second Cycle)',
  'Government College for Women, Rohtak - 124001 (First Cycle)',
  'Government College of Education, Narnaul – 123001 (Second Cycle)',
  'Government College, Bhattu Kalan, Fatehabad – 125053 (Second Cycle)',
  'Government College, Dist. Jhajjar, 124507 (Second Cycle)',
  'Government College, Hisar, 125001 (Second Cycle)',
  'Government College,Jind, Safidon – 126112 (Second Cycle)',
  'Government College, Sector – 9, Gurgaon – 122001 (First Cycle)',
  'Government College, Sidharawali, Gurgaon – 121001 (Second Cycle)',
  'Government College, Tigaon, Faridabad – 121001 (Second Cycle)',
  'Government National College, Sirsa, 125055 (Second Cycle)',
  'Guru Nanak Girls College, Santpura, Yamunanagar – 135001 (Second Cycle)',
  'Guru Nanak Khalsa College, Karnal – 132001 (Second Cycle)',
  'H. L. G. Government College, Mewat, Tauru – 122105 (Second Cycle)',
  'Haryana Institute of Education, Bahadurgarh – 124507 (First Cycle)',
  'Janta Vidya Mandir Ganpat Rai Rasiwasia College, Bhiwani dist, 127306 (Second Cycle)',
  'K. L. Mehta Dayanand College for Women, Faridabad – 121001 (Second Cycle)',
  'K.M. Government College, Dist. Jind, 126116 (Second Cycle)',
  'Kamrah Institute of Information Technology,Gurgaon – 122102 (First Cycle)',
  'Kanya Mahavidyalaya, Dist. Sonepat, 131402 (Second Cycle)',
  'KIIT College of Engineering, Gurgaon, 122102 (First Cycle)',
  'Laxmi College of Education,Sidhrawali,Gurgaon, 122002 (First Cycle)',
  'M.L.R. Saraswati College of Education,Bhiwani Dist, 127306 (Second Cycle)',
  'Maharaja Agrasen Mahavidyalaya, Jagadhri, 135003 (Second Cycle)',
  'Mahila Mahavidyalaya, Bhiwani, 127310 (First Cycle)',
  'Manav Rachna Dental College, Faridabad – 121004 (First Cycle)',
  'Mukhi College of Education, Sonepat, 131301 (First Cycle)',
  'Navyug College for Education, Sonepat – 131001 (First Cycle)',
  'Pratap College of Education, Karnal, 132001 (First Cycle)',
  'Rajiv Gandhi Government College For Women, Bhiwani, 127021 (First Cycle)',
  'Rao Birender Singh College of Education, Rampura, Rewari, 123401 (Second Cycle)',
  'Rattan Singh Girls College of Education, Ballabgarh, Faridabad, 121002 Haryana (First Cycle)',
  'S. R. M. College of Education, Jind – 126102 (First Cycle)',
  'Sant Mohan Singh Khalsa Labana Girls College, Dist. Ambala, 133201 (Second Cycle)',
  'Saraswati Mahila Mahavidyalaya, Palwal – 121102 (Second Cycle)',
  'Sat Jinda Kalyana College, Kalanaur – 124113 (Second Cycle)',
  'Satish Public College of Education, Rewari – 123401 (Second Cycle)',
  'Sh. L. N. Hindu College, Rohtak – 124001 (Second Cycle)',
  'Shaheed Capt. D. K. Khola College of Education, Zainabad, Rewari, 123411 (First Cycle)',
  'Shri Atmanand Jain (PG) College, Ambala, 134002 (Second Cycle)',
  'Shri Krishna Government College, Kanwali, Rewari – 123401 (Second Cycle)',
  'Starex Institute of Education, Gurgaon – 122413 (First Cycle)',
  'Tau Devi Lal Memorial College of Education, Panipat, 132101 (First Cycle)',
  'Women College of Education, Jhojhu Kalan, Charkhi Dadri – 127310 (First Cycle)',
  'Adarsh Subhash Tayal College of Education, Jind Chungi, Hansi – 125033 (First Cycle)',
  'B. S. Anangpuria Institute of Education, Alampur, Faridabad – 121004 (First Cycle)',
  'Bhagwan Mahaveer College of Education, Sonepat – 131030 (First Cycle)',
  "C. M. K. National Girl's College, Sirsa – 125055 (Second Cycle)",
  'Ch. Mani Ram Godara Government College for Women, Fatehabad, Hisar – 125050 (Second Cycle)',
  'Chhaju Ram Memorial Jat College, Hisar – 125001 (Second Cycle)',
  'Dayanand College, Hisar – 125001 (Second Cycle)',
  'Dr. B. R. Ambedkar College of Education, Thanesar – 136118 (Second Cycle)',
  'Dyal Singh College, Karnal – 132001 (Second Cycle)',
  'Gaur Brahman Degree College, Rohtak – 124001 (Second Cycle)',
  'Geeta Engineering College, Naultha, Panipat – 132107 (First Cycle)',
  'Goswami Ganesh Dutt Sanatan Dharam College, Palwal – 121102 (Second Cycle)',
  'Government College for Women, Narnaul Road, Mahendergarh – 123029 (Second Cycle)',
  'Government College for Women, Railway Road, Karnal – 132001 (Second Cycle)',
  'Government College, Ateli, Narnaul – 123021 (Second Cycle)',
  'Government College, Badli, Bahadurgarh, Jhajjar – 124105 (First Cycle)',
  'Government College, Mahendergarh, Narnaul – 123001 (Second Cycle)',
  'Government College, Meham, Rohtak – 124112 (Second Cycle)',
  'Government College, Narnaul Road, Mahendragarh – 123029 (Second Cycle)',
  'Government College, Old G. T. Road, Hodal, Palwal – 121106 (Second Cycle)',
  'Haryana College of Education, Kinana, Jind – 126102 (First Cycle)',
  'Hindu Girls College, Sonepat – 131001 (Second Cycle)',
  'Indira Gandhi Government College, Tohana – 126119 (Second Cycle)',
  'Indira Gandhi Mahila Mahavidyalaya, Kaithal – 136027 (Second Cycle)',
  'Indus College of Education, Rohtak – 124001 (First Cycle)',
  'KIIT College of Education, Bhondsi, Gurgaon – 122102 (Second Cycle)',
  'Kirorimal College of Education, Bhiwani – 127021 (Second Cycle)',
  'Krishna College of Education, Rewari – 123302 (First Cycle)',
  'Kumari Vidyavati Anand D. A. V. College for Women, Karnal – 132001 (Second Cycle)',
  'M. D. S. D. Girls College, Ambala – 133001 (Second Cycle)',
  'Maharani Kishori Jat Kanya Mahavidyalaya, Rohtak – 124001 (Second Cycle)',
  'Mata Jiyo Devi College of Education, Khanda Kheri, Hisar – 125038 (First Cycle)',
  'P. D. M. College of Education, Sarai Aurangabad, Bahadurgarh, Jhajjar – 124507 (Second Cycle)',
  'Pandit Neki Ram Sharma Government College, Rohtak – 124001 (Second Cycle)',
  'PDM Dental College and Research Institute, Bahadurgarh, Jhajjar – 124507 (First Cycle)',
  'Pt. Sita Ram Shastri B.Ed. Training College, Bhiwani – 127021 (First Cycle)',
  'R. S. Memorial College of Education, Buana Lakhu, Israna, Panipat – 132107 (First Cycle)',
  'Radha Krishan Sanatan Dharam (Post Graduate) College, Kaithal – 136027 (Second Cycle)',
  'Sai Mohan College of Education, Neemka, Ballabhgarh, Faridabad – 121004 (First Cycle)',
  'Sanatan Dharma College (Lahore), Jagadhari Road, Ambala – 133001 (Third Cycle)',
  'Shaheed Baba Deep Singh College of Education, Aherwan, Ratia, Fatehabad – 125051 (First Cycle)',
  'Smt. Aruna Asaf Ali Government Post Graduate College, Kalka, Panchkula – 133302 (Second Cycle)',
  'The Aaryan College of Education, Rohtak – 124514 (First Cycle)',
  'V. B. College of Education, Rohtak – 124001 (Second Cycle)',
  'Vaish Arya Kanya Mahavidyalaya, Bahadurgarh – 124507 (Second Cycle)',
  'Vaish Arya Shikshan Mahila Mahavidyalaya, Bahadurgarh, Jhajjar – 124507 (First Cycle)',
  'College of Basic Sciences and Humanities, Hisar – 125004 (First Cycle)',
  'GDC Memorial College,Near Hanuman Mandir, VPO Bahal Tehsil - Loharu ,Bhiwani - 127028 (First Cycle)',
  'Arya College, Panipat,G.T. Road, Opposite Main Bus Stand ,Panipat - 132103 (Second Cycle)',
  'Gandhi Memorial National College,Jawahar Lal Nehru Marg ,Ambala Cantt. - 133001 (Third Cycle)',
  'D. A. V. COLLEGE FOR GIRLS,Jagadhri Road, Yamuna Nagar,Yamuna Nagar , 135001 (Third Cycle)',
  'AGGARWAL COLLEGE BALLABGARH, NEAR AMBEDKAR CHOWK, TIGAON ROAD BALLABGARH, DISTT. FARIDABAD,Faridabad , 121004 (Third Cycle)',
  'INDIRA PRIYADARSHINI COLLEGE FOR WOMEN, JHAJJAR,NEAR DABRA MANDIR, BEHIND THE SECRETARIAT, GURGOAN ROAD, JHAJJAR-124103,JHAJJAR , 124103 (First Cycle)',
  'MARKANDA NATIONAL COLLEGE,Markanda National College, Sector-1, Urban Estate, Ladwa Road,Kurukshetra , 136135 (Second Cycle)',
  'MAHARANI LAKSHMI BAI COLLEGE , Village Post Office Sarsana,Hisar (Rural)(146),Haryana,125001 (First Cycle)',
  'GOVERNMENT COLLEGE FOR GIRLS PANCHKULA,Govt. College for Girls Sec-14 Panchkula,PANCHKULA,Haryana,134109 (First Cycle)',
  'HINDU KANYA MAHAVIDYALAYA JIND,HINDU KANYA MAHAVIDYALAYA, NEAR ARJUN STADIUM, JIND,JIND,Haryana,126102 (Second Cycle)',
  'N.B.G.S.M. COLLEGE, SOHNA DISTRICT GURUGRAM PIN CODE - 122103 (Second Cycle)',
  'DAV Centenary College,Kotkhai, Shimla – 171202 (First Cycle)',
  'Department of Teacher Education K.L.B.D.A.V. College for Girls, Dist. Kangra, 176061 (First Cycle)',
  'G. B. Pant Memorial Government College, Shimla – 172001 (Second Cycle)',
  'Government College of Teacher Education, Dharamshala, Dist. Kangra, 176215 (Second Cycle)',
  'Government College, Bangana, Una – 174307 (First Cycle)',
  'Government College, Bhoranj (Tarkwari) Via Kanjian, Hamirpur – 174025 (First Cycle)',
  'Government College, Chaura Maidan, Kotshera, Shimla – 171004 (Second Cycle)',
  'Government College, Dehri, Nurpur, Kangra – 176022 (First Cycle)',
  'Government College, Dharamshala, Dist. Kangra, 176215 (Second Cycle)',
  'Government P. G. College, Una – 174303 (Second Cycle)',
  'Netaji Subhash Chandra Bose Memorial Government College, Hamirpur, 177005 (Second Cycle)',
  'Thakur Sen Negi Government College,Kinnaur – 172107 (First Cycle)',
  'Abhilashi College of Education, Ner-Chowk, Mandi – 175008 (Second Cycle)',
  'Bhojia Dental College and Hospital, Bhud, Baddi, Solan – 173205 (First Cycle)',
  'Government College, Centre of Excellence, Sanjauli, Shimla – 171006 (Second Cycle)',
  'Government College, Dhalpur, Kullu – 175101 (Second Cycle)',
  'Government College, Nalagarh, Solan – 174101 (Second Cycle)',
  'Government College, Rajgarh Road, Solan – 173212 (Second Cycle)',
  'Government College, Seema (Rohru), Shimla – 171207 (Second Cycle)',
  'Government Degree College, Banjar, Kullu – 175123 (First Cycle)',
  'Government Degree College, Sultanpur, Chamba – 176314 (First Cycle)',
  'Jawahar Lal Nehru Government College, Haripur, Manali, Kullu – 175136 (First Cycle)',
  'Lal Bahadur Shastri Government Degree College, Hatkoti, Jubbal, Saraswati Nagar, Shimla – 171206 (First Cycle)',
  'Maharana Pratap Government Degree College, Una – 177203 (Second Cycle)',
  'SDWG Government College, VPO Beetan, Haroli, Una – 176601 (First Cycle)',
  'Shree Guru Gobind Singh Ji Government College, Paonta Sahib, Sirmaur – 173025 (First Cycle)',
  "St. Bede's College, Shimla – 171002 (Third Cycle)",
  'Vijay Memorial College of Education, Ner Chowk, Bhanrotu, Balh, Mandi – 175021 (Second Cycle)',
  'Government College Karsog (Second Cycle)',
  'GOVT. COLLEGE JHANDUTTA, JHANDUTTA , 174031, JHANDUTTA , 174031 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE SHAHPUR,SHAHPUR DISTT. KANGRA,Kangra , 176206 (First Cycle)',
  'GOVT. DEGREE COLLEGE THEOG,Distt Shimla,Theog , 171201 (First Cycle)',
  'GOVERNMENT P. G. COLLEGE BILASPUR, HIMACHAL PRADESH,Bilaspur Town Bilaspur, District Bilaspur,Bilaspur , 174001 (Third Cycle)',
  'GOVT. DEGREE COLLEGE DRANG AT NARLA,DISTT. MANDI,Drang at Narla, Village Jundhar PO Kunnu Tehsil Padhar,Distt. Mandi HP 175012 (First Cycle)',
  'GOVT COLLEGE DHALIARA, VPO Dhaliara, Teh- Dehra , Distt-Kangra (HP),Dhaliara , 177103 (Second Cycle)',
  'GOVT. COLLEGE NAURA, Naura Tehsil Palampur Distt Kangra,Naura , 176084 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE SARKAGHAT, GOVT. DEGREE COLLEGE SARKAGHAT DISTT-MANDI, HP,Sarkaghat,Himachal pradesh,175024 (Third Cycle)',
  'GOVT. COLLEGE SANGRAH , Govt. College Sangrah P.O Sangrah Tehsil Sangrah Dist. Sirmour HP 173023,Sangrah,Himachal pradesh,173023 (First Cycle)',
  'GOVT. DEGREE COLLEGE ARKI,VPO BATAL, TEH - ARKI, DISTRICT- SOLAN,,ARKI,Himachal pradesh,173208 (Second Cycle)',
  'GOVERNMENT COLLEGE ,Nagrota Bagwan Dist. Kangra H.P.-176047 (First Cycle)',
  'Maharaja Lakshman Sen Memorial College,Sundernagar,Mandi - 175018 (First Cycle)',
  'Government College, Jukhala, Bilaspur,Post Office Jukhala, Tehsil Sadar,Bilaspur - 174033 (First Cycle)',
  'Govt. Sanskrit College, Solan,Punjwila Near Thodo Graund,Solan - 173212 (First Cycle)',
  'Govt. College, Bassa (Gohar), Mandi ,Bassa (Gohar), Tehsil-Chachiot,Mandi - 175029 (First Cycle)',
  'GOVT. COLLEGE BARSAR, DISTT.- HAMIRPUR (H.P), Barsar , 174305 , Govt. College Barsar, Distt-Hamirpur,Barsar , 174305 (First Cycle)',
  'GOVT. DEGREE COLLEGE BEERWAH,Government Degree College Beerwah,Beerwah, District Budgam,Beerwah,Jammu And Kashmir,193411 (First Cycle)',
  'GOVT. DEGREE COLLEGE DOORU, ANANTNAG KASHMIR,Dooru Anantnag Kashmir,Dooru,Jammu And Kashmir,192211 (First Cycle)',
  'GOVT. DEGREE COLLEGE KILAM,Teh. Devsar Distt. Kulgam 192231,Srinagar,Jammu And Kashmir,192231 (First Cycle)',
  'SHEIKHUL ALAM MEMORIAL DEGREE COLLEGE BUDGAM,Govt Sheikhul Alam memorial degree College Budgam,Badgam,Jammu And Kashmir,191111 (First Cycle)',
  'GOVT DEGREE COLLEGE FOR WOMEN SOPORE,Nowpora Kallan Sopore,BARAMULLA,Jammu And Kashmir,193201 (First Cycle)',
  'GOVT. DEGREE COLLEGE TRAL,New Campus Bajwani Tral,SRINAGAR,Jammu And Kashmir,192123 (First Cycle)',
  'GOVT. DEGREE COLLEGE KOKERNAG,IRKUMU KOKERNAG, ANANTNAG,ANANTNAG,Jammu And Kashmir,192202 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE GANDERBAL,Government Degree College Ganderbal,Ganderbal,Jammu And Kashmir,191201 (First Cycle)',
  'Amar Singh College (A S College), Srinagar – 190008 (Second Cycle)',
  'Dogra College of Education, Jammu, 181133 (Second Cycle)',
  'Gandhi Memorial College of Education, Raipur, Bantalab, Jammu – 181123 (Second Cycle)',
  'Government College for Women, Nawakadal, Srinagar – 190002 (Second Cycle)',
  'Government Degree College for Women, Anantnag – 192101 (Second Cycle)',
  'Government Degree College, Baramulla – 193102 (Second Cycle)',
  'Government Degree College, Handwara, Kupwara, Kashmir – 193221 (First Cycle)',
  'Government Degree College, Pulwama, Srinagar – 192301 (First Cycle)',
  'Government Degree College, Sopore, Baramulla – 193201 (Second Cycle)',
  'Government Degree College, Udhampur – 182101 (Second Cycle',
  'KCS College of Education (Women), Jammu, 181121 (Second Cycle)',
  'R.M.College of Education, Jammu, 180011 (First Cycle)',
  'Sacred Heart College of Education, Jammu, 180013 (Second Cycle)',
  'Sai Shyam College of Education, Jammu, 180001 (Second Cycle)',
  'Shadab College of Education, Srinagar, 190006 (First Cycle)',
  'Trikuta College of Education, Jammu, 181123 (Second Cycle)',
  'Government College of Education, Canal Road, Jammu – 180001 (Second Cycle)',
  'Government Degree College, Near SBI, Poonch – 185101 (First Cycle)',
  'Government Degree College, Shopian Kashmir, Srinagar – 192303 (First Cycle)',
  'Institute of Dental Sciences, Jammu – 181132 (First Cycle)MIER College of Education, Jammu – 180001 (Third Cycle)',
  'Model Institute of Engineering and Technology, Kot Bhalwal, Jammu – 180016 (Second Cycle)',
  'Rajiv Gandhi Memorial College of Education, Kathua – 184101 (Second Cycle)',
  'Sanctorum College of Education, Lalad, Sopore, Baramulla – 193201 (First Cycle)',
  'Sri Pratap College, Srinagar – 190001 (Second Cycle)',
  'The Islamia College of Science and Commerce, Srinagar – 190001 (Second Cycle)',
  'Calliope College of Education, Doomi, Jammu – 181206 (Second Cycle)',
  'GOVT COLLEGE FOR WOMEN PARADE,Parade ground Jammu-180001 ,JAMMU , 180001 (Third Cycle)',
  'GOVERNMENT DEGREE COLLEGE, AKHNOOR,Village Palwan Tehsil Akhnoor,JAMMU , 181201 (First Cycle)',
  'GOVERNMENT GENERAL ZORAWAR SINGH MEMORIAL DEGREE COLLEGE REASI,Reasi, Mari, Reasi , 182311 , Reasi , 182311 (First Cycle)',
  'GOVT. DEGREE COLLEGE THANNAMANDI, Rajouri , 185212, Rajouri , 185212 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE,Bhaderwah District Doda, Bhaderwah , 182222 (Second Cycle)',
  'GOVT. DEGREE COLLEGE, KATHUA,Kathua , 184101,Kathua , 184101 (Third Cycle)',
  'GOVT. COLLEGE FOR WOMEN UDHAMPUR, Kallar Himmati, Battal Ballian Road Udhampur (Jammu and Kashmir),UDHAMPUR , 182101 (First Cycle)',
  'GOVT. DEGREE COLLEGE MENDHAR,Mendhar Mendhar, Poonch , 185211 (First Cycle)',
  'GOVT. DEGREE COLLEGE FOR WOMEN, BARAMULLAH, KMR.,Opposite State Bank of India, Baramulla,BARAMULLA , 193101(Second Cycle)',
  'GOVT DEGREE COLLEGE BIJBEHARA,Nilandrus ,Pahalgam Road ,Bijbehara,Anantnag , 192124 (First Cycle)',
  'GOVT. DEGREE COLLEGE RAMNAGAR,RAMNAGAR DISTT. UDHAMPUR JAMMU AND KASHMIR - 182122,RAMNAGAR UDHAMPUR , 182122 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE SAMBA,Samba Near Mansar morh Samba jammu and kashmir, Samba , 184121 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE SUMBAL,umbal Sonawari, Bandipora,Sumbal , 193501 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE KULGAM,KULGAM,Jammu And Kashmir,192231 (First Cycle)',
  'GOVT. DEGREE COLLEGE FOR WOMEN, PULWAMA,Pulwama, Jammu And Kashmir,192301 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE MAGAM,MagamDistrict Budgam,Magam,Jammu And Kashmir,193401 (First Cycle)',
  'GOVT. COLLEGE FOR WOMEN,Moulana Azad Road Srinagar,Srinagar,Jammu And Kashmir,190001 (Third Cycle)',
  'GOVERNMENT DEGREE COLLEGE RAMBAN, GOVT. DEGREE COLLEGE RAMBAN PO-CHANDERKOT - 182148, RAMBAN',
  'JAMMU AND KASHMIR,Ramban,Jammu And Kashmir,182148 (First Cycle)',
  'ELIEZER JOLDAN MEMORIAL COLLEGE LEH, Jammu And Kashmir,194101 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE KARGIL,MOHALLA BAGHE KHUMEINI OPPOSITE WILD LIFE DEPARTMENT KARGIL,KARGIL,Jammu And Kashmir,194103 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE BILLAWAR,dewal, Billawar, Kathua,Billawar,Jammu And Kashmir,184204 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE, BASOHLI,Kathua,Jammu And Kashmir,184201 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE,KHEORA NEAR GOVT. DEGREE COLLEGE RAJOURI,RAJOURI,Jammu And Kashmir,185133 (Third Cycle)',
  'Gandhi Memorial College, Srinagar,Shamaswari Fateh Kadal,Srinagar - 190002 (First Cycle)',
  'Chotanagpur Law College, Ranchi - 834010 (First Cycle)',
  'Deoghar College, Deoghar, 814113 (First Cycle)',
  'Guru Nanak College, Dhanbad, 826001 (First Cycle)',
  'Imamul Hai Khan Law College, Sector-6, Bokaro Steel City – 827006 (First Cycle)',
  'J. M. College, P. O. Bhurkunda Bazar, Dist. Ramgarh, Patratu – 829106 (First Cycle)',
  'Jamshedpur Co-operative College, Jamshedpur – 831001 (First Cycle)',
  'Manrakhan Mahto B.Ed. College, Ranchi – 835217 (First Cycle)',
  'Nirmala College, Ranchi, 834002 (Second Cycle)',
  'Raja Shiva Prasad College, Jharia, Dhanbad – 828111 (Second Cycle)',
  'Ramgarh College, Ramgarh – 829122 (Second Cycle)',
  'S. S. L. N. T. Mahila Mahavidyalaya, Dhanbad – 826001 (First Cycle)',
  'Ursuline Women’s Teachers’ Training College, Dist. Lohardaga, 835302 (Third Cycle)',
  'A. S. College, Satsang Chowk, Deoghar – 814112 (First Cycle)',
  'Aditya Narayan College, Dumka – 814101 (First Cycle)',
  'Al-Iqra Teacher’s Training College, Dhanbad – 828109 (First Cycle)',
  'Baharagora College, Baharagora, East Singhbhum – 832101 (First Cycle)',
  'Baldeo Sahu College, Lohardaga – 835302 (First Cycle)',
  'Bethesda Women Teacher’s Training B.Ed. College, Ranchi – 834001 (First Cycle)',
  'Bhagwat Jha Azad College, Kundahit, Jamtara – 815359 (First Cycle)',
  'Bindeshwari Dubey Awasiya Mahavidyalaya, Pichhri, Bermo, Phusro – 829144 (First Cycle)',
  'Binod Bihari Mahato College, Baliapur, Dhanbad – 828201 (First Cycle)',
  'Bokaro Mahila College, Sector III/E, Bokaro Steel City – 827003 (First Cycle)',
  'Bokaro Steel City College, Bokaro Steel City – 827006 (First Cycle)',
  'Chas College, Bokaro Steel City – 827013(First Cycle)',
  'Chatra College, Chatra – 825401 (First Cycle)',
  'Chotanagpur College, Ramgarh – 829117 (First Cycle)',
  'Dinesh College of Education (B.Ed.), Farathiya, Hoor, Garhwa – 822114 (First Cycle)',
  'Doranda College, Ranchi – 834002 (Second Cycle)',
  'Dr. S. Radhakrishnan Teachers’ Training College, Sukarigarha, Lari, Ramgarh – 825101 (First Cycle)',
  'Ghatsila College, Powrah, Ghatsila, East Singhbhum – 832303 (First Cycle)',
  'Godda College, Godda – 814133 (First Cycle)',
  'Gopinath Singh Mahila Mahavidyalaya, Kalyanpur, Garhwa – 822114 (First Cycle)',
  'Jagannath Jain College, Jhumri Tilaiya – 825409 (Second Cycle)',
  'Jagannath Nagar College, Sector III, Dhurwa, Ranchi – 834004 (First Cycle)',
  "Jamshedpur Women's College, Bistupur, Jamshedpur – 831001 (Third Cycle)",
  'Jamshedpur Workers’ College, Mango, Jamshedpur – 831012 (Second Cycle)',
  'Jawahar Lal Nehru College, Chakradharpur, West Singhbhum – 833102 (First Cycle)',
  'Jharkhand College, Ghutwali, Dumri – 825106 (First Cycle)',
  'Jubilee College, Bhurkunda, Ramgarh – 829135 (First Cycle)',
  "K. B. Women's College, Hazaribag – 825301 (First Cycle)",
  'K. S. G. M. College, Nirsa, Dhanbad – 828205 (First Cycle)',
  'Karam Chand Bhagat College, Bero, Ranchi – 835202 (First Cycle)',
  'Kartik Oraon College, Gumla – 835207 (Second Cycle)',
  'Katras College, Dhanbad – 828114 (First Cycle)',
  'Krishna Ballav College, Jarangdih, Bermo – 829113 (First Cycle)',
  'Kumar Kalidas Memorial College, Belia Danga, Pakaur – 816107 (First Cycle)',
  'Kumaresh International B.Ed. College, Rajwadih, Medininagar, Daltonganj, Palamu – 822118 (First Cycle)',
  'Lal Bahadur Shastri Memorial College, Karandih, East Singhbhum, Jamshedpur – 831002 (First Cycle)',
  'Langta Baba College, Babagram, Mizaganj, Giridih – 815315 (First Cycle)',
  'Maa Vindhyavashini College of Education, Karamtand, Surjapura, Padma, Hazaribagh – 825411 (First Cycle)',
  'Madhupur College, Patherchapti, Madhupur – 815353 (First Cycle)',
  'Mahila College, West Singhbhum Post, Chaibasa – 833201 (Second Cycle)',
  'Markham College of Commerce, Hazaribag – 825301 (First Cycle)',
  'Mayurakshi Gramin College, Ranishwar, Dumka – 814148 (First Cycle)',
  'P. T. P. S. College, Patratu, Ramgarh – 829119 (First Cycle)',
  'Parasnath Mahavidyalaya, Nimiyaghat, Giridih – 825167 (First Cycle)',
  'R.T.C. B.Ed. College, Buti, Ranchi – 834009 (First Cycle)',
  "Rajeev Gandhi Memorial Teachers' Training College, Digwadih, Patherdih, Dhanbad – 828119 (First Cycle)",
  'Ram Narayan Yadav Memorial College, Barhi, Hazaribag – 825405 (First Cycle)',
  'Rama Devi Bajla Mahila Mahavidyalaya, Deoghar – 814112 (First Cycle)',
  'Ran Vijay Smarak Mahavidyalaya, Sector 12D, Chas, Bokaro Steel City – 827012 (First Cycle)',
  "Ranchi Women's College, Ranchi – 834001 (Second Cycle)",
  'S. B. S. S. P. S. J. College, Pathargama, Godda – 814147 (First Cycle)',
  'Sahibganj College, Sahibganj – 816109 (First Cycle) Re-visit',
  'Santal Pargana College, Sonuadangal, Dumka – 814101 (First Cycle)',
  'Santal Pargana Mahila Mahavidyalaya, Dumka – 814101 (First Cycle)',
  'Silli College, Tutki Nawadih, Silli, Ranchi – 835102 (First Cycle)',
  'Sindri College, Sindri, Dhanbad – 828122 (First Cycle)',
  'Singhbhum College, Chandil – 832401 (First Cycle)',
  'Sri R. K. Mahila College, New Barganda, Giridih – 815301 (First Cycle)',
  'St. Columba’s College, Hazaribag – 825302 (First Cycle)',
  'Surat Pandey Degree College, Sahijana, Garhwa – 822114 (First Cycle)',
  'Swami Sahajanand College, Chas, Bokaro Steel City – 827013 (First Cycle)',
  'Tata College, Chaibasa – 833202 (First Cycle)',
  'The Graduate School College for Women, Jamshedpur – 831001 (Second Cycle)',
  'Visthapit Mahavidyalaya, Balidih, Bokaro Steel City – 827014 (First Cycle)',
  'Yodh Singh Namdhari Mahila Mahavidyalaya, Daltonganj – 822101 (Second Cycle)',
  'Yogoda Satsanga Mahavidyalaya, Jagannathpur, Dhurwa, Ranchi – 834004 (First Cycle)',
  'Bhadrakali College, Itkhori, Chatra – 825408 (First Cycle)',
  'Bharat Sewak Samaj Mahila Mahavidyalaya, Dhanbad – 826001 (First Cycle)',
  'Bokaro Steel Mines College, Bhawnathpur, Daltonganj, Garwha – 822112 (First Cycle)',
  'Janjatiya Sandhya (Degree) Mahavidyalaya, Ambedkar Nagar, Mihijam, Jamtara – 815354 (First Cycle)',
  'Mahila Mahavidyalaya, Kargil Chowk, Bhagalpur Road, Godda – 814133 (First Cycle)',
  'Ram Narayan Memorial College, Hunterganj, Chatra – 825403 (First Cycle)',
  'Kashi Sahu College ,Kharsawan,Seraikella - 833219 (First Cycle)',
  'Karim City College ,Post Sakchi,Jamshedpur - 831001 (Third Cycle)',
  'Vananchal College of Science,Vananchal College of Science Dental College Campus Farathiya-Hoor ,Garhwa - 822114 (First Cycle)',
  'MRS. KMPM VOCATIONAL COLLEGE, J. Road, Bistupur, Jamshedpur,Jamshedpur , 831001 (First Cycle)',
  'SARIYA COLLEGE, SURIYA,Suriya RLY Station-Hazaribag Road P.O.-Suriya, P.S- Suriya Dist- Giridih, SURIYA , 825320 (First Cycle)',
  "ST. XAVIER'S COLLEGE,P.O. Mahuadanr,,Mahuadanr , 822119 (First Cycle)",
  'SURAJ SINGH MEMORIAL COLLEGE,KANKE ROAD, RANCHI - 834008, Ranchi , 834008 (First Cycle)',
  'MAJDUR KISAN COLLEGE,DANDAR KALA, At- KARAR, P.O- Panki,PALAMU , 822122 (First Cycle)',
  'RAM LAKHAN SINGH YADAV COLLEGE RANCHI,KOKAR, INDUSTRIAL ESTATE RANCHI,Ranchi , 834001 (First Cycle)',
  'A. B. M. COLLEGE, JAMSHEDPUR,Golmuri, Near St. Joseph Church,Jamshedpur,Jharkhand,831003 (First Cycle)',
  'XITE GAMHARIA , XITE GAMHARIA, BEHIND TATA COMPLEX COLONY, GAMHARIA-832108, DIST-SARAIKELA-KHARSAWAN, JHARKHAND,GAMHARIA,Jharkhand,832108 (First Cycle)',
  'Mandar College,Mandar, Sosai,Ranchi - 835214 (First Cycle)',
  'A. N. Varadarajulu First Grade College, Gorur, Hassan – 573120 (Second Cycle)',
  'Acharya Pathasala College of Arts and Science, Bangalore – 560019 (Second Cycle)',
  'Acharya Pathasala College of Commerce, Bangalore – 560019 (Second Cycle)',
  'Acharya Pathasala Evening College of Arts and Commerce, Bangalore – 560019 (Second Cycle)',
  'Acharya Tulsi National College of Commerce,Shimoga – 577201 (Third Cycle)',
  'Al Ameen Arts, Science and Commerce College, Bangalore – 560027 (Third Cycle',
  'Anjuman Hami-E-Muslimeens Anjuman Arts, Science and Commerce College,Bhatkal, Uttar Kannada – 581320 (Second Cycle)',
  'Army Institute of Hotel Management and Catering Technology, Bangalore, 560077 (First Cycle)',
  'B. E. A. College of Education, Davanagere – 577004 (First Cycle)',
  'B. E. S. College,Jayanagar, Bangalore – 560011 (Second Cycle)',
  'B. G. S. College of Education, Nagamangala Taluk, Mandya – 571811 (First Cycle)',
  "B. L. D. E. A.'s S. B. Arts and K. C. P. Science College,Bijapur – 586103 (Third Cycle)",
  'B. M. S. Educational Trust B. M. S. College for Women, Bangalore – 560004 (Third Cycle)',
  'B. N. M. College,Bangalore – 560070 (Second Cycle)',
  'B. T. Chanaiah Gowramma Government First Grade College, Kodagu – 571236 (Second Cycle)',
  "B. V. V. Sangha's Basaveshwar College of Physical Education, Vidyagiri, Bagalkot – 587102 (Second Cycle)",
  "B. V. V. Sangha's College of Education, Bagalkot – 587101 (First Cycle)",
  'B.E.S. College of Education,Bangalore, 560011 (Second Cycle)',
  "Balavanthrao Varale Education Society's Dr. B. R. Ambedkar First Grade College, Hallikhed (B), Bidar – 585414 (Second Cycle)",
  'Ballari Institute of Technology & Management, New Allipur, Bellary, 583104 (First Cycle)',
  'BEL First Grade College,Jalahalli Post, Bangalore – 560013 (First Cycle)',
  'Besant Evening College,M. G. Road, Kodialbail, Mangalore – 575003 (Second Cycle)',
  "BET's Bharatesh Homoeopathic Medical College & Hospital,Belgaum, 590016 (First Cycle)",
  'BHS Higher Education Society Vijaya College, Bangalore – 560004 (Third Cycle)',
  'BIRDS Bachelor of Social Work College, Belgaum – 591224 (First Cycle)',
  "C. S. I., K. N. D., B. M. H. E. C.'s C. S. I. College of Commerce, Dharwad – 580001 (Second Cycle)",
  'C.G. Bellad Government First Grade College, Dist. Haveri, 581102 (First Cycle)',
  'C.S.I., K.N.D., B.M.H.E.C’s Kittel Arts College, Dharwad – 580001 (Second Cycle)',
  'Canara College, Mangalore – 575003 (Third Cycle)',
  'D.R.M. Science College, Davangere, 577004 (Third Cycle)',
  'D.S.B.G. Government First Grade College, Mudigere, 577132 (Second Cycle)',
  'Dayananda Sagar College of Engineering, Bangalore – 560078 (First Cycle)',
  'Dr. P. G. A. S. Samiti (R ) Gadag Pandit Panchaxara Gavaigalavara Music College, Gadag – 582101 (Second Cycle)',
  "Dr. Puttaraj Gavaigalavar Andar Shikshana Samiti's Pt. Panchaxara Gavaigalavar Arts College, Gadag – 582101 (Second Cycle)",
  'Dr. S. Gopalaraju Government First Grade College, Anekal – 562106 (Second Cycle)',
  'Global College of Business Administration,Hubli – 580031 (First Cycle)',
  "Good News Welfare Society's Arts & Commerce First Grade College, Dharwad Dist, 581204 (Second Cycle)",
  'Government Arts College, Chitradurga – 577501 (Third Cycle)',
  'Government College for Women, Maddur, Mandya – 571428 (Second Cycle)',
  'Government College, Sindhanur, Raichur – 584128 (Second Cycle)',
  'Government First Grade Arts and Commerce College, Shiggaon, Bankapur, Haveri – 581202 (First Cycle)',
  'Government First Grade College for Women, Davanagere, 577004 (First Cycle)',
  'Government First Grade College for Women, Hassan, 573201 (First Cycle)',
  'Government First Grade College For Women, Jamkhandi, Bagalkot – 587301 (First Cycle)',
  'Government First Grade College for Women, Mysore, 570018 (First Cycle)',
  'Government First Grade College, Afzalpur, Kalaburagi, Gulbarga – 585301 (First Cycle)',
  'Government First Grade College,Ajjampura, Chikmagalur – 577547 (Second Cycle)',
  'Government First Grade College,Arkalgud, Hassan – 573102 (Second Cycle)',
  'Government First Grade College, Bailhongal, Belgaum – 591121 (Second Cycle)',
  'Government First Grade College, Balagadi, Koppa, Chikamagalur – 577126 (Second Cycle)',
  'Government First Grade College, Bangalore – 560040 (Third Cycle)',
  'Government First Grade College, Bangalore Rural, Devanahalli – 562110 (Second Cycle)',
  'Government First Grade College, Bangalore, 560102 (First Cycle)',
  'Government First Grade College, BapujiNagara, Shimoga – 577201 (First Cycle)',
  'Government First Grade College, Dakshina Kannada, 574219 (First Cycle)',
  'Government First Grade College, Dist. Belagavi, 591239 (First Cycle)',
  'Government First Grade College, Dist. Chickmagalur, 577548 (Second Cycle)',
  'Government First Grade College, Dist. Tumkur, 572 201 (First Cycle)',
  'Government First Grade College, Harihara – 577601 (First Cycle)',
  'Government First Grade College, Hebbur, Tumkur – 572120 (First Cycle)',
  'Government First Grade College, Hirekerur, Haveri – 581111 (Second Cycle)',
  'Government First Grade College, Mudigere, Chikmagalur – 577124 (First Cycle)',
  'Government First Grade College, Koppal – 583231 (First Cycle)',
  'Government First Grade College,Channarayapatna, Hassan – 573116 (First Cycle)',
  'Government First Grade College,Chikkaballapur Dist, 562105 (Second Cycle)',
  'Government First Grade College, Chitradurga Dist, 577535 (Second Cycle)',
  'Government First Grade College,Krishnarajapete, Mandya – 571426 (Second Cycle)',
  'Government First Grade College,Kudugarhally, Sakleshpur, Hassan – 573134 (First Cycle)',
  'Government First Grade College, Madhugiri, Tumkur – 572132 (Second Cycle)',
  'Government First Grade College, Mandya Dist, 571438 (Second Cycle)',
  'Government First Grade College,Mangalore – 575001 (First Cycle)',
  'Government First Grade College, Mundgod – 581349 (Second Cycle)',
  'Government First Grade College, Mysore – 571101 (Second Cycle)',
  'Government First Grade College, Mysore, 570023 (Second Cycle)',
  'Government First Grade College, Navabagh, Bijapur – 586101 (First Cycle)',
  'Government First Grade College, Ramanagar Dist, 562120 (First Cycle)',
  'Government First Grade College, Ramanagara – 562159 (Second Cycle)',
  'Government First Grade College, Sedam, Gulbarga – 585222 (Second Cycle)',
  'Government First Grade College, Shahapur, Yadagir – 585223 (Second Cycle)',
  'Government First Grade College, Shimoga, 577227 (Second Cycle)',
  'Government First Grade College,Shimoga, 577432 (First Cycle)',
  'Government First Grade College,Shiralakoppa, Shikaripura, Shimoga – 577428 (First Cycle)',
  'Government First Grade College, Sorab, Shimoga – 577429 (Second Cycle)',
  'Government First Grade College, Tumkur, 572130 (Second Cycle)',
  'Government First Grade College,Turuvekere, Tumkur – 572227 (Second Cycle)',
  'Government First Grade Degree College,Jewargi, Gulbarga – 585310 (Second Cycle)',
  'Government Ramnarayan Chellaram Commerce and Management College, Bangalore – 560001 (Third Cycle)',
  'Government Science College, Chitradurga – 577501 (Third Cycle)',
  "Government Women's First Grade College, Jewargi Colony, Gulbarga – 585102 (First Cycle)",
  "H. K. E. Society's Shri Prabhu Arts, Science and J. M. Bohra Commerce College, Shorapur – 585224 (Second Cycle)",
  'H. P. P. C. Government First Grade College, Challakere, Chitradurga – 572160 (Third Cycle)',
  'Hasanamba College of Education, Hassan – 573201 (Second Cycle)',
  'Hoysaleshwara College, Arasikere, Hassan – 573103 (Second Cycle)',
  'Hyderabad Karnataka Education Society’s Seth Shankarlal Lahoti Law College, Gulbarga – 585102 (Second Cycle)',
  "Hyderabad Karnataka Education Society's M. S. Irani Degree College of Arts, Science and Commerce, Gulbarga – 585102 (Second Cycle)",
  "Hyderabad Karnataka Education Society's S. S. Margol College of Arts, Science and Commerce, Shahabad, Gulbarga – 585228 (Second Cycle)",
  'Indian Academy Degree College, Bangalore – 560043 (Second Cycle)',
  "J. E. Co-op. Society's Shri Kumareshwar Arts and Commerce College, Hangal, Haveri – 581104 (Second Cycle)",
  "J. E. Society's Krishnarao Annarao Lokapur Arts, Science and Commerce College, Athani, Belagavi – 591304 (First Cycle)",
  'Jindal First Grade College for Women, Bangalore – 560073 (First Cycle)',
  "K. L. E. Society's College of Education, Vidyanagar, Hubli – 580031 (Second Cycle)",
  "K. L. E. Society's Jagadguru Gangadhar College of Commerce, Hubli – 580021 (Third Cycle)",
  "K. L. E. Society's Raja Lakhamagouda Science Institute, Belgaum – 590001 (Third Cycle)",
  "K.N.V.V. Sangha's Arts & Commerce College, Dist. Belagavi, 591115 (Second Cycle)",
  'K.V.G. College of Engineering,Sullia, Dakshina Kannada Dist, 574327 (First Cycle)',
  "Kamala Nehru Memorial National Arts & Science Women's College, Shivmogga, 577201 (Second Cycle)",
  "Kanaka Welfare Trust's Divekar College of Commerce, Karwar – 581301 (Third Cycle)",
  'Karnataka Law Society’s Gogte College of Commerce,Belgaum, 590006 (Third Cycle)',
  "Khaja Education Society's Bi Bi Raza Degree College For Women Arts & Science, Gulbarga, 585104 (Second Cycle)",
  "Kittur Rani Channamma Education Society's College of Education, Belagavi – 591102 (First Cycle)",
  "KLE Society's Institute of Dental Sciences,Bangalore – 560022 (First Cycle)",
  'KLS Institute of Management Education and Research, Belgaum – 590011 (First Cycle)',
  'Kodachadri Government First Grade College, Shimoga – 577418 (Second Cycle)',
  'Krantiveer Sangolli Rayanna College of Education, Belagavi, 590010 (First Cycle)',
  'Kristu Jayanti College,Bangalore – 560077 (Second Cycle)',
  'Krupanidhi College of Pharmacy, Bangalore, 560035 (First Cycle)',
  'Kukke Sri Subrahmanyeshwara College, Mangalore – 574238 (Second Cycle)',
  'Kumadvathi College of Education,Shikaripura, Shivamogga – 577427 (First Cycle)',
  'M. E. S. College of Arts, Commerce and Science,Bangalore – 560003 (Third Cycle)',
  'M. L. Manjaiahsetty Narasimhasetty College of Education, Chikmagalur – 577102 (First Cycle)',
  'M.E.S. Teachers College, Bangalore, 560010 (Second Cycle)',
  'M.S. Ramaiah College of Arts, Science And Commerce, Bangalore, 560054 (Third Cycle)',
  'Madhava Pai Memorial College, Vidyanagar, Manipal, Udupi – 576104 (Second Cycle)',
  'Maharani Women’s Arts, Commerce & Management College, Bangalore, 560001 (Third Cycle)',
  'Maharani’s Science College for Women,Bangalore, 560001 (Third Cycle)',
  "Maharani's Arts College for Women, Mysore – 570005 (Third Cycle",
  "Maharani's Science College for Women,Mysore – 570002 (Third Cycle)",
  'Makanur Malleshappa College of Education,Davangere – 577004 (First Cycle)',
  "Mallamma Marimallappa Women's Arts and Commerce College, Mysore – 570024 (Second Cycle)",
  'Milagres College,Kallianpur, Udupi – 576114 (Third Cycle)',
  'Moti Mahal College of Hotel Management, Mangalore – 575001 (First Cycle)',
  'Nagarjuna College of Engineering and Technology,Bangalore – 562164 (First Cycle)',
  'National and Rural Education Association (R) Acharya First Grade College for Women, Gauribidanur, Chikkaballapur – 561208 (Second Cycle)',
  'Navodaya Dental College, Raichur, 584103 (First Cycle)',
  'Navodaya First Grade College, Tumkur – 572214 (Second Cycle)',
  'New Horizon College of Engineering,Bangalore – 560103 (First Cycle)',
  "Nitte Education Trust's Dr. Nitte Shankara Adyanthaya Memorial First Grade College, Karkala – 574110 (Third Cycle)",
  'Nitte Meenakshi Institute of Technology (Autonomous), Yelahanka, Bangalore, 560064 Karnataka (First Cycle)',
  'P. E. S. College, Bangalore – 560050 (Second Cycle)',
  'Padmashree Institute of Management and Sciences, Bangalore – 560060 (First Cycle)',
  'PES College of Pharmacy, Bangalore – 560050 (First Cycle)',
  'R. V. College of Engineering, Bangalore – 560059 (First Cycle)',
  'Rajajinagar College of Education, Rajajinagar, Bangalore – 560010 (First Cycle)',
  'Rashtreeya Shikshana Samithi Trust N. M. K. R. V. College for Women, Jayanagar, Bangalore – 560011 (Third Cycle)',
  'Rashtreeya Sikshana Samithi Trust, D.A. Pandu Memorial R.V. Dental College, Bangalore, 560078 (Second Cycle)',
  'Rudragouda Patil Government First Grade College, Dist. Bagalkot, 587116 (Second Cycle)',
  'S. J. M. Vidyapeetha (R), Chitradurga, Sri Jagadguru Murugharajendra First Grade College of Arts and Commerce, Chikmagalur – 577228 (Second Cycle)',
  "S. V. E. Trust's S. B. C. S. Arts and S. V. Commerce and Science College,Bidar – 585330 (Second Cycle)",
  'S.J.M.V. Mahantha First Grade College of Arts & Commerce, Dharwad, 580009 (Second Cycle)',
  'S.S.Khuba Basaveshwar College of Arts And Science,Dist. Bidar, 585327 (Second Cycle)',
  'Sanjay Gandhi College of Education,Bangalore – 560032 (First Cycle)',
  'Sarada Vilas Teachers College, Mysore – 570004 (Second Cycle)',
  'Sarosh Institute of Hotel Administration, Mangalore – 575007 (Second Cycle)',
  'Shantiniketan B.Ed. College,Bangalore,560076 (First Cycle)',
  'Sharanabasaveshwara College of Commerce,Gulbarga – 585103 (Second Cycle)',
  "Shree Vrushabhendra Education Society's Arts & Commerce College, Belgaum Dist, 591220 (Second Cycle)",
  'Shri Dharmasthala Manjunatheshwar College of Dental Sciences & Hospital, Dharwad, 580009 (Third Cycle)',
  'Shri Dharmasthala Manjunatheshwara College (Autonomous),Dakshina Kannada, 574240 (Third Cycle)',
  'Shri Jagadguru Renukacharya College of Science, Arts and Commerce, Bangalore – 560009 (Third Cycle)',
  'Shri Jagadguru Renukacharya Grameen Vidyapeetha Shiggaon, Shri Rambhapuri Jagadguru Veeragangadhar Arts and Commerce College, Shiggaon – 581205 (Second Cycle)',
  'Shri Kumareshwar College of Education,Haveri, Hangal – 581104 (First Cycle)',
  'Sitadevi Ratanchand Nahar Adarsh College, Bangalore – 560018 (Second Cycle)',
  'Smt. Bhagyalakshmamma Rattehalli Ramappa Mahajana First Grade College, Mysore,570012 (Third Cycle)',
  "Smt. Giriyamma R. Kanthappa Shresti First Grade Women's College, Harihar – 577601 (Second Cycle)",
  'Smt. Rukmini Shedthi Memorial National Government First Grade College, Dist. Udupi, 576210 (Second Cycle)',
  "South Konkan Education Society's Govindram Seksaria Science College, Belgaum – 590006 (Third Cycle)",
  'Sri Adichunchanagiri College of Education,Hassan – 573116 (First Cycle)',
  'Sri Adichunchanagiri First Grade College,Channarayapatna, Hassan – 573116 (Second Cycle)',
  'Sri Channappaswamy Vidyapetha Sri Mruthunjaya Shivacharya First Grade College of Arts and Commerce, Davanagere – 577217 (Second Cycle)',
  'Sri H. D. Devegowda Government First Grade College,Paduvalahippe, Hassan – 573211 (First Cycle)',
  'Sri Jagadguru Murusaviramatta Vidyavardhaka Sangha Arts and Commerce College for Women, Hubli – 580020 (Third Cycle)',
  'Sri Jagadguru Renukacharya Education Society S. J. R. College for Women, Bangalore – 560010 (Third Cycle)',
  'Sri Kolli Nageshwara Rao Gangaiah Government First Grade College, Dist. Koppal, 583227 (Second Cycle)',
  'Sri Kongadiyappa College, Bangalore – 561203 (Second Cycle)',
  'Sri Krishna Degree College, Bangalore, 560085 (First Cycle)',
  'Sri Kuvempu First Grade College, Ramanagara Dist, 571502 (Second Cycle)',
  'Sri Manjunathaswamy First Grade College, Davangere, 577004 (First Cycle)',
  'Sri Siddhartha First Grade College, Tumkur, 572105 (Second Cycle)',
  'Sri. Sri. Shivalingeshwaraswamy Government First Grade College, Davanagere, 577213 (Second Cycle)',
  'Srisaila College of Education, Vageesha Nagar, Harihar – 577601 (First Cycle)',
  'St. Aloysius College (Autonomous), Mangalore, 575003 (Third Cycle)',
  'St. Ann’s College of Education (Autonomous), Mangalore, 575001 Karnataka ( Third Cycle)',
  "St. Anne's Degree College for Women, Bangalore – 560008 (First Cycle)",
  'St. Francis De Sales College, Bangalore, 560100 (First Cycle)',
  "St. Joseph's College of Commerce (Autonomous), Bangalore, Karnataka (Third Cycle)",
  "St. Mary's College, Udupi – 574116 (Third Cycle)",
  'St. Philomena College, Puttur – 574202 (Third Cycle)',
  'T. John Institute of Management and Science,Bangalore – 560083 (First Cycle)',
  "T. S. P. Mandal's C. M. Managuli Arts and Science College, Bijapur – 586128 (Second Cycle)",
  "Tagore Memorial Education Association's Sita Subbaraju Memorial College, Raichur – 584101 (Second Cycle)",
  'Teresian College, Mysore – 570011 (Third Cycle)',
  'The Academy of General Education Manipal Sri Bhuvanendra College, Udupi – 574104 (Third Cycle)',
  'The Institute of Education Trust Basudev Somani College, Mysore, 570023 (Second Cycle)',
  'The National College, Bagepalli,Chikkaballapur – 561207 (Second Cycle)',
  'TMAES College of Education, Gangavathi, Koppal – 583227 (First Cycle)',
  'V.V.N. Degree College, Bangalore, 560004 (Second Cycle)',
  "Valaballary Channabasaveshwar Education Society's Arts and Commerce College, Dist. Raichur, 584122 (Second Cycle)",
  'Veerashaiva College, Bellary – 583104 (Third Cycle)',
  "Yuvaraja's College, Mysore – 570005 (Third Cycle)",
  'A. C. S. College of Engineering, Bengaluru – 560074 (First Cycle)',
  'A. D. B. First Grade College, Harapanahalli, Davanagere – 583131 (Third Cycle)',
  'A. R. G. College of Arts and Commerce, Davanagere – 577004 (Third Cycle)',
  'A. V. Kamalamma College for Women, Davangere – 577002 (Third Cycle)',
  'Acharya and B. M. Reddy College of Pharmacy, Soldevanahalli, Hesaraghatta, Bengaluru – 560090 (Second Cycle)',
  'Acharya Institute of Graduate Studies, Soldavenahalli, Chikkabanavara, Bengaluru – 560090 (Second Cycle)',
  "Acharya's Bangalore B-School (ABBS), Bengaluru – 560091 (Second Cycle)",
  'Adi Dravida Vidya Samsthe (R) A. D. V. S. First Grade College, Davanagere – 577224 (Second Cycle)',
  'Adichunchanagiri Institute of Technology, Jyothinagar, Chikmagalur – 577102 (First Cycle)',
  'Al-Ameen College of Law, Bangalore – 560027 (First Cycle)',
  'Al-Ameen Institute of Management Studies, Bengaluru – 560027 (First Cycle)',
  'AMC Engineering College, Bengaluru – 560083 (First Cycle)',
  'Anjuman-e-Islam’s Nehru Arts, Science and Commerce College, Ghantikeri, Hubli – 580020 (Third Cycle)',
  "Anjuman-e-Islam's Anjuman Arts, Science and Commerce College, Vijayapura – 586101 (Third Cycle)",
  'Army Institute of Fashion and Design, Bangalore – 560077 (First Cycle)',
  'Atria Institute of Technology, Anand Nagar, Bengaluru – 560024 (First Cycle)',
  'B. L. D. E. Association’s New Arts College, Bijapur – 586130 (Third Cycle)',
  "B. L. D. E. Association's A. S. Patil College of Commerce, Vijayapura – 586103 (Third Cycle)",
  "B. L. D. E. Association's Commerce, B. H. S. Arts and T. G. P. Science College, Bagalkot – 587302 (Third Cycle)",
  "B. L. D. E. Association's Smt. Bangaramma Sajjan Arts and Commerce College for Women, Vijayapura – 586101 (Third Cycle)",
  'B. M. S. Institute of Technology and Management, Yelahanka, Bengaluru – 560064 (First Cycle)',
  'B. V. Bhoomaraddi College of Arts, Science and Commerce, Bidar – 585403 (Third Cycle)',
  "B. V. V. S. Akkamahadevi Women's Arts, Science and Commerce College, Bagalkot – 587101 (First Cycle)",
  'B. V. V. Sangha’s Basaveshwar Commerce College, Bagalkot – 587101 (Third Cycle)',
  "B. V. V. Sangha's S. R. Kanthi Arts, Commerce and Science College, Mudhol, Bagalkot – 587313 (Third Cycle)",
  'Baldwin Women’s Methodist College, Bangalore – 560025 (First Cycle)',
  'Bapuji Dental College and Hospital, Davanagere – 577004 (Second Cycle)',
  'Bapuji Educational Association M. S. B. Arts and Commerce College, Davangere – 577002 (Third Cycle)',
  'Bapuji First Grade College, Challakere, Chitradurga – 577522 (First Cycle)',
  'Basaveshwara College of Commerce, Arts and Science, Rajajinagar, Bengaluru – 560010 (Third Cycle)',
  'Besant Women’s College, Kodialbail, Mangalore – 575003 (Third Cycle)',
  'BET Sadathunnisa College, Bismillahnagar, Bengaluru – 560029 (First Cycle)',
  'BGS Institute of Management Studies, Chikkaballapur – 562101 (First Cycle)',
  'Bhandarkars’ Arts and Science College, Vaderhobli, Kundapura, Udupi – 576201 (Third Cycle)',
  'Bharathi Education Trust (R) Bharathi College, Bharathinagara, Maddur – 571422 (Third Cycle)',
  'Bharatiya Samskriti Vidyapith Arts and Commerce College for Women, Bangalore – 560040 (Third Cycle)',
  'Bheemanna Khandre Institute of Technology, Bhalki, Bidar – 585328 (First Cycle)',
  'BNM Institute of Technology, BSK 2nd Stage, Bengaluru – 560070 (First Cycle',
  "Byadgi Education Society's Merchants’ Arts and Commerce College, Byadgi – 581106 (Third Cycle)",
  'C. B. Bhandari Jain College, Shankarapuram, Bengaluru – 560004 (First Cycle)',
  'C. B. R. National College of Law, Shimoga – 577201 (Second Cycle)',
  "C. S. Tubachi Education Society's Shri Shivabasavaswamiji Naganur Arts and Commerce College, Hukkeri, Belgaum – 591309 (Third Cycle)",
  'Cambridge Institute of Technology, K. R. Puram, Bengaluru – 560036 (First Cycle)',
  'Cauvery College, Gonikoppal, Kodagu – 571213 (Third Cycle)',
  'Cauvery College, Virajpet, Kodagu – 571218 (Third Cycle)',
  'Channabasaveshwara Institute of Technology, Gubbi, Tumkur – 572216 (First Cycle)',
  'CMR Institute of Technology, Bengaluru – 560037 (First Cycle)',
  'College of Fine Arts, Karnataka Chitrakala Parishat, Bengaluru – 560001 (Third Cycle)',
  'Crossland College, Udupi – 576213 (Third Cycle)',
  "CTE's Smt. A. A. Patil College of Arts and Commerce for Women, Chikodi, Belagavi – 591201 (Second Cycle)",
  'D. Banumaiah’s College of Commerce and Arts, Mysore – 570002 (Second Cycle)',
  "Dakshin Maharashtra Shikshan Mandal's Bhaurao Kakatkar College (Arts, Science and Commerce), Belgaum – 590001 (Third Cycle)",
  'District Madakarinayaka Association (R), Chitradurga Maharaja Madakarinayaka First Grade College for Arts and Commerce, Chitradurga – 577501 (Third Cycle)',
  'Dr. A. V. Baliga College of Arts and Science, Kumta, Uttar Kannada – 581362 (Third Cycle)',
  'Dr. Ambedkar Institute of Technology, Malathahalli, Bengaluru – 560056 (First Cycle)',
  'Dr. S. R. Chandrasekhar Institute of Speech and Hearing, Kariyanapalya, Bengaluru – 560084 (First Cycle)',
  'East West Institute of Technology, Bengaluru – 560091 (First Cycle)',
  'G. V. P. P. Government First Grade College, Hagaribommanahalli, Bellary – 583212 (Second Cycle)',
  "G.E.C.'s G. S. Patil Arts and Commerce College, Kundgol, Hubli – 581113 (First Cycle)",
  'Garden City College of Science and Management Studies, Bangalore – 560049 (Third Cycle)',
  'Global Academy of Technology, Rajarajeshwari Nagar, Bengaluru – 560098 (First Cycle)',
  'GM Institute of Technology, Davangere – 577006 (First Cycle)',
  'Godutai Doddappa Appa Arts and Commerce College for Women, Gulbarga – 585103 (Third Cycle)',
  'Gokhale Centenary College, Ankola, Uttar Kannada – 581314 (Third Cycle)',
  'Government Arts and Science College, Kajubag, Uttara Kannada, Karwar – 581301 (Third Cycle)',
  'Government Arts College, Bangalore – 560001 (Third Cycle)',
  'Government College for Women, Chintamani, Chickaballapur – 563125 (Third Cycle)',
  'Government College for Women, M. C. Road, Mandya – 571401 (Third Cycle)',
  'Government College, M. C. Road, Mandya – 571401 (Third Cycle)',
  'Government Degree College, Yadgir – 585202 (Second Cycle)',
  'Government First Grade College, Yelahanka, Bengaluru – 560064 (First Cycle)',
  'Government First Grade College for Women, Holenarsipura, Hassan – 573201 (First Cycle)',
  'Government First Grade College For Women, K. R. Nagar, Mysore – 571602 (First Cycle)',
  'Government First Grade College for Women, Magadi Road, Rayaradoddi, Ramanagara, Bengaluru – 562159 (First Cycle)',
  'Government First Grade College of Arts, Science and Commerce, Sirsa, Tumkur – 572137 (Second Cycle)',
  'Government First Grade College, Alnavar, Dharwad – 581103 (Second Cycle)',
  'Government First Grade College, APMC Yard, Sandur, Ballary – 583119 (First Cycle)',
  'Government First Grade College, Arasikere, Banavara, Hassan – 573112 (First Cycle)',
  'Government First Grade College, Bada Road, Santebennur Channagiri, Davanagere – 577552 (First Cycle)',
  'Government First Grade College, Bangaruthirupathi, Hulkur Post, via Bethamangala, Bagarpet, Kolar – 563116 (First Cycle)',
  'Government First Grade College, Bettampady, Dakshina Kannada, Puttur – 574259 (Third Cycle)',
  'Government First Grade College, Bilikere Hobli, Hunsur, Mysore – 571103 (First Cycle)',
  'Government First Grade College, Chikkanayakanahalli, Tumkur – 572214 (First Cycle)',
  'Government First Grade College, Dakshina Kannada, Sullia – 574239 (First Cycle)',
  'Government First Grade College, Gandasi, Lalanakere, Arasikere, Hassan – 573164 (First Cycle)',
  'Government First Grade College, Gandhinagar, Kushtagi, Koppal – 583277 (First Cycle)',
  'Government First Grade College, Gandhipur, Guttal Road, Haveri – 581110 (First Cycle)',
  'Government First Grade College, Gudgeri, Kundagol, Dharwad – 581107 (First Cycle)',
  'Government First Grade College, Gundlupet, Chamarajanagar – 571111 (First Cycle)',
  'Government First Grade College, Halebeedu, Cheelanayakana Halli, Belur, Hassan – 573121 (First Cycle)',
  'Government First Grade College, Haleyangady, Dakshina Kannada, Mangalore – 574146 (Third Cycle)',
  'Government First Grade College, Hangal, Haveri – 581104 (First Cycle)',
  'Government First Grade College, Harihar, Harapanahalli, Davangere – 583131 (First Cycle)',
  'Government First Grade College, Haunsbhavi Road, Byadgi, Haveri – 581106 (First Cycle)',
  'Government First Grade College, Heggadadevanakote, Mysore – 571114 (First Cycle)',
  'Government First Grade College, Hirebidanur Post, Gouribidanur, Chikkaballapur – 561208 (First Cycle)',
  'Government First Grade College, Hiriadka, Udupi – 576113 (First Cycle)',
  'Government First Grade College, Holalkere, Chitradurga – 577526 (First Cycle)',
  'Government First Grade College, Honnali, Davangere – 577217 (First Cycle)',
  'Government First Grade College, Hosahalli Gate, Jajur, Arsikere, Hassan – 573103 (First Cycle)',
  'Government First Grade College, Hosapete Road, Kampli – 583132 (First Cycle)',
  'Government First Grade College, Hoskote, Bangalore Rural – 562114 (Third Cycle)',
  'Government First Grade College, Hulsoor, Basavakalyan, Bidar – 585416 (First Cycle)',
  'Government First Grade College, Humanabad Road, Chitguppa, Bidar – 585412 (First Cycle)',
  'Government First Grade College, Hunashikatti Road, Ranebennur, Haveri – 581115 (First Cycle)',
  'Government First Grade College, Hunnur, Jamkhandi, Bagalkot – 587119 (First Cycle)',
  'Government First Grade College, Jnanadhara Campus, Kumareshwar Nagar, Dharwad – 580008 (First Cycle)',
  'Government First Grade College, Jog Road, Siddapur, Uttara Kannada – 581355 (First Cycle)',
  'Government First Grade College, Kalidas Nagar, Kundgol, Dharwad – 581113 (First Cycle)',
  'Government First Grade College, Kethaganahalli Road, Bidadi, Ramanagaram – 562109 (First Cycle)',
  'Government First Grade College, Khanapur, Belagavi – 591302 (First Cycle)',
  'Government First Grade College, Kittur, Bailhongal, Belgaum – 591115 (First Cycle)',
  'Government First Grade College, Koppa, Maddur, Mandya – 571425 (First Cycle)',
  'Government First Grade College, Kuderu, Chamarajanagar – 571316 (First Cycle)',
  'Government First Grade College, Mandya – 571432 (First Cycle)',
  'Government First Grade College, Mangasuli Road, Indira Nagar, Ainapur, Athani, Belgaum – 591303 (First Cycle)',
  'Government First Grade College, Manki Hobali, Honnavara, Uttara Kannada – 581348 (First Cycle)',
  'Government First Grade College, Mariyammanahalli, Hospet, Bellary – 583222 (First Cycle)',
  'Government First Grade College, Mudhol, Bagalkot – 587313 (First Cycle)',
  'Government First Grade College, Muroor Road, Kumta, Uttar Kannada, Karwar – 581343 (First Cycle)',
  'Government First Grade College, Nagasamudra Road, Narasapur, Betgeri, Gadag – 582102 (First Cycle)',
  'Government First Grade College, Nanjangud – 571301 (First Cycle)',
  'Government First Grade College, Narasimharajapura, Chikmagalur – 577134 (Second Cycle)',
  'Government First Grade College, Naubad, Bidar – 585402 (Second Cycle)',
  'Government First Grade College, Nelamangala, Bengaluru Rural – 562123 (First Cycle)',
  'Government First Grade College, Pandavapura, Mandya – 571434 (First Cycle)',
  'Government First Grade College, Parashuramapura, Challakere, Chitradurga – 577538 (First Cycle)',
  'Government First Grade College, Periyapatna, Mysore – 571107 (First Cycle)',
  'Government First Grade College, Poojageri, Basgod, Uttara Kannada, Ankola – 581353 (First Cycle)',
  'Government First Grade College, Rajnagar, Hubli – 580032 (First Cycle)',
  'Government First Grade College, Ripponpet, Hosanagara, Shimoga – 577426 (First Cycle)',
  'Government First Grade College, Saligrama, Mysore – 571604 (First Cycle)',
  'Government First Grade College, Shorapur, Yadgir – 585224 (Second Cycle)',
  'Government First Grade College, Udayapura, Channarayapatna, Hassan – 573225 (First Cycle)',
  'Government First Grade College, Vemagal, Kolar – 563102 (First Cycle)',
  'Government First Grade College, Vidhya Nagara, Byndoor, Kundapur, Udupi – 576214 (First Cycle)',
  'Government First Grade College, Vidyanagar, Hungund, Bagalkot – 587118(First Cycle)',
  'Government First Grade College, Virajpet, Kodagu, Madikeri – 571218 (First Cycle)',
  'Government First Grade College, Yelburga, Koppal – 583236 (First Cycle)',
  'Government Home Science College, Holenarasipura, Hassan – 573211 (First Cycle)',
  'Government Science College, Bangalore – 560001 (Third Cycle)',
  'Government Womens College, Hunsur, Mysore – 571105 (First Cycle)',
  'H. C. Boraiah Memorial SC/ST First Grade College, Davangere – 577528 (Second Cycle)',
  'H. K. E. Society’s A. V. Patil Arts, Science and Commerce College, Gulbarga – 585302 (Second Cycle)',
  'H. K. E. Society’s Smt. Chinnamma Basappa Patil Arts and Commerce Degree College, Gulbarga – 585307 (Second Cycle)',
  'Hasanath College for Women, Bangalore – 560042 (Third Cycle)',
  'Hindu Vidyadayinee Sangh (R) Surathkal Govinda Dasa College, Mangalore – 575014 (Third Cycle)',
  'HKBK College of Engineering, Nagawara, Bengaluru – 560045 (First Cycle)',
  "Hyderabad Karnataka Education Society's Sree Veerendra Patil Degree College of Science, Arts and Commerce, Bengaluru – 560080 (Third Cycle)",
  'I. D. S. G. Government College, Chikmagalur – 577102 (Third Cycle)',
  'IFIM College, Bangalore – 560100 (First Cycle)',
  'Institute of Aerospace Medicine (IAF), Vimanapura Post, Bengaluru – 560017 (Second Cycle)',
  'International Academy of Management and Entrepreneurship, Bangalore - 560082 (First Cycle)',
  'J. S. S. Arts, Science and Commerce College, Gokak, Belgaum – 591307 (Third Cycle)',
  'J. S. S. College for Women, Double Road, Chamarajanagar – 571313 (Third Cycle)',
  'J. S. S. College for Women, Mysore – 570009 (Third Cycle)',
  'J.S.S. Banashankari Arts, Commerce and Shantikumar Gubbi Science College, Dharwad – 580004 (Third cycle)',
  'Jagadguru Panchacharya College of Education, Gadag – 582101 (First Cycle)',
  "Janopakari Sri Doddanna Shetty's S. L. N. College of Arts and Commerce, Bangalore – 560002 (Second Cycle)",
  'Jawaharlal Nehru National College of Engineering, Navule, Shimoga – 577204 (Re-visit,First Cycle)',
  'K. L. E. Society’s Arts and Commerce College, Gadag – 582101 (Third Cycle)',
  'K. L. E. Society’s G. I. Bagewadi Arts, Science and Commerce College, Belagavi – 591237(Third Cycle)',
  'K. L. E. Society’s Gudleppa Hallikeri Arts, Science and Commerce College, Haveri – 581110 (Third Cycle)',
  'K. L. E. Society’s Jagadguru Tontadarya College, Gadag – 582101 (Third Cycle)',
  'K. L. E. Society’s Lingaraj College, Belagavi – 590001 (Third Cycle)',
  'K. L. E. Society’s S. Nijalingappa College, Bangalore – 560010 (Third Cycle)',
  'K. L. E. Society’s S. V. S. Bellubbi Arts and Commerce College, Belgaum – 591126 (Third Cycle)',
  'K. L. E. Society’s Shri Kadasiddheshwar Arts College and H. S. Kotambri Science Institute, Hubli – 580031 (Third Cycle)',
  'K. L. E. Society’s Shri Shivayogi Murughendra Swamiji Arts, Science and Commerce College, Belgaum – 591304 (Third Cycle)',
  "K. L. E. Society's Basavaprabhu Kore Arts, Science and Commerce College, Belgaum – 591201 (Third Cycle)",
  "K. L. E. Society's P. C. Jabin Science College, Vidyanagar, Hubli, Dharwad – 580031 (Fourth Cycle)",
  'K. L. S. Gogte Institute of Technology, Belgaum – 590008 (First Cycle)',
  "K. R. C. E. Society's G. G. Deshanur Arts, B. M. Patil Commerce and S. V. Sadhunavar Science College, Bailhongal, Belagavi – 591102 (Third Cycle)",
  "K. R. E. Society's Karnatak Arts, Science and Commerce College, Bidar – 585401 (Third Cycle)",
  'K. S. S. Arts, Commerce and Science College, Gadag – 582101 (Third Cycle)',
  "K. S. Samiti's Vijayanagar College of Education, Vidyanagar, Hubli – 580031 (First Cycle)",
  'Kalpataru First Grade Science College, Tumkur – 572202 (Third Cycle)',
  "Karnatak Lingayat Education Society's Shri Channagirishwar Prasadik Arts and D. D. Shirol Commerce College, Mudhol, Mahalingpur, Bagalkot – 587312 (Third Cycle)",
  'Karnataka College of Management and Science, Bengaluru – 560064 (First Cycle)',
  'Kottureshwara College, Kottur, Kudligi, Bellary – 583134 (Third Cycle)',
  'Kotturswamy College of Teacher Education, Gandhinagar, Bellary – 583103 (First Cycle)',
  'Krupanidhi College of Pharmacy, Chikkabellandur, Carmelaram Post, Varthur Hobli, Bengaluru – 560035 (First Cycle, Re-assessment)',
  'Lakshmi Soma Bangera Government First Grade College, Kota Padukere, Udupi – 576221 (First Cycle)',
  'M. E. S. Arts and Commerce College, Gokak, Mudalgi, Belgaum – 591312 (Third Cycle)',
  'M. Krishna Law College, Hassan – 573201 (Second Cycle)',
  'M. M. K. College of Visual Art, Kalaburgi, Gulbarga – 585105 (Second Cycle)',
  "M. P. E. Society's S. D. M. Arts, Science and Commerce College, Honavar, Uttar Kannada, Karwar – 581334 (Third Cycle)",
  'M. S. Engineering College, Bangalore – 562110 (First Cycle)',
  'M. S. Padmavathamma M. K. Sambasivasetty College for Women, Chickmagalur – 577101(First Cycle)',
  'M. V. A. S. Shri K. G. Nadgir College of Physical Education, Dharwad – 580008 (First Cycle)',
  'Maharani Lakshmi Ammanni College for Women, Bangalore – 560012 (Third Cycle)',
  'Mahatma Gandhi Memorial College, Udupi – 576102 (Third Cycle)',
  'Malleswaram Ladies’ Association First Grade College for Women, Malleswaram, Bengaluru – 560003 (Third Cycle)',
  'Manjunatha Pai Memorial Government First Grade College of Professional and Business Management, Kabettu, Karkala – 574104 (Third Cycle)',
  "Maratha Mandal's Arts, Commerce, Science and Home Science College, Belgaum – 590016 (Third Cycle)",
  'Miranda College of Education, Bangalore – 560075 (First Cycle)',
  "Modern Education Society's Law College, Sirsi – 581402 (Second Cycle) (Assessed prior to July 2016)",
  'Mulki Sunder Ram Shetty College, Shirva, Udupi – 574112 (Third Cycle)',
  'New Horizon College of Education, Bangalore – 560008 (Second Cycle)',
  'NMAM Institute of Technology (Autonomous), Karkala, Udupi – 574110 (First Cycle) Re-assessment',
  'P. E. S. College of Science, Arts and Commerce, Mandya – 571401 (Third Cycle)',
  'Pallagatti Adavappa Arts and Commerce First Grade College, Tiptur, Tumakuru – 572202 (Third Cycle)',
  'Pompei College, Mangalore – 574141 (Third Cycle)',
  'Poornaprajna College, Volakadu, Udupi – 576101 (Third Cycle)',
  'Presidency College, Kempapura, Hebbal, Bengaluru – 560024 (Second Cycle)',
  "Progressive Education Trust's S. M. Bhandari Arts, R. R. Bhandari Commerce and S. K. Rathi Science College, Guledgudda, Bagalkot – 587203 (Third Cycle)",
  "R.B.A.N.M.'s First Grade College, Bangalore – 560042 (Third Cycle)",
  'Rajarajeswari College of Engineering, Bengaluru – 560074 (First Cycle)',
  'Rao Bahadur Y Mahabaleswarappa Engineering College, Bellary – 583104 (First Cycle)',
  'RNS Institute of Technology, Rajarajeshwari Nagar, Channasandra, Bengaluru – 560098 (First Cycle)',
  "S. A. V. V. P. Samiti's Shri Annadaneshwar Arts, Science and Commerce College, Ron, Naregal, Gadag – 582119 (Third Cycle)",
  'S. D. V. S. Sangh’s Shri L. K. Khot College of Commerce, Sankeshwar, Hukkeri, Belagavi – 591313 (Third Cycle)',
  "S. D. V. S. Sangh's S. S. Arts College and T. P. Science Institute, Hukkeri, Sankeshwar, Belgaum – 591313 (Third Cycle)",
  "S. G. V. C. Vidya Prasarak Trust's Matoshri Gangamma Veerappa Chiniwar Arts, Commerce and Science College, Muddebihal, Bijapur – 586212 (Third Cycle)",
  'S. J. B. Institute of Technology, Kengeri, Bengaluru – 560060 (First Cycle)',
  'S. J. M. College of Pharmacy, Chitradurga – 577502 (First Cycle)',
  'S. J. M. Dental College and Hospital, Chitradurga – 577501 (First Cycle)',
  'S. K. V. P. Samiti’s Arts, Science and Commerce College, Gadag – 582203 (Second Cycle)',
  'S. P. Mandal’s Arts and Commerce College, Raibag, Belagavi – 591317 (Third Cycle)',
  'S. P. S. G. S. Government First Grade College, Kanakagiri, Gangavati – 583283 (First Cycle)',
  'S. S. R. College of Science and Management Studies, Kyalasanahalli, Kothanur, Bengaluru – 560077 (First Cycle)',
  'S. S. S. Samiti’s Mahaveer P. Mirji College of Commerce, Belgaum – 590010 (Third Cycle)',
  "S. S. V. V. Sangha's Shri G. R. Gandhi Arts and Shri Y. A. Patil Commerce College, Indi, Vijapura – 586209 (Third Cycle)",
  'Sacred Heart College, Belthangady, Madanthyar, Dakshina Kannada – 574224 (Third Cycle)',
  'Sahyadri Arts College, Shimoga – 577201 (Third Cycle)',
  'Sahyadri College of Engineering and Management, Adyar, Mangalore – 575007 (First Cycle)',
  'Sarada Vilas Educational Institutions (Regd.) Sarada Vilas College, Mysore – 570004 (Third Cycle)',
  'Sarvodaya College of Education, Virajpet, Madikeri – 571218 (First Cycle)',
  'School of Social Work, Mangalore – 575002 (Third Cycle)',
  'Seshadripuram College, Seshadripuram, Bengaluru – 560020 (Third Cycle)',
  'Seshadripuram First Grade College, Yelahanka New Town, Bengaluru – 560064 (Second Cycle)',
  'Shakuntalabai Ramachandrarao Kasbe College of Education, Raichur – 584101 (First Cycle)',
  'Shanthi Arts, Science and Commerce College, Malavalli, Mandya – 571430 (Third Cycle)',
  'Sharanabasaveshwar College of Arts, Gulbarga – 585103 (Second Cycle)',
  'Shivaji College of Education, Karwar – 581304 (First Cycle)',
  'Shree Jagadguru Fakkeereshwar Government First Grade College, Shirahatti, Gadag – 582120 (First Cycle)',
  'Shri Dharmasthala Manjunatheshwara College of Business Management, Kodialbail, Dakshina Kannada, Mangalore – 575003 (Third Cycle)',
  'Shri K. M. Mamani Government First Grade College, Saundatti-Yellamma, Belagavi – 591126 (First Cycle)',
  'Shri Mrityunjaya College of Arts and Commerce, Dharwad – 580008 (Third Cycle)',
  'Shri R. N. Deshpande Government First Grade College, Mulgund, Gadag – 582117 (First Cycle)',
  'Shri Sangameshwar Arts and Commerce College, Vijayapura – 586205 (Third Cycle)',
  'Shri Shivaji Education Society’s Mahasatee Arts, Commerce and Science College, Ulga, Karwar, Uttar Kannada – 581328 (Third Cycle)',
  'Shri Shripadbodh Swamiji Government First Grade College, Moodalagi, Gokak, Belagavi – 591312 (First Cycle)',
  'Shri Siddeshwara Government First Grade College, Nargund – 582207 (Third Cycle)',
  'Sidhartha Law College, Gulbarga – 585102 (Second Cycle)',
  'Sir M. V. Government Arts and Commerce College, New Town, Bhadravathi - 577301 (Third Cycle)',
  'Sir M. V. Government Science College, Bhadravathi, Shimoga – 577302 (Third Cycle)',
  'Sivananda Sarma Memorial R. V. College (SSMRV College), Jayanagar, Bengaluru – 560041 (Third Cycle)',
  'Smt. Allum Sumangalamma Memorial College for Women, Gandhinagar, Bellary – 583103 (Third Cycle)',
  'Smt. Danamma Channabasavaiah College of Arts, Commerce, Science and Management Studies, Kolar – 563101(First Cycle)',
  'Smt. I. S. Yadawad Government First Grade College, Ramdurg – 591123 (First Cycle)',
  'Smt. Nagarathnamma College of Nursing, Chikkabanavara, Bengaluru – 560090 (Second Cycle)',
  'Smt. Rudramba M. P. Prakash Government First Grade College, Huvinahadagali, Bellary – 583219 (First Cycle)',
  'Smt. Somavva C. Angadi Government First Grade College, Belagavi – 591109 (First Cycle)',
  'Smt. V. H. D. Central Institute of Home Science, Bangalore – 560001 (Third Cycle)',
  'Smt. Veeramma Gangasiri College for Women, Kalaburagi, Gulbarga – 585102 (Third Cycle)',
  "South Konkan Education Society's Rani Parvati Devi College of Arts and Commerce, Belagavi – 590006 (Third Cycle)",
  'Sree Siddaganga College of Education, Tumkur – 572102 (First Cycle)',
  'Sree Siddaganga First Grade College of Arts and Commerce, Nelamangala, Bengaluru Rural – 562162 (Third Cycle)',
  'Sri Adichunchanagiri Arts and Commerce College, Nagamangala, Mandya – 571432 (Third Cycle)',
  'Sri Aurobindo First Grade College for Women, Bengaluru – 560086 (Third Cycle)',
  'Sri Devaraj Urs Institute of Management, Kodigehalli, Doddaballapur, Bangalore Rural – 561203 (First Cycle)',
  'Sri Dhavala College, Mudbidri – 574227 (Third Cycle)',
  'Sri Honnadevi Government First Grade College, Dandinashivara, Turuvekere Taluk, Tumkur – 572215 (First Cycle)',
  'Sri Jagadguru Chandrashekaranatha Swamiji Institute of Technology, Chikkaballapur – 562101 (First Cycle)',
  'Sri Jagadguru Murugharajendra College of Arts, Science and Commerce, Chandravalli, Chitradurga – 577501 (Third Cycle)',
  'Sri K. H. Patil Government First Grade College, Hulkoti, Gadag – 582205 (First Cycle)',
  'Sri K. Venkatapatheppa College of Education, Chikkaballapur – 562101(First Cycle)',
  'Sri Mahaveera First Grade College, Mudbidri – 574197 (Third Cycle)',
  'Sri Murugha Rajendra Swamiji B.Ed. and M.Ed. College, Saraswatipur, Kalaburagi, Gulbarga – 585106 (First Cycle)',
  'Sri Rajiv Gandhi College of Dental Sciences and Hospital, Bengaluru – 560032 (First Cycle)',
  'Sri Sharada College, Kundapura, Udupi – 576211 (Third Cycle)',
  'Sri T. V. Venkataswamy College of Education, Tumkur – 572132 (First Cycle)',
  'Sri T. V. Venkataswamy First Grade College, Tumkur – 572132 (Second Cycle)',
  'Sri Taralabalu Jagadguru Education Society (Regd.) Sirigere B. Parameshwarappa Arts and Commerce College, Chitradurga – 577526 (Second Cycle)',
  'Sri Venkataramana Swamy College, Mangalore – 574211 (Third Cycle)',
  'St. Agnes College (Autonomous), Bendore, Mangalore – 575002 (Fourth Cycle)',
  'St. Joseph’s College of Education, Jayalakshmipuram, Mysore – 570012 (First Cycle)',
  'St. Joseph’s Evening College, Bangalore – 560025 (Third Cycle)',
  "St. Joseph's College (Autonomous), Lalbagh Road, Bengaluru – 560027 (Fourth Cycle)",
  'St. Mary’s Syrian College, Udupi – 576213 (Third Cycle)',
  'St. Paul’s College of Education, Bangalore – 560079 (First Cycle)',
  "SVMVVS's SVM Arts, Science and Commerce College, Ilkal, Bagalkot – 587125 (Third Cycle)",
  'Swamy Vivekananda Rural First Grade College, Chandapura, Anekal Taluk, Bengaluru – 560099 (First Cycle)',
  'T. John College, Gottigere, Bannerghatta Road, Bengaluru – 560083 (Third Cycle)',
  'T. M. A. E. S. College of Education, Davangere – 583131 (First Cycle)',
  'The National College, Jayanagar, Bengaluru – 560082 (Third Cycle)',
  'The Oxford College of Science, HSR Layout, Bengaluru – 560102 (Second Cycle)',
  'The Rural College, Kanakapura, Ramanagaram – 562117 (Third Cycle)',
  'Union Christian College, Tumkur – 572106 (Second Cycle)',
  'University College, Mangalore – 575001 (Third Cycle)',
  'V. M. S. R. Vastrad Arts, Science and V. S. Bellihal Commerce College, Hungund, Bagalkot – 587118 (Third Cycle)',
  "V. V. Sangha's Shree Khasgatesh College of Arts and Commerce, Bijapur – 586214 (Third Cycle)",
  'Vaikunta Baliga College of Law, Udupi – 576102 (First Cycle)',
  'Vidya Prasarak Mandal’s Shri S. R. Narasapur Arts and Shri M. B. Shirur Commerce College, Bagalkot – 587101 (Third Cycle)',
  "Vidya Prasarak Samiti's C. S. Bembalagi Arts, Sha. M. R. Palaresha Science and G. L. Rathi Commerce College, Killa Ramdurg, Belagavi – 591123 (Third Cycle)",
  'Vidya Vardhaka Sangha First Grade College, Basaveshwaranagar, Bengaluru – 560079 (Third Cycle)',
  'Vijaya College, Dakshina Kannada, Mangalore – 574154 (Third Cycle)',
  'Vijayanagar College, Hospet, Bellary – 583201(Third Cycle)',
  'Vivekananda College of Arts, Science and Commerce, Nehru Nagar, Dakshina Kannada, Puttur – 574203 (Third Cycle)',
  'Vivekananda Degree College, Rajajinagar II Stage, Bengaluru – 560055 (Third Cycle)',
  "B. V. V. Sangha's Basaveshwar Engineering College (Autonomous), Vidyagiri, Bagalkot – 587103 (First Cycle)",
  'Bapuji Institute of Engineering and Technology, Davangere – 577004 (First Cycle)',
  'Brindavan College of Engineering, Yelahanka, Bengaluru – 560063 (First Cycle)',
  'Government First Grade College, Sulikunte Road, Bangarpet, Kolar – 563114 (Second Cycle)',
  'Smt. Saraladevi Satishchandra Agarwal Government First Grade College, S N Pet, Bellary – 583101 (Third Cycle)',
  "BLDEA's Shri Sanganabasava Mahaswamiji College of Pharmacy and Research Centre (First Cycle)",
  'Malnad College of Engineering (First Cycle)',
  'Mangalore Institute of Technology and Engineering (First Cycle)',
  'Ramaiah College of Law (First Cycle)',
  'Sir M Visvesvaraya Institute of Technology (First Cycle)',
  'A. J. Institute of Management (Second Cycle)',
  "Janata Shikshan Sangha's Shree Tammannappa Chikodi Arts and Commerce College (Third Cycle)",
  'Nehru Memorial College (Third Cycle)',
  'P. E. S. College of Engineering, Mandya,K. V. Shankaragowda Road,Mandya - 571 401 (First Cycle)',
  'JSS Law College , (Autonomous) New Kantharaja Urs Road, Kuvempunagar,Mysore - 570023 (Third Cycle)',
  'Government First Grade College, Vamadapadavu, Bantwal ,Bantwal Tq., Dakshina Kannada ,Vamadapadavu - 574324 (Third Cycle)',
  'Bankatlal Rajaram Boob College of Commerce,Thimmapur Pet, Yerigera Road,Raichur - 584103 (Third Cycle)',
  'A. V. Kanthamma College for Women, Hassan,P B No 48, Near New City Bus Stand ,Hassan - 573201 (Third Cycle)',
  'Sree Siddaganga College of Arts, Science and Commerce,B H Road,Tumakuru - 572102 (Third Cycle)',
  'BLDEAs Vachana Pitamaha Dr. P. G. Halakatti College of Engineering and Technology,Asharam Road,Vijayapura - 586103 (First Cycle)',
  'Govt. First Grade College, Raibag,Mini Vidhan Soudha,Raibag - 591317 (First Cycle)',
  'Bashumiyan Sahukar Government First Grade College, Manvi,Sindhanur Road,Manvi - 584123 (Second Cycle)',
  'The Oxford College of Business Management,32, 17th B Main, Sector IV, HSR Layout,Bangalore - 560102 (Second Cycle)',
  "Dr.G.Shankar Government Women's First Grade College and P.G. Study Centre,Near District Stadium Ajjarkadu,Udupi - 576101 (Second Cycle)",
  'S. P. V. V. S. S. G. P. Porwal Arts, Commerce and V. V. Salimath Science College,Vijayapur Road, Vijayapur ,Sindgi-586128 (Third Cycle) ',
  'Field Marshal K. M. Cariappa College,Madikeri,Kodagu - 571201 (Third Cycle)',
  "Smt. Indira Gandhi Government First Grade Women's College,S N Nagar , Sagar,Shivamogga - 577401 (Third Cycle)",
  'Government First Grade College, Kushalnagar ,Harangi Road,Kushalnagar - 571234 (Third Cycle)',
  "Karnataka Peoples' Education Society's Dr. Ambedkar College of Arts and Commerce,Darga Road,Kalaburagi - 585101 (Third Cycle)",
  'Dayananda Sagar College of Arts, Science and Commerce,Shavige Malleshwara Hills, Kumaraswamy Layout,Bengaluru - 560078 (Third Cycle)',
  'St. Aloysius Evening College,P.B.No 720, Dakshina Kannada,Mangaluru - 575003 (Third Cycle)',
  "Shivaji Education Society's Shivaji Arts and Commerce College, Karwar,Baad,Karwar - 581304 (Third Cycle)",
  'Government First Grade College, Gubbi,Maranakatte ,Gubbi - 572216 (Third Cycle)',
  'JSS College of Arts and Commerce,Gundlupet,Chamarajanagar - 571111 (Third Cycle)',
  'S.E.A College of Science, Commerce Arts,Ekatanagar, Virgonagar Post, Ayyappanagar Circle, Devasandra Main Road, K.R.Puram,Bengaluru - 560049 (First Cycle)',
  'RR Institute of Technology,Raja Reddy Layout, Near Chikkbanavara Railway Station, Chikkabanavara ,Bengaluru - 560090 (First Cycle)',
  'Government First Grade College, Bhalki,Opp. BKIT Engineering College, Humnabad Road, Beside Idga Maidan, Bhalki,Bidar - 585328 (First Cycle)',
  'MVJ College of Engineering,Near ITPB, Whitefield,Bengaluru - 560067 (First Cycle)',
  'Vidyavardhaka College of Engineering,P.B.No 206, Gokulam 3rd Stage,Mysuru - 570002 (First Cycle)',
  'Government First Grade College, Chickballapur,M. G. Road,Chickballapur - 562101 (Second Cycle)',
  'National College, Basavanagudi ,Pampa Mahakavi Road, Basavanagudi,Bengaluru - 560004 (Third Cycle)',
  'Government First Grade College, Shankaranarayana, Kundapura, Udupi ,Shankaranarayana, Kundapura ,Udupi - 576227 (Third Cycle)',
  'Government First Grade College, Chamarajanagara,,Chamarajanagar - 571313 (Third Cycle)',
  "Maratha Mandal's Arts and Commerce College,Near Raja Tiles, Belagavi-Goa Road, Khanapur ,Belagavi - 591302 (Third Cycle)",
  'Government First Grade College, Malur,Near Malur Railway Station, Malur,Kolar - 563160 (Third Cycle)',
  'Government First Grade College, Haliyal,Haliyal Dist ,Uttara Kannada - 581329 (Third Cycle)',
  "Bapuji Grameen Vikas Samiti's Arts and Commerce College,Sadashivgad, Uttar Kannada ,Karwar - 581352 (Third Cycle)",
  'Government First Grade College, K. R. Puram, Bengaluru,College Road, K. R. Puram Extension ,Bengaluru - 560036 (Third Cycle)',
  'B. R. Tambakad Arts, Commerce and Science First Grade College,Vidyanagar,Hirekerur - 581111 (Third Cycle)',
  'Vidyavardhaka First Grade College, Mysuru ,Sheshadri Iyer Road,Mysuru - 570001 (Third Cycle)',
  'Sri Poornaprajna Evening College, Udupi,,Udupi - 576101 (Third Cycle)',
  "Gramantar Vidya Vardhak Sangh's Shri Shantaveer Arts College,Kakandaki Road Babaleshwar,Vijayapur - 586113 (Third Cycle)",
  'Anjuman Arts and Commerce College,CTS No 3929, Opposite to Belagavi District Court,Belagavi - 590016 (Third Cycle)',
  'Government First Grade College, Hosadurga, Chitradurga ,Holalkere Road, Hosadurga ,Chitradurga - 577 527 (Third Cycle)',
  "Latthe Education Society's Smt. Kusumavati Miraji Arts and Commerce College,A/P-(Shantinagar) Bedkihal Tal-Chikodi ,Belagavi - 591214 (Third Cycle)",
  'Government College for Boys, Chintamani,Polytechnic College Road,Chintamani - 563125 (Third Cycle)',
  'Government First Grade College, Birur, Kadur, Chikmagalur ,KLK Campus, Kadur (Tq), Chikmagalur,Birur - 577116 (First Cycle)',
  'Mangalore Academy of Professional Studies,Chinmaya lane, Bunts Hostel-Kadri Road,Mangalore - 575003 (First Cycle)',
  'The Oxford College of Pharmacy,I Cross, Begur Road, Hongasandra,Bengaluru - 560068 (Second Cycle)',
  'Taranath Shikshana Samsthe Laxmi Venkatesh Desai College,Manik Prabhu Temple Road,Raichur - 584103 (Third Cycle)',
  'Government Science College, Hassan,Salagame Road,Hassan - 573201 (Third Cycle)',
  'Government Arts, Commerce and Post Graduate College, Hassan,R C Road, Near Stadium,Hassan - 573 201 (Third Cycle)',
  'HIRASUGAR INSTITUTE OF TECHNOLOGY,NIDASOSHI,At Post. Nidasoshi Tq. Hukkeri Dist. Belagavi, Nidasoshi , 591236 (First Cycle)',
  'SESHADRIPURAM INSTITUTE OF COMMERCE AND MANAGEMENT,No. 40 Girls School Street, Seshadripuram,Bangalore , 560020 (First Cycle)',
  'SETH CHUNILAL AMARCHAND BOHRA LAW COLLEGE,RAICHUR,MANIK PRABHU TEMPLE ROAD, LVD CAMPUS, RAICHUR -584103. KARNATAKA,RAICHUR , 584103 (First Cycle)',
  'SRI DURGAPARAMESHWARI TEMPLE FIRST GRADE COLLEGE,Kateel Dakshina Kannada Karnataka, Kateel , 574148 (Second Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE AND CENTRE FOR PG STUDIES,THENKANIDIYUR, UDUPI ,POST-KRODHASHRAMA-576106.KARNATAKA,THENKANIDIYUR UDUPI , 576106 (Third Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE, DODDABALLAPURA, Madagondanahalli Road, Doddaballapura , 561203, Doddaballapura , 561203 (Third Cycle)',
  "S.J.A.V SAMITI'S K.R. BELLAD ARTS AND COMMERCE COLLEGE AND PG STUDIES IN ECONOMICS,MUNDARGI , 582118,MUNDARGI , 582118 (Third Cycle)",
  'UNIVERSITY COLLEGE OF SCIENCE, B. H. Road, Tumkur Univesity,Tumkur , 572103 (Third Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE,Kalamma Nagar, YELLAPUR - 581 359 Dist. Uttara Kannada,YELLAPUR , 581359 (First Cycle)',
  'MANEL SRINIVAS NAYAK MEMORIAL BESANT INSTITUTE OF PG STUDIES,Besant Vidya Kendra Bondel,Mangaluru , 575008 (Second Cycle)',
  'RPA FIRST GRADE COLLEGE,CA 02, 70th Cross, 5th Block, Rajajinagar, Bangalore -560010,Bangalore , 560010 (Second Cycle)',
  'VET FIRST GRADE COLLEGE, No.18, 14th Main, J.P. Nagar 2nd Phase,BENGALURU , 560078 (Second Cycle)',
  'ABBAS KHAN COLLEGE FOR WOMEN,O.T.C Road Cross, Cubbonpet, Bengaluru- 560002,Bangalore , 560002 (Third Cycle)',
  'KARNATAK SCIENCE COLLEGE,College Road, Near AIR, Dharwad,Dharwad , 580001 (Third Cycle)',
  "TARANATH SHIKSHANA SAMSTH'S SOMA SUBHADRAMMA RAMANAGOUD WOMEN'S COLLEGE ,Opp. Railway Station, Station Road,RAICHUR , 584101 (Third Cycle)",
  'B.M.S.COLLEGE OF ENGINEERING,P.O.Box.No.1908, Bull Temple Road, Bengaluru- 560019,Bengaluru , 560019 (Second Cycle)',
  'KOSHYS INSTITUTE OF MANAGEMENT STUDIES,No 31/1, Kadusonnapana Halli, Hennur-Bagalur Road Kannur Po,Bangalore , 562149 (First Cycle)',
  'SESHADRIPURAM ACADEMY OF BUSINESS STUDIES,No.18, 2nd Main Road, Behind Post Office, Kengeri Satellite Town, Bengaluru South,Bengaluru , 560060 (First Cycle)',
  'SJM INSTITUTE OF TECHNOLOGY,NH-4, BYE-PASS, P.B.No.73, CHITRADURGA,Chitradurga , 577502 (First Cycle)',
  'ST. ALOYSIUS DEGREE COLLEGE,Sarvagna Nagar, Cox Town, Bangalore 560005,Bangalore , 560005 (First Cycle)',
  "ST. ANNE'S DEGREE COLLEGE, VIRAJPET, VIRAJPET- 571218 SOUTH KODAGU,VIRAJPET , 571218 (First Cycle)",
  'GOVERNMENT FIRST GRADE COLLEGE,Opp Sarvagna Park, Kolar-563101, Kolar , 563101 (Third Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE KAMALAPUR,Kamalapur dist Kalaburagi,KALABURAGI , 585313 (Third Cycle)',
  'KARNATAK ARTS AND COMMERCE COLLEGE DHARWAD,Dharwad-580001,Dharwad-580001 (Third Cycle)',
  'M.E.S. COLLEGE OF COMMERCE,Vidya nagar, College Road Sirsi (Uttara Kannada) - 581402,Sirsi (Uttara Kannada) - 581402 (Third Cycle)',
  'SHARAVATHI FIRST GRADE COLLEGE KONANDUR,C K ROAD KONANDUR KONANDUR POST THIRTHAHALLI TALUK SHIMOGA DIST 577422, SHIMOGA DIST , 577422 (Third Cycle)',
  'SREE SIDDAGANGA COLLEGE OF ARTS SCIENCE AND COMMERCE FOR WOMEN, TUMKUR , 572102, TUMKUR , 572102 (Third Cycle)',
  'GOVT FIRST GRADE COLLEGE,Chitradurga (Taluk and District), Karnataka (State), Bharamasagara-577519 (First Cycle)',
  'SHRI KALAVARA VARADARAJA M SHETTY GOVT FIRST GRADE COLLEGE ,KUNDAPURA, Kundapura, Post- Koteshwara- 576222, Halady Road, Udupi District,Udupi , 576222 (First Cycle)',
  "BISHOP COTTON WOMEN'S CHRISTIAN COLLEGE,No. 19, 3rd Cross, CSI Compound,Bengaluru , 560027 (Third Cycle)",
  'GFGC MULBAGAL,M C ROAD, MULBAGAL TOWN, MULBAGAL,MULBAGAL , 563131 (Third Cycle)',
  'ACHARYA INSTITUTE OF TECHNOLOGY,Acharya Dr. Sarvepalli Radhakrishnan Road, Soladevanahalli, Hesaraghatta main Road, Bengaluru - 560 107 (Re-assessment, First Cycle)',
  'POORNAPRAJNA INSTITUTE OF MANAGEMENT,POORNAPRAJNA CAMPUS UDUPI KARNATAKA-576101, UDUPI , 576101 (First Cycle)',
  'K. S. INSTITUTE OF TECHNOLOGY,14, Raghuvanahalli Kanakapura Main Road,Bengaluru , 560109 (First Cycle)',
  'CITY ENGINEERING COLLEGE,Doddakallasandra, Near Gokulam Apartment, Off, Kanakapura Main Road,, Bengaluru , 560061 (First Cycle)',
  'SURANA COLLEGE, No 16 South End Rad BASAVANAGUDI, Bangalore Urban District , 560004 (Second Cycle)',
  'SHREE GOKARNANATHESHWARA COLLEGE,GANDHINAGAR MANGALORE,MANGALURU , 575003 (Third Cycle)',
  'SRI JATANGI RAMESHWARA RURAL FIRST GRADE COLLEGE,Opposite Police Station,B.B Road,Rampura,Molakalmuru Taluk,Chitradurga Dist,RAMPURA , 577540 (First Cycle)',
  'JSS SAKRI LAW COLLEGE , HEGGERI,ADJACENT TO AYURVEDA MAHAVIDHYALAYA,OLD HUBBALL,HUBBALLI , 580024 (Third Cycle)',
  'DON BOSCO INSTITUTE OF TECHNOLOGY,MYSORE ROAD, KUMBALAGODU,BANGALORE , 560074 (First Cycle)',
  'KRUPANIDHI DEGREE COLLEGE,Chikka Bellandur, Carmelaram Post, Varthur Hobli, off sarjapur road,,BENGALURU , 560035 (First Cycle)',
  'SHRI MADHWA VADIRAJA INSTITUTE OF TECHNOLOGY AND MANAGEMENT,VISHWOTHAMA NAGARA PO BANTAKAL UDUPI-574115,UDUPI , 574115 (First Cycle)',
  "ALVA'S COLLEGE,Smt.Sundari Ananda Alva Campus Vidyagiri D.K Karnataka,Moodbidri,Karnataka,574227 (Second Cycle)",
  'SHRI DHARMASTHALA MANJUNATHESHWARA LAW COLLEGE AND CENTRE FOR P.G. STUDIES AND RESEARCH IN LAW,M . G . ROAD, KODIALBAIL, MANGALURU,Mangaluru,Karnataka,575003 (Third Cycle)',
  'R V INSTITUTE OF MANAGEMENT,CA-17, 36th Cross, 26th Main 4th T Block, Jayanagar,Bangalore,Karnataka,560041 (Second Cycle)',
  'VIDYA VIKAS INSTITUTE OF ENGINEERING AND TECHNOLOGY, Mysore Bannur Road,Mysore, 570028 (First Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE, OLD TOWN, SHIVAJI CIRCLE, HOSAMANE, BHADRAVATI,GOVERNMENT FIRST GRADE COLLEGE, SHIVAJI CIRCLE, HOSAMANE, BHADRAVATHI,BHADRAVATHI,Karnataka,577301 (Second Cycle)',
  'MOUNT CARMEL COLLEGE (AUTONOMOUS),No 58 Palace Road Vasanthnagar,Bengaluru,Karnataka,560052 (Fourth Cycle)',
  'SMT NEELAMMA KUDUR K A SATYANARRAYANA SHETTY GOVERNMENT FIRST GRADE COLLEGE KUDUR, Smt. Neelamma Kudur K.A. Sathyanarayana Setty, Government First Grade College, Kudur Magadi Taluk, Ramanagara District-561101,Magadi Taluk,Karnataka,561101 (Second Cycle)',
  "BASAVESHWAR VEERASHAIVA VIDYAVARDHAKA SANGHA'S, BASAVESHWAR SCIENCE COLLEGE, BAGALKOT, B.V.V.Sanghas Old Campus Belagavi Raichur Road,Bagalkot,Karnataka,587101 (Third Cycle)",
  'GOVERNMENT FIRST GRADE COLLEGE, Governmrnt First Grade College Krishnaraja Nagara Mysore District,Krishnaraja Nagar,Karnataka,571602 (Third Cycle)',
  "K.L.E. SOCIETY'S LAW COLLEGE , C A No. 2, West Circle, BDA Layout, Sir M. Vishweshwaraiah Layout, V Block, Ullal Post,Bengaluru,Karnataka,560091 (First Cycle)",
  'M.N. DEGREE COLLEGE , M.N.DEGREE COLLEGE, M N T I Campus KAMMAGONDANAHALLI, Jalahalli (west) BANGALORE-560015,BANGALORE,Karnataka,560015 (Second Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE , Government First Grade College, M.G Road, Srinivasapur 563135,SRINIVASAPUR,Karnataka,563135 (Third Cycle)',
  'MAHANTSWAMY ARTS, SCIENCE AND COMMERCE DEGREE COLLEGE , Main Road, Opposite to Vijaya Bank TQ Hirekerur DIST Haveri,HAUNSBHAVI,Karnataka,581109 (Third Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE HUMNABAD , SHIV NAGAR,KALLUR ROAD BEHIND BUS STAND HUMNABAD,HUMNABAD,Karnataka,585330 (First Cycle)',
  "MAHARAJA'S COLLEGE , JHANSI LAKSHMI BAI ROAD, UNIVERSITY OF MYSORE, MYSURU,Mysuru,Karnataka,570005 (Second Cycle)",
  "NTSS's SHRI SHANKAR ARTS AND COMMERCE COLLEGE NAVALGUND , RS NO 409, HUBBALLI-SOLAPUR ROAD NAVALGUND 582208 DIST- DHARWAD,NAVALGUND DISTRICT DHARWAD,Karnataka,582208 (Third Cycle)",
  'VEDAVATHI GOVERNMENT FIRST GRADE COLLEGE , Vedavathi Government First Grade College, Mysore Road, Hiriyur, Chitradurga District,Hiriyur,Karnataka,577598 (Second Cycle)',
  'GOVT. FIRST GRADE COLLEGE, VARTHUR, BANGALORE,Govt. First Grade college, Madhuranagar 3rd stage, Varthur,Bangalore,Karnataka,560087 (First Cycle)',
  'SRI SAIRAM COLLEGE OF ENGINEERING,Sai Leo Nagar, Guddanahalli village, Samandur Post, Anekal, Bangalore, Bangalore Urban, Karnataka 562 106,Bangalore,Karnataka,562106 (First Cycle)',
  'ADMINISTRATIVE MANAGEMENT COLLEGE,Administrative Management College 18th KM Bannerghatta Road, Kalkere Bangalore 560083,BANGALORE,Karnataka,560083 (First Cycle)',
  'SIDDAGANGA INSTITUTE OF TECHNOLOGY,Siddaganga Institute of Technology, B.H. Road, Tumakuru-572 103,TUMAKURU,Karnataka,572103 (First Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE, KORATAGERE,Government First Grade college, Hanumantha pura Koratagere -572129,Tumkur,Karnataka,572129 (Third Cycle)',
  "BLDE ASSOCIATION'S BASAVESHWARA ARTS AND COMMERCE COLLEGE BASAVAN BAGEWADI DIST. VIJAYAPUR, KARNATAKA.,Vijaypur Road, Near New Court, Basavan Bagewadi - 586203,BASAVAN BAGEWADI,Karnataka,586203 (Third Cycle)",
  'NEW HORIZON COLLEGE, MARATHALLI,New Horizon College, Marathalli Outer Ring Road, Bellandur Post, Bangalore - 560103,Bangalore,Karnataka,560103 (First Cycle)',
  'ANGADI INSTITUTE OF TECHNOLOGY AND MANAGEMENT,Angadi Institute of Technology and Management Savagaon Road Belagavi,Belagavi,Karnataka,590009 (First Cycle)',
  'GSSS INSTITUTE OF ENGINEERING AND TECHNOLOGY FOR WOMEN,KRS ROAD, METAGALLI INDUSTRIAL AREA, MYSURU-570016,MYSURU,Karnataka,570016 (First Cycle)',
  "SRI KOTTALA BASAVESHWARA BHARATIYA SHIKSHANA SAMITI'S NRUPATUNGA ARTS AND COMMERCE COLLEGE,NRUPATUNGA ARTS AND COMMERCE COLLEGE UDGI ROAD, SEDAM,SEDAM,Karnataka,585222 (Third Cycle)",
  "B.V.V.SANGHA'S BASAVESHWAR ARTS COLLEGE, BVVS CAMPUS RAICHUR- BELAGAVI ROAD BAGALKOT- 587101 (Third Cycle)",
  'NITTE MEENAKSHI INSTITUTE OF TECHNOLOGY (AUTONOMOUS),Post Box No. 6429, Yelahanka,Bangalore,Karnataka,560064 (Second Cycle)',
  'MILAGRES COLLEGE, FALNIR ROAD, HAMPANKATTA, MANGALURU,Karnataka,575001 (First Cycle)',
  'Government First Grade College, Raichur ,Near KEB School, Nijalingappa Colony,Raichur - 584101 (First Cycle)',
  'Duddupudi Degree College for Women,K V Compound, Gangavathi Road ,Sindhanur - 584128 (First Cycle)',
  "Modern Education Society's M. M. Arts and Science College,Vidyanagar, Sirsi ,Uttara Kannada - 581402 (Third Cycle)",
  'NIE First Grade College,No. 65, Vishweshwaranagar, Mananthavadi Road,Mysore - 570008 (First Cycle)',
  'GFGC JAGALUR,Behind Taluk Stadium, Lingannanahalli Road, Jagalur, JAGALUR , 577528 (First Cycle)',
  'GOVERNMENT FIRST GRADE COLLEGE ,NAVANAGAR, BAGALKOT,KARNATAKA,ector No.43 Navanagar Bagalkot,BAGALKOT , 587103 (First Cycle)',
  'SESHADRIPURAM COMMERCE COLLEGE,NO.65,10TH CROSS,MAGADI ROAD,BENGALURU,BANGALORE , 560023 (First Cycle)',
  'SRINIVAS INSTITUTE OF TECHNOLOGY,Merlapadavu, Valachil, Farangipete Post,MANGALORE , 574143 (First Cycle)',
  'Al - Ameen College,Aluva, 683564 (First Cycle)',
  'Amal Jyothi College of Engineering, Kanjirapally, Kottayam – 686518 (First Cycle)',
  'Baselius College, Kottayam, 686001 (Third Cycle)',
  'Bishop Abraham Memorial College, Thiruvalla – 689597 (Second Cycle)',
  'Bishop Benziger College of Nursing, Kollam – 691001 (First Cycle)',
  'Bishop Chulaparambil Memorial College, Kottayam, 686001 (Third Cycle)',
  'Carmel College,Mala, Thrissur – 680732 (Third Cycle)',
  'Catholicate College, Pathanamthitta – 689645 (Third Cycle)',
  'Don Bosco College, Wayanad, 673592 (First Cycle)',
  'Government Arts and Science College, Meenchantha, Arts College P.O., Kozhikode – 673018 (Third Cycle)',
  'Government College for Women, Thiruvananthapuram, 695014 (Second Cycle)',
  'Government College of Teacher Education,Kozhikode – 673001 (Second Cycle)',
  'Government College of Teacher Education,Thiruvananthapuram – 695014 (Second Cycle)',
  'Government College,Thiruvananthapuram, 695101 (First Cycle)',
  'Government College, Kariavattom,Thiruvananthapuram – 695581 (First Cycle)',
  'IES College of Engineering, Chittilappilly,Thrissur – 680551 (First Cycle)',
  'Ilahia College of Arts & Science,Ernakulam Dist, 686674 (First Cycle)',
  'K. K. T. M. Government College, Thrissur – 680663 (Second Cycle)',
  'Lead College of Management,Palakkad – 678009 (First Cycle)',
  'Little Flower College, Thrissur, 680103 (Second Cycle',
  'Loyola College of Social Sciences, Sreekariyam, Thiruvananthapuram, 695017 Kerala ( Third Cycle)',
  'M. E. S. Mampad College, Malappuram – 676542 (Third Cycle)',
  'M.E.S. Keveeyam College, Malappuram Dist, 676552 (Second Cycle)',
  'M.P. Moothedath Memorial Sree Narayana Trusts College, Palakkad Dist, 679122 (Second Cycle)',
  'Mar Athanasios College for Advanced Studies, Thiruvalla – 689101 (First Cycle)',
  'Milad-E-Sherief Memorial College,Alappuzha Dist, 690502 (First Cycle)',
  'Muhammed Abdurahiman Memorial Orphanage College,Kozhikode – 673602 (Second Cycle)',
  'N. S. S. College, Nemmara, Palakkad – 678508 (Second Cycle)',
  'N. S. S. Training College, Changanacherry, Perunnai, Kottayam – 686102 (Second Cycle)',
  'NAM College, Kallikkandy, Kannur – 673693 (First Cycle)',
  'National College for Teacher Education,Vengola P.O., Perumbavoor, Kochi – 683556 (First Cycle)',
  'National Institute of Speech and Hearing,Karimanal P.O.,Thiruvananthapuram – 695583 (First Cycle)',
  'Nehru College of Engineering and Research Centre, Dist. Thrissur, 680588 (First Cycle)',
  'Newman College, Thodupuzha – 685585 (Third Cycle)',
  'P. K. M. College of Education, Kannur – 670631 (Second Cycle)',
  'Panampilly Memorial Government College,Thrissur Dist, 680722 (Second Cycle)',
  'Pavanatma College, Idukki – 685604 (Third Cycle)',
  'Pazhassi Raja College, Wayanad, 673579 (First Cycle)',
  'Pocker Sahib Memorial Orphanage College, Malappuram – 676306 (Second Cycle)',
  'Pookoya Thangal Memorial Government College, Malappuram, Dist, 679322 (First Cycle)',
  'Prajyoti Niketan College,Pudukad, Thrissur – 680301 (Second Cycle)',
  "Providence Women's College, Malaparamba, Kozhikode – 673009 (Third Cycle)",
  'Pushpagiri College of Dental Sciences, Tiruvalla – 689107 (First Cycle)',
  'Pushpagiri College of Pharmacy, Tiruvalla – 689107 (First Cycle)',
  'Rajagiri College of Social Sciences Kochi,Kerala (Third Cycle)',
  'S. E. S. College,Kannur – 670631 (First Cycle)',
  'S. N. M. Training College, North Parur,Moothakunnam, Ernakulam – 683516 (Second Cycle)',
  'S. V. R. N. S. S. College,Theerthapadapuram P.O., Kottayam – 686505 (Second Cycle)',
  'Sacred Heart College Kochi, Kerala (Third Cycle) 7 Years Validity',
  'Sahrdaya College of Engineering & Technology, Thrissur, 680684 (First Cycle)',
  'Saintgits College of Applied Sciences, Kottayam, 686532 (First Cycle)',
  'SCMS School of Technology & Management,Cochin, 683106 (First Cycle)',
  'Sree Narayana College for Women, Kollam – 691001 (Second Cycle)',
  'Sree Narayana College, Chempazhanthy, Thiruvananthapuram – 695587 (Second Cycle)',
  'Sree Narayana College, Cherthala – 688582 (Second Cycle)',
  'Sree Narayana College, Palakkad Dist, 678682 (Second Cycle)',
  'Sree Narayana College, Sreenivasapuram P.O., Varkala – 695145 (Second Cycle)',
  'Sree Narayana Gurukulam College of Engineering, Ernakulam – 682311 (First Cycle)',
  'Sri Vyasa N. S. S. College,Thrissur – 680623 (Second Cycle)',
  "St. Albert's College, Ernakulam – 682018 (Third Cycle)",
  'St. Aloysius College,Alappuzha Dist, 689573 (Third Cycle)',
  "St. George's College, Erattupetta, Kottayam – 686122 (Third Cycle)",
  'St. Gregorios College, Kollam, 691531 (Second Cycle)',
  "St. John's College, Kollam, 691306 (Second Cycle)",
  'St. Mary’s College, Thrissur, 680020 (Third Cycle)',
  "St. Mary's College, Manarcaud, Kottayam – 686019 (First Cycle)",
  "St. Michael's College, Cherthala, 688539 (Second Cycle)",
  "St. Paul's College, Kalamassery, Ernakulam, Kochi – 683503 (Third Cycle)",
  "St. Peter's College, Ernakulam – 682331 (Third Cycle)",
  "St. Stephen's College, Kollam Dist, 689695 (Second Cycle)",
  "St. Stephen's College, Kottayam Dist, 686634 (Second Cycle)",
  'St. Thomas College, Dist. Pathanamthitta,Kozhencheri – 689641 (Third Cycle)',
  'St. Thomas College, Kottayam Dist, 686574 (Third Cycle)',
  'St. Thomas College,P. O. Pazhavangadi, Pathanamthitta – 689673 (Second Cycle)',
  "St. Xavier's College for Women, Aluva, Ernakulam, Kochi – 683101 (Fourth Cycle)",
  'T. K. Madhava Memorial College, Alappuzha – 690513 (Second Cycle)',
  'The Dale View College of Pharmacy and Research Centre, Thiruvananthapuram - 695575 (First Cycle)',
  'Vimala College, Thrissur, 680009 Kerala (Third Cycle)',
  "All Saints' College, Thiruvananthapuram – 695007 (Third Cycle)",
  'Baby John Memorial Government College, Chavara, Kollam – 691583 (First Cycle)',
  'Bishop Moore College, Kallumala, Mavelikara, Alappuzha – 690110 (Third Cycle)',
  'C. K. G. Memorial Government College, Perambra P.O., Kozhikode – 673525 (Second Cycle)',
  'Christ College, Irinjalakuda, Thrissur – 680125 (Third Cycle)',
  'Co-operative Arts and Science College, Mayadi, Payangadi, Kannur – 670358 (First Cycle)',
  'Deva Matha College, Kuravilangad, Kottayam – 686633 (Third Cycle)',
  'Devaswom Board College, Kollam – 690521 (Second Cycle)',
  'Devaswom Board College, Midayikunnam, Kottayam – 686605 (Second Cycle)',
  'Farook College, Kozhikode – 673632 (Third Cycle)',
  'Federal Institute of Science and Technology, Perumbavoor – 683577 (First Cycle)',
  'Government Arts College, Thycaud, Thiruvananthapuram – 695014 (Second Cycle)',
  'Government College, Chittur-Thathamangalam, Palakkad – 678104 (Second Cycle)',
  'Government College, Kattappana P.O., Idukki - 685508 (First Cycle)',
  'Government College, Mekkara, Tripunithura, Ernakulam, Kochi – 682301 (First Cycle)',
  'Government College, Mokeri, Kakkattil, Kozhikode – 673507 (Second Cycle)',
  'Government College, Munduparamba P.O., Malappuram – 676509 (Second Cycle)',
  'Government College, Nattakom, Kottayam – 686013 (Second Cycle)',
  'Government Sanskrit College, Palayam, Thiruvananthapuram – 695034 (Second Cycle)',
  'Government Sanskrit College, Tripunithura, Ernakulam – 682301 (Second Cycle)',
  'Govinda Pai Memorial Government College, Manjeswar, Kasargod – 671323 (First Cycle)',
  'Her Highness Maharani Sethu Parvathi Bai NSS College for Women, Neeramankara, Thiruvananthapuram – 695040 (Third Cycle)',
  'Institute of Advanced Study in Education, Thrissur – 680020 (First Cycle)',
  'JDT Islam College of Nursing, Vellimadukunnu, Kozhikode – 673012 (First Cycle)',
  'JDT Islam College of Pharmacy, Vellimadukunnu, Kozhikode – 673012 (First Cycle)',
  'JDT Islam College of Physiotherapy, Marikunnu, Kozhikode – 673012 (First Cycle)',
  'Jyothi Engineering College, Thrissur – 679531 (First Cycle)',
  'K. N. M. Government Arts and Science College, Kanjiramkulam, Thiruvananthapuram – 695524 (Second Cycle)',
  'K. V. M. College of Special Education, Maruthorvattom, Cherthala, Alappuzha – 688539 (First Cycle)',
  'M. E. S. College, Chembalam, Nedumkandam, Idukki – 685553 (Second Cycle)',
  'Mahatma Gandhi College, Keezhur P. O., Iritty, Kannur – 670703 (First Cycle)',
  'Malabar Christian College, Kozhikode – 673001 (Third Cycle)',
  'Mangalam College of Engineering, Ettumanoor, Kottayam – 686631 (First Cycle)',
  'Mar Athanasius College, Kothamangalam, Ernakulam – 686666 (Third Cycle)',
  'Mar Baselios College of Engineering and Technology, Thiruvananthapuram – 695015 (First Cycle)',
  'Mar Thoma College for Women, Perumbavoor, Ernakulam – 683542 (Third Cycle)',
  'Mohandas College of Engineering and Technology, Thiruvananthapuram – 695544 (First Cycle)',
  'Morning Star Home Science College, Angamaly South, Kochi – 683752 (Third Cycle)',
  'Mount Tabor Training College, Kollam, Punalur – 689695 (Second Cycle)',
  'N. M. S. M. Government College, Wayanad – 673121 (Second Cycle)',
  'N. S. S. College, Kochuramapuram, Cherthala – 688556 (Second Cycle)',
  'N. S. S. College, Rajakumari, Idukki – 685619 (First Cycle)',
  'N. S. S. Training College, Ottapalam P.O., Palakkad – 679101 (Second Cycle)',
  'Nehru Arts and Science College, Padnekat, Kanhangad, Kasaragod – 671328 (Third Cycle)',
  'Nirmalagiri College, Thalassery, Kuthuparamba, Kannur – 670701 (Third Cycle)',
  'Pazhassi Raja N. S. S. College, Mattanur, Kannur – 670702 (Second Cycle)',
  'Peet Memorial Training College, Mavelikkara – 690101 (Second Cycle)',
  'Rajagiri School of Engineering and Technology, Kochi – 682039 (Second Cycle)',
  'S. A. R. B. T. M. Government College, Quilandy, Kozhikode – 673307 (Second Cycle)',
  'S. C. M. S. Science of Engineering and Technology, Ernakulam – 683582 (First Cycle)',
  'S. C. M. S. Science of Engineering and Technology, Ernakulam – 683582 (First Cycle)',
  'Sacred Heart College, Chalakudy, Thrissur – 680307 (Third Cycle)',
  'Sahodaran Ayyappan Smaraka SNDP Yogam College, Pathanamthitta – 689691 (First Cycle)',
  'Sanatana Dharma College, Sanatanapuram, Alappuzha – 688003 (Third Cycle)',
  'Sir Syed College, Karimbam, Taliparamba, Kannur – 670142 (Third Cycle)',
  'Sree Ayyappa College, Eramallikkara, Chengannur – 689109 (First Cycle)',
  'Sree Krishna College of Pharmacy and Research Centre, Parassala, Thiruvananthapuram – 695502 (First Cycle)',
  'Sree Narayana College, Chathannur, Kollam – 691579 (First Cycle)',
  'Sree Narayana College, Kollam – 691001 (Second Cycle)',
  'Sree Narayana Guru College, Chelannur, Kozhikode – 673616 (Second Cycle)',
  'Sree Narayana Mangalam College, Maliankara P.O., Ernakulam – 683516 (Second Cycle)',
  'Sree Sankara Vidyapeetom College, Valayanchirangara P.O., Perumbavoor – 683556 (Second Cycle)',
  'Sree Vivekananda College, Kizhoor, Kunnamkulam, Thrissur – 680523 (First Cycle)',
  'Sreekrishnapuram V. T. Bhattathiripad College, Palakkad – 679517 (Second Cycle)',
  'St. Berchmans College, Changanassery, Kottayam – 686101 (Fourth Cycle)',
  'St. Dominic’s College, Kanjirapally, Parathodu, Kottayam – 686512 (Third Cycle)',
  "St. Joseph's College, Devagiri, Kozhikode – 673008 (Third Cycle)",
  'St. Mary College, Sulthan Bathery, Wayanad – 673592 (Third Cycle)',
  'St. Thomas’ College, (Autonomous), Thrissur – 680001 (Third Cycle)',
  'T. K. M. College of Engineering, Kollam – 691005 (First Cycle)',
  'Thunchan Memorial Government College, Tirur – 676502 (Second Cycle)',
  'Union Christian College, Aluva – 683102 (Fourth Cycle)',
  'College of Engineering, Mantharathur, Kurunthodi, Vadakara – 673105 (First Cycle)',
  'College of Engineering, Trikaripur, Cheemeni, Kasargod – 671313 (First Cycle)',
  'T. K. M. College of Engineering, Karicode, Kollam – 691005 (Re-Visit) (First Cycle)',
  'Kuriakose Gregorios College, Pampady, Kottayam – 686502 (Second Cycle)',
  'N. S. S. College, Palappuram, Ottapalam, Palakkad – 679103 (Second Cycle)',
  'Sree Krishna College, Ariyannur, Guruvayoor – 680102 (Second Cycle)',
  'N. S. S. Hindu College, Perunna, Changanacherry, Kottayam – 686102 (Third Cycle)',
  "The Zamorin's Guruvayurappan College, Kozhikode – 673014 (Third Cycle)",
  'Mannam Memorial N. S. S. College (Second Cycle)',
  'Sree Keralavarma College (Second Cycle)',
  'Payyanur College,Edat,Payyanur - 670327 (Second Cycle)',
  'Sree Narayana College, Kannur,Thottada ,Kannur - 670007 (Second Cycle)',
  'Devaswom Board Pampa College,Parumala Mannar,Pathanamthitta - 689626 (Second Cycle)',
  'T.M. Jacob Memorial Government College,Manimalakunnu, Oliyappuram ,Koothattukulam - 686662 (Second Cycle)',
  'Sree Sankara College,Sankar Nagar, Mattoor, Kalady,Ernakulam - 683574 (Third Cycle)',
  'University College, Thiruvananthapuram,,Thiruvananthapuram - 694034 (Third Cycle)',
  'Mahatma Gandhi College,Kesavadasapuram Pattom P O,Thiruvananthapuram - 695004 (Third Cycle)',
  'Fatima Mata National College,Near Railway Station,Kollam - 691001 (Fourth Cycle)',
  'Iqbal College,Peringammala Daivappura PO,Thiruvananthapuram - 695563 (Second Cycle)',
  'DC School of Management and Technology,One School Avenue, Pullikkanam P.O, Vagamon,Idukki - 685503 (Second Cycle)',
  'VTM NSS College,Vellu Thampi Memorial N.S.S. College, Dhanuvachapuram,Thiruvananthapuram - 695503 (Third Cycle)',
  'Nirmala College ,Muvattupuzha ,Ernakulam - 686661 (Fourth Cycle)',
  'EKNM GOVERNMENT COLLEGE ELERITHATTU,Elerithattu PO., Nileshwar Via., Kasaragod Dist., Kerala State,Kerala State, PIN- 671314 (First Cycle)',
  'MEA ENGINEERING COLLEGE,Vengoor, Pattikkad P.O. Perinthalmanna Malappuram,Malappuram , 679325 (First Cycle)',
  "ST. CYRIL'S COLLEGE,Cyrils Mount Vadakkadathukavu P O Adoor, Pathanamthitta , 691526 (Second Cycle)",
  'TOC H INSTITUTE OF SCIENCE AND TECHNOLOGY,ARAKUNNAM ERNAKULAM-682313,Ernakulam , 682313 (Second Cycle)',
  'MAR IVANIOS COLLEGE (AUTONOMOUS),Mar Ivanios Vidya Nagar Nalanchira P.O.,THIRUVANANTHAPURAM , 695015 (Fourth Cycle)',
  'SRI VELLAPPALLY NATESAN COLLEGE OF ENGINEERING, KATTACHIRA, PALLICKAL P.O, MAVELIKARA, ALAPPUZHA, KERALA, PIN.690503,MAVELIKARA , 690503 (First Cycle)',
  'VIMAL JYOTHI ENGINEERING COLLEGE,JYOTHI NAGAR CHEMPERI P.O KANNUR-670632, Kannur , 670632 (First Cycle)',
  'AQUINAS COLLEGE,,COCHIN- 682010 (Third Cycle)',
  'KURIAKOSE ELIAS COLLEGE,ATHIRAMPUZHA , 686561 , Mannanam P O, Kottayam,ATHIRAMPUZHA , 686561 (Third Cycle)',
  'M.E.S. COLLEGE,MARAMPALLY ALUVA-7 ERNAKULAM DT,ALUVA , 683107 (Third Cycle)',
  'ALPHONSA COLLEGE,ARUNAPURAM P.O PALA,PALA , 686574 (Fourth Cycle)',
  'MAR DIONYSIUS COLLEGE, Mar Dionysius College Pazhanji P.O Thrissur District, Kunnamkulam , 680542 (Second Cycle)',
  'MARY MATHA ARTS AND SCIENCE COLLEGE,Vemom P O, Mananthavady, Wayanad District,Mananthavady , 670645 (Third Cycle)',
  'ST. THOMAS COLLEGE OF ENGINEERING AND TECHNOLOGY,Kozhuvalloor Post Chengannur Alappuzha District,Kozhuvalloor Chengannur , 689521 (First Cycle)',
  'AMAL COLLEGE OF ADVANCED STUDIES,Santhigramam, Myladi, Eranhimangad P.O., Nialmbur, Malappuram District,Nilambur , 679329 (First Cycle)',
  'THANGAL KUNJU MUSALIAR COLLEGE OF ARTS AND SCIENCE, TKM College P.O., Kollam - 5, Kollam , 691005 (Third Cycle)',
  "ST. XAVIER'S COLLEGE, THUMBA,ST. XAVIERS COLLEGE THUMBA,THIRUVANANTHAPURAM,Kerala,695586 (Third Cycle)",
  'GOVERNMENT COLLEGE,Madappally College P.O Vatakara, Calicut,Madappally,Kerala,673102 (Third Cycle)',
  'BISHOP KURIALACHERRY COLLEGE FOR WOMEN,Amalagiri P.O , Kottayam,Kottayam,Kerala,686561 (Fourth Cycle)',
  "ST.XAVIER'S COLLEGE VAIKOM,St.Xaviers College Vaikom Kothavara P.O Vaikom Kottayam Dist. PIN-686607,Vaikom,Kerala,686607 (Second Cycle)",
  'BASELIOS POULOSE II CATHOLICOS COLLEGE,MULAKKULAM NORTH, PIRAVOM ERNAKULAM DISTRICT,Piravom,Kerala,686664 (Second Cycle)',
  'NAIPUNNYA INSTITUTE OF MANAGEMENT AND INFORMATION TECHNOLOGY,Naipunnya Institute of Management and Information Technology , Pongam , East Koratty ,Thrissur (DT),Chalakudy,Kerala,680308 (First Cycle)',
  "Korambayil Ahamed Haji Memorial Unity Women's College, Manjeri, Korambayil Ahamed Haji Memorial Unity Womens College, P.O. Narukara, Malappuram District,Manjeri,Kerala,676122 (Third Cycle)",
  "ST.TERESA'S COLLEGE, St. Teresas College (Autonomous), Park Avenue, Marine Drive, Ernakulam,Kochi,Kerala,682011 (Fourth Cycle)",
  'GOVERNMENT COLLEGE MANANTHAVADY, Government College Mananthavady, Nalloornadu P.O., Wayanad 670645,Mananthavady,Kerala,670645 (Second Cycle)',
  'NSS COLLEGE,N.S.S. COLLEGE, PANDALAM PANDALAM P.O., PATHANAMTHITTA DISTRICT, KERALA STATE,Pandalam,Kerala,689501 (Third Cycle)',
  'SREE BUDDHA COLLEGE OF ENGINEERING, PATTOOR,SREE BUDDHA COLLEGE OF ENGINEERING PATTOOR P.O NOORANAD ALAPPUZHA,ALAPPUZHA,Kerala,690529 (Second Cycle)',
  'BHARATA MATA COLLEGE, THRIKKAKARA,Bharata Mata College Seaport Airport Road, Thrikkakara Kerala, 682021,Kochi,Kerala,682021 (Third Cycle)',
  'SULLAMUSSALAM SCIENCE COLLEGE,Sullamussalam Science College Ugrapuram(PO) Areekode,AREEKODE,Kerala,673639 (Third Cycle)',
  'M E S KALLADI COLLEGE,MES Kalladi College Mannarkkad Mannarkkad College P O Palakkad District,Mannarkkad,Kerala,678583 (Third Cycle)',
  'MUSALIAR COLLEGE OF ENGINEERING AND TECHNOLOGY,MUSALIAR COLLEGE OF ENGINEERING AND TECHNOLOGY MUSALIAR COLLEGE (PO) PATHANAMTHITTA - 689653,Pathanamthitta,Kerala,689653 (First Cycle)',
  'MAR THOMA COLLEGE, TIRUVALLA,Mar Thoma College, Tiruvalla Kuttapuzha P O Tiruvalla Pathanamthitta Dist,TIRUVALLA,Kerala,689103 (Fourth Cycle)',
  'MANNANIYA COLLEGE OF ARTS AND SCIENCE, Pangode Kallara,THIRUVANANTHAPURAM,Kerala,695609 (First Cycle)',
  'CHRISTIAN COLLEGE, Angadical Chengannur 689122 Alappuzha District',
  'YOUNUS COLLEGE OF ENGINEERING AND TECHNOLOGY,VADAKKEVILA P O, KOLLAM,Kerala,691010 (First Cycle)',
  "St. Joseph's College, Moolamattam ,Arakulam P.O, Moolamattom ,Idukki - 685591 (Third Cycle)",
  'The Cochin College ,Panayappilly,Kochi - 682002 (Third Cycle)',
  "St. Joseph's College for Women,Convent Square,Alappuzha - 688001 (Third Cycle)",
  'MES ASMABI COLLEGE, P. VEMBALLUR, P. VEMBALLUR (P.O) KODUNGALLUR THRISSUR, Kodungallur , 680671 (Third Cycle)',
  'Arihant College, Indore – 452001 (First Cycle)',
  'Bombay Hospital College of Nursing, Indore – 452010 (First Cycle)',
  'Center for Higher Studies and Research for A.A.and H. B.Ed. College, Jabalpur – 482021 (First Cycle)',
  'Chandra Shekhar Azad Government Post Graduate (Nodal) College, Sehore – 466001 (Second Cycle)',
  'Chaudhary Dilip Singh Girls College, Bhind, 477001 (First Cycle)',
  'Corporate Institute of Science and Technology,Bhopal – 462022 (First Cycle)',
  'Government (Modal Autonomous) Holkar Science College,Indore – 452001 (Third Cycle)',
  'Government Arts and Commerce College,Bhopal – 462008 (Second Cycle)',
  'Government Chandra Vijay College, Dindori –481880 (Second Cycle)',
  'Government Chandra Vijay College, Dindori –481880 (Second Cycle)',
  'Government Girls College, Bina, Sagar – 470113 (Second Cycle)',
  'Government Girls College, Khargone – 451001 (Second Cycle)',
  'Government Girls College, Nyas Colony, Hoshangabad, Itarsi – 461111 (Second Cycle)',
  'Government Girls College, Vidisha – 464001 (Second Cycle)',
  'Government Home Science College, Hoshangabad, 461001 (Second Cycle)',
  'Government Indira Gandhi Home Science Girls College, Shahdol – 484001 (First Cycle)',
  'Government Junnardeo Mahavidyalaya, Dist. Chhindwara, Junnardeo – 480551 (Second Cycle)',
  'Government Madhav Science College, Ujjain – 456010 (Second Cycle)',
  'Government Maharaja P. G. College (Autonomous), Chhatarpur – 471001 (Second Cycle)',
  'Government Model Science College, Gwalior, 474009 (Second Cycle)',
  'Government Post Graduate College, Khargone, 451001 (Second Cycle)',
  'Government Post Graduate College, Neemuch – 458441 (Second Cycle)',
  'Government Post Graduate College, Sheopur – 476337 (First Cycle)',
  'Government Post-Graduate College,Tikamgarh, 472001 (Second Cycle)',
  'Government Science and Commerce College, Benazeer, Shahjahanbad, Bhopal – 462001 (Second Cycle)',
  'Government Vrinda Sahay P.G. College, Gwalior, 475110 (First Cycle)',
  'Guru Ramdas College of Education, Damoh, 470661 (First Cycle)',
  'Gyan Chandra Shrivastava Government Post Graduate College, Damoh – 470661 (Second Cycle)',
  'Gyanveer Institute of Management & Science, Sagar, 470002 (First Cycle)',
  'HICT Shiksha Mahavidyalaya, Gwalior, 475001 (First Cycle)',
  'Hitkarini Law College, Jabalpur, 482001 (Second Cycle)',
  'IES College of Technology, Bhopal – 462044 (First Cycle)',
  'Institute of Professional Studies, Gwalior – 474001 (First Cycle)',
  'Jabalpur Public College, Jabalpur, 482002 (First Cycle)',
  'Jain Institute, Salupura, Gwalior, 456006 (First Cycle)',
  'Jawahar Lal Nehru Smriti Government Post Graduate College, Shajapur – 465333 (First Cycle)',
  'Jawaharlal Nehru Smiriti Mahavidyalaya, Vidisha – 464221 (Second Cycle)',
  'Lakshmi Narain College of Technology, Indore – 453331 (First Cycle)',
  'M.B. Khalsa Institution of Education, Rajmohalla Square, Indore, 452002 (First Cycle)',
  'Madhav Institute of Technology and Science, Gwalior – 474005 (First Cycle)',
  'Mahatma Gandhi Post Graduate College, Dist. Narsinghpur, 487221 (Second Cycle)',
  'Mata Jijabai Government Girls Post Graduate College (Autonomous), Indore, 452004 (Second Cycle)',
  'Matushri Kankuben Hirachand Sanghvi Gujarati Girls College, Indore, 452007 (Second Cycle)',
  'Narmada Education Society College of Education, Hoshangabad, 461001 (First Cycle)',
  'P.M.B. Gujarati Commerce College, Indore, 452001 (Second Cycle)',
  'Parikh Manilal Baldevdas Gujarati Science College, Indore, 452001 (Second Cycle)',
  'Prestige Institute of Management, Gwalior – 474020 (First Cycle)',
  'Pt. S.N. Shukla Government P.G. College (Autonomous), Shahdol, 484001 (Second Cycle)',
  'Rani Durgawati Government Post Graduate College, Mandla – 481661 (Second Cycle)',
  'Renaissance College of Commerce and Management, Indore – 452001 (First Cycle)',
  'S. R. College of Education, Gwalior – 474006 (First Cycle)',
  'Samrat Ashok Technological Institute (Engineering College), Vidisha – 464001 (First Cycle)',
  'Sant Hirdaram Girls College, Bhopal, 462030 (First Cycle)',
  'Sardar Ajeet Singh Memorial College, Ashoka Garden, Bhopal, 462023 (First Cycle)',
  'Sardar Vallabh Bhai Patel Shiksha Mahavidyalaya, Sendhwa, Barwai – 451666 (First Cycle)',
  'Sendhwa Sharirik Shiksha Sansthan, Dist. Barwani, 451666 (First Cycle)',
  'Shaheed Bhagat Singh Government Degree College, Ashta, Sehore – 466116 (Second Cycle)',
  'Sheetla Shiksha Mahavidyalaya, Dabra, Gwalior – 475110 (First Cycle)',
  'Shri Gujarati Samaj B.Ed. College, Indore, 452001 (First Cycle)',
  'Shri Jayantilal Hirachand Sanghvi Gujarati Innovative College of Commerce & Science, Indore, 452010 (First Cycle)',
  'Shri Rawatpura Sarkar College of Education, Dist. Satna, 485780 (First Cycle)',
  'Shri Rawatpura Sarkar Institute of Science and Education, Datia – 475661 (First Cycle)',
  'Shri Vaishnav College of Commerce, Indore, 452009 (Second Cycle)',
  'Sri Aurobindo Institute of Medical Sciences, Sri Aurobindo College of Dentistry, Dist. Indore, 453555 (First Cycle)',
  'Sri Sathya Sai College for Women, Bhopal – 462024 (Second Cycle)',
  'Swa.Gulabbai Yadav Smriti Shiksha Mahavidyalaya, Khargone – 451228 (First Cycle)',
  'Swami Vivekanand Government College, Raisen – 464551 (First Cycle)',
  'Swami Vivekanand Government Commerce College, Viriya Khedi, Ratlam – 457001 (First Cycle)',
  'Swami Vivekananda Mahavidyalaya, Makroniya, Sagar, 470004 (First Cycle)',
  'Swami Vivekananda Mahavidyalaya, Tahsil – Banda , Dist. Sagar, 470339 (First Cycle)',
  'Tagore Shiksha Mahavidyalaya, Indore, 452013 (First Cycle)',
  'Vijyashree Educational Institute, Jabalpur, 482003 (First Cycle)',
  'AEC Training College and Centre, Pachmarhi, Hoshangabad – 461881 (First Cycle)',
  'Anand Vihar College for Women, Tulsi Nagar, Bhopal – 462003 (First Cycle)',
  'Bhagat Singh Government P. G. College, Jaora, Ratlam – 457226 (First Cycle)',
  'Chhatrasal Government Post Graduate College, Panna – 488001 (First Cycle)',
  'College of Life Sciences (Jan Vikas Nyas), Gwalior – 474009 (Second Cycle)',
  'Dr. Radhakrishnan College of Education, Karmeta, Jabalpur – 482002 (First Cycle)',
  'Gandhi Vocational B.Ed. College, A. B. Road, Kushmoda, Guna – 473001 (First Cycle)',
  'Government Arts and Commerce College, Sagar – 470001 (Second Cycle)',
  'Government Arts College, Panagar, Jabalpur – 483220 (First Cycle)',
  'Government College, Mandleshwar, Maheshwar, Khargone – 451221 (First Cycle)',
  'Government College, Sailana, Ratlam – 457550 (First Cycle)',
  'Government College, Sausar, Chhindwara – 480106 (Second Cycle)',
  'Government Degree College, Banda, Sagar – 470335 (First Cycle)',
  'Government Degree College, Barwani, Anjad – 451116 (Second Cycle)',
  'Government Degree College, Bhikangaon, Khargone – 451331 (First Cycle)',
  'Government Degree College, Bichhua, Chhindwara – 480111 (First Cycle)',
  'Government Degree College, Timarni, Harda – 461228 (Second Cycle)',
  'Government Girls College, Do Batti, Ratlam – 457001 (First Cycle)',
  "Government Girls' College, Near Nagar Nigam, Mission Chowk, Katni – 483501 (Second Cycle)",
  "Government Girls' College, Ranjhi, Jabalpur – 482005 (Second Cycle)",
  'Government Girls College, Sadar, Betul – 460001 (Second Cycle)',
  'Government Girls Post Graduate College, Rewa – 486001 (Second Cycle)',
  'Government Girls Post Graduate College, Ujjain – 456010 (Second Cycle)',
  'Government Kalidas Girls College, Bada Teliwada Chauraha, Ujjain – 456006 (First Cycle)',
  'Government Kamala Raja Girls Post Graduate Autonomous College, Gwalior – 474001 (Third Cycle)',
  'Government Kamla Nehru Mahila Mahavidyalaya, Damoh – 470661 (Second Cycle)',
  'Government Madhav Sadashivrao Golvalkar College, Civil Lines, Rewa – 486001 (First Cycle',
  'Government Maharani Laxmi Bai Girls P. G. Autonomous College, Bhopal – 462002 (Second Cycle)',
  'Government Model Science College, Civil Lines, Rewa – 486001 (First Cycle)',
  'Government Nehru Degree College, Burhar, Shahdol – 484110 (First Cycle)',
  'Government Nehru Post Graduate College, Agar Malwa, Shajapur – 465441 (First Cycle)',
  'Government Nirbhay Singh Patel Science College, Indore – 452001 (First Cycle)',
  'Government P. G. College, BHEL, Mahatma Gandhi Chouraha, Berkhera, Bhopal – 462021 (Second Cycle)',
  'Government P. G. College, Raisen, Bareli – 464668 (Second Cycle)',
  'Government Post Graduate Arts and Science College, College Road, Infront of Nagar Nigam, Ratlam – 457001 (Second Cycle)',
  'Government Post Graduate College, Dahod Road, Alirajpur, Jhabua – 457887 (Second Cycle)',
  'Government Post Graduate College, Narsinghpur – 487001 (Second Cycle)',
  'Government Rajeev Gandhi Post Graduate College, Mhow, Neemuch Road, Mandsaur – 458001 (Second Cycle)',
  'Government Sanjay Gandhi Smriti Post Graduate College, Ganj Basoda, Vidisha – 464221 (Second Cycle)',
  'Government Science College, Pandhurna, Chhindwara – 480334 (Second Cycle)',
  'Government Shyam Sundar Agrawal P. G. College, Sihora, Jabalpur – 483225 (Second Cycle)',
  'Government Swami Vivekananda Mahavidyalaya, Bhopal – 463106 (Second Cycle)',
  'Government Thakur Ranamat Singh College, Rewa – 486001 (Second Cycle)',
  'Government V. A. B. L. Girls College, Tikamgarh – 472001 (Second Cycle)',
  'Gyanodaya Mahavidyalaya, Jaisinagar, Sagar – 470125 (First Cycle)',
  "Hawabagh Women's College, Jabalpur – 482001 (First Cycle)",
  'Hitkarini Prashikshan Mahila Mahavidyalaya, Madhatal, Jabalpur – 482002 (First Cycle)',
  'Indore Mahavidyalaya, Thandla, Jhabua – 457777 (First Cycle)',
  'Institute for Excellence in Higher Education, Bhopal – 462016 (Third Cycle)',
  'Jayawanti Haksar Government P. G. College, Betul – 460001 (Second Cycle)',
  'Maharani Pushpmala Raje Puar Government Girls Degree College, Dewas – 455001 (Second Cycle)',
  'Millennium College of Education, Bhopal – 462044 (First Cycle)',
  'National Education College, Kedarpur, Gwalior – 474001 (First Cycle)',
  'Ojaswini College of Education, Hathna, Damoh – 470661 (First Cycle)',
  'P. M. B. Gujarati Arts and Law College, Indore – 452001 (First Cycle)',
  'Rajmata Scindia Government Girls College, Chhindwara – 480001 (Second Cycle)',
  'Regional Institute of Education, Bhopal – 462013 (First Cycle)',
  'Sanjay Gandhi Smriti Government P. G. Autonomous College, Sidhi – 486661 (Second Cycle)',
  'Sarojini Naidu Government Girls P. G. (Autonomous) College, Shivaji Nagar, Bhopal – 462016 (Third Cycle)',
  'SDPS College of Nursing, Indore – 452020 (First Cycle)',
  'Seva Sadan Mahavidyalaya, Burhanpur – 450331(First Cycle)',
  'Shivnath Singh Educational Mahavidhyalaya, Madhav Nagar, Gwalior – 474002 (First Cycle)',
  'Shri Krishnajirao Powar Government Post Graduate College, Bhopal Square, Dewas – 455001 (Second Cycle)',
  'Shri Swamiji Maharaj College of Education and Sciences, Hameerpur, Datia – 475661 (First Cycle)',
  'Shri Vaishnav Institute of Technology and Management, Nirawali, Barauia, Gwalior – 474006 (First Cycle)',
  'Shyamlal Pandviya Government Post Graduate College, Morar, Gwalior – 474006 (Second Cycle)',
  'Sonali College, Guna – 473001 (First Cycle)',
  'St. Aloysius College (Autonomous), Jabalpur – 482001 (Third Cycle)',
  'State Institute of Science Education and College of Teacher Education, Jabalpur – 482001 (First Cycle)',
  'The Bhopal School of Social Sciences, Habibganj, Bhopal – 462024 (Third Cycle)',
  'Veerangna Awanti Bai College, Chatarpur – 471001 (First Cycle)',
  'Choithram College of Nursing, Indore – 452014 (First Cycle)',
  'Government Aranya Bharti College, Baihar, Balaghat – 481111 (Second Cycle)',
  'Government Degree College, Amarwara, Chhindwara – 480221 (Second Cycle)',
  'Government Sanskrit College, Rambagh, Tilak Path, Indore – 452007 (First Cycle)',
  'Government Jagannath Munnalal Choudhary Mahila Mahavidyalaya, Mandla – 481661 (Second Cycle)',
  'Veer Savarkar Government College, Obedullaganj, Raisen – 464993 (First Cycle)',
  'Government Kusum College, Banapura, Seoni Malwa, Hoshangabad – 461223 (Second Cycle)',
  'Government P. G. College, Shobhapur Road, Pipariya – 461775 (Second Cycle)',
  'Vijaya Raje Government Girls Post Graduate College, Garam Sadak Morar, Gwalior – 474001 (Second Cycle)',
  'Mata Gujri Mahila Mahavidyalaya (Autonomous), Marhatal, Jabalpur – 482001 (Third Cycle)',
  'Dr. Bhagwat Sahai Government College, Gwalior – 474003 (First Cycle)',
  'Government College, Indore Road, Kasrawad, Khargone – 451228 (First Cycle)',
  'Government Kamla Nehru Girls College, Near DIET Campus, Balaghat – 481001 (First Cycle)',
  'Government New Law College, Bhawarkua, Indore – 452017 (First Cycle)',
  'Saifee Golden Jubilee Quaderia College, Burhanpur – 450331 (First Cycle)',
  'Shri Jain Diwakar Mahavidyalaya, New Palasia, Indore – 452001 (First Cycle)',
  'Shri Shri Laxminarayan Government Pench Valley Post Graduate Mahavidyalaya, Khirsadho, Parasia – 480441 (First Cycle)',
  'Bherulal Patidar Government P. G. College, Dongargaon, Mhow, Indore – 453441 (Second Cycle)',
  'Christian Eminent Academy of Management, Professional Education and Research, Indore – 452011 (Second Cycle)',
  'Government Arts and Commerce P. G. College, Harda – 461331 (Second Cycle)',
  'Government Degree College, Sleemnabad, Katni – 483440 (Second Cycle)',
  'Government S. S. P. College, Waraseoni, Balaghat – 481331 (Second Cycle)',
  'Ordinance Factory Khamaria Government College, Khamaria, Jabalpur – 482005 (Second Cycle)',
  'Shaheed Chandrashekar Azad Government Post Graduate College, Rajgar Naka, Jhabua – 457661 (Second Cycle)',
  'Shri Raghvendra Singh Hazari Government Degree College, Hatta, Damoh – 470775 (Second Cycle)',
  'Shri Vaishnav Institute of Management, Gumasta Nagar, Indore – 452009 (Second Cycle)',
  'Shri Cloth Market Kanya Vanijya Mahavidyalaya, Ganesh Ganj, Indore – 452002 (Third Cycle)',
  'GOVERNMENT COLLEGE BAGLI,Gandhi Colony Bagli Dist. Dewas,Bagli , 455227 (First Cycle)',
  'GOVT. ARTS COLLEGE,Lalmati, Behind Petrol Pump Chhapara,Chhapara , 480884 (First Cycle)',
  'GOVERNMENT COLLEGE THANDLA,Govt. College Thandla distt. Jhabua,Thandla,Madhya Pradesh,457777 (First Cycle)',
  'DANIELSON DEGREE COLLEGE,NAGPUR ROAD, CHHINDWARA , M.P. 480001,CHHINDWARA,Madhya Pradesh,480001 (First Cycle)',
  'GOVT. DEGREE COLLEGE PUSHPRAJGARH,REWA AMARKANTAK ROAD SH8 VILLAGE KIRGI POST RAJENDRAGRAM TEHSIL PUSHPRAJGARH DISTT ANUPPUR,ANUPPUR SHAHDOL,Madhya Pradesh,484881 (First Cycle)',
  'GOVT. MAHATMA GANDHI MAHAVIDYALAYA JAWAD,Nimach Road, Jawad, Dist. Nimach (MP),Jawad Dist Nimach,Madhya Pradesh,458330 (First Cycle)',
  'GOVERNMENT M.H.COLLEGE OF HOME SCIENCE AND SCIENCE FOR WOMEN,Napier Town, Jabalpur 482002,Jabalpur,Madhya Pradesh,482002 (Third Cycle)',
  'GOVT COLLEGE DHARAMPURI,GRAM GULATI KHALGHAT ROAD DHARAMPURI DISTT. DHAR M.P.,DHARAMPURI DISTT DHAR,Madhya Pradesh,454449 (First Cycle)',
  'GOVT. NEHRU DEGREE COLLEGE, ASHOKNAGAR (M.P.),Govt. Nehru Degree College, Isagarh Bypass Road, Ashoknagar,Ashoknagar,Madhya Pradesh,473331 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE BARGHAT,GOVERNMENT DEGREE COLLEGE BARGHAT SALAI ROAD BARGHAT DISTRICT SEONI,Barghat,Madhya Pradesh,480667 (Second Cycle)',
  'GOVERNMENT GIRLS COLLEGE,Near Bus Stand Behind City Police Thana,Seoni,Madhya Pradesh,480661 (Second Cycle)',
  'GOVT. P. G. COLLEGE, BINA,Govt. P. G. College, Bina, Near Telephone Exchange, Rajeev Gandhi Ward, Bina,BINA,Madhya Pradesh,470113 (Third Cycle)',
  'GOVT. P. G. COLLEGE, SENDHWA,A. B. ROAD, SENDHWA DIST-BARWANI MP-451666,SENDHWA,Madhya Pradesh,451666 (First Cycle)',
  'GOVT PG COLLEGE RAJGARH MP, Near khilchipur naka rajgarh,RAJGARH,Madhya Pradesh,465661 (First Cycle)',
  'GOVT S.K.COLLEGE MAUGANJ, Govt.S.K.College Mauganj NH 7(135) Distt. Rewa,MAUGANJ Rewa,Madhya Pradesh,486331 (First Cycle)',
  'GOVT.VIVEKANAND MAHAVIDYALAYA MAIHAR DISTT.SATNA (M.P.), SATNA ROAD NEAR NEELKANTH ASHRAM MAIHAR DISTT SATNA,MAIHAR,Madhya Pradesh,485771 (First Cycle)',
  'GOVT. GRADUATE COLLEGE ARON, SIRONJ ROAD ARON, DIST. GUNA,ARON,Madhya Pradesh,473101 (First Cycle)',
  'MAHARAJA BHOJ GOVT.P.G.AUTONOMOUS COLLEGE,DHAR, Indore Ahamdabad National Highway Near Indore Naka Dhar,DHAR,Madhya Pradesh,454001 (First Cycle)',
  'RANI DURGAWATI SHASKIYA MAHAVIDYALAY PARASWADA,BALAGHAT MP, AT -LINGA PARASWADA ,BALAGHAT,PARASWADA,Madhya Pradesh,481556 (First Cycle)',
  'GOVT COLLEGE, KUNDAM, Hadipani Road,Kundam,Jabalpur,Madhya Pradesh,483110 (First Cycle)',
  'CAREER COLLEGE, Govindpura, BHEL, Opp. Dushehara Maidan,Bhopal,Madhya Pradesh,462023 (Third Cycle)',
  'VEERANGNA JHALKARI BAI GOVERNMENT GIRLS COLLEGE, Morena Link Road Near IIITM Gwalior,Gwalior,Madhya Pradesh,474002 (First Cycle)',
  'SHRI MAKHANLAL CHATURVEDI GOVT. COLLEGE BABAI , SHRI MAKHANLAL CHATURVEDI GOVT. COLLEGE PIPARIYA ROAD BABAI, Distt. HOSHANGABAD,BABAI,Madhya Pradesh,461661 (First Cycle)',
  'GOVT CHHATRASAL MAHARAJA COLLEGE MAHARAJPUR , MAIN ROAD NEAR YOG SANSTHAN,MAHARAJPUR,Madhya Pradesh,471501 (First Cycle)',
  'SWAMI VIVEKANAND GOVT. COLLEGE LAKHNADON , Ghansor Road Lakhnadon District Seoni M.P. Pin 480886,LAKHNADON,Madhya Pradesh,480886 (First Cycle)',
  'GOVT.GIRLS COLLEGE, RAISEN , Near Dushera Maidan, Raisen,Raisen,Madhya Pradesh,464551 (First Cycle)',
  'SHRI SITARAM JAJU GOVENRMENT GIRLS COLLEGE , Mahaveer Marg In front of Old Nagar Palika, Near GPO, Neemuch,NEEMUCH,Madhya Pradesh,458441 (Second Cycle)',
  'MADHAV COLLEGE, UJJAIN , Dewas Gate, Opposite BSNL Office,Ujjain,Madhya Pradesh,456001 (First Cycle)',
  'SHRI ATAL BIHARI VAJPAYEE GOVERNMENT ARTS AND COMMERCE COLLEGE , A.B. Road, Near Bhanwarkuan Square,Indore,Madhya Pradesh,452017 (Third Cycle)',
  'SHAHEED BHEEMA NAYAK GOVERNMENT POST GRADUATE COLLEGE , KHANDWA BARODA STATE HIGHWAY BARWANI,BARWANI,Madhya Pradesh,451551 (Third Cycle)',
  'JAWAHARLAL NEHRU GOVERNMENT DEGREE COLLEGE BARWAHA , Jawaharlal Nehru Government Degree College, Narmada Road Barwaha District Khargone,BARWAHA,Madhya Pradesh,451115 (Second Cycle)',
  'GOVT. MAHAKOSHAL ARTS COMMERCE MAHAVIDYALAYA JABALPUR , Govt Mahakoshal Arts and Commerce Mahavidhyalaya South Civil Lines Pachpedhi Jabalpur,JABALPUR,Madhya Pradesh,482001 (Third Cycle)',
  'RAJA BHOJ GOVERNMENT COLLEGE MANDIDEEP , RajaBhoj Government College Satlapur Mandideep (Raisen),MANDIDEEP,Madhya Pradesh,462046 (First Cycle)',
  'GOVERNMENT POST GRADUATE COLLEGE,Seoni Mungwani Road, Bhairongunj Seoni,MadhyaPradesh,480661 (Second Cycle)',
  'GOVERNMENT MODEL SCIENCE COLLEGE (AUTONOMOUS),Pachpedhi, South CivIl Lines,JABALPUR,MadhyaPradesh,482001 (Third Cycle)',
  'GOVT. R.V.P.S. COLLEGE UMARIA,Shahpura Road, Opposite Collectorate Umaria,UMARIA,Madhya Pradesh,484661 (First Cycle)',
  'B.K.S.N GOVT. COLLEGE, SHAJAPUR,A B ROAD OPP. ITI SHAJAPUR,SHAJAPUR,Madhya Pradesh,465001 (First Cycle)',
  'GOVERNMENT GIRLS COLLEGE, DHAR (M.P.),Govt. Girls College , Mandu Road, Dhar,DHAR,Madhya Pradesh,454001 (Second Cycle)',
  'GOVERNMENT DEGREE COLLEGE HATPIPLIYA,Neori Bagli Marg Tilyakhedi Hatpipliya,Hatpipliya,Madhya Pradesh,455223 (First Cycle)',
  'GOVERNMENT COLLEGE RAGHOGARH,Aron Road, Barbatpura,Raghogarh,Madhya Pradesh,473226 (First Cycle)',
  'GOVERNMENT GIRLS COLLEGE BHIND,Purana Kila near purani basti bhind,BHIND,Madhya Pradesh,477001 (First Cycle)',
  'GOVERNMENT COLLEGE PITHAMPUR, DHAR,Near Daak Banglow Basement Govt.H.S.School Pithampur District Dhar (M.P.),PITHAMPUR,Madhya Pradesh,454775 (First Cycle)',
  'GOVERNMENT MOTILAL VIGYAN MAHAVIDYALAYA, BHOPAL,Near Old Vidhan Sabha, Jahangirabad,,Bhopal,Madhya Pradesh,462008 (Third Cycle)',
  'GOVERNMENT COLLEGE KHURAI,BEHIND SANJAY PETROL PUMP, BINA ROAD,KHURAI,Madhya Pradesh,470117 (First Cycle)',
  'GOVT. J.S.T. P.G. COLLEGE, BALAGHAT,Kali Putli Chouk, Near Hanuman Mandir, Balaghat,Balaghat,Madhya Pradesh,481001 (Second Cycle)',
  'GOVT. COLLEGE MEHGAON,Govt. College Mehgaon Distt. Bhind,Mehgaon,Madhya Pradesh,477557 (First Cycle)',
  'MLC GOVT. GIRLS COLLEGE PG KHANDWA MADHYA PRADESH,MLC Govt Girls PG College, Padava, Indore Road, Khandwa,Khandwa,Madhya Pradesh,450001 (Third Cycle)',
  'GOVT. MAHARANI LAXMIBAI GIRLS PG COLLEGE,GOVT. MAHARANI LAXMIBAI GIRLS P.G. COLLEGE KILA BAWAN, INDORE,INDORE,Madhya Pradesh,452006 (Third Cycle)',
  'PIONEER INSTITUTE OF PROFESSIONAL STUDIES,Sector R, Mahalaxmi Nagar, Near Bombay Hospital, Indore,Madhya Pradesh,452010 (Third Cycle)',
  'GOVT. MAHATMA GANDHI MEMORIAL POST GRADUATE COLLEGE, Main Road Nyas Colony Itarsi (M.P.)461111 (Third Cycle)',
  'INDORE INSTITUTE OF LAW,Gendalal Bam Parisar Rau- Pithampur Road, Opposite IIM, Village Dehari-Rangwasa, Rau,Indore,Madhya Pradesh,453331 (First Cycle)',
  'Government College, Multai, Betul ,Near Railway Station, Bordehi Road, Multai,Betul - 460661 (First Cycle)',
  'Adarsh Institute of Management and Science,AB Road, Dhamnod, Teh Dharampuri,Dhar - 454552 (First Cycle)',
  'Government Tilak PG College,Rafi Ahmad Kidwai Ward,Katni - 483501 (Second Cycle)',
  'G. S. College of Commerce and Economics,,Jabalpur - 482001 (Third Cycle)',
  'Lokmanya Tilak Science and Commerce College, Ujjain,Neelganga Road, Behind Railway Station,Ujjain - 456010 (First Cycle)',
  "A. B. M. S. Parishad's Shri Shahu Mandir Mahavidyalaya, Parvati Ramana, Pune – 411009 (Third Cycle)",
  'A. G. S. College of Education, Saravali, Boisar (W), Palghar, Thane – 401501 (First Cycle)',
  'Abhay Yuwa Kalyan Kendra’s Arts Mahila College, Dhule – 424002 (Second Cycle)',
  "Abhinav Education Society's College of Education, Pune, 411046 (First Cycle)",
  'Adarsh Arts and Commerce College,Dist. Gadchiroli, 441207 (Second Cycle)',
  "Adarsh Shikshan Prasarak Mandal's, Shri Bapusaheb D.D. Vispute College of Education, Dist. Raigad, 410206 (First Cycle)",
  "Adivasi Seva Sahayyak and Shikshan Prasarak Sanstha's Shri D. H. Agrawal Arts, Shri Rang Avadhoot Commerce and Shri C. C. Shah and M. G. Agarwal Science College, Nawapur – 425418 (Second Cycle)",
  "Agricultural Development Trust's Shardabai Pawar Mahila College (Arts, Commerce and Science), Baramati, Pune – 413115 (Second Cycle)",
  'Ahmednagar Jilha Maratha Vidya Prasarak Samaj’s Shri Dhokeshwar College, Ahmednagar – 414304 (Second Cycle)',
  "Akole Taluka Education Society's Agasti Arts, Commerce And Dadasaheb Rupwate Science College, Ahmednagar – 422601 (Second Cycle)",
  'All India Shri Shivaji Memorial Society’s College of Hotel Management and Catering Technology, Pune, 411005 (First Cycle)',
  "All India Shri Shivaji Memorial Society's Institute of Information Technology, Pune - 411001 (First Cycle)",
  'Amrutvahini College of Engineering, Sangamner, Ahmednagar – 422608 (First Cycle)',
  "Anekant Education Society's Jaysingpur College, Kolhapur – 416101 (Second Cycle)",
  "Anjuman Khairul Islam's Poona College of Arts, Science and Commerce, Pune – 411001 (Second Cycle)",
  'Annasaheb Waghire Arts, Science & Commerce College, Dist. Pune, 412409 (Second Cycle)',
  'Anurag Adhyapak Mahavidyalaya, Dist. Bhandara, 441905 (First Cycle)',
  'Appaswami Mahavidyalaya, Shendurjana (Adhao), Tq. Manora, Washim – 444403 (First Cycle)',
  "Aqsa Women's Degree College, Bhiwandi – 421302 (First Cycle)",
  'Armed Forces Medical College, Pune, 411040 (Third Cycle)',
  'Arts and Commerce College, Nagthane, Satara – 415519 (First Cycle)',
  'Arts and Commerce College, Sindhudurg, Phondaghat – 416601 (First Cycle)',
  'Arts, Commerce and Science College, Saraswati Nagar, Gadhinglaj, Kolhapur – 416502 (First Cycle)',
  'Ashokrao Mane Group of Institutions Faculty of Engineering & Management Studies (MBA), Dist. Kolhapur, 416112 (First Cycle)',
  'B. L. Amlani College of Commerce and Economics M. R. Nathwani College of Arts, Vile Parle West, Mumbai – 400056 (First Cycle)',
  'B.B. Arts, N.B. Commerce & B.P. Science College, Dist. Yavatmal, 445203 (Second Cycle)',
  'Baba Naik Mahavidyalaya, Dist. Sangli, 415405 (First Cycle)',
  "Balaghat Shikshan Sanstha's Arts, Science and Commerce College, Osmanabad, Naldurg – 413602 (Second Cycle)",
  'Balbhgwan Shikshan Prasarak Mandals, Swami Vivekanand Mahavidyalaya, Dist. Latur, 413514 (Second Cycle)',
  'Bar. S. K. Wankhede College of Education, Nagpur – 440001 (First Cycle)',
  'Bhadrawati Shikshan Sanstha, Bhadrawati Nilkanthrao Shinde Science and Arts College, Chandrapur – 442902 (Third Cycle)',
  "Bhagini Mandal Chopda's College of Social Work, Jalgaon – 425107 (First Cycle)",
  'Bhagwantrao Shivaji Patil Mahavidyalaya, Dist. Amravati, 444805 (Second Cycle)',
  'Bharatiya Vidya Bhavan’s Hazarimal Somani College of Arts and Science and Jayaramdas Patel College of Commerce and Management Studies, Chowpatty, Mumbai, 400007 (Second Cycle)',
  "Bharatiya Vidya Bhavan's , Bhavan's College, Mumbai, 400058 (Second Cycle)",
  'Bhawabhuti Mahavidyalaya (Arts, Commerce and Science), Amgaon, Gondia – 441902 (Second Cycle)',
  'Bhiwapur Mahavidyalaya, Nagpur – 441201 (First Cycle)',
  'Bhusawal Arts, Science & P.O. Nahata Commerce College, Jalgaon, 425201 (Third Cycle)',
  'Birla College of Arts, Science & Commerce, Kalyan,421304 (Third Cycle)',
  "Bombay Physical Culture Association's College of Physical Education, Mumbai – 400031 (Third Cycle)",
  'Br. Balasaheb Khardekar College, Dist. Sindhudurg, 416516 (Second Cycle)',
  'Brijlal Biyani Science College, Amravati, 444605 (Second Cycle)',
  "C. P. and Berar Education Society's College, Tulsibag, Mahal, Nagpur – 440002 (Second Cycle)",
  "Chh. Shahu Institute of Business Education and Research, Trust's College of Non-conventional Vocational Courses for Women, Kolhapur – 416004 (Third Cycle)",
  "Clara's College of Commerce, Mumbai – 400061 (First Cycle)",
  'College of Social Work, Kamptee, Nagpur – 441001 (First Cycle)',
  'College of Social Work, Mumbai, 400020 (Third Cycle)',
  "Cosmopolitan's Valia Chhaganlal Laljibhai College of Commerce and Valia Lilavantiben Chhaganlal College of Arts, Mumbai – 400053 (Second Cycle)",
  "D. M. S. P. Mandal's N. K. Varadkar Arts and R. V. Belose Commerce College, Ratnagiri – 415712 (Third Cycle)",
  'D.A.V. Velankar College of Commerce, Solapur, 413002 (Second Cycle)',
  'D.G Tatkare Mahavidiyalya, Arts Science and Commerce, Dist Raigad, 402104 (First Cycle)',
  'Damani Premratan Bhairuratan Dayanand College of Education, Solapur - 413002 (Second Cycle)',
  'Datta Meghe Institute of Engineering, Technology and Research, Wardha – 442004 (First Cycle)',
  "Daulat Vishwasth Sanstha's Yashwantrao Chavan Mahavidyalaya, Chandgad, Kolhapur – 416552 (Second Cycle)",
  'Dayanand College of Law, Latur, 431531 (Second Cycle)',
  'Deccan Education Society’s Brihan Maharashtra College of Commerce, Pune, 411004 (Third Cycle)',
  "Deccan Education Society's Fergusson College, Pune – 411004 (Third Cycle)",
  "Deccan Education Society's Kirti M. Doongursee College of Arts, Science and Commerce, Dadar (West), Mumbai – 400028 (Third Cycle)",
  "Deshbhakt Babasaheb Bhausaheb Khanjire Shikshan Sansthan's Night College of Arts and Commerce, Ichalkaranji – 416115 (Third Cycle)",
  'Deshbhakta Ratnappa Kumbhar College of Commerce, Kolhapur – 416002 (Second Cycle)',
  "Devrukh Shikshan Prasarak Mandal's Nya. Tatyasaheb Athalye Arts, Ved S. R. Sapre Commerce and Vid. Dadasaheb Pitre Science College, Ratnagiri – 415804 (Third Cycle)",
  "Dhanaji Nana Chaudhari Vidya Prabodhini's Shirish Madhukarrao Chaudhari College, Jalgaon – 425001 (First Cycle)",
  "Dhanaji Nana Chaudhuri Vidya Prabodhini's College of Social Work, Jalgaon – 425001 (First Cycle)",
  'Dharmabad Shikshan Sanstha’s Lal Bahadur Shastri Mahavidyalaya, Nanded – 431809 (Second Cycle)',
  "Dnyan Prasarak Mandal's Shikshan Maharshi Dnyandeo Mohekar Mahavidyalaya, Osmanabad – 413507 (Second Cycle)",
  "Dnyanopasak Shikshan Mandal's, Arts, Commerce & Science College, Dist. Parbhani, 431509 (Second Cycle)",
  'Dnyanopasak Shikshan Mandals’ College of Arts, Commerce and Science, Parbhani – 431401 (Third Cycle)',
  'Dr. Babasaheb Ambedkar College of Social Work, Morane (Nakane), Dhule, 424001 (First Cycle)',
  'Dr. Babasaheb Ambedkar Mahavidyalaya, Dist. Kolhapur, 416112 (Second Cycle)',
  'Dr. D. Y. Patil College of Ayurved and Research Centre, Pune – 411018 (First Cycle)',
  'Dr. D. Y. Patil Homoeopathic Medical College and Research Centre, Pimpri, Pune – 411018 (First Cycle)',
  'Dr. D. Y. Patil Institute of Engineering and Technology, Pune – 411018 (First Cycle)',
  "Dr. D. Y. Patil Pratishthan's Padmashree Dr. D. Y. Patil Arts, Commerce and Science College, Pune – 411018 (Second Cycle)",
  "Dr. D. Y. Patil Vidya Pratishthan Society's Padmashree Dr. D. Y. Patil Institute of Pharmaceutical Sciences and Research, Pune – 411018 (First Cycle)",
  'Dr. Datar Science, Dr. Behere Arts and Shri Pilukaka Joshi Commerce College, Dist. Ratnagiri, 415605 (Third Cycle)',
  'Dr. G. D. Pol Foundation YMT College of Management, Sector 4, Institutional Area, Kharghar, Navi Mumbai – 410210 (First Cycle)',
  'Dr. H.N. Sinha Arts & Commerce College, Dist. Akola, 444501 (Second Cycle)',
  "Dr. S.S.M. Pratisthan's College of Education, Dist. Latur, 431515 (First Cycle)",
  'G. H. Raisoni College of Engineering, Digdoh Hills, Nagpur – 440016 (Second Cycle)',
  'G.H. Raisoni Institute of Management & Research, Nagpur, 441102 (First Cycle)',
  "Gaurishankar Seva Samiti's Vidnyan Mahavidyalaya, Dist. Buldana, Malkapur – 443101 (Second Cycle)",
  'Ghulam Nabi Azad Arts, Commerce and Science College, Akola – 444401 (Second Cycle)',
  'Gokhale Education Society’s Shri Bhausaheb Vartak Arts, Commerce and Science College, Borivli (West), Mumbai – 400091 (Third Cycle)',
  "Gokhale Education Society's Arts, Commerce and Science College, Raigad – 402110 (Second Cycle)",
  "Gondia Education Society's Manoharbhai Patel Arts and Commerce College, Gondia – 441619 (Second Cycle)",
  'Government College of Education, Aurangabad, 431005 (Second Cycle)',
  'Government College of Education, Morewadi, Ambajogai – 431517 (Second Cycle)',
  'Government College of Education, Ratnagiri – 415612 (Second Cycle)',
  'Government Institute of Science, Aurangabad – 431004 (Second Cycle)',
  'Gram Vikas Shikshan Mandal, Nagpur Rani Indirabai Bhonsale Mahavidyalaya, Nagpur – 441202 (Second Cycle)',
  'Guru Nanak College of Arts, Science & Commerce, Mumbai, 400037 (Second Cycle)',
  'Guru Nanak Khalsa College of Arts, Science and Commerce, Mumbai – 400019 (Third Cycle)',
  'Gurukrupa College of Education and Research, Kalyan (West), Thane – 421301 (First Cycle)',
  'Gurukul College of Commerce, Ghatkopar East, Mumbai – 400077 (First Cycle)',
  'Gurunanak College of Pharmacy, Nagpur – 440026 (First Cycle)',
  'H.G.M. Azam College of Education, Pune, 411001 (First Cycle)',
  'H.R. College of Commerce & Economics Mumbai, Maharashtra (Third Cycle)',
  'Hashu Advani College of Special Education, Mumbai – 400074 (First Cycle)',
  "Hindustani Education Society's Azad Mahavidyalaya, Ausa Tq., Latur – 413520 (Second Cycle)",
  "Hon. Shri. Dadapatil Rajale Shikshan Sanstha's Dadapatil Rajale Arts and Science College, Ahmednagar – 414505 (Second Cycle)",
  "Ideal Education Society's, Nutan Adarsh Arts, Commerce & Smt. Maniben Harilal Wegad Science College, Dist. Nagpur, 441203 (Second Cycle)",
  'Indian Institute of Cost And Management Studies & Research (Autonomous), Pune, 411004 (Second Cycle)',
  'Indira Gandhi (SR.) College, New Nanded, 431603 (First Cycle)',
  "IQRA Education Society's IQRA College of Education, Jalgaon – 425001 (First Cycle)",
  'J. D. College of Engineering and Management, Nagpur – 440018 (First Cycle)',
  'J. D. M. V. P. Co-op. Samaj’s Shri S. S. Patil Arts, Shri Bhausaheb T. T. Salunkhe Commerce and Shri G. R. Pandit Science College, Jalgaon – 425001 (Second Cycle)',
  "J. D. M. V. P. Co-op. Samaj's Arts, Science and Commerce College, Varangaon, Jalgaon – 425305 (Second Cycle)",
  'Jai Hind College, Mumbai – 400020 (Third Cycle)',
  "Jaikranti Shikshan Prasarak Mandal, Kava's Shivaji Mahavidyalaya, Latur – 413527 (Second Cycle)",
  'Jalgaon Jilla Maratha Prasarak Sahakari Samaj Arts, Commerce and Science College, Yawal, Jalgaon – 425301 (Second Cycle)',
  "Jalna Education Society's R. G. Bagdia Arts, S. B. Lakhotia Commerce and R. Bezonji Science College, Jalna – 431203 (Second Cycle)",
  'Janshakti Shikshan Sanstha Pandharkawada Shri Babasaheb Deshmukh Parwekar Mahavidyalaya, Pandharkawada – 445302 (Second Cycle)',
  'Jeevan Jyot Educational Trusts Reena Mehta College of Commerce and Management Studies, Bhayander (West), Thane – 401101 (First Cycle)',
  'Jijamata Education Society’s Arts, Science and Commerce College, Nandurbar – 425412 (Second Cycle)',
  "JSSP's Arts, Commerce and Science College, Goveli, Rayate P.O., Dist. Thane, Kalyan – 421301 (First Cycle)",
  'Jyotiba Fule College of Education, Nagpur, 440025 (First Cycle)',
  'K. J. Somaiya College of Science and Commerce, Mumbai – 400077 (Third Cycle)',
  'K. J. Somaiya Comprehensive College of Education, Training and Research, Mumbai – 400077 (Third Cycle)',
  'K. Z. S. Science College, Bramhani, Kalmeshwar, Nagpur – 441501 (Second Cycle)',
  "K.T.S.P. Mandal's Hutatma Rajguru Mahavidyalaya, Dist. Pune, 410505 (Second Cycle)",
  "K.V.R. Shinde Shikshan Sanstha's Shivraj College of Arts, Commerce and D.S. Kadam Science College, Dist. Kolhapur, 416502 (Second Cycle)",
  'Kala Mahavidyalaya, Chandrapur Dist, 442916 (First Cycle)',
  "Kamala Education Society's Pratibha College of Commerce and Computer Studies, Pune – 411019 (First Cycle)",
  "Kannada Sangha Pune's Kaveri College of Science and Commerce, Pune – 411038 (First Cycle)",
  "Karnataka Sangha's Manjunatha College of Commerce, Dist. Thane, 421201 (First Cycle)",
  'Karve Institute of Social Service, Pune – 411052 (Third Cycle)',
  "Khandesh College Education Society's College of Engineering and Information Technology, Jalgaon – 425001 (First Cycle)",
  'Khorshedbanu R. Mewawala Mahila Arts & Commerce Mahavidyalaya, Nanded, 431601 (Second Cycle)',
  "Kisan Shikshan Prasarak Mandal's Shivaji Mahavidyalaya, Latur District, Udgir – 413517 (Second Cycle)",
  'Kishinchand Chellaram College, Churchgate, Mumbai, 400020 Maharashtra (Third Cycle)',
  "Kolhapur Institute of Technology's College of Engineering, Kolhapur, 416234 (First Cycle)",
  "Kolhapur Municipal Corporation's Yashwantrao Chavan (K.M.C.) College, Kolhapur – 416012 (Second Cycle)",
  'Krantiveer Vasantrao Narayanrao Naik Shikshan Prasarak Sanstha’s Arts and Commerce College, Nashik – 422202 (First Cycle)',
  "Krantiveer Vasantrao Narayanrao Naik Shikshan Prasarak Sanstha's Arts, Commerce & Science College, Nashik, 422002 (Second Cycle)",
  'Krishak Education Societies Arts, Commerce and Science College, Arvi, Wardha – 442201 (Third Cycle)',
  'Lala Lajpat Rai ollege of Commerce and Economics, Mumbai – 400034 (Third Cycle)',
  'Late Annasaheb R. D. Deore Arts and Science College, Mhasadi, Sakri, Dhule – 424304 (First Cycle)',
  "Late Digambarrao Bindu Smarak Samiti's Digambarrao Bindu Arts and Commerce College, Nanded – 431801 (Second Cycle)",
  'Late Pundalikrao Gawali Arts and Science Mahavidyalaya, Washim – 444504 (First Cycle)',
  'Late Ramesh Warpudkar Arts & Commerce College, Dist. Parbhani, 431516 (First Cycle)',
  "Late Shri Vishnu Waman Thakur Charitable Trust's Bhaskar Waman Thakur College of Science Yashvant Keshav Patil College of Commerce and Vidhya Dayanand Patil College of Arts, Thane – 401303 (First Cycle)",
  'Laxman Devram Sonawane College of Arts and Commerce, Kalyan (W) – 421301 (First Cycle)',
  "Laxmi Education Society's Shri. Chinai College of Commerce and Economics, Mumbai – 400069 (Second Cycle)",
  'M. S. P. Mandal’s Deogiri College, Aurangabad – 431005 (Third Cycle)',
  "MAEER's MIT School of Education and Research, Pune – 411038 (First Cycle)",
  "Maharashtra Education Society's Abasaheb Garware College, Pune – 411004 (Third Cycle)",
  "Maharashtra Education Society's Maharashtra Udayagiri Mahavidyalaya, Udgir, Latur – 413517 (Second Cycle)",
  "Maharshi Karve Stree Shikshan Samstha's K. B. Joshi Institute of Information Technology, Pune – 411052 (First Cycle)",
  'Mahatma Gandhi Mission’s Dental College and Hospital, Navi Mumbai – 410209 (First Cycle)',
  "Mahatma Gandhi Vidyamandir's Arts, Science & Commerce College, Nashik, 423104 (Second Cycle)",
  "Mahatma Gandhi Vidyamandir's Arts, Science and Commerce College, Nashik – 422204 (Second Cycle)",
  'Mahila Mahavidyalaya, Jog Chowk, Amravati – 444601 (Second Cycle)',
  'Malad Kandivli Education Society’s, Nagindas Khandwala College of Commerce, Arts & Management Studies And Shantaben Nagindas Khandwala College of Science, Malad (West), Mumbai, Maharashtra (Third Cycle)',
  'Manavlok’s College of Social Sciences, Dist Beed, 431517 (First Cycle)',
  'Mangaon Taluka Education Society’s Doshi Vakil Arts College and G. C.U. B. Science and Commerce College, Raigad – 402103 (First Cycle)',
  'Manghanmal Udharam College of Commerce, Pimpri, Pune – 411017 (Third Cycle)',
  "Maniben Nanavati Women's College, Mumbai – 400056 (Third Cycle)",
  "Maratha Vidya Prasarak Samaj's Arts, Commerce & Science College, Dist. Nashik, 422202 (First Cycle)",
  "Marathwada Sanskritik Mandal's College of Physical Education, Khadkeshwar, Aurangabad – 431001 (Second Cycle)",
  "Marathwada Shikshan Prasarak Mandal's R. B. Attal Arts, Science and Commerce College, Georai – 431127 (Third Cycle)",
  "Marathwada Shikshan Prasarak Mandal's Vinayakrao Patil Mahavidyalaya, Vaijapur, Aurangabad – 423701 (Third Cycle)",
  'Marutirao Harirao Mahadik Arts and Commerce College, Madha, Modnimb, Solapur – 413301 (Second Cycle)',
  'Matoshri College of Engineering and Research Centre, Nashik – 422105 (First Cycle)',
  'Maulana Azad College of Arts, Science and Commerce, Aurangabad – 431001 (Second Cycle)',
  "Maulana Azad Education Society's Marathwada College of Education, Aurangabad – 431001 (Second Cycle)",
  "Mauli Vidyapeeth's Mahila Kala Mahavidyalaya, Beed – 431122 (Second Cycle)",
  "Modern Education Society's College of Engineering, Pune – 411001 (First Cycle)",
  "Modern Education Society's, College of Education, Dist. Sangli, 415311 (Second Cycle)",
  "Moreshwar Shikshan Prasarak Mandal's Moreshwar Arts, Science and Commerce College, Bhokardan, Jalna – 431114 (Second Cycle)",
  'Nagar Parishad Shivaji Mahavidyalaya, Dist. Nagpur, 441303 (Second Cycle)',
  "Nandurbar Taluka Vidhayak Samitee's G.T. Patil Arts, Commerce And Science College, Nandurbar Dist, 425412 (Second Cycle)",
  'Nashik District Maratha Vidya Prasarak Samaj’s Karmaveer Adv. Baburao Ganpatrao Thakare College of Engineering, Nashik – 422013 (First Cycle)',
  "National Education Society's Ratnam College of Arts, Science and Commerce, Bhandup (W), Mumbai – 400078 (Third Cycle)",
  'Navjeevan Law College, Nashik - 422009 (Second Cycle)',
  'Navnirman Shikshan Sanstha’s Laxmibai Sitaram Halbe College of Arts, Commerce and Science, Kasai-Dodamarg, Sindhudurg – 416512 (First Cycle)',
  "Nav-Sahyadri Charitable Trust's College of Education, Pune – 410501 (First Cycle)",
  "NCRD's Sterling College of Arts, Commerce and Science, Navi Mumbai – 400706 (First Cycle)",
  'Night College of Arts and Commerce, Kolhapur – 416002 (Second Cycle)',
  'Nirmala Memorial Foundation College of Commerce and Science, Kandivali (East), Mumbai – 400101 (First Cycle)',
  'Padmashree Dr. D.Y. Patil Institute of Management Studies, Pune, 411044 (First Cycle)',
  'Padmashree Dr. Vithalrao Vikhe Patil Foundation’s College of Physiotherapy, Ahmednagar, 414111 (First Cycle)',
  "Padmashree Dr. Vithalrao Vikhe Patil Foundation's College of Pharmacy, Ahmednagar – 414111 (First Cycle)",
  "Padmashree Dr. Vithalrao Vikhe Patil Foundation's Institute of Business Management and Rural Development, Ahmednagar – 414111 (First Cycle)",
  'Padmashri Dr. Vithalrao Vikhe Patil College of Engineering, Ahmednagar – 414111 (First Cycle)',
  'Pen Education Society’s Bhausaheb Nene Arts, Science and Commerce College, Raigad, Pen – 402107 (Second Cycle)',
  'People’s Welfare Society’s Dr. Madhukarrao Wasnik P. W. S. College, Teka Naka, Nagpur – 440026 (Third Cycle)',
  "Pimpalner Education Society's Karm. A. M. Patil Arts, Commerce and Kai. Annasaheb N. K. Patil Science Senior College, Pimpalner – 424306 (Second Cycle)",
  "Prathibha Niketan Education Society's Prathibha Niketan Mahavidyalaya (Arts, Commerce and Science), Nanded – 431601 (Second Cycle)",
  "Pratishthan Education Society's Pratishthan Mahavidyalaya, Paithan – 431107 (Second Cycle)",
  "Pravara Rural Education Society's Arts, Science and Commerce College, Dist.-Ahmednagar, 413710 (First Cycle)",
  'Priyadarshini College of Education, Nagpur – 440022 (First Cycle)',
  "Pune District Education Association's Mamasaheb Mohol College, Pune, 411038 (Second Cycle)",
  "Pune District Education Association's Seth Govind Raghunath Sable College of Pharmacy, Pune – 412301 (First Cycle)",
  'Rajaram College, Kolhapur – 416004 (Second Cycle)',
  'Rajarshi Shahu Arts, Commerce and Science College, Pathri, Phulambri, Aurangabad – 431111 (First Cycle)',
  "Rajarshi Shahu Education Soceity's Yeshwantrao Chavan College of Arts, Commerce and Science, Sillod, Aurangabad – 431112 (Second Cycle)",
  "Rajgad Dnyanpeeth's Sou. Nirmalatai Thopate College of Education, Dist. Pune, 412206 (Second Cycle)",
  'Rajiv Gandhi College of Arts, Commerce and Science, Navi Mumbai – 400703 (First Cycle)',
  'Ramanand Arya D. A. V. College,Bhandup (East), Mumbai – 400042 (Second Cycle)',
  'Ramji Assar Vidyalaya’s Laxmichand Golwala College of Commerce and Economics, Mumbai – 400077 (First Cycle)',
  'Rani Laxmibai Mahila Mahavidyalaya, Nagpur – 441306 (First Cycle)',
  'Rashtrapita Mahatma Gandhi Arts & Commerce College, Dist. Chandrapur, 441225 (First Cycle)',
  "Rayat Shikshan Sanstha's Dhananjayrao Gadgil College of Commerce, Satara – 415001 (Third Cycle)",
  "Rayat Shikshan Sanstha's Dr. Babasaheb Ambedkar College, Shinde Sarkar Wada, Aundh, Pune – 411067 (Third Cycle)",
  'S. B. Jain Institute of Technology, Management and Research, Yerla, Nagpur – 441501 (First Cycle)',
  'S. P. D. M. Arts, S. B. B. and S. H. D. Commerce and S. M. A. Science College, Dhule – 425405 (Second Cycle)',
  'S. P. M. Science and Gilani Arts Commerce College, Yavatmal, Ghatanji – 445301 (Second Cycle)',
  'S. P. M. Tatyasaheb Mahajan Arts and Commerce College, Buldana – 443201 (Second Cycle)',
  'S. S. Girls College, Vithhal Nagar, Ansari Ward, Gondia – 441601 (Third Cycle)',
  'S. V. C. S. B.Ed. College, Solapur – 413006 (First Cycle)',
  'Saket College of Arts, Science and Commerce, Katemanivali, Kalyan (East) – 421306 (First Cycle)',
  "Samaj Shikshan Mandal Vinzar's Amruteshwar Arts Commerce and Science College, Pune – 412213 (Second Cycle)",
  'Sambhajirao Kendre Mahavidyalaya, Jalkot, Latur – 413532 (First Cycle)',
  'Sangola College, Sangola, Solapur – 413307 (Third Cycle)',
  'Sanjeevanee Mahavidyalaya, Latur – 413513 (First Cycle)',
  'Sanjivani College of Pharmaceutical Education and Research, Sahajanandnagar, Shingnapure, Kopargaon, Ahmednagar - 423603 (First Cycle)',
  'Sanjivani Rural Education Society’s Sanjivani College of Engineering, Sahajanandnagar, Shingnapur, Kopargaon, Ahmednagar – 423603 (First Cycle)',
  "Sant Dnyaneshwar Shikshan Santha's Annasaheb Dange College of Engineering & Technology, Dist. Sangli, 416301 (First Cycle)",
  'Saraswati Vidya Mandir Arts College, Kinwat, Nanded – 431804 (Second Cycle)',
  'School of Fashion Technology, Pune – 411052 (First Cycle)',
  'Secondary Education Society’s Arts and Science College, District Jalgaon, Bhalod – 425304 (Second Cycle)',
  'Secondary Training College, Mumbai, 400001 (Second Cycle)',
  "Seva Sadan's R. K. Talreja College of Arts, Science and Commerce, Ulhasnagar, Thane – 421003 (Second Cycle)",
  'Shankarlal Khandelwal Arts, Science and Commerce College, Akola – 444002 (Second Cycle)',
  'Sharadchandra Arts and Commerce College, Nagpur – 441108 (First Cycle)',
  'Sharadopasak Shikshan Sanstha Aurad Shaha Sanchalit Master Deenanath Mangeshkar Mahavidyalaya, Latur – 413522 (Second Cycle)',
  "Shegaon Education Society, Shegaon's G. B. Murarka Arts and Commerce College, Shegaon, Buldhana – 444203 (Second Cycle)",
  'Shikshan Maharshi Guruvarya R.G. Shinde Mahavidyalaya, Dist. Osmanabad, 413502 (Second Cycle)',
  "Sholapur Social Association's Arts and Commerce College, Solapur – 413005 (Second Cycle)",
  "Shree Chanakya Education Society's Indira College of Commerce And Science, Pune, 411033 (Second Cycle)",
  'Shree Yoganand Swami Arts College, Hingoli – 431512 (First Cycle)',
  'Shreemati Nathibai Damodar Thackersey Arts and Commerce College for Women, Pune – 411038 (Second Cycle)',
  "Shri Balaji Sansthan Deulgaon Raja's Shri Vyankatesh Arts and Commerce College, Deulgaon Raja, Dist. Buldana, 443204 (Second Cycle)",
  'Shri Datta Arts & Commerce College, Dist. Nanded, 431712 (Second Cycle)',
  'Shri Dnyanesh Mahavidyalaya, Nawargaon District, Chandrapur – 441223 (Second Cycle)',
  'Shri Dr. R.G. Rathod Arts And Science College, Dist. Akola, 444107 (First Cycle)',
  'Shri Gadge Maharaj Mahavidyalaya, Dist. Akola, 444107 (Second Cycle)',
  "Shri Ganesh Education Soceity's Shri Asaramji Bhandwaldar Arts, Commerce and Science College, Aurangabad – 425112 (Second Cycle)",
  'Shri Govindrao Munghate Arts & Science College, Dist. Gadchiroli, 441209 (Second Cycle)',
  "Shri Mudhaidevi Shikshan Sanstha's Prof. Sambhajirao Kadam College, Koregaon, Satara, Deur – 415524 (Second Cycle)",
  'Shri Pandurang Shikshan Prasarak Mandal, Pandharapur Sanchalit Uma Mahavidyalaya, Pandharpur, Solapur – 413304 (Second Cycle)',
  "Shri Sachhidanand Shikshan Sanstha's Arts, Commerce & Science College, Dist. Nagpur, 441111 (First Cycle)",
  'Shri Samarth Shikshan Prasarak Mandal Ashti Dwara Sanchalit Shri Samarth Arts and Commerce College, Wardha – 442202 (Second Cycle)',
  "Shri Sant Tukaram Shikshan Prasarak Mandal's Adhyapak Mahavidyalaya, Maval, Vadgaon, Pune – 412106 (Second Cycle)",
  'Shri Shahaji Chhatrapati Mahavidyalaya, Kolhapur, 416002 (Second Cycle)',
  "Shri Shivaji Education Society Amravati's Science College, Nagpur – 440012 (Third Cycle)",
  "Shri Shivaji Education Society Amravati's Shri Pundlik Maharaj Mahavidyalaya, Buldana – 443404 (Second Cycle",
  "Shri Shivaji Education Society Amravati's Shri Shivaji Arts, Commerce & Science College, Dist. Buldhana, 443103 (Second Cycle)",
  "Shri Shivaji Education Society Amravati's Shri Shivaji College of Arts, Commerce and Science, Akola – 444001 (Third Cycle)",
  "Shri Shivaji Education Society, Amravati's Arts and Commerce Mahavidyalaya, Dist. Amravati, 444908 (Second Cycle)",
  "Shri Shivaji Education Society, Amravati's, Matoshree Vimalabai Deshmukh Mahavidyalaya, Amravati, 444603 (Second Cycle)",
  'Shri Shivaji Education Society, Dr. Gopalrao Khedkar Mahavidyalaya, Dist. Akola, 444108 (Second Cycle)',
  'Shri Shivaji Science College, Amravati – 444603 (Third Cycle)',
  "Shri Shivaji Shikshan Prasarak Mandal Barshi's B.P. Sulakhe Commerce College, Dist: Solapur, 413411 (Second Cycle)",
  "Shri Swami Vivekanand Shikshan Sanstha's Tuljabhavani Mahavidyalaya, Dist. Osmanabad, 413601 (Second Cycle)",
  "Shri Swami Vivekanand Shikshan Sanstha's Vivekanand College, Kolhapur – 416003 (Third Cycle)",
  "Shri Vile Parle Kelavani Mandal's Mithibai College of Arts, Chauhan Institute of Science and Amrutben Jivanlal College of Commerce and Economics, Mumbai – 400056 (Second Cycle)",
  "Shri Yogeshwari Education Society's Yogeshwari Mahavidyalaya, Ambajogai – 431517 (Second Cycle)",
  "Shrikrishna Education Society's Shrikrishna Mahavidyalaya, Omerga, Osmanabad, Amravati – 413613 (Second Cycle)",
  'Shrimant Babasaheb Deshmukh Mahavidyalaya, Sangli, Atpadi – 415301 (Second Cycle)',
  'Shripad Krishna Kolhatkar Mahavidyalaya, Jalgaon Jamod – 443402 (Second Cycle)',
  'SIES (Nerul) College of Arts, Science and Commerce, Navi Mumbai – 400706 (Second Cycle)',
  'SIES College of Arts, Science & Commerce, Mumbai, 400022 (Third Cycle)',
  'SIES College of Commerce and Economics, Mumbai, 400022 (Third Cycle)',
  "Sillod Shikshan Sanstha Aurangabad's Siddharth Arts, Commerce & Science College, Dist. Jalna, 431206 (Second Cycle)",
  'Smt. Dankunwar Mahila Mahavidyalaya, Jalna – 431203 (Second Cycle)',
  'Smt. Kokilabai Gawande Mahila Mahavidyalaya, Daryapur, Amravati – 444803 (First Cycle',
  'Smt. Nankibai Wadhwani Kala Mahavidyalaya, Yavatmal – 445001 (First Cycle)',
  "Smt. P. N. Doshi Women's College of Arts Kum. U. R. Shah Women's College of Commerce and Dr. (Smt.) Nanavati Bhanuben Mahendra Women's College of Home Science, Mumbai – 400086 (Third Cycle)",
  'Smt. Radhadevi Goenka College for Women, Akola – 444001 (Second Cycle)',
  'Smt. Rajkamal Baburao Tidke Mahavidyalaya, Mouda, Nagpur – 441104 (First Cycle)',
  'Smt. Shakuntalabai Dhabekar Mahavidyalaya, Karanja (Lad), Washim – 444105 (First Cycle)',
  'Smt. Sushiladevi Deshmukh Senior College, Latur – 413512 (Second Cycle)',
  "Sonopant Dandekar Shikshan Mandal's Sonopant Dandekar Arts, V. S. Apte Commerce and M.H. Mehta Science College, Thane – 401404 (Second Cycle)",
  'Sophia College For Women, Mumbai, 400026 (Third Cycle)',
  'Sophia Smt. Manorama Devi Somani College, Mumbai – 400026 (First Cycle)',
  "Sou. Sushila Danchand Ghodawat Charitable Trust's Group of Institutions, Atigre, Dist. Kolhapur, 416118 (First Cycle)",
  'St. Francis De Sales College, Nagpur – 440006 (Third Cycle)',
  'St. Francis Institute of Management and Research, Mumbai – 400103 (First Cycle)',
  'St. Gonsalo Garcia College of Arts and Commerce, Thane - 401201 (Second Cycle)',
  'St. Joseph College of Arts and Commerce, Palghar – 401301 (Second Cycle)',
  "St. Teresa's Institute of Education, Mumbai – 400054 (Third Cycle)",
  'St. Xavier’s College (Autonomous), Mahapalika Marg, Mumbai, Maharashtra (Third Cycle)',
  "St. Xavier's Institute of Education, Mumbai – 400020 (Second Cycle)",
  "SVB's Saraswathi College of Education and Research, Dombivli East , Thane – 421204 (First Cycle)",
  "SVERI's College of Engineering, Pandharpur, Solapur – 413304 (First Cycle)",
  'Swami Vivekanand Night College of Arts and Commerce, Dombivli – 421201 (Second Cycle)',
  'Swami Vivekanand Senior College, Jalna – 431504 (Second Cycle)',
  'Swavalambi College of Education, Wardha – 442001 (Second Cycle)',
  "The Berar General Education Society's Smt. Laxmibai Radhakisan Toshniwal College of Commerce, Akola – 444001 (Third Cycle)",
  "The Shirpur Education Society's R. C. Patel College of Education, Dhule – 425405 (Second Cycle)",
  "The Shirpur Education Society's, Smt. H.R. Patel Arts Mahila College, Dist. Dhule, 425405 (Second Cycle)",
  'V. K. Krishna Menon College of Commerce and Economics and Sharad Shankar Dighe College of Science, Bhandup (East), Mumbai – 400042 (Second Cycle',
  'Vasantrao Kale Mahavidyalaya, Osmanabad – 413580 (First Cycle)',
  'Vichar Vikas Mandal, Mahatma Gandhi College, Dist. Latur, 413515 (Second Cycle)',
  "Vidya Prasarak Mandal's B. N. Bandodkar College of Science, Thane (West), Mumbai – 400601 (Third Cycle)",
  'Vidya Pratishthan’s Kamalnayan Bajaj Institute of Engineering and Technology, Vidyanagari, Baramati, Pune – 413133 (First Cycle)',
  "Vidya Pratishthan's Institute of information Technology, Dist. Pune, 413133 (First Cycle)",
  'Vidya Vikas Arts, Commerce & Science College, Dist. Wardha, 442305 (Second Cycle)',
  'Vidya Vikas Mandal’s Arts and Commerce College, Akkalkuwa, Nandurbar – 425415 (Second Cycle)',
  'Vidya Vikas Pratishthan Institute of Engineering and Technology, Solapur – 413008 (First Cycle)',
  "Vidya Wardhini Sabha's Arts, Commerce and Science College, Dhule – 424001 (Second Cycle)",
  'Vidyalankar School of Information Technology, Mumbai, 400037 (First Cycle)',
  'Vitthalrao Patil Mahavidyalaya, Kale, Panhala, Kolhapur – 416205 (First Cycle)',
  'Vitthalrao Shinde Arts College, Solapur – 413211 (First Cycle)',
  'Vivekanand Education Society’s College of Arts, Science and Commerce, Chembur, Mumbai – 400071 (Third Cycle',
  'Wada College of Management and Science, Harosale, Wada, Palghar – 421303 (First Cycle',
  'Walchand College of Engineering, Sangli – 416415 (First Cycle)',
  'Warana Mahavidyalaya, Walwa, Uran Islampur, Sangli – 415409 (First Cycle)',
  "Women's College of Arts, Commerce and Computer Application, Dongar Kathore, Tal. Yawal, Jalgaon – 425317 (Second Cycle)",
  "Women's Education Society's Smt. Mathubai Garware Kanya Mahavidyalaya, Sangli – 416416(Third Cycle)",
  'Yadaorao Poshattiwar Arts College, Chandrapur – 441221 (First Cycle)',
  'Yeshwant Mahavidyalaya, Nanded – 431602 (Third Cycle)',
  'A. B. M. S. Parishad’s Yashwantrao Chavan Law College, Pune – 411009 (Third Cycle)',
  "A. V. Education Society's Degloor College, Nanded – 431717 (Second Cycle)",
  "Aadivasi Seva Sahayyak and Shikshan Prasarak Sanstha's Shri S. H. Naik College of Education, Nawapur, Nandurbar – 425418 (Second Cycle)",
  "Abhinav Bharat Shikshan Sanstha's Netaji Subhashchandra Bose Arts, Commerce and Science College, Vairabad, Nanded-Waghala – 431601 (Second Cycle)",
  'Adarsh Education Society’s Arts, Commerce and Science College, Hingoli – 431513 (Second Cycle)',
  'Adarsha Science, Jairamdas Bhagchand Arts and Birla Commerce Mahavidyalaya, Dhamangaon Rly, Amravati – 444709 (Third Cycle)',
  'Amolakchand Mahavidyalaya, Yavatmal – 445001 (Second Cycle)',
  'Anantrao Pawar College, Pune – 412115 (First Cycle)',
  'Army Institute of Technology (AIT), Pune – 411015 (Third Cycle)',
  'Arts and Commerce College, Warvat Bakal, Sangrampur, Buldana – 444202 (First Cycle)',
  'Arts, Commerce and Science College, Maregaon, Yavatmal – 445303 (First Cycle)',
  'Ashoka International Centre for Educational Studies and Research, Wadala Shiwar, Nashik – 422006 (First Cycle)',
  "Ashti Taluka Shikshan Prasarak Mandal's College of Arts, Commerce and Science, Ashti, Beed – 414203 (Second Cycle)",
  'B. S. S. Arts, Science and Commerce, Osmanabad – 413604 (First Cycle)',
  "B. S. V. Education Society of Wapti's Bahirji Smarak Mahavidyalaya, Hingoli – 431512 (Second Cycle)",
  'Bahujan Hitay Jagat Shikshan Sanstha Gondia Jagat Arts, Commerce and Indiraben Hariharbhai Patel Science College, Gondia – 441801 (Third Cycle)',
  'Balasaheb Desai College, Patan, Satara – 415206 (Third Cycle)',
  "Bansilal Ramnath Agarwal Charitable Trust's Vishwakarma Institute of Information Technology, Pune – 411048(First Cycle)",
  'Bharat College of Commerce, Thane – 421503 (Second Cycle)',
  'Bharati Vidyapeeth’s New Law College, Kolhapur – 416012 (First Cycle)',
  'Bharati Vidyapeeth’s New Law College, Sangli – 416416 (First Cycle)',
  "Bharati Vidyapeeth's Yashwantrao Chavan Law College, Satara – 415539 (First Cycle)",
  "Bharatiya Shikshan Prasarak Sanstha's Shri Siddheshwar Mahavidyalaya, Beed – 431131 (Second Cycle)",
  'Bhimthadi Education Society’s Late. K. G. Kataria College, Pune – 413801 (First Cycle)',
  'Bombay Teachers’ Training College, Colaba, Mumbai – 400039 (Third Cycle)',
  "Bunts Sangha's S. M. Shetty College of Science, Commerce and Management Studies, Mumbai – 400076 (First Cycle)",
  "Chakan Shikshan Mandal's Arts and Commerce College, Pune – 410501 (Second Cycle)",
  'Chembur Sarvankash Shikshanshastra Mahavidyalaya, Chembur, Mumbai – 400071 (Third Cycle)',
  "Chembur Trombay Education Society's N. G. Acharya and D. K. Marathe College of Arts, Science and Commerce, Chembur, Mumbai – 400071 (Third Cycle)",
  "Chh. Shahu Central Institute of Business Education and Research Trust, Kolhapur's V. P. Institute of Management Studies and Research, Sangli – 416414 (Second Cycle)",
  'Chhatrapati Shahu Institute of Business Education and Research, Kolhapur – 416004 (Third Cycle)',
  'College of Military Engineering, Pune – 411031 (Second Cycle)',
  'Dahiwadi College, Tal. Man, Dahiwadi, Satara – 415508 (Third Cycle)',
  'Deshbhakta Sambhajirao Garad Mahavidyalaya, Mohol, Solapur – 413213 (Third Cycle)',
  'Devchand College, Arjunnagar, Kolhapur – 591269 (Third Cycle)',
  'Dhandaimata Education Society Sanchalit Arts College, Jalgaon – 425401 (First Cycle)',
  'Dhote Bandhu Science College, Gondia – 441614 (Third Cycle)',
  "DKTE Society's Textile and Engineering Institute, Rajwada, Ichalkaranji – 416115 (First Cycle)",
  "Dnyan Bharti Society's Sau. Sitabai Ramkrushna Karandikar Senior College of Commerce and Late Mehernosh Boman Burjor Irani College of Arts, Dahanu, Palghar – 401602 (Second Cycle)",
  "Dombivli Shikshan Prasarak Mandal's K. V. Pendharkar College of Arts, Science and Commerce, Dombivli (E) – 421203 (Third Cycle)",
  'Dr. Arun Motghare Mahavidyalaya, Nagpur – 441908 (First Cycle)',
  "Dr. Ashok Gujar Technical Institute's Dr. Daulatrao Aher College of Engineering, Banawadi, Karad – 415124 (First Cycle)",
  'Dr. Babasaheb Ambedkar College of Arts, Science and Commerce, West Chembur, Mumbai – 400089 (First Cycle)',
  'Dr. M. K. Umathe Arts and Ramchandra Mokhare Commerce College, Bhamti, Nagpur – 440022 (Second Cycle)',
  'G. H. Raisoni Academy of Engineering and Technology, Nagpur – 440028 (First Cycle)',
  'G. S. College of Commerce and Economics, Nagpur – 440010 (Third Cycle)',
  'Gandhi Shikshan Bhavan’s Smt. Surajba College of Education, Mumbai – 400049 (Third Cycle)',
  'Gangamai Education Trust’s Arts, Commerce and Science College, Nagaon, Dhule – 424004 (Second Cycle)',
  "Gharda Foundation's Gharda Institute of Technology, Lavel, Khed, Ratnagiri – 415708 (First Cycle)",
  "Godavari Manar Charitable Trust's Arts, Commerce and Science College, Biloli, Shankarnagar, Nanded – 431736 (Second Cycle)",
  "Godavari Shikshan Mandal's G. D. Sawant Arts, Commerce, Science and B. C. S. College, Nashik – 422010 (First Cycle)",
  "Gokhale Education Society's Dr. T. K. Tope Arts and Commerce Night Senior College, Parel, Mumbai – 400012 (Third Cycle)",
  'Government College of Arts and Science, Aurangabad – 431001 (Second Cycle)',
  'Government College of Education, Chikhali Road, Buldana – 443001 (Second Cycle)',
  'Government College of Education, Parbhani – 431401 (Second Cycle)',
  "Government of Maharashtra's Elphinstone College, Fort, Mumbai – 400032 (Second Cycle)",
  "Government of Maharashtra's Sydenham College of Commerce and Economics, Churchgate, Mumbai – 400020 (Second Cycle)",
  'Government Vidarbha Institute of Science and Humanities, Amravati – 444604 (Second Cycle)',
  'Gram Vikas Shikshan Mandal Late Nhanbhau Mansaram Tukaram Patil Arts College, Jalgaon – 425402 (First Cycle)',
  'Gramin (Arts, Comm. and Sci.) Mahavidyalaya, Nanded – 431715 (Second Cycle)',
  'Gramin Vikas Sanstha, Hinganghat R. S. Bidkar Arts, Commerce and Science College, Hinganghat, Wardha – 442301 (Second Cycle)',
  "Gujarat Research Society's Hansraj Jivandas College of Education, Khar (W), Mumbai – 400052 (Third Cycle)",
  'Guru Nanak College of Education and Research, Bhandup (W), Mumbai – 400078 (Second Cycle)',
  'Hirachand Nemchand College of Commerce, Solapur – 413006 (Third Cycle)',
  'Hislop College, Nagpur – 440001 (Third Cycle)',
  "ICLES' Motilal Jhunjhunwala College of Arts, Science and Commerce, Sector 9A, Vashi, Navi Mumbai – 400703 (Second Cycle)",
  'Indapur Taluka Gramvikas Prathisthan’s Vishwasrao Ransing College (Arts, Commerce and Science), Kalamb, Walchandnagar, Indapur, Pune – 413114 (Second Cycle)',
  "Indapur Taluka Shikshan Prasarak Mandal's College of Arts, Bhigwan – 413130 (First Cycle)",
  'Institute of Naval Medicine, Colaba, Mumbai – 400005 (First Cycle)',
  'Ismail Yusuf College of Arts, Science and Commerce, Jogeshwari (East), Mumbai – 400060 (Second Cycle)',
  "Jagdamba Education Society's S. N. D. College of Engineering and Research Centre, Babhulgaon, Yeola, Nashik – 423401 (First Cycle)",
  'Jagruti Shikshanshastra Mahavidyalaya, Kolhapur – 416502 (First Cycle)',
  'Janta Kala Vanijya Mahavidyalaya, Malkapur, Buldana – 443101 (Second Cycle)',
  'Jayawantrao Awale Shikshan Prasarak Mandal’s Jaywant Mahavidyalaya, Shahapur, Ichalkaranji, Hatkanangale, Kolhapur – 416115 (Second Cycle)',
  'K. J. Somaiya College of Arts and Commerce, Mumbai – 400077 (Third Cycle)',
  'K. J. Somaiya College of Engineering, Vidyavihar, Mumbai – 400077 (First Cycle)',
  "K. V. P. Sanstha's Kisan Arts, Commerce and Science College, Parola, Jalgaon – 425111 (Second Cycle)",
  'Kai. Rasika Mahavidyalaya, Deoni, Latur – 413519 (First Cycle)',
  'Karmavir Mahavidyalaya, Mul, Chandrapur – 441224 (First Cycle)',
  'Karmayogi Engineering College, Solapur – 413304 (First Cycle)',
  'Kasegaon Education Society’s Rajarambapu Institute of Technology, Sangli – 415414 (First Cycle)',
  'Khairul Islam Higher Education Society’s Maharashtra College of Arts, Science and Commerce, Mumbai – 400008 (Second Cycle)',
  'KIT’s Institute of Management Education and Research, Kolhapur – 416234 (First Cycle)',
  'Kohinoor Arts, Commerce and Science College, Sulibhanjan, Khultabad, Aurangabad – 431101 (First Cycle)',
  "Konkan Education Society's Dr. C. D. Deshmukh Commerce and Sau. K. G. Tamhane Arts College, Roha, Pen, Raigad – 402109 (Third Cycle)",
  'Konkan Unnati Mitra Mandal’s Vasantrao Naik College of Arts and Commerce, Murud-Janjira, Raigad, Mumbai – 402401 (Second Cycle)',
  'Krishna Mahavidyalaya, Rethare, Shivnagar, Karad, Satara – 415108 (Second Cycle)',
  'Lal Bahadur Shastri Senior College, Jalna – 431501 (Second Cycle)',
  "Late Balasaheb Ghuikhedkar Vidya Prasarak Mandal's Mungsaji Maharaj Mahavidyalaya, Darwha, Yavatmal – 445202 (Second Cycle)",
  'Late Bhaskarrao Shingane Arts, Prof. Narayanrao Gawande Science and Ashalata Gawande Commerce College, Buldana – 443202 (First Cycle)',
  'Late Dattatraya Pusadkar Arts College, Amravati – 444901 (First Cycle)',
  'Late Dr. Shankarrao Satav Arts and Commerce College, Kalamnuri, Hingoli – 431702 (Second Cycle)',
  'Late Ku. Durga K. Banmeru Science College, Lonar, Buldana – 443302 (First Cycle)',
  'Lokmanya Mahavidyalaya, Warora, Chandrapur – 442907 (Second Cycle)',
  "M. S. P. Mandal's Shri Shivaji College, Parbhani – 431401 (Third Cycle)",
  'M. V. P. Samaj’s College of Education, Nashik – 422002 (Third Cycle)',
  'Madhavrao Patil Arts, Commerce and Science College, Palam, Parbhani – 431720 (First Cycle)',
  "Maharashtra Education Society's Garware College of Commerce, Pune – 411004 (Third Cycle)",
  "Maharshi Karve Stree Shikshan Samstha's Shree Siddhivinayak Arts and Commerce Mahila Mahavidyalaya, Karvenagar, Pune – 411052 (Third Cycle)",
  "Maharshi Karve Stree Shikshan Samstha's Smt. Bakul Tambat Institute of Nursing Education, Pune – 411502 (First Cycle)",
  "Mahatma Education Society's Pillai’s College of Arts, Commerce and Science, New Panvel – 410206 (Third Cycle)",
  "Mahatma Education Society's Pillai's College of Education and Research, Chembur Naka, Mumbai – 400071 (Third Cycle)",
  'Mahatma Gandhi Arts, Science and Late Nassrudinbhai Panjavani Commerce College, Gadchiroli, Armori – 441208 (Third Cycle)',
  'Mahatma Gandhi Institute of Medical Sciences, Sevagram, Wardha – 442102 (Second Cycle)',
  'Mahatma Phule Mahavidyalaya, Ahmedpur, Latur – 413515 (First Cycle)',
  'Malini Kishor Sanghvi College of Commerce and Economics, Mumbai – 400049 (Second Cycle)',
  "Maratha Samaj Seva Mandal's Chhatrapati Shivaji Night College of Arts and Commerce, Solapur – 413001 (Second Cycle)",
  'Marathwada Shikshan Prasarak Mandal’s Balbhim Arts Science and Commerce College, Beed – 431122 (Third Cycle)',
  'Marathwada Shikshan Prasarak Mandal’s Law College, Beed – 431122 (Third Cycle)',
  "Marathwada Shikshan Prasarak Mandal's Shri Muktanand College, Gangapur, Aurangabad – 431109 (Third Cycle)",
  "Margtamhane Education Society's Dr. Tatyasaheb Natu College of Arts and Senior College of Commerce, Margtamhane, Chiplun, Ratnagiri – 415702 (Third Cycle)",
  'Marwari Vidyalaya Sanchalit Smt. Kamaladevi Gauridutt Mittal College of Arts and Commerce, Malad (W), Mumbai – 400064 (Second Cycle)',
  'Matoshri Nanibai Gharphalkar Science College, Babhulgaon, Yavatmal – 445101 (First Cycle)',
  "Modern Education Society's The D. G. Ruparel College of Arts, Science and Commerce, Mahim, Mumbai – 400016 (Third Cycle)",
  'Mohanrao Patangrao Patil Mahavidyalaya, Sangli – 415413 (First Cycle)',
  'Muktainagar Taluka Education Society’s Shrimati Godawaribai Ganpatrao Khadse College, Muktainagar – 425306 (Second Cycle)',
  'Mula Education Society’s Arts, Commerce and Science College, Sonai, Newasa, Ahmednagar – 414105 (Third Cycle)',
  'N. L. Dalmia Institute of Management Studies and Research, Mira-Bhayandar, Mumbai – 401104 (First Cycle)',
  'Nagrik Shikshan Sanstha’s College of Commerce and Economics, Tardeo, Mumbai – 400034 (Third Cycle)',
  "Nana Vanjare Vidya Nagari New Education Society's Arts, Commerce and Science College, Ratnagiri – 416701 (Third Cycle)",
  'Narayanrao Chavan Law College, Nanded-Waghala – 431602 (Second Cycle)',
  "Navgan Shikshan Sanstha Rajuri's Arts and Commerce College, Parli – Vaijnath, Beed – 431515 (Third Cycle)",
  'Nehru Mahavidyalaya (Arts, Commerce, Science), Yavatmal – 445102 (Second Cycle',
  'Netaji Shikshan Sanstha’s Subhash Baburao Kul Arts, Commerce and Science College, Kedgaon, Daund, Pune – 412203 (First Cycle)',
  'New Arts, Commerce and Science College, Shevgaon, Ahmednagar – 414502 (Third Cycle)',
  "Nijampur - Jaitane Shikshan Prasarak Mandal's Adarsh College of Arts, Nijampur – 424305 (Second Cycle)",
  'P. E. S. College of Engineering, Nagsenvana, Aurangabad – 431002 (First Cycle)',
  "P. E. Society's Modern College of Arts, Science and Commerce, Pune – 411053 (Third Cycle)",
  "P. E. Society's Modern College of Arts, Science and Commerce, Shivajinagar, Pune – 411005 (Third Cycle)",
  'Padmashri Annasaheb Jadhav Bharatiya Samaj Unnati Mandal’s B. N. N. College (Arts, Science and Commerce), Bhiwandi, Thane – 421305 (Second Cycle)',
  'Pankaj Shaikshanik and Samajik Sanstha Sanchalit, Pankaj Kala Mahavidyalaya, Chopda, Jalgaon – 425107 (First Cycle)',
  "Parle Tilak Vidyalaya Association's Mulund College of Commerce, Mumbai – 400080 (Third Cycle)",
  "Patuck Polytechnic's Trust's Patuck - Gala College of Commerce and Management, Mumbai – 400055 (Second Cycle)",
  'Pillai College of Education and Research, Panvel – 410206 (First Cycle)',
  'Poojya Sane Guruji Vidya Prasarak Mandal’s S. I. Patil Arts, G. B. Patel Science and S. T. S. K. V. Sangh Commerce College, Shahada, Nandurbar – 425409 (Third Cycle)',
  'Prof. Ram Meghe Institute of Technology and Research, Badnera, Amravati – 444701 (First Cycle)',
  'Progressive Education Society’s Modern College of Engineering, Shivajinagar, Pune – 411005 (Second Cycle)',
  'Progressive Education Society’s Modern Law College, Ganeshkhind, Pune – 411016 (First Cycle)',
  'Punyashlok Ahilyadevi Holkar Mahavidyalaya, Ranisawargaon, Gangakhed, Parbhani – 431536 (First Cycle)',
  'Purushottam Thote College of Social Work, Nagpur – 440034 (Second Cycle)',
  'Ramrao Adik Institute of Technology, Navi Mumbai – 400706 (First Cycle)',
  'Rashtrapita Mahatma Gandhi Mahavidyalaya, Kumarvishwa, Khednagar, Karjat, Ahmednagar – 414403 (First Cycle)',
  'Rashtriya Sharirik Shikshan Mahavidyalaya, Chandrapur – 442401(First Cycle)',
  'Raver Parisar Shikshan Prasarak Mandal’s Shri Vitthalrao Shankarrao Naik Arts, Commerce and Science College, Raver, Jalgaon – 425508 (Second Cycle)',
  'Rayat Shikshan Sanstha’s Balwant College, Khanapur, Vita, Sangli – 415311 (Third Cycle)',
  "Rayat Shikshan Sanstha's Karmaveer Bhaurao Patil College, Sector 15A, Vashi, Navi Mumbai, Thane – 400703 (Third Cycle)",
  "Rayat Shikshan Sanstha's Sadguru Gadage Maharaj College, Vidyanagar, Karad, Satara – 415124 (Third Cycle)",
  "Rayat Shikshan Sanstha's Shri Sadguru Gangageer Maharaj Science, Gautam Arts and Sanjivani Commerce College, Kopargaon, Ahmednagar – 423601 (Third Cycle)",
  'Renuka College, Besa, Nagpur – 440037 (First Cycle)',
  'S. B. Patil College of Engineering, Vangali, Indapur, Pune – 413106 (First Cycle)',
  'S. N. D. T. College of Education, Maharshi Karve Vidya Vihar, Pune – 411038 (Second Cycle)',
  "S. S. B. T.'s College of Engineering and Technology, Jalgaon – 425001 (First Cycle)",
  'S. S. P. Mandal Tehu Sanchalit Rani Laxmibai Mahavidyalaya, Parola, Jalgaon – 425111 (Second Cycle)',
  'Sadguru Education Society’s College of Physical Education, Jalgaon – 425001 (First Cycle)',
  "Sadhana Education Society's Smt. Kapila Khandvala College of Education, Mumbai – 400054 (Third Cycle)",
  'Sahakar Maharshi Late Bhaskarrao Shingne Arts College, Buldana – 444303 (First Cycle)',
  'Sahyadri Parisar Shikshan Prasarak Mandal’s Shri Manohar Hari Khapane College of Arts and Commerce, Ratnagiri – 416704 (Second Cycle)',
  'Samarth Educational Trust, Arvind Gavali College of Engineering, Panmalewadi, Varye, Satara – 415015 (First Cycle)',
  'Sangameshwar College, Solapur – 413001 (Third Cycle)',
  "Sanskar Mandir Sanstha's Arts and Commerce College, Warje Malwadi, Pune – 411058 (First Cycle)",
  "Sanskar Sarjan Education Society's Dhirajlal Talakchand Sankalchand Shah College of Commerce, Malad (East), Mumbai – 400097 (Third Cycle)",
  'Sant Jagnade Maharaj Shikshan Mandals Arts and Commerce College, Khapar, Akkalkuwa, Nandurbar – 425419 (First Cycle)',
  'Santaji Mahavidyalaya, Nagpur – 440015 (Third Cycle)',
  'Saraswati College of Engineering, Kharghar, Navi Mumbai – 410210 (First Cycle)',
  'Saraswati Dhanwantari Dental College and Hospital, Post Graduate Research Institute, Parbhani – 431401 (First Cycle)',
  "Sarvodaya Shikshan Mandal's Sardar Patel Mahavidyalaya, Chandrapur – 442402 (Third Cycle)",
  'Savitribai College of Arts, Ahmednagar – 413703 (First Cycle)',
  "Seva Sadan's College of Education, Ulhasnagar, Thane – 421003 (Third Cycle)",
  'Sevadal Shikshan Sanstha’s Sevadal Mahila Mahavidyalaya, Nagpur – 440009 (Third Cycle)',
  'Sharad Institute of Technology College of Engineering, Yadrav (Ichalkaranji), Kolhapur – 416121 (First Cycle)',
  "Sheth T. J. Education Society's Sheth Nanjibhai Khimjibhai Thakkar Thanawala College of Commerce and Sheth Jayantilal Tribhovandas Thanawala College of Arts, Thane (W) – 400601 (Third Cycle)",
  "Shikshan Prasarak Mandal Kamptee's Seth Kesarimal Porwal College, Nagpur – 441001 (Third Cycle)",
  'Shikshan Prasarak Mandal, Akluj Sanchalit Mahatma Phule College of Education, Akluj, Malshiras, Solapur – 413101 (Second Cycle',
  "Shikshan Prasarak Mandal's R. A. Podar College of Commerce and Economics, Matunga, Mumbai – 400019 (Third Cycle)",
  "Shikshan Prasarak Mandal's Sahebrao Shakarrao Dhamdhere Arts and Commerce College, Pune – 412208 (First Cycle)",
  "Shikshan Prasarak Sanstha's Sangamner Nagarpalika Arts, D. J. Malpani Commerce and B. N. Sarada Science College, Sangamner – 422605 (Third Cycle)",
  'Shikshanmaharshi Dr. Bapuji Salunkhe College, Miraj, Sangli – 416410 (Third Cycle)',
  'Shivaji College, Hingoli – 431513 (First Cycle)',
  'Shivneri Mahavidyalaya, Shirur Anantpal, Latur – 413544 (First Cycle)',
  "Shreeyash Pratishthan's Shreeyash College of Engineering and Technology, Aurangabad – 431010 (First Cycle)",
  "Shri A. P. D. Jain Pathashala's Walchand College of Arts and Science, Solapur – 413006 (Third Cycle)",
  "Shri Chhatrapati Shikshan Prasarak Mandal's Shivaji Arts, Commerce and Science College, Aurangabad – 431103 (Third Cycle)",
  "Shri Gajanan Shikshan Prasarak Mandal's Toshniwal Arts, Commerce and Science College, Hingoli – 431542 (Second Cycle)",
  'Shri Govindprabhu Arts and Commerce College, Chandrapur – 441221 (First Cycle)',
  'Shri Guru Buddhiswami Mahavidyalaya, Purna, Parbhani – 431511 (Second Cycle)',
  'Shri Kumarswami Mahavidyalaya, Ausa, Latur, Aurangabad – 413520 (Second Cycle)',
  'Shri Maharani Tarabai Government College of Education, Shahupuri, Kolhapur – 416001 (Second Cycle)',
  'Shri Mathuradas Mohota College of Science, Nagpur – 440009 (Third Cycle)',
  'Shri Narendra Tidke College of Arts and Commerce, Ramtek, Nagpur - 441106 (First Cycle)',
  'Shri Padmamani Jain Arts and Commerce College, Pabal, Shirur, Pune – 412403 (First Cycle)',
  'Shri Saibaba Gramin Vikas Sanstha, Gadchiroli Mahila Mahavidyalya, Gadchiroli – 442605 (Second Cycle)',
  'Shri Sampatrao Mane Mahavidyalaya, Khanapur, Sangli – 415307 (Second Cycle)',
  'Shri Sant Damaji Mahavidyalaya, Mangalwedha, Solapur – 413305 (Second Cycle)',
  'Shri Sant Savta Mali Gramin Mahavidyalaya, Aurangabad – 431111 (First Cycle)',
  'Shri Saraswati College of Social Work, Washim – 444505 (First Cycle)',
  "Shri Shahu Shikshan Prasarak Seva Mandal's Shri Vijaysinha Yadav Arts and Science College, Kolhapur – 416112 (Second Cycle)",
  'Shri Shivaji Arts and Commerce College, Amravati – 444603 (Third Cycle)',
  'Shri Shivaji Education Society Amravati’s Science College, Nagpur – 440012 (Third Cycle, Re-assessment)',
  'Shri Shivaji Law College, Parbhani – 431401 (Third Cycle)',
  'Shri Swami Vivekanand Shikshan Sanstha Padmabhushan Dr. Vasantraodada Patil Mahavidyalaya, Sangli – 416312 (Third Cycle)',
  "Shri Vile Parle Kelavani Mandal's Narsee Monjee College of Commerce and Economics, Juhu Scheme, Vile Parle (West), Mumbai – 400056 (Second Cycle)",
  'Sindhudurg Education Society’s V. Y. S. B.Ed. College, Tondavali, Kankavali, Sindhudurg – 416601 (First Cycle)',
  'Sinhgad Dental College and Hospital, Pune – 411041 (First Cycle)',
  'Sinhgad Institute of Technology, Lonavala – 410401 (First Cycle)',
  'Sinhgad Technical Education Society’s Sinhgad Academy of Engineering, Kondhwa, Pune – 411048 (First Cycle)',
  "Sinhgad Technical Education Society's Sinhgad College of Engineering, Vadgaon, Pune – 411041 (First Cycle)",
  "Sinhgad Technical Education Society's Sinhgad Institute of Technology and Science, Pune – 411041 (First Cycle",
  "Sinhgad Technical Education Society's Smt. Kashibai Navale College of Engineering, Pune – 411041 (First Cycle)",
  'Smt. Kashibai Navale College of Physiotherapy, Narhe, Pune – 411041 (First Cycle)',
  'Smt. Mithibai Motiram Kundnani College of Commerce and Economics, Bandra (West), Mumbai – 400050 (Third Cycle)',
  "Social and Cultural Association's Smt. Narmadabai Nago Chaudhari Arts, Commerce and Science College, Dhule – 424302 (First Cycle)",
  'Sri Basaveshwar Education Society Sant Gadge Maharaj Mahavidyalaya, Nagpur – 441110 (Second Cycle)',
  "St. Andrew's College of Arts, Science and Commerce, Mumbai – 400050 (Third Cycle)",
  'St. Mira’s College for Girls, Pune – 411001 (Third Cycle)',
  'Stree Shikshan Prasarak Mandal’s Mahila Mahavidyalaya, Nagpur – 440009 (Third Cycle)',
  'SVKM’s Usha Pravin Gandhi College of Management, Vile Parle West, Mumbai – 400056 (First Cycle)',
  'Swayam Siddhi Mitra Sanghs College of Management and Research, Temghar, Bhiwandi, Thane – 421302 (First Cycle)',
  "Swayam Siddhi Mitra Sangh's Degree College, Bhiwandi, Thane – 421302 (First Cycle)",
  'Swayamsiddhi Mitra Sangh’s College of Education, Bhiwandi, Thane – 421302 (First Cycle)',
  "Swoddharak Vidyarthi Sanstha's Arts and Science College, Dhule – 425408 (Second Cycle)",
  'Symbiosis College of Arts and Commerce, Pune – 411004 (Third Cycle)',
  'Tatyasaheb Kore Institute of Engineering and Technology, Warananagar, Kolhapur – 416113 (First Cycle)',
  'Thakur Educational Trust (Regd.) Thakur College of Science and Commerce, Kandivali East – 400101 (Third Cycle)',
  "The Berar General Education Society's Radhakisan Laxminarayan Toshniwal College of Science, Akola – 444001 (Third Cycle)",
  "The Kelkar Education Trust's Vinayak Ganesh Vaze College of Arts, Science and Commerce, Mulund (E), Mumbai – 400081 (Fourth Cycle)",
  'The S. I. A. College of Higher Education, Dombivli – 421203 (First Cycle)',
  'Tolani Education Society, Mumbai, Tolani College of Commerce, Mumbai – 400093 (Third Cycle',
  'Tribal Education Society’s Arts, Commerce and Science Mahila Mahavidyalaya, Nandurbar – 425412 (Second Cycle)',
  'Tuljaram Chaturchand College of Arts, Science and Commerce, Baramati, Pune – 413102 (Third Cycle)',
  "Tulsi Bahuudeshiya Shikshan Sanstha, Tumsar's Arts and Commerce Degree College, Bhandara, Nagpur – 441906 (Second Cycle)",
  'Tulsiramji Gaikwad-Patil College of Engineering and Technology, Nagpur – 441108 (First Cycle)',
  'Vai Dhunda Maharaj Deglurkar Mahavidyalaya, Degloor, Nanded – 431717 (First Cycle',
  'Vasundhara College, Ghatnandur, Ambajogai, Beed – 431519 (First Cycle)',
  "Vidya Prasarak Mandal's Arts, Commerce and Science College, Kinhavali, Shahapur, Kalyan, Thane – 421403 (First Cycle)",
  'Vidya Pratishthan’s Vasantrao Pawar Law College, Vidyanagari, Baramati – 413133 (First Cycle)',
  "Vidya Vikas Mandal's Yashawantrao Chavan Mahavidyalaya, Karmala, Solapur – 413203 (Second Cycle)",
  'Vidyabharti College, Seloo, Wardha – 442104 (First Cycle)',
  "Vidyavardhini's Annasaheb Vartak College of Arts, Kedarnath Malhotra College of Commerce and E. S. Andrades College of Science, Palghar – 401202 (Second Cycle)",
  'Vishwakarma College of Arts, Commerce and Science, Kondhwa Budruk, Pune – 411048 (First Cycle)',
  "VPM's K. G. Joshi College of Arts and N. G. Bedekar College of Commerce, Thane – 400601 (Third Cycle)",
  "Women's Education Society's Lady Amritbai Daga College for Women of Arts, Commerce and Science and Smt. Ratnidevi Purohit College of Home Science and Home Science Technology, Nagpur – 440010 (Third Cycle)",
  'Yashavantrao Chavan Institute of Science, Satara – 415001 (Third Cycle',
  "Yashoda Girls' Arts and Commerce College, Sneh Nagar, Nagpur – 440015 (First Cycle)",
  'Yashwantrao Chavan School of Social Work, Satara – 415002 (First Cycle)',
  'Yashwantrao Chavan Warana Mahavidyalaya, Warananagar, Panhala, Kolhapur – 416113 (Third Cycle)',
  'Yeshwantrao Chavan College of Engineering, Nagpur – 441110 (First Cycle)',
  "Yugantar Education Society's Tirpude College of Social Work, Civil Lines, Sadar, Nagpur – 440001 (Third Cycle)",
  'Dr. Babasaheb Ambedkar Mahavidyalaya, Kavha Naka, Latur – 413512 (First Cycle)',
  'Chhatrapati Shivaji Mahavidyalaya, Kalamb, Osmanabad – 413507 (First Cycle)',
  'Veerbhadra Education Society’s Mahatma Jyotiba Phule Mahavidyalaya, Mukhed, Nanded – 431715 (Second Cycle)',
  'Lokmanya Tilak Mahavidyalaya, Wadwani, Manjlegaon, Beed – 431122 (First Cycle)',
  'Rashtrapita Mahatma Gandhi Arts and Science College, Nagbhid, Chandrapur – 441205 (First Cycle)',
  'Dnyandeep College (Science and Commerce), Morvande-Boraj, Khed, Ratnagiri – 415709 (First Cycle)',
  'Shri Sant Gadge Maharaj Mahavidyalaya, Loha, Nanded – 431708 (First Cycle)',
  'Indira Institute of Pharmacy, Sadavali, Sangameshwar, Ratnagiri – 415804 (First Cycle)',
  'J. T. Mahajan College of Engineering, Faizpur, Yawal, Jalgaon – 425524 (First Cycle)',
  'Kamaladevi College of Arts and Commerce, Vitthalwadi, Kalyan East – 421305 (First Cycle)',
  'Vidarbha Institute of Technology, Bhiwapur, Nagpur – 441209 (First Cycle)',
  'Sharadchandra Arts, Commerce and Science College, Naigaon, Nanded – 431709 (Second Cycle)',
  'Athawale College of Social Work, Bhandara – 441904 (Third Cycle)',
  'Shushikshan Prasarak Mandal, Pinjar Bhausaheb Lahane Dnyanprakash Arts College, Barshitakli, Pinjar, Akola – 444407 (Third Cycle)',
  'Sarvodaya Mahavidyalaya, Sindewahi, Chandrapur – 441222 (First Cycle)',
  "B. S. P. Sanstha's Swa Sawarkar Mahavidyalaya, Beed – 431122 (Second Cycle)",
  "Satpuda Shikshan Prasarak Mandal's Vasantrao Naik Arts, Science and Commerce College, Shahada, Nandurbar – 425409 (Second Cycle)",
  'Karmayogi Tulshiram Pawar Mahavidyalaya, Hadolti, Ahmedpur, Latur – 413515 (First Cycle)',
  'Dr. Sau. Kamaltai Gawai Institute of Engineering and Technology, Darapur, Daryapur, Amravati – 444814 (First Cycle)',
  'Late Vasantrao Kolhatkar Arts College, Rohana, Arvi, Wardha – 442302 (First Cycle)',
  "PSGVP Mandal's D. N. Patel College of Engineering, Shahada, Nandurbar – 425409 (First Cycle)",
  'Maratha Vidya Prasarak Samaj’s Arts and Commerce College, Taharabad, Baglan, Nashik – 423302 (First Cycle)',
  'Shivnagar Vidya Prasarak Mandal’s College of Engineering, Malegaon, Baramati, Pune – 413115 (First Cycle)',
  'Belapur Education Society’s Arts and Commerce College, Belapur, Shrirampur, Ahmednagar – 413715 (First Cycle)',
  'Varvand Gram Shikshan Sanstha’s Eknath Sitaram Divekar Arts, Science and Commerce College, Varvand, Daund, Pune – 412215 (Second Cycle)',
  'Adarsh Institute of Technology and Research Centre, Khanapur, Vita, Sangli – 415311 (First Cycle)',
  "Saraswati Mandir Sanstha's Saraswati Mandir Night College of Commerce and Arts, Pune – 411002 (Second Cycle)",
  "Women's College of Arts and Commerce, Nagpur – 440009 (Second Cycle)",
  'Dattakala Group of Institutions, Swami Chincholi, Daund, Pune – 413130 (First Cycle)',
  "Shri Narayanrao Babasaheb Education Society's Shri Venkatesh Mahavidyalaya, Ichalkaranji, Kolhapur – 416115 (Third Cycle)",
  'Pillai HOC College of Arts, Science and Commerce, Rasayani, Khalapur, Raigad, Panvel – 410207 (First Cycle)',
  "Late Babasaheb Varhade Education Society, Amravati's Mahatma Jyotiba Fule Arts, Commerce and Science College, Bhatkuli, Amravati – 444601 (Second Cycle)",
  'Fule-Ambedkar College of Social Work, Gadchiroli – 442605 (First Cycle)',
  'Late Pushpadevi Patil Arts and Science College, Risod, Washim – 444506 (First Cycle)',
  'St. John Institute of Pharmacy and Research, Palghar – 401404 (First Cycle)',
  "Shri Jagadamba Vinkar Shikshan Sanstha's Jagadamba Mahavidyalaya, Mehrabpura, Achalpur, Amravati – 444806 (Second Cycle)",
  "Jai Bhagwan Sevabhavi Sanstha's Late Shankarrao Gutte Gramin Arts, Commerce and Science College, Dharmapuri, Parli, Beed – 431515 (First Cycle)",
  'Tapaswi Public Charitable Trust, Yeoti’s Venkatesh Mahajan Senior College, Osmanabad – 413501 (Second Cycle)',
  'Shri Tulshiramji Jadhao Arts and Science College, Lakhala, Washim – 444505 (First Cycle)',
  'Sharadrao Pawar Arts and Commerce College, Gadchandur – 442908 (First Cycle)',
  'Shree Ramchandra College of Engineering, Wagholi, Pune – 412216 (First Cycle)',
  'Adv. Ramkrishnaji Rathi Law College, Washim – 444505 (First Cycle)',
  'DES Shri Navalmal Firodia Law College, Pune – 411004 (First Cycle)',
  'Rajarshee Shahu Science College, Amravati – 444904 (First Cycle)',
  'Manjara Charitable Trust’s Smt. Sushiladevi Deshmukh Mahila Mahavidyalaya, Latur – 413531 (Second Cycle)',
  'Arts, Commerce College, Yeoda, Daryapur, Amravati – 444706 (First Cycle)',
  'Chandrabhan Sharma College of Arts, Science and Commerce, Powai, Mumbai – 400076 (First Cycle)',
  'Kalyani Charitable Trusts Ravindra Gambhirrao Sapkal College of Pharmacy, Nashik – 422213 (First Cycle)',
  'Shri Gopinath Mahadeo Vedak Pratishthan’s G. M. Vedak College of Science, Nandadeep, Tala, Raigad – 402111 (First Cycle)',
  'Hutatma Rashtriya College of Arts and Science, Ashti, Wardha – 442202 (Second Cycle)',
  'V. P. S. P. M. S. Arts, Commerce and Science College, Kannad, Aurangabad – 431103 (First Cycle)',
  'G. B. Tatha Tatyasaheb Khare Commerce, Parvatibai Gurupad Dhere Arts and Shri Mahesh Janardhan Bhosale Science College, Guhagar, Ratnagiri – 415703 (Third Cycle)',
  'Pune District Education Association’s College of Engineering, Manjari (Bk), Pune – 412307 (First Cycle)',
  "The Bhusawal People's Charitable Sanstha's Dadasaheb Devidas Namdeo Bhole College, Bhusawal, Jalgaon – 425201 (Second Cycle)",
  'Arts and Science College, Shivajinagar, Gadhi, Georai, Beed – 431143 (First Cycle)',
  'Datta Meghe College of Engineering, Sector 3, Airoli, Navi Mumbai – 400708 (First Cycle)',
  'Dr. Babasaheb Ambedkar College of Engineering and Research, Wanadongari, Nagpur – 441110 (First Cycle)',
  'Amdar Shasikant Shinde Mahavidyalaya, Medha, Jawali, Satara – 415012 (Second Cycle)',
  "Vivekanand Dnyanpeeth (Covent) Warora's Vivekanand Mahavidyalaya, Bhadrawati, Chandrapur – 442902 (Third Cycle)",
  "Shanti Education Society's A. G. Patil Institute of Technology, Solapur – 413008 (First Cycle)",
  'Maratha Vidya Prasarak Samaj, Nashik Arts, Science and Commerce College, Niphad, Saikheda, Nashik – 422210 (Second Cycle)',
  "The Berar General Education Society, Akola's Kisanlal Nathmal Arts and Commerce College, Karanja Lad, Washim – 444105 (Third Cycle)",
  'Baliram Patil Arts, Commerce and Science College, Kinwat, Nanded – 431804 (Second Cycle)',
  'Savithribai Phule Shikshan Prasarak Mandal’s Loknete Gopinathji Munde Arts, Commerce and Science College, Madangad, Ratnagiri – 415203 (Third Cycle)',
  'Shri Shankarrao Bezalwar Arts and Commerce College, Gadchiroli, Chandrapur – 442705 (Second Cycle)',
  'ATSS College of Business Studies and Computer Applications, Chinchwad, Pune – 411019 (First Cycle)',
  'Shurparaka Educational and Medical Trust’s M. B. Harris College of Arts and A. E. Kalsekar College of Commerce and Management, Nallasopara, Vasai, Palghar – 401203 (First Cycle)',
  'Loknete Ma, Hanmantrao Patil Charitable Trust’s Adarsh College, Vita, Sangli – 415311 (Second Cycle)',
  'Shri Shivaji Mofat Education Society’s Shri Shivaji College of Arts, Commerce and Science, Kandhar, Waghala, Nanded – 431714 (Second Cycle)',
  'Jayawantrao Sawant College of Engineering, Hadapsar, Pune – 411028 (First Cycle)',
  "Mahatma Gandhi Vidyamandir's Arts and Commerce College, Yevla, Nashik – 423401 (Second Cycle)",
  "Vidarbha Youth Welfare Society's College of Social Work, Badnera, Amravati – 444602 (Second Cycle)",
  'Sahakar Maharshi Shankarrao Mohite-Patil Pratishthan Shankarnagar, Akluj Sanchalit, Vijaysinh Mohite-Patil Mahavidyalaya, Malshiras, Natepute, Solapur – 413109 (Third Cycle)',
  "Vidarbha Youth Welfare Society, Amravati's Indirabai Meghe Mahila Mahavidyalaya, Amravati – 444602 (Second Cycle)",
  'Sahyadri Valley College of Engineering, Junnar, Pune – 412411 (First Cycle)',
  'Shri Dnyaneshwar Maskuji Burungale Science College, Shegaon – 444203 (First Cycle)',
  "G. S. Mandal's Marathwada Institute of Technology, Aurangabad – 431010 (First Cycle)",
  'S. N. D. T. College of Arts and S. C. B. College of Commerce and Science for Women, New Marine Lines, Mumbai – 400020 (First Cycle)',
  "Konkan Education Society's Anandibai Pradhan Science College, Roha, Nagothane, Raigad – 402106 (Third Cycle)",
  "Shri Swami Vivekanand Shikshan Sanstha's Kakasaheb Chavan Mahavidyalaya, Talmavale, Patan, Satara – 415103 (Third Cycle)",
  'Swargiya Dadasaheb Kalmegh Smruti Dental College and Hospital, Hingna, Nagpur – 441110 (Re-visit,First Cycle)',
  'Society for Computer Technology and Research (R) Pune Institute of Computer Technology, Dhankawadi, Pune – 411043 (Third Cycle)',
  "Nandurbar Taluka Vidhyak Samiti's College of Law, Institute of Legal Education and Research, Nandurbar – 425412 (Second Cycle)",
  "People's Education Society's Dr. Babasaheb Ambedkar College of Arts, Science and Commerce, Mahad, Raigad – 402301 (Second Cycle)",
  'Hanuman Vyayam Prasarak Mandal’s College of Engineering and Technology, Hanuman Vyayam Nagar, Amravati – 444605 (First Cycle)',
  'Dr. Ambedkar College of Arts, Commerce and Science, Deekshabhoomi, Civil Lines, Chandrapur – 442401 (Second Cycle)',
  "Navgan Shikshan Sanstha Rajuri's Padmabhushan Vasantdada Patil College, Patoda, Beed – 414204 (Third Cycle)",
  "Padmashall Shikshan Sanstha's A. R. Burla Mahila Varishtha Mahavidyalaya, Solapur – 413005 (Third Cycle)",
  "Vasantrao Naik Shikshan Prasarak Mandal's Vasantrao Naik Mahavidyalaya, Aurangabad – 431003 (Third Cycle)",
  'MET’s Institute of Engineering, Adgaon, Nashik – 422003 (First Cycle)',
  "Gokhale Education Society's Arts, Commerce and Science College, Jawhar, Palghar – 401603 (Third Cycle)",
  "Rayat Shikshan Sanstha's Yashwantrao Chavan Mahavidyalaya, Pachwad, Wai, Satara – 415513 (Third Cycle)",
  "Shree Chanakya Education Society's Indira College of Pharmacy, Tathawade, Pune – 411033 (First Cycle)",
  "Vidarbha Youth Welfare Society, Amravati's Bar. Ramrao Deshmukh Arts, Smt. Indiraji Kapadiya Commerce and Nya. Krushnarao Deshmukh Science College, Badnera, Amravati – 444701 (Second Cycle)",
  "Marathwada Shikshan Prasarak Mandal's Yeshwantrao Chavan Arts, Commerce and Science College, Ambajogai, Beed – 431517 (Third Cycle)",
  "Maharogi Sewa Samiti, Warora's Anand Niketan College of Science, Arts and Commerce, Anandwan, Warora, Chandrapur – 442914 (Second Cycle)",
  'M. S. Kakade College, Someshwarnagar, Baramati, Pune – 412306 (Third Cycle)',
  "Rayat Shikshan Sanstha's Savitribai Phule Mahila Mahavidyalaya, Satara – 415001 (Third Cycle)",
  "Yeshwant Rural Education Society's Yeshwant Mahavidyalaya, Wardha – 442001 (Third Cycle)",
  'KJ’s Educational Institutes Trinity College of Engineering and Research, Pune – 411048 (First Cycle)',
  'Venutai Chavan Pratisthan’s Arts and Commerce Mahila Mahavidyalaya (Senior College), Ambajogai, Beed – 431517 (Second Cycle)',
  'Deogiri Institute of Engineering and Management Studies, Aurangabad – 431005 (First Cycle)',
  'NBN Sinhgad Technical Institutes Campus, Ambegaon, Pune – 411041 (First Cycle)',
  'Shree Shivaji Arts, Commerce and Science College, Rajura, Chandrapur – 442905 (Second Cycle)',
  "Nagpur Shikshan Mandal's Shrimati Binzani Mahila Mahavidyalaya, Nagpur – 440032 (Third Cycle)",
  'Dr. D. Y. Patil Vidya Pratishthan Society’s Dr. D. Y. Patil Arts, Commerce and Science College, Akurdi, Pune – 411044 (First Cycle)',
  "Adarsh Vidya Prasarak Sanstha's Adarsh College of Arts and Commerce, Kulgaon, Badlapur, Thane – 421503 (Second Cycle)",
  'Shri Shivaji Education Society Yashwantrao Chavan College of Science, Vidyanagar, Karad, Satara – 415124 (Third Cycle)',
  "Sinhgad Technical Education Society's Sinhgad College of Nursing, Narhe, Pune – 411041 (Second Cycle)",
  "Jamner Taluka Education Society's Gitabai Dattatraya Mahajan Arts, Shri Kesharimal Rajmal Navlakha Commerce and Manoharseth Dhariwal Science College, Jamner, Jalgaon – 424206 (Third Cycle)",
  'Shri Binzani City College, Nagpur – 440009 (Third Cycle)',
  'Mahatma Night Degree College of Arts and Commerce, Chembur Naka, Mumbai – 400071 (Third Cycle)',
  'Govindrao Warjukar Arts and Commerce College, Shionagar, Nagbhid, Chandrapur – 441205 (Third Cycle)',
  "CHME Society's Bhonsala Military College, Rambhoomi, Nashik – 422005 (Re-visit,Third Cycle)",
  'Shreemati Nathibai Damodar Thackersey College of Home Science, Pune – 411038 (Second Cycle)',
  'Lokmanya Tilak College of Engineering, Sector 4, Vikas Nagar, Koparkhairane, Navi Mumbai – 400709 (First Cycle)',
  'Dr. Ambedkar Institute of Management Studies and Research, Deekshabhoomi, Nagpur – 440010 (First Cycle)',
  "Marathwada Shikshan Prasarak Mandal's Arts, Commerce and Science College, Kille Dharur, Beed – 431124 (Third Cycle)",
  'R. S. Mundle Dharampeth Arts and Commerce College, Nagpur – 440010 (Third Cycle)',
  "KJ's Educational Institutes Trinity Academy of Engineering, Pisoli, Yewalewadi, Haveli, Pune – 411048 (First Cycle)",
  'Shri Ambabai Talim Sanstha’s Sanjay Bhokare Group of Institutes, Tilak Nagar, Miraj – 416414 (First Cycle)',
  'SKN Sinhgad College of Engineering, Korti, Pandharpur, Solapur – 413304 (First Cycle)',
  'School of Fashion Technology, Ambegaon, Pune – 411052 (First Cycle) Re-assessment',
  'The Council of Education Kolhapur Shahaji Law College, Shahupuri, Kolhapur – 416002 (Second Cycle)',
  "Chetana's Hazarimal Somani College of Commerce and Economics Smt. Kusumtai Chaudhari College of Arts, Bandra (East), Mumbai – 400051 (Third Cycle)",
  'Dattajirao Kadam Arts, Science and Commerce College, Hatkanangale, Ichalkaranji – 416115 (Third Cycle)',
  'Maharshi Dayanand College of Arts, Science and Commerce, Parel, Mumbai – 400012 (Third Cycle)',
  'Bharati Vidyapeeth’s College of Engineering, Morewadi, Kolhapur – 416013 (First Cycle)',
  "P. R. Pote (Patil) Education and Welfare Trust's Group of Institutions, College of Engineering and Management, Amravati – 444602 (First Cycle)",
  "Shree Shankar Narayan Education Trust's Shankar Narayan College of Arts and Commerce, Mira-Bhayandar (E), Thane – 401105 (Second Cycle)",
  'Maratha Vidya Prasarak Samaj, Nashik G. M. D. Arts, B. W. Commerce and Science College, Sinnar, Nashik – 422103 (Third Cycle)',
  "Dr. D. Y. Patil Vidya Pratishtan Society's Dr. D. Y. Patil Institute of Hotel Management and Catering Technology, Tathawade, Mulshi, Pune – 411033 (First Cycle)",
  "Jaywaant Shikshan Prasarak Mandal's Imperial College of Engineering and Research, Wagholi, Pune – 412207 (First Cycle)",
  'S.N.J.B.’s Late Sau. Kantabai Bhavarlalji Jain College of Engineering, Neminagar, Chandwad, Nashik – 423101 (First Cycle)',
  "Gokhale Education Society's Parel Centre College of Education and Research, Parel, Mumbai – 400012 (Third Cycle)",
  "Maratha Vidya Prasarak Samaj's Arts, Commerce and Science College, Nandgaon, Nashik – 423106 (Third Cycle)",
  'Maharashtra Institute of Technology, Aurangabad – 431010 (First Cycle)',
  'St. John College of Engineering and Management, Vevoor, Palghar – 401404 (First Cycle)',
  "Deccan Education Society's Willingdon College, Vishrambag, Sangli – 416415 (Second Cycle)",
  "Mahatma Basweshwar Education Society's Mahatma Basweshwar Mahavidyalaya, Latur – 413512 (Second Cycle)",
  "Satya Niketan Sanstha's Adv. Manoharrao Nanasaheb Deshmukh Arts and Science College, Akole, Rajur, Ahmednagar – 422604 (Second Cycle)",
  'Ahmednagar Jilha Maratha Vidya Prasarak Samaj’s New Arts, Commerce and Science College, Parner, Ahmednagar – 414302 (Third Cycle)',
  "Gokhale Education Society's B. Y. K. (Sinnar) College of Commerce, Nashik – 422005 (Third Cycle)",
  "Rayat Shikshan Sanstha's Dada Patil Mahavidyalaya, Karjat, Ahmednagar – 414402 (Third Cycle)",
  "Rayat Shikshan Sanstha's Rajarshi Chhatrapati Shahu College, Kolhapur – 416003 (Third Cycle)",
  'D. Y. Patil College of Engineering and Technology, Kasba Bawda, Kolhapur – 416006 (First Cycle)',
  'Mahatma Gandhi Mission’s, Dr. G. Y. Pathrikar College of Computer Science and Information Technology, Aurangabad – 431003 (Second Cycle)',
  "Mula Education Society's Shri Dnyaneshwar Mahavidyalaya, Newasa, Ahmednagar – 414603 (Third Cycle)",
  'Marathwada Mitra Mandal’s College of Engineering, Karvenagar, Pune – 411052 (First Cycle)',
  'Shrikrishnadas Jajoo Grameen Seva Mahavidyalaya, Pipri, Wardha – 442001 (Third Cycle)',
  'SKN Sinhgad Institute of Technology and Science, Lonavala, Maval, Pune – 410401 (First Cycle)',
  "Anand Charitable Sanstha Asthi's Anandrao Dhonde Alias Babaji Mahavidyalaya, Ashti, Kada, Beed – 414202 (Second Cycle)",
  'Mahavir Mahavidyalaya, Kolhapur – 416003 (Third Cycle)',
  'Kamala College, Rajarampuri 1st Lane, Kolhapur – 416008 (Third Cycle)',
  "Rayat Shikshan Sansthan's D. P. Bhosale College, Karegaon, Satara – 415501 (Third Cycle)",
  "Shikshan Prasarak Mandal's Kankavli College, Vidyanagar, Kankavli, Sindhudurg – 416602 (Third Cycle)",
  "Maharshi Karve Stree Shikshan Sanstha's Cummins College of Engineering for Women, Karvenagar, Pune – 411052 (Third Cycle)",
  "Rayat Shikshan Sanstha's Mahatma Phule Mahavidyalaya, Pimpri, Pune – 411017 (Third Cycle)",
  "Zagdu Singh Charitable Trust's Thakur College of Engineering and Technology, Kandivali (E), Mumbai – 400101 (First Cycle)",
  'R. C. Patel Institute of Technology, Shirpur-Warwade, Dhule – 425405 (First Cycle)',
  "Kopargaon Taluka Education Society's K. J. Somaiya Arts, Commerce and Science College, Kopargaon, Ahmednagar – 423601 (Third Cycle)",
  "Rayat Shikshan Sanstha's Mahatma Phule Arts, Science and Commerce College, Panvel, Raigad – 410206 (Third Cycle)",
  "Nashik District Maratha Vidya Prasarak Samaj's Karmveer Abasaheb Alias N. M. Sonawane Arts, Commerce and Science College, Nashik – 423301 (Third Cycle)",
  'Maratha Vidya Prasarak Samaj, Nashik Karmveer Shantarambapu Kondaji Wavare Arts, Science and Commerce College, Nashik – 422008 (Third Cycle)',
  'K J Somaiya Institute of Engineering and Information Technology, Sion East, Mumbai – 400022 (First Cycle)',
  "Bharati Vidyapeeth's Matoshri Bayabai Shripatrao Kadam Kanya Mahavidyalaya, Kadegaon, Sangli – 415304 (Third Cycle)",
  'John Wilson Education Society’s Wilson College, Mumbai – 400007 (Third Cycle)',
  'JSPM’s Rajarshi Shahu College of Engineering, Tathawade, Pune – 411033 (First Cycle)',
  'Kandivli Education Society’s B. K. Shroff College of Arts and M. H. Shroff College of Commerce, Kandivli (West), Mumbai – 400067 (Second Cycle)',
  'Dr. D. Y. Patil Institute of Management and Research, Pimpri, Pune – 411018 (First Cycle)',
  "Nutan Vidya Prasarak Mandal's Arts, Commerce and Science College, Niphad, Lasalgaon, Nashik – 422306 (Third Cycle)",
  'Dr. Ambedkar College, Deekshabhoomi, Nagpur – 440010 (Third Cycle)',
  "Modern Education Society's Nowrosjee Wadia College, Pune – 411001 (Second Cycle)",
  'Karmaveer Bhaurao Patil Mahavidyalaya, Pandharpur – 413304 (Third Cycle)',
  "Rayat Shikshan Sanstha's Chhatrapati Shivaji College, Satara – 415001 (Third Cycle)",
  'Society of our Lady of Grace Convent Pushpanjali College of Education, Vasai (W), Palghar – 401207',
  "Khandesh Education Society's Pratap College, Amalner, Jalgaon – 425401 (Third Cycle)",
  "Amar Sewa Mandal's Kamla Nehru Mahavidyalaya, Sakkardara Chowk, Nagpur – 440009 (Third Cycle)",
  "Chikitsak Samuha's S. S. and L. S. Patkar College of Arts and Science and V. P. Varde College of Commerce and Economics, Goregaon (West), Mumbai – 400062 (Third Cycle)",
  "Smt. P. D. Hinduja Trust's K. P. B. Hinduja College of Commerce, Mumbai – 400004 (Third Cycle)",
  'Changu Kana Thakur Arts, Commerce and Science College, New Panvel (W), Raigad – 410206 (Third Cycle)',
  "Seva Mandal Education Society's Dr. Bhanuben Mahendra Nanavati College of Home Science, Matunga, Mumbai – 400019 (Third Cycle)",
  'Shikshan Prasarak Mandali’s Sir Parashurambhau College, Pune – 411030 (Third Cycle)',
  "Ahmednagar Jilha Maratha Vidya Prasarak Samaj's New Arts, Commerce and Science College, Ahmednagar – 414001 (Third Cycle)",
  "Maratha Vidya Prasarak Samaj's K. R. T. Arts, B. H. Commerce and A. M. Science College, Shivajinagar, Nashik – 422002 (Third Cycle)",
  'Abha Gaikwad-Patil College of Engineering, Mohgaon, Nagpur – 441108 (First Cycle)',
  'Annapurnadevi Vidya Prasarak Sanstha Sanchalit Late. Annasaheb Pitambar Shankar Wadile Arts College, Thalner, Shirpur-Warwade, Dhule – 425421 (First Cycle)',
  'Arts and Science College, Chincholi Limbaji, Kannad, Aurangabad – 431147 (First Cycle)',
  'Arts College, Malkapur, Akola – 444004 (First Cycle)',
  'Baburao Patil College of Arts and Science, Angar, Mohol, Solapur – 413214 (First Cycle)',
  'College of Engineering and Technology, Babhulgaon, Akola – 444104 (First Cycle)',
  'D. Y. Patil College of Engineering, Akurdi, Pune – 411044 (First Cycle)',
  'Dadasaheb Balpande College of Pharmacy, Nagpur – 440037 (First Cycle)',
  'Dr. D. Y. Patil Centre for Management and Research, Chikhali, Pune – 412114 (First Cycle)',
  'Dr. Shyamaprasad Mukherjee Arts College, Shendurjanaghat, Warud, Amravati – 444907 (First Cycle)',
  'DRT’s A. E. Kalsekar Degree College, Dawla Kausa, Mumbra, Mumbai – 400612 (First Cycle)',
  'Institute of Management and Computer Studies (IMCOST), Thane West – 400604 (First Cycle)',
  'K. J. Somaiya College of Engineering and Management Research, Pune – 411048 (First Cycle)',
  'K. K. Wagh Institute of Engineering Education and Research, Amrutdham, Panchavati, Nashik – 422003 (Re-visit, First Cycle)',
  'Late Rajkamalji Arts, Commerce and Smt. Sushilabai R. Bharti Science College, Arni, Yavatmal – 445103 (First Cycle)',
  'Lokseva Education Society’s Arts and Science College, Aurangabad – 431009 (First Cycle)',
  'Mahatma Gandhi Mission College of Journalism and Mass Communication, CIDCO, Aurangabad – 431003 (First Cycle)',
  'Mahatma Gandhi Mission’s Jawaharlal Nehru Engineering College, CIDCO, Aurangabad – 431003 (First Cycle)',
  'Mahatma Phule Nutan Mahavidyalaya, Mirajgaon, Karjat, Ahmednagar – 414401 (First Cycle)',
  'Matoshri Pratishthan Group of Institution School of Engineering and Management, Khupsarwadi, Vishnupuri, Nanded-Waghala – 431606 (First Cycle)',
  "NDMVP Samaj's Institute of Management, Research and Technology, Shivaji Nagar, Nashik – 422002 (First Cycle)",
  'Oswal Shikshan and Rahat Sangh Sanchalit Shree Halari Visa Oswal College of Commerce, Anjurphata, Bhiwandi, Thane – 421302 (First Cycle)',
  'PCET’s Pimpri Chinchwad College of Engineering, Sector 26, Pradhikaran, Nidgi, Pune – 411044 (First Cycle)',
  'Priyadarshini Bhagwati College of Engineering, Harpur Nagar, Nagpur – 440024 (First Cycle)',
  'Priyadarshini J. L. College of Engineering, Nagpur – 440009 (First Cycle)',
  'Prof. Ram Meghe College of Engineering and Management, Badnera, Amravati – 444701 (First Cycle)',
  'Rajarshi Shahu Mahavidyalaya, Parbhani – 431401 (First Cycle)',
  'Rajendra Mane College of Engineering and Technology, Ambav, Devrukh, Sangameshwar, Ratnagiri – 415804 (First Cycle)',
  'Rajiv Gandhi College of Engineering and Research, Wanadongri, Nagpur – 441110 (First Cycle)',
  'Rasiklal M. Dhariwal Sinhgad Technical Institutes Campus, Warje, Haveli, Pune – 411058 (First Cycle)',
  'Sambhaji College (Arts and Commerce), Murud, Latur – 413510 (First Cycle)',
  'Shri Yashwantrao Patil Science College, Solankur, Radhanagari, Kolhapur – 416212 (First Cycle)',
  'Sinhgad Institute of Hotel Management and Catering Technology, Kusgaon, Lonavala – 410401 (First Cycle)',
  'Suryodaya College of Engineering and Technology, Vihirgaon, Nagpur – 441204 (First Cycle)',
  "Zeal Education Society's Zeal College of Engineering and Research, Narhe, Pune – 411041 (First Cycle)",
  'Arts and Science College, Kurha, Tiosa, Amravati – 444709 (Second Cycle)',
  'Bhagwantrao Memorial Education Society, Aheri Bhagwantrao Arts and Science College, Etapalli, Gadchiroli – 442704 (Second Cycle)',
  "Bharat Liberal Education Society's Shri Havagiswami College, Udgir, Latur – 413517 (Second Cycle)",
  'Gramin Vikas Sanstha Shikshan Maharshi Shri Krushnarao Zoting Patil Arts and Commerce College, Samudrapur, Wardha – 442305 (Second Cycle)',
  "Gramin Vikas Shikshan Prasarak Mandal's Late M. D. Sisode Alias Bhausaheb Arts and Commerce College, Shindkheda, Dhule – 425404 (Second Cycle)",
  "J. B. Sawant Education Society's Tikambhai Mehta Commerce College, Mangaon, Raigad – 402104 (Second Cycle)",
  "Jaibhawani Shikshan Prasarak Mandal's Mahila Mahavidyalaya, Georai, Beed – 431127 (Second Cycle)",
  'Jnan Vikas Mandal’s Mohanlal Raichand Mehta College of Commerce, Diwali Maa College of Science, Amrutlal Raichand Mehta College of Arts, Dr. R. T. Doshi College of Computer Science, Sector 19, Airoli, Navi Mumbai – 400708 (Second Cycle)',
  "Late Babasaheb Varhade Education Society, Amravati's Sant Gadge Maharaj Arts, Commerce and Science College, Walgaon, Amravati – 444801 (Second Cycle)",
  "Late Laxmibai Deshmukh Shikshan Prasarak Mandal's Late Laxmibai Deshmukh Mahila Mahavidyalaya, Parli Vaijnath, Beed – 431515 (Second Cycle)",
  'Mahatma Gandhi Vidyamandir’s Arts, Science and Commerce College, Surgana, Nashik – 422211 (Second Cycle)',
  'Matsyodari Shikshan Sanstha‘s Arts, Science and Commerce College, Ambad, Jalna – 431204 (Second Cycle)',
  "People's Education Society (Mumbai's) Dr. Ambedkar College of Arts and Commerce, Yerwada, Pune – 411006 (Second Cycle)",
  "Rajgad Dnyanpeeth's Anantrao Thopte College, Bhor, Pune – 412206 (Second Cycle)",
  'Rishi Dayaram and Seth Hassaram National College and Seth Wassiamull Assomull Science College, Bandra (W), Mumbai – 400050 (Re-visit,Second Cycle)',
  'Shikshan Prasarak Mandal Anadur Jawahar Arts, Science and Commerce College, Tuljapur, Gunjoti, Osmanabad – 413606 (Second Cycle)',
  'Shivaji Shikshan Prasarak Mandal Karmveer Dadasaheb Deotale Mahavidyalaya, Chamorshi, Gadchiroli – 442603 (Second Cycle)',
  'Vidarbha Youth Welfare Society, Amravati’s Prof. Rajabhau Deshmukh Kala Mahavidyalaya, Badnera, Nandgaon, Amravati – 444708 (Second Cycle)',
  'Vidya Shikshan Prasarak Mandal, Nagpur Arvindbabu Deshmukh Mahavidyalaya, Nagpur – 441305 (Second Cycle)',
  "W. K. B. S. Mandal's Arts and Commerce College for Women, Deopur, Dhule – 424005 (Second Cycle)",
  'Adivasi Pragati Mandal Sanchalit Comrade Godavari Shamrao Parulekar College of Arts, Commerce and Science, Talasari, Palghar, Thane – 401606 (Third Cycle)',
  'Dharampeth M. P. Deo Memorial Science College, Nagpur – 440010 (Third Cycle)',
  'Government College of Education, Near S. T. Stand, Panvel, Raigad – 410206 (Third Cycle)',
  "Marathwada Shikshan Prasarak Mandal's Sunderrao Solanke Mahavidyalaya, Majalgaon, Beed – 431131 (Third Cycle)",
  "Nanded Education Society's Science College, Sneh Nagar, Nanded-Waghala – 431605 (Third Cycle)",
  "Parle Tilak Vidyalaya Association's Sathaye College, Vile Parle (East), Mumbai – 400057 (Third Cycle)",
  "People's Education Society's Dr. Ambedkar College of Commerce and Economics, Wadala, Mumbai – 400031 (Third Cycle)",
  "Rajasthan Education Society's Rajasthan Aryan Arts, Shri Mithulalji Kacholiya Commerce and Shri Satyanarayanji Ramkrishnaji Rathi Science College, Washim – 444505 (Third Cycle)",
  "Rayat Shikshan Sanstha's Annasaheb Awate Arts, Commerce and Hutatma Babu Genu Science College, Manchar, Ambegaon, Pune – 410503 (Third Cycle)",
  "Shri Shivaji Vidya Prasarak Sanstha's Late Karmveer Dr. P. R. Ghogrey Science College, Deopur, Dhule – 424005 (Third Cycle)",
  "The Berar General Education Society's Sitabai Arts College, Akola – 444001 (Third Cycle)",
  'Yavatmal Zilha Akhil Kunbi Samaj Yavatmal Dwara Sanchalit Gopikabai Sitaram Gawande Mahavidyalaya, Umarkhed, Yavatmal – 445206 (Third Cycle)',
  'Anandi Arts, Commerce and Science Mahavidyalaya, Gaganbavada(First Cycle)',
  'Atharva College of Engineering (First Cycle)',
  'Christ College, Pune (First Cycle)',
  'Dr D Y Patil Educational Enterprises Charitable Trusts Dr D Y Patil Group of Institutions Dr D Y Patil School of Engineering (First Cycle)',
  "JCEI's Jaihind College of Engineering (First Cycle)",
  "Mahatma Gandhi Vidyamandir's Arts College Nimgaon (First Cycle)",
  "Maulana Azad Educational Trust's Y B Chavan College of Pharmacy (First Cycle)",
  'Nagesh Karajagi Orchid College of Engineering and Technology (First Cycle)',
  'Padmashri Dr. V. B. Kolte College of Engineering (First Cycle)',
  'Priyadarshini J. L. College of Pharmacy (First Cycle)',
  "Rajmata Jijau Shikshan Prasarak Mandal's Arts, Commerce and Science College Maharashtra (First Cycle)",
  'Shri Vasantrao Naik Mahavidyalaya, Dharni (First Cycle)',
  'Sipna College of Engineering and Technology (First Cycle)',
  'SSVPS BS Deore College of Engineering (First Cycle)',
  'Vidya Niketan Degree College of Commerce (First Cycle)',
  'Vidyasagar Kala Mahavidyalaya (First Cycle)',
  "Vivekanand Education Society's Institute of Management Studies and Research (First Cycle)",
  "Nirmal Krida and Samaj Prabodhan Trust's Arts Science and Commerce College ( Second Cycle)",
  "Pune Vidyarthi Griha's College of Engineering andTechnology (Second Cycle)",
  "Shirdi Sai Rural Institute's Arts Science and Commerce College (Second Cycle)",
  'Athavale College of Social Work Chimur ( Third Cycle)',
  "B.P.H.E. Society's Ahmednagar College ( Third Cycle)",
  "Janata Shikshan Mandal's Smt. Indirabai G. Kulkarni Arts College, J. B. Sawant Science College and Sau. Janakibai Dhondo Kunte Commerce College ( Third Cycle)",
  "K.C.E.S's Mooljie Jaitha College Maharashtra ( Third Cycle)",
  'Katruwar Arts, Ratnalal Kabra Science and B. R. Mantri Commerce College ( Third Cycle)',
  "Khadki Education Society's Tikaram Jagannath Arts, Commerce and Science College ( Third Cycle)",
  'Late Sow. Kamaltai Jamkar Mahila Mahavidyalaya ( Third Cycle)',
  "Latthe Education Society's Ganpatrao Arwade College of Commerce ( Third Cycle)",
  "Latthe Education Society's Smt. Kasturbai Walchand College (Arts-Science) ( Third Cycle)",
  'Phaltan Education Society Mudhoji College ( Third Cycle)',
  "Shri Marutrao Ghule Patil Shikshan Sanstha's Jijamata College of Science and Arts ( Third Cycle)",
  'RAJARSHI SHAHU MAHAVIDYALAYA, Kaku Seth Ukka Marg, Chandranagar Latur-413512 (Third Cycle)',
  'ANJUMAN ISLAM JANJIRA DEGREE COLLEGE OF SCIENCE, MURUD JANJIRA,Lokmanya Tilak Road, Bazar Peth, Murud Janjira,Murud Janjira, 402401 (First Cycle)',
  'ATHARVA INSTITUTE OF MANAGEMENT STUDIES, AET Campus, Malad Marve Road,Charkop Naka, Malad West, Mumbai-400095,Mumbai-400095 (First Cycle)',
  'BHARAT COLLEGE OF ENGINEERING,BADLAPUR (W), OPP. GAJANAN MAHARAJ TEMPLE, KANHOR ROAD, BADLAPUR (W),Badlapur , 421503 (First Cycle)',
  'CHHTRAPATI SHIVAJI KALA MAHAVIDYALAYA, ASEGAON PURNA,AT POST- ASEGAON PURNA, TQ.- CHANDUR BAZAR, DIST.- AMRAVATI,ASEGAON PURNA , 444806 (First Cycle)',
  "C.H.M.E. SOCIETY'S DR. MOONJE INSTITUTE OF MANAGEMENT AND COMPUTER STUDIES,B.M. COLLEGE CAMPUS, GANGAPUR ROAD, NASHIK-422005,NASHIK , 422005 (First Cycle)",
  "DANG SEVA MANDAL'S ARTS COLLEGE ABHONE,Abhone, Tal.Kalwan, Dist.Nashik,Abhone , 423502 (First Cycle)",
  "DECCAN EDUCATION SOCIETY'S CHINTAMANRAO INSTITUTE OF MANAGEMENT DEVELOPMENT AND RESEARCH SANGLI,Deccan Education Society Campus, P.O. Willingdon College, Vishrambag, Sangli,SANGLI , 416416 (First Cycle)",
  "DECCAN EDUCATION SOCIETY'S NAVINCHANDRA MEHTA INSTITUTE OF TECHNOLOGY AND DEVELOPMENT,DES Mumbai Campus, Kirti College Road, Off Veer Savarkar Marg, Dadar(W),Mumbai , 400028 (First Cycle)",
  'HINDI SEVA MANDALS SHRI SANT GADGE BABA COLLEGE OF ENGINEERING AND TECHNOLOGY BHUSAWAL,Near Z.T.C., Bhusawal,Bhusawal , 425203 (First Cycle)',
  'MS COLLEGE OF ARTS SCIENCE COMMERCE AND BMS, Habib Educational Complex, M.H. Mohani Road, Kausa, Mumbra,Thane , 400612 (First Cycle)',
  "AJINTHA EDUCATION SOCIETY'S SANT DNYANESHWAR MAHAVIDYALAYA SOEGAON, DIST AURANGABAD (MS),Soegaon Tq.Soegaon Dist.Aurangabad , 431120,Aurangabad , 431120 (Second Cycle)",
  'BAR. SHESHRAO WANKHEDE COLLEGE OF ARTS COMMERCE, KHAPERKHEDA,Khaperkheda (Bhanegaon) Tah. Saoner. Dist. Nagpur,Khaperkheda , 441102 (Second Cycle)',
  'BHALERAO SCIENCE COLLEGE, Nagpur Road ,Saoner , Dist-Nagpur (M.S.) 441107,Saoner , 441107 (Second Cycle)',
  "DANG SEVA MANDAL'S DADASAHEB BIDKAR ARTS, SCIENCE AND COMMERCE COLLEGE, PETH, TAL. PETH, DIST. NASHIK,Peth, Taluka Peth, District Nashik, State Maharashtra 422208,Peth Nashik , 422208 (Second Cycle)",
  'NAVJEEVAN INSTITUTE OF MANAGEMENT,SHIVSHAKTI CHOWK 4TH SCHEME CIDCO NASHIK,NASHIK , 422008 (Second Cycle)',
  'SMT. SALUNKABAI RAUT ARTS AND COMMERCE COLLEGE, WANOJA, MANGRULPIR., At Post Wanoja Ta. Mangrulpir Dist Washim,Wanoja , 444402 (Second Cycle)',
  "S. S. P. MANDAL'S BHAGWAN MAHAVIDYALAYA(ARTS, COMMERCE AND SCIENCE), ASHTI, TAL. ASHTI, DIST. BEED (M.S.),Ashti, Dist. Beed,Ashti , 414203 (Second Cycle)",
  'HPT ARTS AND RYK SCIENCE COLLEGE,Vidyanagar College Road, Nashik , 422005, Nashik , 422005 (Third Cycle)',
  'MIRAJ MAHAVIDYALAYA, Miraj 795/1/A, Near Govt. Milk Dairy, Budhagaonkar Mala, Miraj, Dist. Sangli,MIRAJ , 416410 (Third Cycle)',
  "PRAVARA RURAL EDUCATION SOCIETY'S PADMASHRI VIKHE PATIL COLLEGE ARTS, SCIENCE AND COMMERCE,A/p-Loni Kd, Tal-Rahata, Dist-Ahmednagar,Loni Kd , 413713 (Third Cycle)",
  'R.N.C. ARTS, J.D.B. COMMERCE AND N.S.C SCIENCE COLLEGE, NASHIK PUNE ROAD OPP SUJATA BIRLA HOSPITAL NR ASHIRWAD BUS STOP NASHIK ROAD NASHIK,NASHIK , 422101 (Third Cycle)',
  "SATARA MARATHA VIDYA PRASARAK SAMAJ'S ARTS AND COMMERCE COLLEGE SATARA,Satara 117, Shukrawar Peth, Satara,Satara , 415002 (Third Cycle)",
  "SHRI SARASWATI VIDYA PRASARAK MANDAL'S SMT.PADAMBAI KAPURCHANDJI KOTECHA MAHILA MAHAVIDYALAYA,Shanti Nagar Bhusawal Maharashtra,Bhusawal , 425201 (Third Cycle)",
  "ALL INDIA SHRI SHIVAJI MEMORIAL SOCIETY'S INSTITUTE OF MANAGEMENT,Kennedy Road, Near RTO,Pune , 411001 (First Cycle)",
  'ASHOKA CENTER FOR BUSINESS AND COMPUTER STUDIES,Plot No.585/2,169-172,Nandavan Estate ,Near Chandashi Village,Anadwalli, Gangapur Road,Nashik,Nashik , 422013 (First Cycle)',
  'DHOLE PATIL COLLEGE OF ENGINEERING, PUNE,1284, Ubale Nagar, Near Kharadi IT Park, Wagholi, Pune,Pune , 412207 (First Cycle)',
  'GURU NANAK INSTITUTE OF ENGINEERING AND TECHNOLOGY,Khasra No. 95, Mouza Dahegaon, Kalmeshwar Road, Nagpur,Nagpur , 441501 (First Cycle)',
  'INSTITUTE OF MANAGEMENT AND SCIENCE, Bhusawal , 425201 , N.H.-06, Sakegaon, Jalgaon Road, Bhusawal,Bhusawal , 425201 (First Cycle)',
  'JAYAWANTRAO SAWANT INSTITUTE OF MANAGEMENT AND RESEARCH,Sr.No.58, Indrayani Nagar,Handewadi Road, Hadapsar, Pune- 411028 State- Maharashtra,Pune , 411028 (First Cycle)',
  "JMF'S VANDE MATARAM DEGREE COLLEGE OF ARTS, COMMERCE AND SCIENCE,JMF Sanskriti Vihar Dr. Nemade Road, Telcoswadi. Kopar Cross Road, Near Diva-vasai Railway route, Dombivli (west).,Dombivli west , 42120 (First Cycle)",
  "MAHARSHI KARVE STREE SHIKSHAN SAMSTHA'S DR. BHANUBEN NANAVATI COLLEGE OF ARCHITECTURE FOR WOMEN,BNCA campus, Karvenagar, Pune,PUNE , 411052 (First Cycle)",
  'MAHATMA PHULE ARTS AND SCIENCE COLLEGE, PATUR,PATUR TQ PATUR Dist AKOLA , 444501 , MAHATMA PHULE ARTS AND SCIENCE COLLEGE, PATUR,AKOLA , 444501 (First Cycle)',
  "NSCT'S INSTITUTE OF MANAGEMENT SCIENCE, PIMPRI(BK),At Post - Pimpri Bk., Payeet Road, Taluka - Khed, District - Pune,Pune , 410501 (First Cycle)",
  'PRAVARA RURAL ENGINEERING COLLEGE, LONI,Loni Tal Rahata Dist Ahmednagar (MS),Loni , 413736 (First Cycle)',
  'RAJARSHI SHAHU COLLEGE OF ENGINEERING,BULDANA,Near Palna Gahr, Sagwan Raod,Tq.Buldana,Dist-Buldana,Buldana , 443001 (First Cycle)',
  'SARASWATI SANGEET KALA MAHAVIDYALAYA, LATUR,opposite Government Womens Polytechnic College, Sangeet Nagari, Barshi Road, Latur Tq. - Dist. Latur,Barshi Road,Latur , 413512 (First Cycle)',
  'SHEILA RAHEJA SCHOOL OF BUSINESS MANAGEMENT AND RESEARCH,Raheja Education Complex, Opp. Chhatrapati Shivaji Ground, Kher Nagar, Bandra (East), Mumbai , 400051 (First Cycle)',
  'VIDYALANKAR INSTITUTE OF TECHNOLOGY,Vidyalankar College Marg Wadala(E),Mumbai , 400037 (First Cycle)',
  'ISMAILSAHEB MULLA LAW COLLEGE, SATARA, SATARA , 415001, SATARA , 415001 (Second Cycle)',
  'JEEVAN VIKAS MAHAVIDYALAYA, THUGAONDEO,At Post- Thugaondeo (Devgram), Tah. Narkhed, Dist. Nagpur (Maharashtra), Thugaondeo , 441301 (Second Cycle)',
  'KALIKADEVI ARTS, COMMERCE AND SCIENCE COLLEGE, SHIRUR KASAR,Shirur kasar , 413249,Shirur kasar , 413249 (Second Cycle)',
  'LOKNAYAK BAPUJI ANEY MAHILA MAHAVIDYALAYA, YAVATMAL,AWDHOOTWADI, DATTA CHOWK,YAVATMAL , 445001 (Second Cycle)',
  "SINDHU NAVYUVAK MANDAL'S RAJKUMAR KEWALRAMANI KANYA MAHAVIDYALAYA, Sai Vasanshah Square, Jaripatka, Nagpur-440014,Nagpur , 440014 (Second Cycle)",
  "INDAPUR TALUKA SHIKSHAN PRASARAK MANDAL'S ARTS, SCIENCE AND COMMERCE COLLEGE,Off National Highway No. 65, Opposite to Indapur Municipality, Indapur, Taluka Indapur, Dist. Pune., Indapur , 413106 (Third Cycle)",
  "Maratha Vidya Prasarak Samaj's Karmaveer Punjababa Goverdhane Arts, Commerce and Science College, Near Take-Ghoti, Mumbai-Agra Road, Igatpuri, Tal.- Igatpuri, Dist.- Nashik,,Near Take-Ghoti, Mumbai-Agra Road, Tal.- Igatpuri Dist.-Nashik 422403,Igatpuri , 422403 (Third Cycle)",
  'SHRI BHAIYYAJI PANDHAIPANDE NATIONAL INSTITUTE OF SOCIAL WORK,Krida square, Hanuman Nagar, Nagpur,Nagpur , 440009 (Third Cycle)',
  'S M JOSHI COLLEGE HADAPSAR PUNE (MS),Malwadi Road Hadapsar Pune -28,Hadapsar Pune , 411028 (Third Cycle)',
  'DEGREE COLLEGE OF PHYSICAL EDUCATION,AMRAVATI,Near Ekvira Devi Temple, Hanuman Vyayam Nagar,AMRAVATI , 444605 (Third Cycle)',
  'ASIAN COLLEGE OF SCIENCE AND COMMERCE,Sr. No. 28/15/16, Narhe Dhayri Road, Pari Company Chowk, Tal- Haveli Dist.Pune,Pune , 411041 (First Cycle)',
  'ATHARVA COLLEGE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY,S No.263, Plot No.8-12, Malad Marve Road, Charkop Naka, Malad West, Mumbai-400095.,Mumbai , 400095 (First Cycle)',
  "GRAMODAYA TRUST'S RAJEEV BUSINESS SCHOOL,Near Dange Chowk, Tathawade Road, Tathawade, Pune 411033. M.S., Pune, Pune, Maharashtra, 411033,Pune , 411033 (First Cycle)",
  "HOLY-WOOD ACADEMY KOLHAPUR'S, SANJEEVAN ENGINEERING AND TECHNOLOGY INSTITUTE, PANHALA,Sanjeevan Knowledge City, Somwar Peth-Injole, Panhala Dist. Kolhapur,Panhala , 416201 (First Cycle)",
  'HUTATMA JAYWANTRAO PATIL MAHAVIDYALAYA HIMAYATNAGAR,HUTATMA JAYWANTRAO PATIL MAHAVIDYALAYA HIMAYATNAGAR Tq.Himayatnagar Dist.Nanded.,Himayatnagar , 431802 (First Cycle)',
  'INTERNATIONAL CENTRE OF EXCELLENCE IN ENGINEERING AND MANAGEMENT,Gut No. 4, Opp. M.I.D.C Waluj Water Treatment Plant, Aurangabad - Pune National Highway, Waluj, Aurangabad,Aurangabad , 431136 (First Cycle)',
  'ISBM SCHOOL OF TECHNOLOGY,S. No. 44/1/2, nande village, near Susgaon, Pashan-Sus Road, taluka Mulshi, Pune 412115,Pune , 412115 (First Cycle)',
  'JALNA COLLEGE OF SOCIAL WORK,NEAR JALNA CO-OPERATIVE SUGAR MILL RAMNAGAR, JALNA - NANDED HIGHWAY,JALNA , 431214 (First Cycle)',
  'KONKAN GYANPEETH COLLEGE OF ENGINEERING, KARJAT, Vengaon Road, Dahivali, Taluka-Karjat, District-Raigad, Raigad , 410201 (First Cycle)',
  "MCT'S RAJIV GANDHI INSTITUTE OF TECHNOLOGY, MUMBAI, Juhu Versova Link Road, Behind HDFC Bank Versova, Andheri West, Mumbai,Mumbai , 400053 (First Cycle)",
  'MUMBAI INSTITUTE OF MANAGEMENT & RESEARCH,J.K.KNOWLEDGE CENTRE, NEAR MBPT COLONY, NADKARNI PARK, WADALA EAST,Mumbai , 400037 (First Cycle)',
  'NANASAHEB MAHADIK COLLEGE OF ENGINEERING,Gat No. 894/2665 Pune-Bangalore (NH4) Highway, At Post- Peth Naka, Tal- Walwa, Dist- Sangli Pin-415407,Peth Naka Islampur , 415407 (First Cycle)',
  "PADMABHUSHAN VASANTDADA PATIL PRATISHTHAN'S COLLEGE OF ENGINEERING,Patil Educational Complex, Eastern Express Highway, Near Everard Nagar, Sion Chunabhatti,Mumbai , 400022 (First Cycle)",
  'PILLAI HOC COLLEGE OF ENGINEERING AND TECHNOLOGY,Rasayani, Tal. Khalapur, Dist Raigad,Rasayani Tal Khalapur Dist Raigad , 410207 (First Cycle)',
  'PRIYADARSHINI COLLEGE OF ENGINEERING,Near CRPF Campus Hingna Road, Nagpur,Nagpur , 440019 (First Cycle)',
  'PRIYADARSHINI INDIRA GANDHI COLLEGE OF ENGINEERING,NAGPUR, Opposite Lata Mangeshkar Hospital,Digdoh Hills,Hingna Road,Nagpur-440019,Nagpur , 440019 (First Cycle)',
  'PRIYADARSHINI LOKMANYA TILAK INSTITUTE OF MANAGEMENT STUDIES RESEARCH,Priyadarshini Campus, Digdoh Hills, Hingna Road, Nagpur,Nagpur , 440019 (First Cycle)',
  'RAJARSHI SHAHU INSTITUTE OF MANAGEMENT, AURANGABAD, MAHARASHTRA,PLOT NO. P-75, BEHIND GARWARE POLYESTER, CHIKALTHANA M.I.D.C. AURANGABAD.,Aurangabad , 431210 (First Cycle)',
  'SANJIVANI RURAL EDUCATION SOCIETY, SANJIVANI ARTS, COMMERCE AND SCIENCE COLLEGE,At Sahajanandnagar Post Shingnapur Tal Kopargaon Dist Ahmednagar (M.S.) 423603,Kopargaon , 423603 (First Cycle)',
  'SHRI PANDITGURU PARDIKAR MAHAVIDYALAYA, SIRSALA.,Sirsala Tq Parli V Dist Beed , 431128 , Survey No. 349 Moha Road,Dist Beed , 431128 (First Cycle)',
  'SHRI RENUKADEVI ARTS, COMMERCE AND SCIENCE MAHAVIDYALAYA, MAHUR DIST. NANDED.,Mahur.Tq. Mahur Dist. Nanded.,Mahur , 431721 (First Cycle)',
  'ST. VINCENT PALLOTTI COLLEGE OF ENGINEERING AND TECHNOLOGY, NAGPUR, Gavsi Manapur, Wardha Road, Nagpur,Nagpur , 441108 (First Cycle)',
  'THEEM COLLEGE OF ENGINEERING, Boisar Chilhar Road, Boisar, Palghar-401501,Boisar Palghar , 401501 (First Cycle)',
  "VIDYAVARDHINI'S COLLEGE OF ENGINEERING AND TECHNOLOGY,Vasai Virar Municipal Corporation Vidyvardhinis Campus K.T. Marg Vasai Road West,401202 (First Cycle)",
  'YASHWANTRAO CHAWHAN ARTS, COMMERCE AND SCIENCE COLLEGE, LAKHANDUR,Lakhandur, Dist. Bhandara, Maharashtra,Lakhandur , 441803 (First Cycle)',
  "F.E.S.GIRLS' COLLEGE,Anchaleshwar Gate Chandrapur,Chandrapur , 442401 (Second Cycle)",
  'G.H.RAISONI INSTITUTE OF ENGINEERING & TECHNOLOGY, Gat. no. 1200, Domkhel Road, Wagholi, Pune,Pune , 412207 (Second Cycle)',
  'JAWAHARLAL NEHRU ARTS, COMMERCE AND SCIENCE COLLEGE WADI NAGPUR,Jai Mangalmurti Society, Charde Layout, Near Wadi Khadan, NAGPUR , 440023 (Second Cycle)',
  'PRINCIPAL ARUNRAO KALODE MAHAVIDYALAYA,BEHIND ONKAR NAGAR, MANEWADA RING ROAD, NAGPUR,NAGPUR , 440027 (Second Cycle)',
  'RAMKRUSHNA MAHAVIDYALAYA,Darapur , At- Po- Darapur, Tal- Daryapur Dist- Amravati, Darapur , 444814 (Second Cycle)',
  'SARVAJANIK ARTS AND COMMERCE COLLEGE,Visarwadi Tahsil Navapur District Nandurbar , 425426 , Village Visarwadi Tahsil Navapur District Nandurbar,Nandurbar , 425426 (Second Cycle)',
  "SONAMAI SHIKSHAN PRASARAK MANDAL'S ARTS MAHILA COLLEGE,Mahalaxmi Nagar, Dongargaon Road, Shahada,Shahada , 425409 (Second Cycle)",
  "DAPOLI EDUCATION SOCIETY'S DAPOLI URBAN BANK SENIOR SCIENCE COLLEGE,Dapoli , 415712 , Uday Nagar Road, Dapoli Dist- Ratnagiri, Dapoli , 415712 (Third Cycle)",
  'G S SCIENCE, ARTS AND COMMERCE COLLEGE, KHAMGAON,National Highway No. 6, Nandura Road, Khamgaon Dist- Buldana, KHAMGAON , 444303 (Third Cycle)',
  "LATTHE EDUCATION SOCIETY'S SMT. GANGABAI KHIVARAJ GHODAWAT KANYA MAHAVIDYALAYA, JAYSINGPUR,Shirol-Wadi Road, Jaysingpur,Jaysingpur , 416101 (Third Cycle)",
  'MAHARASHTRA MAHAVIDYALAYA, NILANGA,Main Road, Nilanga Dist. Latur 413521,Nilanga , 413521 (Third Cycle)',
  "NASHIK SHIKSHAN PRASARAK MANDAL'S ARTS AND COMMERCE MAHILA MAHAVIDYALAYA, Sane Guruji Nagar Jail Road Nashik Road , Nashik , 422101 (Third Cycle)",
  "NUTAN VIDYALAYA SHIKSHAN SANSTHA'S NUTAN MAHAVIDYALAYA,Jintoor road, selu, dist. Parbhani,Selu , 431503 (Third Cycle)",
  'RAOSAHEB GOGATE COLLEGE OF COMMERCE AND SMT. SARASWATIBAI GANSHET WALKE COLLEGE OF ARTS,At Panval, Banda Tal- Sawantwadi,BANDA , 416511 (Third Cycle)',
  "SANT DNYANESHWAR SHIKSHAN SANSTHA'S HON. SHRI. ANNASAHEB DANGE ARTS, COMMERCE AND SCIENCE COLLEGE, HATKANANGALE DIST-KOLHAPUR (MS),Near Water Tank, Hatkanangale,Hatkanangale , 416109 (Third Cycle)",
  'S.B. KHADE MAHAVIDYALAYA, Koparde, Tal.Karveer Dist. Kolhapur 416205, Koparde , 416205 (Third Cycle)',
  'SHARADCHANDRA PAWAR MAHAVIDYALAYA,Near MSEB Substation, Lonand, Tal. Khandala, Dist. Satara, LONAND , 415521 (Third Cycle)',
  "SHRI SHIVAJI SHIKSHAN PRASARAK MANDAL'S ARTS, SCIENCE AND COMMERCE COLLEGE,Rahuri, Tal. Rahuri, Dist. Ahmednagar, Rahuri , 413705 (Third Cycle)",
  'SHRI S.H. KELKAR COLLEGE OF ARTS, COMMERCE AND SCIENCE, DEVGAD,Smt. Neerabai Jagannath Parkar Vidyanagari,,Devgad Dist Sindhudurg , 416613 (Third Cycle)',
  "SHRI SWAMI VIVEKANAND SHIKSHAN SANSTHA, KOLHAPUR'S SHRI SANT GADGEBABA MAHAVIDYALAYA,Kolhapurs Shri Sant Gadgebaba Mahavidyalaya, Kapashi, Tal-Shahuwadi,Dist-Kolhapur(Third Cycle)",
  'VISHWASRAO NAIK ARTS, COMMERCE AND BABA NAIK SCIENCE MAHAVIDYALAYA, SHIRALA, AT / POST-SHIRALA, TAL-SHIRALA,,SHIRALA , 415408 (Third Cycle)',
  "RASHTRIYA SHIKSHAN MANDAL'S CHETAN DATTAJI GAIKWAD INSTITUTE OF MANAGEMENT STUDIES,CDGIMS ,25, Karve road , near Central mall, Pune, PUNE , 411004 (First Cycle)",
  'SAIBALAJI INTERNATIONAL INSTITUTE OF MANAGEMENT SCIENCES,Survey No - 54, Nere Marunje, Near Hinjewadi Infotech Park, Pune,Pune , 411033 (First Cycle)',
  'SHRI SAI COLLEGE OF ENGINEERING AND TECHNOLOGY, BHADRAWATI.,Near Village Lonara, Chandrapur-Nagpur Road Tah.- Bhadrawati, Dist Chandrapur,BHADRAWATI DIST CHANDRAPUR 442902 (First Cycle)',
  'XAVIER INSTITUTE OF ENGINEERING,Opposite S L Raheja Hospital, Mahim Causeway, Mahim West,Mumbai , 400016 (First Cycle)',
  "BALAGHAT EDUCATION SOCIETY'S YESHWANTRAO CHAVAN MAHAVIDYALAYA,Near Helipad, Naldurg Road, Tuljapur - 413601, Dist. Osmanabad,Tuljapur , 413601 (Second Cycle)",
  "GONDIA EDUCATION SOCIETY'S MANOHARBHAI PATEL COLLEGE OF ARTS AND COMMERCE,AT- AMGAON ROAD DEORI DIST-GONDIA 441901, Deori , 441901 (Second Cycle)",
  'INDIRA MAHAVIDYALAYA, KALAMB,Kalamb Ralegaon Road, Kalamb, Dist. Yavatmal, Kalamb , 445401 (Second Cycle)',
  'ARTS, SCIENCE AND COMMERCE COLLEGE, RAMANANDNAGAR (BURLI),At Ramanandnagar, Post Kirloskarwadi, Tahsil Palus, Dist Sangli,Ramanandnagar , 416308 (Third Cycle)',
  "JANATA SHIKSHAN SANSTHA'S KISAN VEER MAHAVIDYALAYA, WAI, WAI-PANCHGANI ROAD, WAI, TAL. WAI, DIST. SATARA,Wai , 412803 (Third Cycle)",
  'MANIKCHAND PAHADE LAW COLLEGE, NIRALA BAZAR SAMARTH NAGAR AURANGABAD,AURANGABAD , 431001 (Third Cycle)',
  "RAYAT SHIKSHAN SANSTHA'S RADHABAI KALE MAHILA MAHAVIDYALAYA, AHMEDNAGAR,Behind Tarakpur Bus Stand, Tarakpur, Ahmednagar- 414 001, AHMEDNAGAR , 414001 (Third Cycle)",
  "RAYAT SHIKSHAN SANSTHA'S R.B. NARAYANRAO BORAWAKE COLLEGE,Shrirampur Tal- Shrirampur Dist-Ahmednagar, Pin-413709,SHRIRAMPUR , 413709 (Third Cycle)",
  'SHRI RAOSAHEB RAMRAO PATIL MAHAVIDYALAYA,Savlaj A/P- Savlaj, Tal- Tasgaon, Dist- Sangli, Pin- 416311, Sangli , 416311 (Third Cycle)',
  'SMRK ARTS, FINE ARTS,BK COMMERCE AND AK HOME SCIENCE MAHILA MAHAVIDYALAYA NASHIK, Prin. T. A. Kulkarni Vidyanagar, College Road, Nashik,NASHIK , 422005 (Third Cycle)',
  "BGPS' MUMBAI COLLEGE OF ARTS, COMMERCE AND SCIENCE,J.k. Jadhav Knowledge Centre, Nadkarni Park, Behind MBPT Hospital, Wadala East,Mumbai , 400037 (First Cycle)",
  "BHARAT SHIKSHAN PRASARAK MANDAL'S JAIKRANTI COLLEGE OF COMPUTER SCIENCE AND MANAGEMENT STUDIES ,PUNE,S.No.70/2/1 , Behind B.R.T. Bus Stand , Katraj,Pune , 411046 (First Cycle)",
  'DILKAP RESEARCH INSTITUTE OF ENGINEERING AND MANAGEMENT STUDIES, Village-Mamdapur, Post-Neral, Mumbai, Raigad, Neral , 410101 (First Cycle)',
  'GURU GOBIND SINGH COLLEGE OF ENGINEERING AND RESEARCH CENTRE, NASHIK, KHALSA EDUCATIONAL COMPLEX, GURU GOBIND SINGH MARG, WADALA-PATHARDI ROAD, INDIRA NAGAR ANNEXE, NASHIK,NASHIK , 422009 (First Cycle)',
  'INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY, P-14 Rajiv Gandhi Infoteck Park, MIDC Phase-1, Hinjawadi, Pune-411057,Pune , 411057 (First Cycle)',
  'JAYAWANT INSTITUTE OF MANAGEMENT STUDIES,S.No 80, Pune-Mumbai Bypass Highway, Tathawade, Pune,Pune , 411033 (First Cycle)',
  "MKSSS'S SMT. HIRABEN NANAVATI INSTITUTE OF MANAGEMENT AND RESEARCH FOR WOMEN, Near Cummins Engineering College, Karvenagar,Pune , 411052 (First Cycle)",
  "M V MANDALI's COLLEGES OF COMMERCE AND SCIENCE,MVM EDUCATIONAL CAMPUS, MVM EDUCATIONAL CAMPUS MARG, OFF. VEERA DESAI ROAD, ANDHERI (WEST), MUMBAI -400058,Mumbai , 400058 (First Cycle)",
  'PADMASHREE DR. D Y PATIL INSTITUTE OF ENGINEERING, MANAGEMENT AND RESEARCH,Sector No 29, PCNTDA (Ravet), Nigdi Pradhikaran, Akurdi, Pune 411044, Pune , 411044 (First Cycle)',
  "ANEKANT EDUCATION SOCIETY'S ANEKANT INSTITUTE OF MANAGEMENT STUDIES, BARAMATI,Maharashtra , Baramati , 413102 , Anekant Education Society Campus T. C. College Road, Baramati , 413102, Maharashtra (First Cycle)",
  'RENAISSANCE INSTITUTE OF MANAGEMENT STUDIES,Maharashtra , Chandrapur , 442403 , MIDC Road, Datala Square,Chandrapur , 442403 (First Cycle)',
  "WEST KHANDESH DALIT SHIKSHAN PRASARAK MANDAL'S DR. BABASAHEB AMBEDKAR MEMORIAL COLLEGE OF LAW,Near Chitale Hospital, Jai Hind Colony Road,Maharashtra , Dhule , 424002 (Second Cycle)",
  "AINPUR PARISAR SHIKSHAN PRASARAK MANDAL'S SARDAR VALLABHABHAI PATEL ARTS AND SCIENCE COLLEGE,At Post- Ainpur, Khirdi Road, Near MSEB Substation Tal- Raver, Ainpur , 425507",
  'LAXMIBAI BHAURAO PATIL MAHILA MAHAVIDYALAYA,1428, Modikhana, Saat Rasta, Solapur , 413001 (Third Cycle)',
  "SHRI SEVADAS SHIKSHAN PRASARAK MANDAL'S JAWAHARLAL NEHRU COLLEGE OF SOCIAL WORK, Jawaharlal Nehru College of Social Work, CIDCO, New Nanded,Nanded , 431603 (Second Cycle)",
  "EVEREST EDUCATIONAL SOCIETY'S GROUP OF INSTITUTIONS,Gut No. 187 and 189 Ohar Jatwada Road,Aurangabad , 431119 (First Cycle)",
  'MANAV SCHOOL OF ENGINEERING AND TECHNOLOGY,Gut No. 1035, Nagpur Surat Highway NH6, Vyala, Balapur, Akola , 444302 (First Cycle)',
  'G. H. RAISONI INSTITUTE OF ENGINEERING & TECHNOLOGY NAGPUR,Shardha Park Hingna Wadi, NAGPUR , 440016 (First Cycle)',
  "NAV MAHARASHTRA SHIKSHAN MANDAL SHEVGAON'S LATE. ABASAHEB KAKADE ARTS COLLEGE,BODHEGAON,TAL- SHEVAGAON,DIST- AHMEDNAGAR,MAHARASHTRA.,A/p- Bodhegaon, Tal- Shevgaon, Dist- Ahmednagar, 414503,Bodhegaon , 414503 (Second Cycle)",
  "M.V.P. SAMAJ'S KARMAVEER KAKASAHEB WAGH ARTS, SCIENCE AND COMMERCE COLLEGE, PIMPALGAON BASWANT TAL NIPHAD, DIST NASHIK,Pimpalgaon Baswant, Tal- Niphad, Dist- Nashik,Pimpalgaon Baswant , 422209 (Third Cycle)",
  'SHRI SAIBABA LOK PRABODHAN ARTS COLLEGE, WADNER,NH-07, At/Po- Wadner, Th- Hinganghat, Dist- Wardha., Wadner , 442307 (First Cycle)',
  "GOKHALE EDUCATION SOCIETY'S R. H. SAPAT COLLEGE OF ENGINEERING, MANAGEMENT STUDIES AND RESEARCH, NASHIK,Nashik Prin. T. A. Kulkarni Vidyanagar, Nashik,Nashik , 422005 (First Cycle)",
  "HIRWAL EDUCATION TRUST'S COLLEGE OF COMPUTER SCIENCE AND INFORMATION TECHNOLOGY,Behind Dharia Petrol Pump , At-Chambharkhind ,Post/Tal Mahad, Dist Raigad,ChambharKhind Mahad , 402301 (First Cycle)",
  "SHRI SWAMI VIVEKANAND SHIKSHAN SANSTHA KOLHAPUR'S SMT. AKKATAI RAMGONDA PATIL KANYA MAHAVIDYALAYA, Vivekanand Colony, Ichalkarnji , 416115 (Third Cycle)",
  'DR. BABASAHEB AMBEDKAR COLLEGE OF ARTS, COMMERCE AND SCIENCE,Khed Road, Bramhapuri Ta. Bramhapuri Dist.Chandrapur,BRAMHAPURI , 441206 (Third Cycle)',
  'S.N.G. INSTITUTE OF MANAGEMENT AND RESEARCH,A/P JAIDWADI,PUNE-NASIK HIGHWAY,RAJGURUNAGAR.,RAJGURUNAGAR,PUNE,MAHARASHTRA,410512,Rajgurunagar (First Cycle)',
  'NAVALBHAU PRATISHTHAN SANCHALIT RUKHMINIBAI ARTS AND COMMERCE MAHILA COLLEGE,SIDDHIVINAYAK COLONY IN FRONT OF UNION BANK AMALNER,AMALNER , 425401 (Second Cycle)',
  'JSPM NARHE TECHNICAL CAMPUS, S. No. 12/2/2 and 14/9 Narhe, Tal. Haveli, Dist. Pune, 411041 (First Cycle)',
  "M.C.E.SOCIETY'S A.K.K.NEW LAW ACADEMY PUNE,Hidyatullah Road, Azam Campus, Camp,Pune , 411001 (Second Cycle)",
  'KAUTILYA INSTITUTE OF MANAGEMENT AND RESEARCH,Gat No.-720 (1 and 2), Pune-Nagar Road, Wagholi,Pune , 412207  (First Cycle)',
  "R. C. PATEL EDUCATIONAL TRUST'S INSTITUTE OF MANAGEMENT RESEARCH AND DEVELOPMENT, SHIRPUR,RCPETS IMRD, Karvand Naka, SHIRPUR , 425405 (First Cycle)",
  'SIR VISVESVARAYA INSTITUTE OF TECHNOLOGY, CHINHOLI, NASHIK, Pravara Technical Education Campus, Nashik Pune Highway, A/p Chincholi, Tal. Sinnar, Sinnar Nashik , 422102 (First Cycle)',
  'SATISH PRADHAN DNYANASADHANA COLLEGE,THANE (ARTS, SCIENCE AND COMMERCE),Off Eastern Express Highway, Dnyanasadhana Marg, Thane (West),Thane , 400604 (Third Cycle)',
  "CAMP EDUCATION SOCIETY'S RASIKLAL M. DHARIWAL INSTITUTE OF MANAGEMENT, Sector No. 27 / A, Pradhikaran, Nigdi, Pune - 411044 (First Cycle)",
  'BHARATIYA MAHAVIDYALAYA, AMRAVATI,Rajapeth, Badnera Road, Amravati , 444605 (Third Cycle)',
  "B. M. RUIA GIRLS' COLLEGE,Krishna Kunj, Vachha Gandhi Road, Gamdevi,MUMBAI , 400007 (Third Cycle)",
  'R.B.MADKHOLKAR MAHAVIDYALAYA, At post Chandgad Taluka Chandgad Dist. Kolhapur,Chandgad , 416509 (Third Cycle)',
  'SHIVSHAKTI ARTS AND COMMERCE COLLEGE,At Post. Babhulgaon. Tq. Babhulgaon. Dist. Yavatmal. (M. S.),Babhulgaon , 445101 (Third Cycle)',
  'SHRI PANCHAM KHEMRAJ MAHAVIDYALAYA,Sawantwadi, Near Moti Talav, Tal - Sawantwadi, Dist - Sindhudurg, Maharashtra, 416510.,SAWANTWADI , 416510',
  'SHRI SHIVAJI MAHAVIDYALAYA,Shivajinagar, Karmveer Dr. Mamasaheb Jagdale Road, Barshi,BARSHI , 413411',
  "SHRI SWAMI VIVEKANAND SHIKSHAN SANSTHA KOLHAPUR'S SMT.MEENALBEN MEHTA COLLEGE(ARTS,COMMERCE AND SCIENCE),Khingar Road, Panchgani, Tal-Mahabaleshwar, Dist-Satara, 412805,Panchgani , 412805",
  'G.H. RAISONI INSTITUTE OF ENGINEERING & MANAGEMENT,Gat No. 57/1Shirsoli Road, At Post-. Mohadi, Jalgaon.,Jalgaon,Maharashtra,425002 (Second Cycle)',
  'PUNE INSTITUTE OF BUSINESS MANAGEMENT,Gut No. 605/1, LAVASA ROAD, PIRUNGUT,PUNE,Maharashtra,412115 (First Cycle)',
  'AKEMI BUSINESS SCHOOL,S. No. 30/3/1, 30/4/A, 30/4/B, BUCHADE VASTI, VILLAGE - MARUNJI, TAL-MULSHI DIST-PUNE,Pune,Maharashtra,411057 (First Cycle)',
  "B.P.H.E SOCIETY'S CENTER FOR STUDIES IN RURAL DEVELOPMENT INSTITUTE OF SOCIAL WORK AND RESEARCH,Center for Studies in Rural Development CSRD Campus, Station Road, Ahmednagar,Ahmednagar,Maharashtra,414001 (Third Cycle)",
  'INSTITUTE OF SCIENCE,RAVINDRANATH TAGORE MARG, CIVIL LINES, NAGPUR,Nagpur,Maharashtra,440001(Third Cycle)',
  'GODAVARI INSTITUTE OF MANAGEMENT AND RESEARCH, JALGAON,Plot No P-54, Near Bharat Petroleum Additional MIDC Jalgaon,(First Cycle)',
  'DESHBHAKT ANANDRAO BALWANTRAO NAIK ARTS AND SCIENCE COLLEGE, Yashwantnagar, Chikhali, Tal Shirala Dist Sangli , Maharashtra -415408,Yashwantnagar Chikhali,Maharashtra,415408(Second Cycle)',
  'SHRI. KHASDAR GOVINDRAO ADIK LAW COLLEGE, SHRIRAMPUR, Maharashtra,413709 (First Cycle)',
  "EXCELSSIOR EDUCATION SOCIETY'S K.C. COLLEGE OF ENGINEERING AND MANAGEMENT STUDIES AND RESEARCH,Mith Bunder Road, Near Sadguru Garden, Kopri,THANE EAST,Maharashtra,400603(First Cycle)",
  "ADV. VITTHALRAO BANPURKAR MEMORIAL ART'S AND COMMERCE COLLEGE, MALEWADA,At. Post. Malewada, Tah. Kurkheda, Dist. Gadchiroli, Maharashtra, Pin No. 441209,GADCHIROLI,Maharashtra,441209 (First Cycle)",
  "SHRI. DADASAHEB GAWAI CHARITABLE TRUST'S, DR. BABASAHEB AMBEDKAR MAAVIDALAYA,Uttam Nagar, Mahadevkhori Road, Yashoda Nagar, Old Byepass Road,,Amravati,Maharashtra,444606(Third Cycle)",
  'VEER WAJEKAR ARTS, SCIENCE AND COMMERCE COLLEGE, MAHALAN VIBHAG, PHUNDE,Mahalan Vibhag, Phunde Tal. Uran, Dist. Raigad, Navi Mumbai, Maharashtra,Navi Mumbai,Maharashtra,400702 (Third Cycle)',
  "PTVA'S INSTITUTE OF MANAGEMENT,Chitrakar Ketkar Marg, Behind M. L. Dahanukar College of Commerce, Vile Parle (East), Mumbai 400057(First Cycle)",
  "SHRI DADASAHEB GAWAI CHARITABLE TRUST, AMRAVATI'S TAKSHASHILA MAHAVIDYALAYA,,Shyam Nagar, Frezarpura Road, Amravati,Maharashtra,444606 (Third Cycle)",
  'C. B. KHEDGIS BASAVESHWAR SCIENCE, RAJA VIJAYSINH COMMERCE AND RAJA JAYSINH ARTS COLLEGE, AKKALKOT,NEW PALACE ROAD, BESIDE FATHEHSINH GROUND, AKKALKOT, DIST- SOLAPUR,Maharashtra,413216 (Third Cycle)',
  'YASHWANTRAO CHAVAN ARTS AND SCIENCE MAHAVIDYALAYA,Washim Road, Mangrulpir Dist.Washim,Mangrulpir,Maharashtra,444403 (Second Cycle)',
  'KARMAVEER BHAURAO PATIL INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH,Survey No. 467/2,468, Varye, Tal. and Dist. Satara - 415015(First Cycle)',
  'INSTITUTE OF INDUSTRIAL AND COMPUTER MANAGEMENT AND RESEARCH(I.I.C.M.R),HS 2 ,Sector 27 A, Pradhikaran Nigdi,Pune-411044,PIMPRI CHINCHWAD,Maharashtra,411044 (Second Cycle)',
  'SHANKARLAL AGRAWAL SCIENCE COLLEGE, SALEKASA,Shankarlal Agrawal Science College Salekasa Dist. Gondia, Maharashtra,Gondia,Maharashtra,441916 (First Cycle)',
  "MATSYODARI SHIKSHAN SANSTHA'S COLLEGE OF ENGINEERING AND TECHNOLOGY, JALNA,Matsyodari Shikshan Sansthas College of Engineering and Technology, Auranagabad Road, Nagewadi, Jalna,JALNA,Maharashtra,431203 (First Cycle)",
  "TSSM'S BHIVARABAI SAWANT COLLEGE OF ENGINEERING AND RESEARCH,S. No. 12/1/2 and 12/2/2, Narhe, Tal. Haveli, Dist. Pune,Pune,Maharashtra,411041 (First Cycle)",
  'P K TECHNICAL CAMPUS,GAT NO 714 AT KADACHIWADI, CHAKAN TAL KHED DISTRICT PUNE 410501,PUNE,Maharashtra,410501 (First Cycle)',
  "NAVSAHYADRI EDUCATION SOCIETY'S GROUP OF INSTITUTIONS,GAT NO.69,70,71,MOUJE-NAIGAON,TAL.BHOR,DIST-PUNE,MAHARASHTRA-412213,PUNE,Maharashtra,412213 (First Cycle)",
  'PADMABHOOSHAN VASANTRAODADA PATIL INSTITUTE OF TECHNOLOGY,Budhgaon, Miraj Sangli,Sangli,Maharashtra,416304 (First Cycle)',
  'CHANDRAROOP DAKLE JAIN COLLEGE OF COMMERCE,At Post Taluka Shrirampur Dist - Ahmednagar,SHRIRAMPUR,Maharashtra,413709 (Third Cycle)',
  "R. E. SOCIETY'S R. P. GOGATE COLLEGE OF ARTS AND SCIENCE AND R. V. JOGALEKAR COLLEGE OF COMMERCE, RATNAGIRI,Adv N V Joshi Road Near District Court, Ratnagiri,Ratnagiri,Maharashtra,415612 (Fourth Cycle)",
  'GREEN HEAVEN INSTITUTE OF MANAGEMENT AND RESEARCH,NAGPUR,Green Heaven Institute of Management and Research Village Rui, Near Hotel Le-Meridien, Wardha Road,NAGPUR,Maharashtra,441108 (First Cycle)',
  "MATSYODARI SHIKSHAN SANSTHA'S ARTS COLLEGE, TIRTHPURI,Tirthpuri-Ambad Road Tirthpuri Tq. Ghansawangi Dist. Jalna,Tirthpuri tq Ghansawangi Dist Jalna,Maharashtra,431209 (First Cycle)",
  "MARATHA VIDYA PRASARAK SAMAJ'S COMMERCE, MANAGEMENT AND COMPUTER SCIENCE (CMCS) COLLEGE,UDOJI MARATHA BOARDING CAMPUS, GANGAPUR ROAD , NASHIK,NASHIK,Maharashtra,422013 (First Cycle)",
  "R. C. PATEL EDUCATIONAL TRUST'S R. C. PATEL ARTS, COMMERCE AND SCIENCE COLLEGE, SHIRPUR,R. C. Patel Arts, Commerce and Science College, Near Karvand Naka. Karvand Road, Shirpur Dist Dhule,Shirpur,Maharashtra,425405 (Third Cycle)",
  'NETAJI SUBHASHCHANDRA SCIENCE COLLEGE,Ashti Road Mulchera Dist. Gadchiroli,MULCHERA,Maharashtra,442707 (First Cycle)',
  "SHRI SHIVAJI MARATHA SOCIETY'S INSTITUTE OF MANAGEMENT AND RESEARCH,Sr. No. 74/1A, 74/1B, Parvati, Near Shinde High School, Taljai Road, Aranyeshwar,Pune,Maharashtra,411009 (First Cycle)",
  'SHRIPATRAO CHOUGULE ARTS AND SCIENCE COLLEGE,MALWADI-KOTOLI,At/Post- Kotoli,Tal- Panhala, Dist- Kolhapur 416230,Kolhapur,Maharashtra,416230 (Third Cycle)',
  "RAYAT SHIKSHAN SANSTHA'S MAHARAJA JIVAJIRAO SHINDE MAHAVIDYALAYA SHRIGONDA DIST-AHMEDNAGAR (MS),Daund - Jamkhed Road, Shrigonda, Dist-Ahmednagar,Shrigonda,Maharashtra,413701 (Third Cycle)",
  'INTERNATIONAL INSTITUTE OF MANAGEMENT SCIENCE,Srv. no. 169/1/A, Opposite Elpro International, Chinchwad, Pune-411033 (MS),Pune,Maharashtra,411033 (First Cycle)',
  'PRIYADARSHINI INSTITUTE OF ENGINEERING AND TECHNOLOGY.,Near CRPF Campus, Hingna Road.,Nagpur,Maharashtra,440019 (First Cycle)',
  'NAGPUR INSTITUTE OF TECHNOLOGY, NAGPUR,Survey No. 13/2, Mahurzari, Near Fetari, Katol Road, Nagpur-441501,Nagpur,Maharashtra,441501 (First Cycle)',
  'H. J. THIM COLLEGE OF ARTS AND SCIENCE,IQRA EDUCATION SOCIETY H. J. THIM COLLEGE OF ARTS AND SCIENCE, HAJI GULAM NABI NAGAR, MEHRUN, JALGAON,Jalgaon,Maharashtra,425003 (Third Cycle)',
  "SHRI BHAIRAVNATH SHIKSHAN PRASARAK MANDAL'S ADHALRAO PATIL INSTITUTE OF MANAGEMENT AND RESEARCH,Ap - Landewadi (Manchar), Tal. - Ambegaon, Dist - Pune,Pune,Maharashtra,410503 (First Cycle)",
  'SHRI TULJABHAVANI COLLEGE OF ENGINEERING,NALDURG ROAD, TULJAPUR - 413601 DIST. OSMANABAD MAHARASHTRA STATE, TULJAPUR - 413601,TULJAPUR,Maharashtra,413601 (First Cycle)',
  'INDIRA COLLEGE OF ENGINEERING AND MANAGEMENT,Gat No. 276, Parandwadi, Off Pune-Mumbai Highway, Near Somatane Phata, Taluka - Maval, Dist - Pune,Pune,Maharashtra,410506 (First Cycle)',
  "PARLE TILAK VIDYALAYA ASSOCIATION'S M.L.DAHANUKAR COLLEGE OF COMMERCE,DIXIT ROAD, VILE PARLE (EAST),MUMBAI,Maharashtra,400057 (Third Cycle)",
  'NIT GRADUATE SCHOOL OF MANAGEMENT,Survey No. 13/2, Near Fetri, Mahurzari, Katol Road, Nagpur.,NAGPUR,Maharashtra,441501 (First Cycle)',
  "ABHINAV EDUCATION SOCIETY'S COLLEGE OF COMPUTER SCIENCE AND MANAGEMENT,College of Computer Science and Management, Post- Narhe- Ambegaon, Tal Haweli (Excluding Corporation Area), Dist Pune 411041,PUNE,Maharashtra,411041 (First Cycle)",
  'ARTS, COMMERCE AND SCIENCE COLLEGE, BODWAD., Arts, Commerce and Science College, Bodwad Jamner Road, Bodwad, Tal- Bodwad, Dist- Jalgaon Maharashtra, India Pin - 425310,Bodwad,Maharashtra,425310 (Third Cycle)',
  "LEWA EDUCATION UNION'S DR. ANNASAHEB, G.D. BENDALE MAHILA MAHVIDYALAYA, Jilha Road, Jilha Peth, Jalgaon,Jalgaon,Maharashtra,425001 (Third Cycle)",
  "GONDIA EDUCATION SOCIETY'S CHHOTABHAI JAVERBHAI PATEL ARTS AND COMMERCE COLLEGE TIRORA, DIST. GONDIA, Khairlanji Road, Tirora,TIRORA,Maharashtra,441911 (Third Cycle)",
  'PRAVARA CENTRE FOR MANAGEMENT RESEARCH AND DEVELOPMENT, Off Senapati Bapat Road, Near Patrakar Nagar,Pune,Maharashtra,411016 (First Cycle)',
  'DR.C.V.RAMAN SCIENCE COLLEGE, Nagram Road , At post-Sironcha , Tahsil Sironcha , Dist Gadchiroli.,SIRONCHA,Maharashtra,442504 (First Cycle)',
  "SAMARTH RURAL EDUCATIONAL INSTITUTE'S, SAMARTH COLLEGE OF COMPUTER SCIENCE, BELHE, BANGARWADI, TAL JUNNAR, DIST PUNE., SAMARTH RURAL EDUCATIONAL INSTITUTES,SAMARTH COLLEGE OF COMPUTER SCIENCE, BELHE, (BANGARWADI) TAL. JUNNAR DIST. PUNE - 412 410,Pune,Maharashtra,412410 (First Cycle)",
  'ILS LAW COLLEGE, PUNE, LAW COLLEGE ROAD, CHIPLUNKAR ROAD,PUNE,Maharashtra,411004 (Second Cycle)',
  'NAGNATH ARTS, COMMERCE AND SCIENCE COLLEGE, AT.POST. AUNDHA NAGNATH , TQ. AUNDHA NAGNATH DIST. HINGOLI, NEAR GOVERNMENT RESTHOUSE, AUNDHA NAGNATH,AUNDHA NAGNATH DIST HINGOLI,Maharashtra,431705 (Second Cycle)',
  'FR. C. RODRIGUES INSTITUTE OF MANAGEMENT STUDIES, FR. AGNEL TECHNICAL EDUCATION COMPLEX, SECTOR-9A, VASHI, NAVI MUMBAI.,NAVI MUMBAI,Maharashtra,400703 (First Cycle)',
  'WAGHIRE COLLEGE OF ARTS, COMMERCE AND SCIENCE, A/p- Saswad, Tal-Purandar, Dist-Pune,SASWAD,Maharashtra,412301 (Third Cycle)',
  'ORANGE CITY COLLEGE OF SOCIAL WORK, NAGPUR, Plot no. 8, Smrutinagar, IInd Railway Crossing, Koradi Road, Nagpur,Nagpur,Maharashtra,441111 (Second Cycle)',
  "RAYAT SHIKSHAN SANSTHA'S CHANDRABAI- SHANTAPPA SHENDURE COLLEGE, A/p Hupari, Tal. Hatkanangale Dist. Kolhapur,Hupari,Maharashtra,416203 (Third Cycle)",
  "MARATHA VIDYA PRASARAK SAMAJ'S ARTS, SCIENCE AND COMMERCE COLLEGE, Tilak Nagar, Mumbai-Agra Highway, Ozar (MIG) Tal-Niphad Dist-Nashik (MS),Ozar MIG,Maharashtra,422206 (Third Cycle)",
  'MANOHAR BHAI PATEL COLLEGE OF ARTS, COMMERCE AND SCIENCE SAKOLI, Manoharbhai Patel College of Arts, Commerce and Science, Sakoli,Sakoli,Maharashtra,441802 (Third Cycle)',
  "Smt. Maniben M. P. Shah Women's College of Arts and Commerce, Smt. Parmeshwari Devi Gordhandas Garodia Educational Complex, 338, R. A. Kidwai Road, Matunga.,Mumbai,Maharashtra,400019 (Third Cycle)",
  'INTERNATIONAL INSTITUTE OF MANAGEMENT HUMAN RESOURCE DEVELOPMENT FOR WOMEN, Sr 54(1,2/1),Nere Dattawadi, Near Hinjewadi Infotech Park, Pune - 411 033,PUNE,Maharashtra,411033 (First Cycle)',
  'ABASAHEB MARATHE ARTS AND NEW COMMERCE, SCIENCE COLLEGE, RAJAPUR, Abasaheb Marathe Arts and New Commerce, Science College, Vikhare Gothane Rajapur.,Rajapur,Maharashtra,416702 (Third Cycle)',
  'SAMAJBHUSHAN GANPATRAO KALBHOR ARTS, COMMERCE AND SCIENCE COLLEGE, Shri Swami Vivekanand Shikshan Sanstha Kolhapurs, Samajbhushan Ganpatrao Kalbhor Arts, Commerce and Science College, Loni Kalbhor, Tal.-Haveli, Dist.-Pune,Lonikalbhor Pune,Maharashtra,412201 (Third Cycle)',
  "JUNNAR TALUKA SHIVNER SHIKSHAN PRASARAK MANDAL'S SHRI SHIV CHHATRAPATI COLLEGE, BODKENAGAR,JUNNAR, DIST. PUNE, MAHARASHTRA, AT POST- BODKENAGAR, JUNNAR, TAL- JUNNAR, DIST- PUNE,JUNNAR,Maharashtra,410502 (Third Cycle)",
  'MATRIX SCHOOL OF MANAGEMENT STUDIES, Survey No. 9/1/5, 9/2/4, 9/1/4, Off Westernly Bypass Road, Next to Sinhgad Science College, Vadgaon, Ambegaon (Bk.),,Pune,Maharashtra,411041 (First Cycle)',
  'VASANTRAO NAIK GOVERNMENT INSTITUTE OF ARTS AND SOCIAL SCIENCES, Samvidhan (RBI) Square, Pt. Jawaharlal Nehru Marg, Civil Lines, Nagpur,Nagpur,Maharashtra,440001 (Third Cycle)',
  'SHREE PANDHARINATH ARTS AND COMMERCE COLLEGE,NARKHED , Opposite to Bus Stand, Narkhed Sawargaon Road, Narkhed Dist.- Nagpur.,NARKHED,Maharashtra,441304 (Second Cycle)',
  'SHIVAJIRAO S. JONDHALE COLLEGE OF ENGINEERING , Behind Venkatesh Petrol Pump, Sonarpada Dombivli (East),Dombivli East,Maharashtra,421204 (First Cycle)',
  'SHAHID BHAGATSINGH MAHAVIDYALAYA KILLARI , Shahid Bhagatsingh Mahavidyalaya, Killari Tq.Ausa, Dist.Latur - 413516 MS-India,Latur Killari,Maharashtra,413516 (Second Cycle)',
  'KARMAVEER BHAURAO PATIL COLLEGE OF ENGINEERING, SATARA , Sadar Bazar, Near RTO Office, Satara,Satara,Maharashtra,415001 (First Cycle)',
  "TAPI VALLEY EDUCATION SOCIETY'S DHANAJI NANA MAHAVIDYALAYA. , NEHRU VIDYANAGAR, SAVDA ROAD FAIZPUR,FAIZPUR,Maharashtra,425503 (Third Cycle)",
  "STMEI'S SANDIPANI TECHNICAL CAMPUS FACULTY OF ENGINEERING , GAT NO.23,MAUJE- KOLPA, TAL AND DIST.LATUR, 413512,MAHARASHTRA,Latur,Maharashtra,413512 (First Cycle)",
  'SANT TUKARAM COLLEGE OF ARTS AND SCIENCE, PARBHANI , Near Old RTO Office, Basmat Road,,Parbhani,Maharashtra,431401 (First Cycle)',
  "ANJUMAN-I-ISLAM'S KALSEKAR TECHNICAL CAMPUS , PLOT 2 AND 3, SECTOR 16, NEAR THANA NAKA, KHANDAGAON, NEW PANVEL, NAVI MUMBAI,New Panvel Navi Mumbai,Maharashtra,410206 (First Cycle)",
  "VPM'S DR.V.N.BEDEKAR INSTITUTE OF MANAGEMENT STUDIES , VPMs Dr.V.N. Bedekar Institute of Management Studies, Building No. 4, Jnanadweep, Thane College Campus, Chendani Bunder Road, Near CiDCO Bus Stop, Thane - West,Thane,Maharashtra,400601 (First Cycle)",
  'G.S.TOMPE ARTS, COMMERCE AND SCIENCE COLLEGE, CHANDUR BAZAR - AMRAVATI, MAHARASHTRA , G. S. Tompe Arts, Commerce and Science College, Chandur Bazar, Dist. Amravati -444704,Chandur Bazar,Maharashtra,444704 (Third Cycle)',
  'LATE RAJENDRASINGH (BABA) VYAS ARTS AND COMM. COLLEGE, KONDHALI , Budhawar Bazar, Ward no. 03, Kondhali,KONDHALI,Maharashtra,441103 (First Cycle)',
  'PRERNA COLLEGE OF COMMERCE , Reshimbag Square, Nagpur - 440024,NAGPUR,Maharashtra,440024 (First Cycle)',
  "MARATHA VIDYA PRASARAK SAMAJ'S ARTS AND COMMERCE COLLEGE , At Post - Vani, Tal. - Dindori, Dist. - Nashik Maharashtra - 422215,Vani,Maharashtra,422215 (Third Cycle)",
  'ROYAL COLLEGE OF ARTS, SCIENCE AND COMMERCE , Shrishti Hsg Complex, Penkar Pada, Mira Road(E), Dist. Thane,Thane,Maharashtra,401107 (Third Cycle)',
  'NATWARLAL MANIKLAL DALAL COLLEGE OF ARTS AND COMMERCE , RAM NAGAR KUDWA ROAD,Gondia,Maharashtra,441614 (Third Cycle)',
  'Dada Ramchand Bakhru Sindhu Mahavidyalaya, Nagpur , Kaka Tilokchand Rughwani Marg, Panchpaoli, Nagpur - 440017 (Maharashtra),Nagpur,Maharashtra,440017 (Third Cycle)',
  "PUNE DISTRICT EDUCATION ASSOCIATION'S PROF. RAMKRISHNA MORE ARTS, COMMERCE AND SCIENCE COLLEGE , Sec. No. 28, Ganganagar, Pradhikaran,Akurdi Pune,Maharashtra,411044 (Third Cycle)",
  'TULSIRAMJI GAIKWAD-PATIL COLLEGE OF ARCHITECTURE , Mohgoan, KH.No .08,NH-7, Wardha Road,Nagpur,Maharashtra,441108 (First Cycle)',
  'SHRI SADGURU SAIBABA SCIENCE AND COMMERCE COLLEGE, ASHTI, AT POST-ASHTI. CHAMORSHI ROAD, Th- CHAMORSHI,DIST- GADCHIROLI- 442707, Ashti, Maharashtra, 442707 (First Cycle)',
  'D. Y. PATIL INSTITUTE OF MASTER OF COMPUTER APPLICATIONS AND MANAGEMENT,DR. D. Y. PATIL EDUCATIONAL COMPLEX, SECTOR NO. 29, NIGDI-PRADHIKARAN, AKURDI, PUNE,PUNE,Maharashtra,411044 (First Cycle)',
  'SMT. SURAJDEVI RAMCHAND MOHATA MAHILA MAHAVIDYALAYA,KHAMGAON,Balaji Plots, Near National High School,,KHAMGAON,Maharashtra,444303 (Third Cycle)',
  'RIZVI COLLEGE OF ENGINEERING,Rizvi College of Engineering Rizvi Educational Complex Sherly Rajan Village Off Carter Road Bandra West Mumbai 400050,Mumbai,Maharashtra,400050 (First Cycle)',
  'THAKUR INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH,C- Block, Thakur Educational Campus, Shyamnarayan Thakur Marg, Thakur Village, Kandivali (E), Mumbai,Mumbai,Maharashtra,400101 (First Cycle)',
  'D.B.F. DAYANAND COLLEGE OF ARTS AND SCIENCE, SOLAPUR,Maharshi Dayanand Saraswati Chowk, Raviwar Peth,Solapur,Maharashtra,413002 (Third Cycle)',
  'ALARD COLLEGE OF ENGINEERING AND MANAGEMENT , PUNE,Survey No 50 , Near Rajiv Gandhi Infotech Park , Phase-II ,Hinjewadi , Marunje , Pune -411057 , Pune , Maharashtra.,PUNE,Maharashtra,411057 (First Cycle)',
  "RASHTRIYA SAHAKARI SHIKSHAN PRASARAK MANDAL LTD. SANSTHA'S NANASAHEB YASHAVANTRAO NARAYANRAO CHAVAN ART'S, SCIENCE AND COMMERCE COLLEGE CHALISGAON DIST. JALGAON,Hirapur Road Chalisgaon,Chalisgaon,Maharashtra,424101 (Third Cycle)",
  'ST. PAUL COLLEGE,BEHIND VTC GROUND, NEAR GANAPATI MANDIR, ASHELEPADA, ULHASNAGAR 421004,ULHASNAGAR,Maharashtra,421004 (First Cycle)',
  'K.NARKHEDE COLLEGE BHUSAVAL,BEHIND TECHNICAL HIGHSCHOOL SHRADA NAGAR ,BHUSAVAL -425201 DIST. JALGAON,JALGAON,Maharashtra,425201 (First Cycle)',
  'SANMATI ENGINEERING COLLEGE,At.Swargaon Barde, Washim - Malegaon Road, Washim.,Washim,Maharashtra,444505 (First Cycle)',
  'SHIVAJI MAHAVIDYALAYA GADCHIROLI,Dhanora Road, Gadchiroli Tq. Dist. Gadchiroli,GADCHIROLI,Maharashtra,442605 (Second Cycle)',
  'BALLARPUR INSTITUTE OF TECHNOLOGY,VILLAGE - BAMNI, TA., BALLARPUR , DIST. CHANDRAPUR,BALLARPUR,Maharashtra,442701 (First Cycle)',
  'ASHOKA BUSINESS SCHOOL,URJAYANT PLAZA, NEAR SUMAN PETROL PUMP, MUMBAI-AGRA HIGHWAY, CIDCO, NASHIK, MAHARASHTRA,NASHIK,Maharashtra,422009 (First Cycle)',
  "SHRI SWAMI VIVEKANAND SHIKSHAN SANSTHAS'S DR PATANGARAO KADAM ARTS AND COMMERCE COLLEGE, PEN, DIST. RAIGAD- MAHARASHTRA,Near Pen Civil Court, Pen Dist Raigad,Pen,Maharashtra,402107 (Second Cycle)",
  'SANT GAJANAN MAHARAJ COLLEGE OF ENGINEERING,Site Chinchewadi Gadhinglaj Halkarni Road Tal Gadhinglaj Dist. Kolhapur,Site Chinchewadi Gadhinglaj Halkarni Road Tal Gadhinglaj Dist kolhapur,Maharashtra,416503 (First Cycle)',
  'RAJARSHI SHAHU ARTS AND COMMERCE COLLEGE,A/p Rukadi, Taluka Hatkanangale, District Kolhapur,Rukadi Taluka Hatkananagale District Kolhapur,Maharashtra,416118 (Third Cycle)',
  'LOK MAHAVIDYALAYA,Bachelor Road, Pratap Nagar,Wardha,Maharashtra,442001 (Third Cycle)',
  "MARATHA VIDYA PRASARAK SAMAJ'S ARTS, COMMERCE AND SCIENCE COLLEGE, TRYAMBAKESHWAR,Jawhar Road, Tryambakeshwar, Tal- Tryambakeshwar, Dist.-Nashik,Nashik,Maharashtra,422212 (Third Cycle)",
  "PUNE VIDYARTHI GRIHA'S COLLEGE OF SCIENCE,Pune Vidyarthi Grihas College of Science, Vidyanagari,S.No. 44, Parvati,,Pune,Maharashtra,411009 (First Cycle)",
  "SHRI VILE PARLE KELAVANI MANDAL'S DWARKADAS J. SANGHVI COLLEGE OF ENGINEERING,PLOT NO. U-15, JVPD SCHEME, BHAKTIVEDANTA SWAMI MARG, VILE PARLE (WEST), MUMBAI 400056.,Mumbai,Maharashtra,400056 (First Cycle)",
  "KHANDESH COLLEGE EDUCATION SOCIETY'S S.S.MANIYAR LAW COLLEGE,IMR Campus, Ring Road, Jilha Peth, Jalgaon,JALGAON,Maharashtra,425001 (Third Cycle)",
  "VPM'S MAHARSHI PARSHURAM COLLEGE OF ENGINEERING,At Post - Velneshwar, Hedvi-Guhagar Road, Taluka - Guhagar, District - Ratnagiri,Velneshwar,Maharashtra,415729 (First Cycle)",
  'GOVINDRAO WANJARI COLLEGE OF ENGINEERING AND TECHNOLOGY,Salai Godhani ,Near Chikana Village ,Hudkeshwar Road,Nagpur,NAGPUR,Maharashtra,441204 (First Cycle)',
  'DOODHSAKHAR MAHAVIDYALAYA, BIDRI,At/Post Bidri, Taluka Kagal District Kolhapur,Bidri,Maharashtra,416208 (Third Cycle)',
  'SHIVPRASAD SADANAND JAISWAL COLLEGE, ARJUNI MORGAON,NEAR RAILWAY STATION, ARJUNI/MORGAON, DISTRICT-GONDIA,ARJUNI MORGAON,Maharashtra,441701 (Third Cycle)',
  'NARAYANRAO WAGHMARE MAHAVIDYALAYA, AKHADA BALAPUR.,Behind Irrigation Camp, Akhada Balapur. Taluka. Kalamnuri Dist.Hingoli,Akhada Balapur,Maharashtra,431701 (First Cycle)',
  "MARATHWADA MITRA MANDAL'S INSTITUTE OF MANAGEMENT EDUCATION RESEARCH AND TRAINING,S. No. 18, Plot No. 5/3, CTS No. 205, Karve Nagar,PUNE,Maharashtra,411052 (First Cycle)",
  "DAYANAND EDUCATION SOCIETY'S DAYANAND COLLEGE OF COMMERCE, LATUR,Dayanand College of Commerce Dayanand Education Society Campus, Barshi Road, Latur - 413531 (MS),Latur,Maharashtra,413531 (Third Cycle)",
  "KALWAN EDUCATION SOCIETY'S ARTS, COMMERCE AND SCIENCE COLLEGE,Kalwan, Tal- Kalwan, Dist- Nashik,Kalwan,Maharashtra,423501 (Third Cycle)",
  'GNVS INSTITUTE OF MANAGEMENT,R.Jaimalsingh Marg, GTB Nagar, Sion-Koliwada (East),,Mumbai,Maharashtra,400037 (First Cycle)',
  'BHAGWANT INSTITUTE OF TECHNOLOGY,GAT NO.-1242, TADSOUNDANE ROAD, LATUR-KURDUWADI BYPASS, BARSHI.,BARSHI,Maharashtra,413401 (First Cycle)',
  "VILLAGE UPLIFT SOCIETY'S ANNASAHEB GUNDEWAR COLLEGE,Gundewar Marg, Chhaoni, Katol Road, Nagpur,Nagpur,Maharashtra,440013 (Third Cycle)",
  'KRANTISINH NANA PATIL MAHAVIDYALAYA, WALAWE.,A/P-Walawe, Islampur Road, Tal.Walwa Dist. Sangli,Walawe,Maharashtra,416313 (Third Cycle)',
  'ARTS,COMMERCE AND SCIENCE COLLEGE,TUKUM, CHANDRAPUR,Near S.T. Workshop, Tukum, Tadoba Road, Chandrapur,Maharashtra,442401 (Second Cycle)',
  "SHAHADA TALUKA EDUCATIONAL SOCIETY AND CO.OP. EDUCATION SOCIETY LIMITED'S SR. ARTS MAHILA MAHAVIDYALAYA,SHETH V K SHAH VIDYA MANDIR SCHOOL CAMPUS, DONDAICHA ROAD,SHAHADA,Maharashtra,425409 (Second Cycle)",
  "CHALISGAON EDUCATION SOCIETY'S .B.P.ARTS, S.M.A SCIENCE AND K.K.C. COMMERCE COLLEGE,Dhule Road, Near Adarsh Nagar,Chalisgaon,Maharashtra,424101 (Third Cycle)",
  'REAL INSTITUTE OF MANAGEMENT AND RESEARCH,Survey No.30, Sai Shraddha Park, Beltarodi Road, Nagpur,Maharashtra,440037 (First Cycle)',
  "THE BHARAT EDUCATION SOCIETY'S SANT GADGE MAHARAJ COLLEGE OF COMMERCE AND ECONOMICS,Lane No.12 Khetwadi, Grant Road,Mumbai,Maharashtra,400004 (Third Cycle)",
  'SINDHUDURG SHIKSHAN PRASARAK MANDALS COLLEGE OF ENGINEERING, A/P Harkul Budruk Tal Kankavali Dist- Sindhudurg,Kankavli,Maharashtra,416602 (First Cycle)',
  "SAHYOG PRATISHTHAN'S, SAHYOG COLLEGE OF MANAGEMENT STUDIES, Indraratna Palace, Station Road, Jambhali Naka, Thane (W),Maharashtra,400601 (First Cycle)",
  'PRIYADARSHINI INSTITUTE OF ARCHITECTURE AND DESIGN STUDIES, PRIYADARSHINI CAMPUS, DIGDOH HILLS, HINGNA ROAD,NAGPUR,Maharashtra,440019 (First Cycle)',
  'BURHANI COLLEGE OF COMMERCE AND ARTS,Nesbit Road Mazagaon Mumbai,Maharashtra,400010 (Second Cycle)',
  "JANSEVA SHIKSHAN MANDAL'S SHANTARAMBHAU GHOLAP ARTS,SCIENCE AND GOTIRAMBHAU PAWAR COMMERCE COLLEGE,SHIVLE,Gandhi Camp,At post Shivle , Tal - Murbad , Dist.- Thane 421 401 (Third Cycle)",
  'SIDDHANT COLLEGE OF MANAGEMENT STUDIES,At Post Sudumbare, Tal-Maval, Chakan- Talegaon Road, Dist Pune-412109 (First Cycle)',
  "DEOLA EDUCATION SOCIETY'S KARMAVEER RAMRAOJI AHER ARTS, SCIENCE AND COMMERCE COLLEGE, DEOLA, DIST. NASHIK,A/P - Deola ,Maharashtra,423102",
  'MARATHWADA INSTITUTE OF TECHNOLOGY, D-sector, Plot.No. 37, N4, Cidco, Aurangabad,Maharashtra,431003 (First Cycle)',
  'S.K.Somaiya College of Arts,Science and Commerce,Vidyanagar,Vidyavihar(East), Mumbai 400077',
  'MATOSHRI COLLEGE OF MANAGEMENT AND RESEARCH CENTRE,Eklahare, Near Odhagaon Off Nashik Aurangabad Highway, Tal Dist- Nashik,Maharashtra,422105 (First Cycle)',
  'JAIKRANTI ARTS SENIOR COLLEGE,Sitaram Nagar, Bh. Ashtavinayak Temple,Latur,Maharashtra,413512 (Second Cycle)',
  "RAJGAD DNYANPEETH'S , SHRI CHHATRAPATI SHIVAJIRAJE COLLEGE OF ENGINEERING,Gat No.237, Pune - Bangalore Highway, Dhangawadi, Taluka - Bhor, Dist - Pune,PUNE,Maharashtra,412206 (First Cycle)",
  'SHRI NEMINATH JAIN BRAHMACHARYASHRAM (JAIN GURUKULS), KARMVEER KESHAVLALJI HARAKCHANDJI ABAD ARTS, SHRIMAN MOTILALJI GIRIDHARILALJI LODHA COMMMERCE AND SHRIMAN P.H. JAIN SCIENCE COLLEGE,Neminagar, Chandwad Dist. Nashik,Chandwad,Maharashtra,423101',
  'YASHWANT COLLEGE, SELU,Near APMC, Sukali Station Road, Selu, Dist. Wardha,Selu,Maharashtra,442104',
  "THE PEOPLE'S EDUCATION SOCIETY'S JAMKHED MAHAVIDYALAYA,At/Post/Tal- Jamkhed,Maharashtra,413201 (Second Cycle)",
  "BHARATIYA JAIN SANGHATANA'S ARTS, SCIENCE AND COMMERCE COLLEGE,Bakori Phata, Pune-Nagar Highway, Wagholi, PUNE,Maharashtra,412207",
  'Seth Hirachand Mutha College of Arts, Commerce Science, Adharwadi Jail Road, Kolivali Village, Umbarde Gaon , Kalyan (w) - 421301 (Second Cycle)',
  'PILLAI COLLEGE OF ENGINEERING,Dr.K.M.Vasudevan Pillai Campus, Sector 16, New Panvel , Navi Mumbai,Maharashtra,410206 (First Cycle)',
  "BHAIRAVNATH SHIKSHAN MANDAL'S BHAIRAVNATH VIDNYAN MAHAVIDYALAYA, KHUTBAV,At Post Khutbav, Taluka Daund, District Pune 412203 (First Cycle)",
  'Govindlal Kanhaiyalal Joshi (Night) Commerce College,Shri. Marwadi Rajasthan School, Campus, Signal Camp,Latur - 413512 (First Cycle)',
  'Nutan Maharashtra Institute of Engineering and Technology,Samarth Vidya Sankul, Vishnupuri, Talegaon Station, Tal. Maval,Pune - 410507 (First Cycle)',
  'Siddhant Institute of Business Management,A/P Sudumbare, Chakan Talegaon Road, Tal. Maval,Pune - 412109 (First Cycle)',
  'SIES Graduate School of Technology,Plot No. 1/C/D/E, Srichandrasekarendra Saraswati, Vidyapuram, Sector 5, Nerul,Navi Mumbai - 400706 (First Cycle)',
  'Parvatibai Genba Moze College of Engineering,New GAT No. 1178 (Old GAT No. 2181), Baif Road, Wagholi,Pune - 412207 (First Cycle)',
  'Akhil Bharatiya Maratha Shikshan Parishad Pune Anantrao Pawar College of Engineering and Research,S. No. 103, Shahu College Campus, Parvati,Pune - 411009 (First Cycle)',
  'Dr D Y Patil School of Engineering and Technology,Dr D Y Patil Technical Campus, Dr D Y Patil Knowledge City, Sr. No. 136, Charholi(Bk), Via. Lohegaon, Taluka Haveli,Pune 12105 (First Cycle)',
  'Unique Institute of Management ,S No 36 / 3C, Gokulnagar, Katraj Kondhwa Road, Katraj,Pune - 411046 (First Cycle)',
  "Marathwada Mitra Mandal's Institute of Technology,Survey No. 35, Plot No. 5/6, Lohgaon ,Pune - 411047 (First Cycle)",
  "Mahila Vikas Sanstha's Arts and Science College,Super Express Highway, Nachangaon-Pulgaon, Tah. Deoli,Wardha - 442302 (Second Cycle)",
  "Anjuman-I-Islam's Akbar Peerbhoy College of Commerce and Economics,Maulana Shaukatali Road, Two Tanks, Grant Road,Mumbai - 400008 (Second Cycle)",
  "Sarvodaya Shikshan Mandal's Sushilabai Ramachandrarao Mamidwar College of Social Work,Harbanskaur Kanda Premises, Behind Tata Motors, Padoli, (Mouza - Morwa), Post Box No.20, Nagpur Road,Chandrapur - 442406 (Second Cycle)",
  'Institute of Management Studies, Career Development Research,IMSCDR, IMS Campus, Station Road,Ahmednagar - 414001 (Second Cycle)',
  'Mahila Arts, Commerce College, Chandur Rly,Near Hutatma Smarak, Chandur Railway ,Amravati - 444904 (Second Cycle)',
  "Mahila Vikas Sanstha's New Arts, Commerce and Science College,Bachelor Road, Nalwadi,Wardha - 442001 (Second Cycle)",
  "Jai Hind Educational Trust's Zulal Bhilajirao Patil College,Z.B.Patil Road,Deopur,Dhule - 424002 (Third Cycle)",
  'Ekmeka Sahaya Karu/Awaghe Dharu Supanth Ambegaon Taluka Vidya Vikas Mandal’s B.D. Kale Mahavidyalaya,Ghodegaon,Tal-Ambegaon,Pune - 412408 (Third Cycle)',
  'Narayanrao Kale Smruti Model College Arts, Commerce and Science,N.H. 06, Karanja (Ghadge),Wardha - 442203 (Third Cycle)',
  'Annasaheb Magar Mahavidyalaya,Survey No. 215/277, Manjari Road, Mahadevnagar, Hadapsar,Pune - 411028 (Third Cycle)',
  "Sipna Shikshan Prasarak Mandal's Amravati Arts, Science and Commerce College,Upper Plateau, Near Government Garden, Chikhaldara,Amravati - 444807 (Third Cycle)",
  "Kasegaon Education Society's Arts and Commerce College,Kasegaon, Walwa,Sangli - 415404 (Third Cycle)",
  'Bharati Vidyapeeths Dr. Patangrao Kadam Mahavidyalaya, Sangli,Post Box No-74,Sangli-416416 (Third Cycle)',
  'Gokhale Education Societys N B Mehta Valwada Science College,Acharya Bhise Vidyanagar,Bordi - 401701 (Third Cycle)',
  "Vile Parle Mahila Sangh's Lions Juhu Nandlal Jalan Mahila Mahavidyalaya,Mangalayatan, Paranjape B Scheme, Road No. 1, Vile Parle (East),Mumbai - 400057 (Third Cycle)",
  "Kalyani Charitable Trust's Kalyani Ravindra Sapkal College of Management Studies,Sapkal Knowledge Hub, Kalyani Hills, Anjaneri-Trimbakeswar Road, Tal - Trimbakeswar,Nashik - 422213 (First Cycle)",
  'Tirpude Institute of Management Education,1, Balasaheb Tirpude Marg, Civil Lines, Sadar,Nagpur - 440001 (First Cycle)',
  "Pune Vidyarthi Griha's College of Engineering,PVG Campus, 206, Behind Reliance Petrol Pump, Dindori Road, Mhasrul,Nashik - 422004 (First Cycle)",
  "Camp Education Society's Dr. Arvind B. Telang Institute of Hotel Management,Plot No. G/P - 159, G - Block, MIDC Chinchwad, Sambhajinagar,Pune - 411019 (First Cycle)",
  'Institute of Business Management and Research, Wakad,Survey No. 130, Mumbai-Bengaluru Highway, Near Bhumkar Chowk, Wakad,Pune - 411057 (First Cycle)',
  'Marathwada Institute of Management and Research,Gut No- 166. Deolai Satara Link Raod, Opp. MHADA Colony, Satara Parisar, Beed by pass Road,Aurangabad - 431010 (First Cycle)',
  "Mahatma Gandhi Mission's College of Engineering,Near Airport, Hingoli Road ,Nanded - 431605 (First Cycle)",
  "Gokhale Education Society's J. D. C. Bytco Institute of Management Studies and Research,Principal T.A. Kulkarni Vidyanagar, B.Y.K. College Campus, College Road,Nashik - 422005 (First Cycle)",
  "KVN Naik S. P. Sanstha's Loknete Gopinathji Munde Institute of Engineering Education and Research,KVN Naik Marg, Canada Corner, Sharanpur Road,Nashik - 422002 (First Cycle)",
  'Sinhgad Institute of Pharmacy,Mumbai-Pune By Pass, Off Smt. Kashibai Navale Hospital, Narhe Road, Narhe (Ambegaon),Pune - 411041 (First Cycle)',
  'Sinhgad Institute of Pharmaceutical Sciences,Gat No. 309/310, Off Mumbai-Pune Expressway, Kusgaon, Lonavala,Pune - 410401 (First Cycle)',
  'Jawahar Education Societys A. C. Patil College of Engineering,Plot No 17 Sector 4 Kharghar,Navi Mumbai - 410210 (First Cycle)',
  'Indira Gandhi Kala Mahavidyalaya, Ralegaon,Kalamb Road Ralegaon,Yavatmal - 445402 (First Cycle)',
  "Mauli Group of Institution's College of Engineering and Technology,MGICOET, Shegaon, Khamgaon Road,Shegaon - 444203 (First Cycle)",
  'N. B. Navale Sinhgad College of Engineering,Gat. No. 38/1/B, Sinhgad Institutes, Kegaon, Solapur-Pune National Highway,Solapur - 413255 (First Cycle)',
  'Choudhari Attarsingh Yadav Memorial Trust Siddhant College of Engineering,A/p-Sudumbre, Chakan-Talegaon Road, Taluka- Maval,Pune - 412109 (First Cycle)',
  "Jayawant Shikshan Prasarak Mandal's Rajarshi Shahu College of Pharmacy and Research,Sr.No.82/2,Pune-Mumbai Bypass Highway,Tathawade,Pune - 411033 (First Cycle)",
  'M. S. Bidve Engineering College,P. O. Box 112, Vaswadi Barshi Road,Latur - 413531 (First Cycle)',
  'Bapurao Deshmukh College of Engineering,Sevagram,Wardha - 442102 (First Cycle)',
  "Marathwada Mitra Mandal's Shankarrao Chavan Law College,202/A, Deccan Gymkhana,Pune - 411004 (First Cycle)",
  'Dr D Y Patil School of Management,Dr D Y Patil Knowledge City, Charholi (Bk.), Via Lohegaon,Pune - 412105 (First Cycle)',
  'RFNS, Senior Science College, Akkalkuwa,Akkalkuwa,Nandurbar - 425415 (First Cycle)',
  'Jawaharlal Darda Institute of Engineering and Technology,MIDC, Lohara, Yavatmal - 445001 (First Cycle)',
  "Sinhgad Technical Education Society's Smt. Kashibai Navale College of Pharmacy,S. NO. 40/4-A, Near Octroi Post, Kondhwa-Saswad Road, Kondhwa (Bk),Pune - 411048 (First Cycle)",
  'Suryadatta Institute of Management and Mass Communication (SIMMC),Saraswati, Survey No. 342, Off Pashan Chandani Chowk Road, Besides DSK Ranwara, Near Lalani Quantum, Bavdhan (BK),Pune - 411021 (First Cycle)',
  'Smt. Kishoritai Bhoyar College of Pharmacy,Behind Railway Station, New Kampree,Nagpur - 441002 (First Cycle)',
  "All India Shri Shivaji Memorial Society's College of Engineering,# 1, Kennedy Road,Pune - 411001 (First Cycle)",
  'Suryadatta College of Hospitality Management and Travel Tourism,Gayatri, Srv. No. 342, Patil Nagar, Near DSK Ranwara Society, Pashan Road, Bavdhan (bk),Pune - 411021 (First Cycle)',
  'Ardhanari Nateshwar Mahavidyalya,Post. Velapur Tal.Malshiras,Solapur - 413113 (First Cycle)',
  'Anuradha Engineering College, Chikhli,Anuradha Nagar, Sakegaon Road, Chikhli,Buldhana - 443201 (First Cycle)',
  'Genba Sopanrao Moze College of Engineering,Survey No. 25/1/3, Balewadi, Near Balewadi Stadium,Pune - 411045 (First Cycle)',
  'Dr. Rajendra Gode Institute of Technology and Research,University - Mardi Road ,Amravati - 444602 (First Cycle)',
  "ASPM'S K T Patil College of Pharmacy, Osmanabad,Siddharth Nagar, Barshi Road,Osmanabad - 413501 (First Cycle)",
  "Pravara Rural Education Society's Arts, Commerce and Science College,At-Satral,Post-Songaon,Tahsil-Rahuri,Ahmednagar - 413711 (Second Cycle)",
  "Anusaya Shikshan Prasarak Mandal's Swatantrya Sainik Suryabhanji Pawar College,Adarsh Colony, Purna ,Parbhani - 431511 (Second Cycle)",
  'SBB Alias Appasaheb Jedhe Arts, Commerce and Science College,425, Shukrawar Peth, Subhash Nagar,Pune-411002 (Second Cycle)',
  'Mahatma Gandhi Arts and Commerce College,Ramtek Road, Parseoni,Nagpur - 441105 (Second Cycle)',
  'Vidnyan Mahavidyalaya, Sangola,Near ST Stand, Wasud Road, Sangola,Solapur - 413307 (Third Cycle)',
  "Shri Swami Vivekanand Shikshan Sanstha, Kolhapur's, Lal Bahadur Shastri College of Arts, Science Commerce,17, Malhar Peth,Satara - 415002 (Third Cycle)",
  "Shikshan Prasarak Sanstha's Padmabhushan Vasantraodada Patil Mahavidyalaya,Kavathe Mahankal,Vidyanagar - 416405 (Third Cycle)",
  "Kasegoan Education Society's Smt. Kusumtai Rajarambapu Patil Kanya Mahavidyalaya,Near Shirala Naka,Islampur - 415409 (Third Cycle)",
  'Nemgonda Dada Patil Night College of Arts and Commerce,Rajnemi Campus, Wood House Road,Sangli - 416416 (Third Cycle)',
  "S. S. V. P Santha's Late S. D. Patil alias Baburao Dada Arts, Commerce and Late Bhausaheb M.D. Sisode Science College,Railway Station Road,Shindkheda - 425406 (Third Cycle)",
  "M.C.E. Society's Abeda Inamdar Senior College of Arts, Science and Commerce,2390-B, K. B. Hidayatullah Road, Azam Campus, New Modikhana Camp,Pune - 411001 (Third Cycle)",
  'Arts and Commerce College, Ashta,Dudhgaon Road, A/P-Ashta, Tal-Walwa,Sangli - 416301 (Third Cycle)',
  'Raje Ramrao Mahavidyalaya, Jath,Palace Road, Jath,Sangli - 416404 (Third Cycle)',
  'Chandmal Tarachand Bora College of Arts, Commerce and Science,Shirur Ghodnadi,Pune - 412210 (Third Cycle)',
  'Ramkrishna Paramhansa Mahavidyalaya,Tambri Vibhag,Osmanabad - 413501 (Third Cycle)',
  "Shri Swami Vivekanand Shikshan Sanstha, Kolhapur's Shikshanmaharshi Bapuji Salunkhe Mahavidyalaya,Somwar Peth, Pantacha Kot, Karad ,Satara - 415110 (Third Cycle)",
  'Dr. Ghali College, Gadhinglaj,Jagrutinagar, Bhadgoan Road,Gadhinglaj - 416502 (Third Cycle)',
  "The Poona Gujarati Kelvani Mandal's Haribhai. V. Desai College of Commerce, Arts & Science,Haribhai V. Desai College 596, Budhwar Peth,Pune - 411002 (Third Cycle)",
  "Yogeshwari Education Society's Swami Ramanand Teerth Mahavidyalaya,Parali Road,Ambajogai - 431517 (Third Cycle)",
  "Marathwada Mitra Mandal's College of Commerce,202/A, Deccan Gymkhana, Near Gokhale Institute of Politics and Economics, Next To BMCC,Pune - 411004 (Third Cycle)",
  'Shri Shiv-Shahu Mahavidyalaya, Sarud,A/P-Sarud, Tal-Shahuwadi,Kolhapur - 416214 (Third Cycle)',
  "Ahmednagar Jilha Maratha Vidya Prasarak Samaj's New Law College,Delhi Gate, Laltaki Road ,Ahmednagar - 414001 (Third Cycle)",
  "TSSM's Padmabhooshan Vasantdada Patil Institute of Technology,S. No. 33/22, Off Pirangut road, Near Chandani Chowk, opposite Athashree Project, Bavdhan (Khurd),Pune - 411021 (First Cycle)",
  'Shri Ram College of Commerce,Datta Mandir Road, Bhandup (W) ,Mumbai - 400078 (First Cycle)',
  'Sandip Institute of Engineering and Management,Mahiravani, Trimbak Road,Nashik - 422213 (First Cycle)',
  'Mahila Kala Mahavidyalaya, Umred, Nagpur,Mangalwari Peth, Umred,Nagpur - 441203 (First Cycle)',
  'Sandip Institute of Pharmaceutical Sciences,Mahiravani, Trimbak Road,Nashik - 422213 (First Cycle)',
  "JSPM's Bhivarabai Sawant Institute of Technology and Research,Gat No 720 ( 1 and 2) Pune Nagar Road, Wagholi, Tal Haveli,Pune - 412207 (First Cycle)",
  "Bharati Vidyapeeth's College of Engineering, Lavale, Pune,Lavale, Tal Mulshi ,Pune - 412115 (First Cycle)",
  "All India Shri Shivaji Memorial Society's College of Pharmacy, Pune,Kennedy Road, Near RTO,Pune - 411001 (First Cycle)",
  "Dhamangaon Education Society's College of Engineering and Technology,Knowledge Hub, Anjanshing Road,Dhamangaon - 444709 (First Cycle)",
  'Amrutvahini Institute of Management and Business Administration,Amrtunagar, Post-Sangamner,Ahmednagar - 422608 (First Cycle) ',
  'G.H.R. Educational Foundation Society’s G. H. Raisoni Institute of Business Management, Jalgaon (Re-assessment),Gat No. 57/1 , Shirsoli Road, At post Mohadi,Jalgaon - 425002 (First Cycle)',
  'Sameer Gandhi Kala Mahavidyalaya, Malshiras,Piliv Road, Malshiras, Tal. Malshiras,Solapur - 413107 (First Cycle)',
  'Zulekha College of Commerce, Science and Technology ,Plot No.38/39 Main Road, Shantinagar,Nagpur - 440002 (First Cycle)',
  'Pratapsinh Mohite-Patil Mahavidyalaya ,Near Giridhardas Devi High School, Pune Road, Karmala,Solapur - 413203 (First Cycle)',
  'SIES College of Management Studies,Sri. Chandrasekarendra Saraswati Vidyapuram, Plot 1E, Sector 5, Nerul ,Navi Mumbai - 400706 (First Cycle)',
  "Abhinav Shetkari Shikshan Mandal's Abhinav College of Commerce, Arts and Science,Abhinav Degree College, Abhinav Education Complex, Goddeo, Bhayander East,Thane - 401105 (First Cycle)",
  'Sinhgad Institute of Business Administration and Computer Application,Gat No- 309/310, Kusgaon (BK), Off- Mumbai-Pune Expressway,Lonavala - 410401 (First Cycle)',
  'Lokmangal Science and Entrepreneurship College,Wadala, Tal- North Solapur,Solapur - 413222 (First Cycle)',
  "Sinhgad Technical Educational Society's Sinhgad Institute of Management,S. No. 44/1, Vadgaon (Bk), Off Sinhgad Road,Pune - 411041 (First Cycle)",
  'Mahatma Phule Mahavidyalaya, Kingaon,Kingaon, Ahmedpur,Latur - 413523 (First Cycle)',
  'Yashoda Technical Campus, Satara ,S. No. 242/1, NH-4, Near Vanaz LPG Pump, Wadhe Phata,Satara - 415011 (First Cycle)',
  'Neville Wadia Institute of Management Studies and Research,Prin. V.K. Joag Path, Wadia College Campus,Pune - 411001 (First Cycle)',
  'S.K.N. Sinhgad School of Business Management,S.No. 10/1, Ambegaon Bk.,Pune - 411041 (First Cycle)',
  'Dr. L.D. Balkhande College of Arts and Commerce,Khapri Road, Pauni,Bhandara - 441910 (First Cycle)',
  'Sinhgad Institute of Business Administration and Research,S. No. 40/4A - 4B/1, Near PMC Octroi Post, Kondhwa-Saswad Road, Kondhwa(Bk),Pune - 411048 (First Cycle)',
  'Cummins College of Engineering for Women,Mouja Sukali (Gupchup), Hingna,Nagpur - 441110 (First Cycle)',
  'Bapumiya Sirajoddin Patel Arts, Commerce & Science College,B.S.Patel College Campus, Kurha Road, Pimpalgaon Kale Tq. Jalgaon Jamod,Buldana - 443403 (First Cycle)',
  'Arts and Commerce College, Bhisi,Bhisi, Chimur,Chandrapur - 442903 (First Cycle)',
  'Sinhgad Institute of Management and Computer Application,S No 49/2, Near Navale Hospital, Narhe,Pune - 411041 (First Cycle)',
  'Pankaj Laddhad Institute of Technology and Management Studies,Chikhli Road, Yelgaon,Buldhana-443002 (First Cycle)',
  "STE's Sinhgad College of Architecture,S.No 44/1, Vadgaon (Bk) ,Off Sinhgad Road,Pune - 411041 (First Cycle)",
  'G. H. Raisoni School of Business Management, Nagpur (Re-assessment),Khasara No. 50, Plot No. 1, Near CRPF Gate No. 3, Madhav Nagari,Nagpur - 440016 (First Cycle)',
  "Khandesh College Education Society's Institute of Management and Research,IMR Campus, Behind DIC , NH-6,Jalgaon - 425001 (First Cycle)",
  'Brahmdevdada Mane Institute of Technology,Gat.No 136, Solapur-Mangalwedha-Kolhapur State Highway, A/P-Belati,North Solapur - 413002 (First Cycle)',
  'Alamuri Ratnamala Institute of Engineering and Technology,A.S.Rao Nagar, Village- Sapgaon, Taluka- Shahapur,Thane - 421601 (First Cycle)',
  'Kavikulguru Institute of Technology and Science,K. K. Nagar, Mouda Road, Ramtek,Nagpur - 441106 (First Cycle)',
  'Anjuman College of Engineering and Technology,Mangalwari Bazaar Road, Sadar,Nagpur - 440001 (First Cycle)',
  'Jhulelal Institute of Technology,Khasra number 68/1,2,3,72, Off Koradi Road, Lonara,Nagpur - 441111 (First Cycle)',
  'Pratibha Institute of Business Management,Block D-III, Plot No. 3, Behind Mehta Hospital, Chinchwad,Pune - 411019 (First Cycle)',
  "Zeal Education Society's Zeal Institute of Business Administration, Computer Application and Research,S. No. 39, Behind Bhairavnath Temple, Narhe - Dhayari Road Narhe gaon Tal- Haveli,Pune - 411041 (First Cycle)",
  'K. D. K. College of Engineering, Nagpur,Great Nag Road, Nandanvan,Nagpur - 440009 (First Cycle)',
  'S. G. V. & S. S. P. Arts, Commerce and Science College,Onde, Tal. Vikramgad,Palghar - 401605 (First Cycle)',
  'Siddhant College of Pharmacy,Talegaon-Chakan Road,Sudumbare Taluka-Maval,Pune - 412109 (First Cycle)',
  'Institute of Business Management and Research, Chakan,IBMR Chakan, 94/1B, Near Chakreshwar Temple, Chakreshwar Nagar, Chakan, Taluka Khed,Pune - 410501 (First Cycle)',
  'Sandip Institute of Technology and Research Centre,Mahiravani, Trimbak Road,Nashik - 422213 (First Cycle)',
  'Universal College of Engineering,Kaman Bhiwandi Road, Kaman, Vasai East,Palghar - 401212 (First Cycle)',
  "Phaltan Education Society's College of Engineering,Sr. No. 31 Ap Thakurki,Tal Phaltan,Satara - 415523 (First Cycle)",
  'Suman Ramesh Tulsiani Technical Campus-Faculty of Engineering,Gat N0. 81,82,91,92,94,97,99,101,102 and 106 (Part), Mauje Khamshet, Maval,Pune - 410405 (First Cycle)',
  "Kalaprabodhini's Institute of Design,253 Kh, Bhalji Pendharkar Cultural Centre, Behind Mahaveer Garden, Nagala Park,Kolhapur - 416001 (First Cycle)",
  'Fabtech Technical Campus, College of Engineering and Research,Pandharpur Road, Gat No 565/1, Sangola,Solapur - 413307 (First Cycle)',
  'Sinhgad Business School,Erandwane 19/15 Smt Khilare Marg Off Karve Road,Pune - 411004 (First Cycle)',
  'Mahant Jamanadas Maharaj Arts, Commerce and Science College,Karanjali, Tal.- Peth,Nashik - 422208 (First Cycle)',
  'G.H. Raisoni College of Engineering and Management, Ahmednagar (Re-assessment),Gat No. 1030, At. Post. Chas, Tal. Nagar,Ahmednagar - 414005 (First Cycle)',
  'Sinhgad Technical Education Societys Sinhgad College of Pharmacy,S. No. 44/1, Vadgaon (Budruk) Off. Sinhgad Road,Pune - 411041 (First Cycle)',
  'Shri Omkarnath Malpani Law College, Sangamner,Pune Nashik Highway, Ghulewadi, Sangamner,Ahmednagar - 422605 (First Cycle)',
  'G. H. Raisoni Institute of Information Technology, Nagpur (Re-assessment),B-37-39/1 Shradha Park, Hariganga Campus, MIDC, Hingna wadi Link Road,Nagpur - 440028 (First Cycle)',
  'Sudhakarrao Naik Institute of Pharmacy,Nagpur Road, Pusad,Yavatmal - 445204 (First Cycle)',
  'Shivajirao S. Jondhle College of Engineering & Technology,Opp. Asangaon Railway station, Asangaon, Tal. Shahapur,Thane - 421601 (First Cycle)',
  "Bharati Vidyapeeth's College of Engineering for Women,Pune-Satara Road, Dhankawadi, Taluka- Haveli,Pune - 411043 (First Cycle)",
  'Rajiv Gandhi College of Engineering, Research and Technology,Ballarpur Road, Babupeth,Chandrapur - 442403 (First Cycle)',
  'Sadhu Vaswani Institute of Management Studies for Girls,# 6, Koregaon Road ,Pune - 411001 (First Cycle)',
  "Bansilal Ramnath Agarwal Charitable Trust's Vishwakarma Institute of Technology,S.No. 666, Upper Indira Nagar, Bibwewadi,Pune - 411037 (Second Cycle)",
  'Acharya Atre Development Trust College of Arts,Chinchbaug, Kadepathar Road,Jejuri - 412303 (Second Cycle)',
  'Godavari Shikshan Prasarak Mandal, B. Raghunath Arts, Commerce & Science College,Boralkar Nagar,Jintur Road,Parbhani - 431401 (Second Cycle)',
  'Lokmanya Tilak Mahavidyalaya,Warora Road, Wani ,Yavatmal - 445304 (Second Cycle)',
  'Swami Ramanand Shikshan Prasarak Mandal’s Sant Ramdas Arts, Commerce and Science College,Kumbhar, Pimpalgaon Road, Ghansawangi,Jalna - 431209 (Second Cycle)',
  "Marathwada Shikshan Prasarak Mandal's Shivchhatrapati College,CIDCO, N-3,Aurangabad - 431003 (Second Cycle)",
  'St. Vincent College of Commerce,2004 St.Vincent Street, Camp ,Pune - 411001 (Second Cycle)',
  'Arts, Commerce and Science College, Palus,Vidyanagar, Tasgaon-Karad Road, Palus,Sangli - 416310 (Third Cycle)',
  "Shikshan Mandal's Mahila Mahavidyalaya,Mangalwar Peth, Karad,Satara - 415110 (Third Cycle)",
  'Dayanand Arya Kanya Mahavidyalaya,Beside Janta Hospital, Jaripatka,Nagpur - 440014 (Third Cycle)',
  "Vidya Pratishthan's Arts, Science and Commerce College,Vidyanagari, Baramati,Pune - 413133 (Third Cycle)",
  'Smt. Vatsalabai Naik Mahila Mahavidyalaya,Near LIC Office, Talao Layout,Pusad - 445204 (Third Cycle)',
  "Sahajeevan Shikshan Sanstha's Shrimati Indira Mahadev Beharay College of Arts Shriman Chandulal Sheth College of Commerce and Shrimati Shobhanatai Chandulal Sheth College of Science,Khed ,Ratnagiri - 415709 (Third Cycle)",
  'Sou. Suvarnalata Gandhi Mahavidyalaya,Barshi Road, AT Post Vairag, Tal Barshi,Solapur - 413402  (Third Cycle)',
  "Rayat Shikshan Sansta's Sou. Mangaltai Ramchandra Jagatap Mahila Mahavidyalaya,Umbraj, Tal. Karad,Satara - 415109 (Third Cycle)",
  'D.G.B. Dayanand Law College,Raviwar peth, Dayanand Nagar,Solapur - 413002 (Third Cycle)',
  'Navgan Shikshan Sanstha Rajuri (N) Mrs. Kesharbai Sonajirao Kshirsagar Alias Kaku Arts, Science and Commerce College,Shivaji Nagar,Beed - 431122 (Third Cycle)',
  'Phulsing Naik Mahavidyalaya, Pusad,Pusad,Yavatmal - 445216 (Third Cycle)',
  "Poona District Education Association's Baburaoji Gholap College,Sangvi,Pune - 411027 (Third Cycle)",
  'J. M. Patel Arts, Commerce and Science College,Rajgopalachari Ward, Civil Lines,Bhandra - 441904 (Third Cycle)',
  "Shri Nagpur Gujarati Mandal's Vrajlal Manilal Vasant Commerce, Jaydeoshankar Manishankar Thakar Arts and Jashbhai Jijibhai Patel Science College,Wardhaman Nagar, Central Avenue,Nagpur - 440008 (Third Cycle)",
  'Samarth Group of Institutions ,Samarth Group of Institutions College of Engineering and Faculty of Management, On Nagar-Kalyan highway NH-61, At Post. Belhe, Tal. Junnar,Pune - 412410 (First Cycle)',
  "MET's Institute of Management,MET League of Colleges, Bhujbal Knowledge City, Adgaon,Nashik - 422003 (First Cycle)",
  'R M Dhariwal Sinhgad Management School,Gat no-37/1, 37/2,A/P-Kondhapuri, Tehsil- Shirur ,Pune - 412208 (First Cycle)',
  'Nivrutti Babaji Navale College of Commerce and Science,Gat No 309/310 Kushgaon Bk, Lonavala- Taluka Maval,Pune - 410401 (First Cycle)',
  'Guru Nanak Institute of Technology, Nagpur ,(Formerly known as Guru Nanak Institute of Engineering and Management) Khasara No. 95, Mouza Dahegaon, Kalmeshwar Road ,Nagpur - 441501 (First Cycle)',
  'Sharadchandra Pawar College of Engineering,At-Dumbarwadi, Po-Khamundi, Tal-Junnar,Pune - 410504 (First Cycle)',
  'Government College of Engineering, Jalgaon,National Highway No. 9,Jalgaon - 425002 (First Cycle)',
  'S N D College of Pharmacy,Babhulgaon, Tal.Yeola,Nashik - 423401 (First Cycle)',
  'Wainganga College of Engineering and Management,Dongargaon, Near Gumgaon Railway Station, Wardha Road ,Nagpur - 441114 (First Cycle)',
  "Kalyani Charitable Trust's Late Gambhirrao Natuba Sapkal College of Engineering,Sapkal Knowledge Hub, Kalyani Hills, Anjaneri, Tal. Trimbakeshwar,Nashik - 422213 (First Cycle)",
  'Walchand Institute of Technology, Solapur,P.B.No. 634, Seth Walchand Hirachand Marg, Ashok Chowk,Solapur - 413006 (First Cycle)',
  'Hi-Tech Institute of Technology,P-119, Bajajnagar, MIDC Waluj,Aurangabad - 431136 (First Cycle)',
  'Godavari College of Engineering, Jalgaon,M-Sector, P-51, Additional MIDC Area, Bhusawal Road, NH-6,Jalgaon - 425003 (First Cycle)',
  'College of Computer Sciences,Survey No.130,Near Bhumkar Chowk, Mumbai-Bangalore Highway, Wakad,Pune - 411057 (First Cycle)',
  'G.H.RAISONI INSTITUTE OF MANAGEMENT AND RESEARCH,BABUBHAI COLONY, NEAR PRINCE LAWN, CHICHOLI, KHAPERKHEDA, NAGPUR,Nagpur - 441102 (First Cycle)',
  'Abasaheb Parvekar Mahavidyalay, Yavatmal,Near Power House, Pandharkawda Road,Yavatmal - 445001 (Second Cycle)',
  'JAGADAMBHA COLLEGE OF ENGINEERING AND TECHNOLOGY, YAVATMAL,Survey No. 167/1, 167/2 ,163, Arni Road, Kinhi, Yavatmal,YAVATMAL , 445001 (First Cycle)',
  'BABASAHEB NAIK COLLEGE OF ENGINEERING,Karla Road Kakad Dati Tq. Pusad Dist. Yavatmal,Pusad , 445215 (First Cycle)',
  'DAGDOJIRAO DESHMUKH ARTS, COMMERCE AND SCIENCE COLLEGE,More Chowk, Bajaj Nagar, Waluj, Tq. Gangapur, Dist. Aurangabad.,Aurangabad , 431136 (First Cycle)',
  'DON BOSCO INSTITUTE OF TECHNOLOGY,Premier Automobiles Road, Kurla (west) - Mumbai - 400070, Mumbai , 400070 (First Cycle)',
  'FINOLEX ACADEMY OF MANAGEMENT AND TECHNOLOGY, Ratnagiri , 415639 , P-60, P-60/1, MIDC, Mirjole Block,Ratnagiri , 415639 (First Cycle)',
  'D. M. College of Arts, Imphal – 795001 (Second Cycle)',
  'D. M. College of Teacher Education, Imphal – 795001 (First Cycle)',
  'Don Bosco College, Imphal – 795105 (Second Cycle)',
  'G. P. Government Women’s College, Imphal West – 795001 (Second Cycle)',
  'Government Khawzawl College, Khawzawl, Zuchhip Veng, Champhai – 796310 (First Cycle)',
  'Liberal College, Luwangsangbam, Imphal – 795002 (First Cycle)',
  'Nambol L. Sanoi College, Nambol – 795134 (First Cycle)',
  'R.K. Sanatombi Devi College of Education, Asha Jina Complex, Imphal, 795001 (Second Cycle)',
  'Thoubal College, Wangmataba, Thoubal – 795138 (First Cycle)',
  "Waikhom Mani Girls' College, Thoubal – 795138 (First Cycle)",
  'Kakching Khunou College, Thoubal – 795103 (First Cycle)',
  'Kha Manipur College, Wairi Panjao Pallum, Kakching – 795103 (First Cycle)',
  'Oriental College, Takyel, Imphal – 795001 (Second Cycle)',
  'South East Manipur College, Imphal – 795135 (First Cycle)',
  'Standard College, Imphal (East) – 795008 (First Cycle)',
  'Thambal Marik College, Imphal – 795134 (First Cycle)',
  'Imphal College, Kwakeithel Lamdong, Imphal – 795001 (Second Cycle)',
  "IDEAL GIRLS' COLLEGE,AKAMPAT,Akampat, Imphal East, Manipur, Imphal East , 795001 (First Cycle)",
  'THE MAHARAJA BODHCHANDRA COLLEGE,Palace Compound, Imphal East,Imphal , 795001 (Second Cycle)',
  'DM COLLEGE OF COMMERCE,Imphal West, Manipur,Imphal West , 795001 (First Cycle)',
  'College of Teacher Education (PGT), Laitumkhrah, Shillong, 793003 (First Cycle)',
  'Jaintia Eastern College, Khliehriat – 793200 (First Cycle)',
  'Nongstoin College, Nongstoin – 793119 (First Cycle)',
  'Sankardev College, Shillong – 793004 (Second Cycle)',
  'Shillong College, Shillong – 793003 (Third Cycle)',
  'Sngap Syiem College, Mawkyrwat – 793114 (First Cycle)',
  'St. Anthony’s College, Shillong, Meghalaya (Third Cycle)',
  "St. Mary's College, Shillong – 793003 (Third Cycle)",
  'Nongtalang College, West Jaintia Hills, Nongtalang – 793109 (First Cycle)',
  'Shillong Commerce College, Laitumkhrah, Shillong – 793003 (First Cycle)',
  'Thomas Jones Synod College (First Cycle)',
  'Mendipathar College,North Garo Hills,Mendipathar - 794112 (First Cycle)',
  "ST. EDMUND'S COLLEGE,OWAI ROAD, NH 44 LAITUMKHRAH,SHILLONG , 793003 (Third Cycle)",
  "WOMEN'S COLLEGE, UPPER NEW COLONY LAITUMKHRAH, SHILLONG,Meghalaya,793003",
  'Government Hnahthial College, Hnahthial, Lunglei – 796571(Second Cycle)',
  'Government J. Buana College, Lunglei – 796701 (Second Cycle)',
  'Government Zirtiri Residential Science College, Aizawl – 796007 (Second Cycle)',
  'Institute of Advanced Study in Education, Aizawl – 796001 (First Cycle)',
  'Government Aizawl College, Aizawl – 796001 (Third Cycle)',
  'Government Champai College, Champai – 796321 (Second Cycle)',
  'Government Mamit College, Mamit – 796441 (First Cycle)',
  'Government Serchhip College, Serchhip – 796181 (Second Cycle)',
  'Government Zawlnuam College, Vengpui, Mamit, Zawlnuam – 796471 (First Cycle)',
  'J. Thankima College, Aizawl – 796014 (Second Cycle)',
  'Lunglei Government College, Lunglei – 796701 (Second Cycle)',
  'Pachhunga University College, Aizawl – 796001 (Second Cycle)',
  'Government Aizawl West College, Dawrpui Vengthar, Aizawl – 796001 (Third Cycle)',
  'Synod College, Jaiaw Lumdiengiri, Shillong – 793002 (Third Cycle)',
  'Government Hrangbana College,,Aizawl - 796007 (Third Cycle)',
  'GOVT. MIZORAM LAW COLLEGE,Luangmual, Aizawl, Mizoram,Aizawl , 796009 (First Cycle)',
  'GOVT. AIZAWL NORTH COLLEGE,Ramhlun North, Aizawl, Mizoram. 796012,Aizawl , 796012 (Second Cycle)',
  'GOVT. KOLASIB COLLEGE,College Veng, Kolasib, Mizoram,Kolasib,Mizoram,796081 (Second Cycle)',
  'Alder College, Kohima – 797001 (First Cycle)',
  'Dimapur Government College, Dimapur – 797112 (First Cycle)',
  'Fazl Ali College, Mokokchung – 798601 (Second Cycle)',
  'Kros College, Kohima – 797001 (First Cycle)',
  'Modern College, Dzuvurii, Kohima – 797001 (First Cycle)',
  'Patkai Christian College, Dimapur – 797103 (Third Cycle)',
  'Unity College, Dimapur, 797112 (First Cycle)',
  'C-Edge College, Naga United Village, Dimapur – 797112 (First Cycle)',
  'Immanuel College, Dimapur – 797112 (First Cycle)',
  'Kohima College, Kruoliezou, Kohima – 797003 (Second Cycle)',
  'Kohima Science College, Jotsoma, Kohima – 797002 (Second Cycle)',
  'Model Christian College, Lower A. G. Colony, Kohima – 797001 (First Cycle)',
  'Mount Olive College, Kohima – 797001 (First Cycle)',
  'Pranabananda Women College, Dimapur – 797112 (First Cycle)',
  'Sakus Mission College, Dimapur – 797112 (First Cycle)',
  'Sazolie College, Phezhu, Jotsoma, Kohima – 797002 (First Cycle)',
  "St. Joseph's College, Kohima – 797001 (Third Cycle)",
  'St John College (First Cycle)',
  'Japfu Christian College (Second Cycle)',
  'Mount Tiyi College,,Wokha - 797111 (First Cycle)',
  'PHEK GOVERNMENT COLLEGE,Phek , 797108,Phek , 797108 (First Cycle)',
  "S. D. JAIN GIRLS' COLLEGE,Jain Temple Road,DIMAPUR , 797112 (First Cycle)",
  'TETSO COLLEGE, C/O TETSO COLLEGE 6th Mile SOVIMA VILLAGE,DIMAPUR , 797115 (Second Cycle)',
  'PUBLIC COLLEGE OF COMMERCE,Public College of Commerce Near Nagaland Fire Service Station Burma Camp Road,Dimapur,Nagaland,797112 (Second Cycle)',
  'PFUTSERO GOVERNMENT COLLEGE,C/O PRINCIPAL, PFUTSERO GOVERNMENT COLLEGE,PFUTSERO,Nagaland,797107 (First Cycle)',
  'ZISAJI PRESIDENCY COLLEGE, KIPHIRE NAGALAND, 798611 (First Cycle)',
  'Adikavi Saraladas College, Jagatsinghpur, 754137 (Second Cycle)',
  'Anandapur College, Dist. Keonjhar, Anandapur – 758021 (Second Cycle)',
  'Anchalika Snatak Mahavidyalaya, Dist. Mayurbhanj, 757102 (First Cycle)',
  'AUL College, Kendrapara – 754219 (Second Cycle)',
  'Baba Bhairabananda Mahavidyalaya, Dist. Jajpur, 755044 (Second Cycle)',
  'Brahmanjharilo Mahavidyalaya, Dist. Cuttack, 754001 (First Cycle)',
  'Brajrajnagar College, Dist. Jharsuguda, 768216 (Second Cycle)',
  'Chandra Sekhar College, Dist. Kendujhar, 758041 (First Cycle)',
  'Choudwar College, Cuttack, 754071 (Second Cycle)',
  'College of Engineering, Chandrasekharpur, Bhubaneswar – 751004 (First Cycle)',
  'Dharmasala Mahavidyalaya, Jajpur, 755008 (Second Cycle)',
  'Ekamra College, Dist. Khurda, 751002 (Second Cycle)',
  'Gandhi Engineering College, P.O. Madanpur, Dist. Khordha, Bhubaneswar – 752054 (First Cycle)',
  'Gandhi Institute for Technological Advancement (GITA), Dist. Khurda, 752054 (First Cycle)',
  'Gandhi Institute for Technology, Khorda, Bhubaneswar – 752054 (First Cycle)',
  'Gandhi Institute of Engineering And Technology, Rayagada Dist, 765022 (Second Cycle)',
  'Gangadhar Meher College (Autonomous), Dist. Sambalpur, 768004 (Second Cycle)',
  'Gopal Krishna College of Engineering and Technology, Dist. Koraput, 764005 (First Cycle)',
  'Government College, Koraput – 764021 (Second Cycle)',
  "Government Women's College, Baripada – 757001 (Second Cycle)",
  'Gunupur College, Rayagada, Gunupur – 765022 (Second Cycle)',
  'Hindol College, Dist. Dhenkana, 759020 (First Cycle)',
  'ISPAT Autonomous College, Sector – 16, Rourkela, 769003 (Second Cycle)',
  'Kamakhyanagar College, Dist. Dhenkanal, 759018 (Second Cycle)',
  'Kanpur Anchalika Mahavidyalaya, Dist. Cuttack, 754037 (First Cycle)',
  'Karanjia College, Karanjia, Mayurbhanj – 757037 (Second Cycle)',
  'Khallikote Autonomous College, Berhampur – 760001 (Second Cycle)',
  'Khariar (Autonomous) College, Dist. Nuapada, 766107 (Second Cycle)',
  'Kunja Bihari College, Barang, Dist. Khurda, Bhubaneswar – 754005 (First Cycle)',
  "Kuntala Kumari Sabat Women's College, Dist. Balasore, 756003 (Second Cycle)",
  'Luipa Degree Mahavidyalaya, Dist. Mayurbhanj, 757101 (First Cycle)',
  'Mahapurus Achyutananda Mahavidyalaya, Dist. Cuttack, 754293 (First Cycle)',
  'Maharishi College of Natural Law, Bhubaneswar, 751007 (First Cycle)',
  'Nachuni Mahavidyalaya, Nachuni, Khordha, Bhubaneswar – 752028 (Second Cycle)',
  'Niali College, Niali, Cuttack, 754004 (First Cycle)',
  'Orissa Engineering College, Bhubaneswar, 752050 (First Cycle)',
  'Panchayat College, Dist. Kalahandi, 766015 (First Cycle)',
  'People’s College, Ganjam, 761143 (First Cycle)',
  'Prasanna Purusottam Dev Mohavidyalaya, Tigiria, Cuttack – 754030 (First Cycle)',
  'R.D.S. Degree Mahavidyalaya, Dist. Mayurbhanj, 757087 (First Cycle)',
  'Rama Chandra Mardharaj Science College, Khallikote – 761030 (Second Cycle)',
  "Rama Devi Women's Autonomous College, Bhubaneswar, 751022 (Second Cycle)",
  'Rayagada Autonomous College, Rayagada, 765001 (Second Cycle)',
  'Rukmini Devi Chilika Mahavidyalaya, Puri – 752011 (First Cycle)',
  'S. S. J. Mohavidyalaya, Krushnachandrapur, Jagatsinghpur, Ersama – 754138 (First Cycle)',
  'Shri Krushna Chandra Gajapati Autonomous College, Dist. Gajapati, 761200 (Second Cycle)',
  'Tara Tarini College, Purushottampur, Ganjam, Brahmapur – 761018 (First Cycle)',
  'Tentulia Sasan Debasthan College, Baragam, Ganjam – 761120 (First Cycle)',
  'Vikram Deb (Autonomous) College, Koraput, Jeypur – 764001 (Second Cycle)',
  'Agarpara College, Bhadrak – 756115 (Second Cycle)',
  'Ajay Binay Institute of Technology, Cuttack – 753014 (First Cycle)',
  'Anchal College, Rajborasambar, Bargarh – 768036 (Second Cycle)',
  'Aryan Institute of Engineering and Technology, Bhubaneswar – 752050 (First Cycle)',
  'Aska Science College, Nuagam, Asika, Ganjam – 761111 (Second Cycle)',
  'Atal Behari College, Basudevpur, Bhadrak – 756125 (Second Cycle)',
  'B. J. B. Autonomous College, Bhubaneswar – 751014 (Second Cycle)',
  'Barasahi P. S. College, Barasahi, Mayurbhanj, Baripada – 757026 (Second Cycle)',
  'Baripada College, Mayurbhanj, Baripada – 757002 (Second Cycle)',
  'Baruneswar Mohavidyalaya, Lenkasahi, Arei, Jajpur – 755027 (Second Cycle)',
  'Berhampur City College, Ambapua, Berhampur – 760010 (First Cycle)',
  'Betnoti College, Mayurbhanj, Baripada – 757025 (Second Cycle)',
  'Bhadrak Autonomous College, Bhadrak – 756100 (Second Cycle)',
  'Bhima Bhoi College, Rairakhol, Sambalpur – 768106 (Second Cycle)',
  'Bijepur Degree College, Bijepur, Bargarh – 768032 (First Cycle)',
  'Biju Pattanaik College, Kendrapara – 754162 (First Cycle)',
  'Binayak Acharya College, Haridakhandi, Brahmapur – 760006 (Second Cycle)',
  'Biranchi Narayana Madhaba Arjuna College, Paliabindha, Bhadrak – 756167 (First Cycle)',
  'Chitalo Mohavidyalaya, Chitalo, Jajapur – 755062 (First Cycle)',
  'College of Basic Science and Humanities, Bhubaneswar – 751003 (First Cycle)',
  'College of Engineering and Technology, Ghatikia, Bhubaneswar – 751003 (First Cycle)',
  'College of IT and Management Education, Bhubaneswar – 751010 (First Cycle)',
  'D. A. V. Autonomous College, Bhatipara, Titlagarh – 767042 (Second Cycle)',
  'Dadhi Baman College, Bhatli, Bargarh – 768030 (First Cycle)',
  'Dalmia College, Sundargarh, Rajagangapur – 770070 (Second Cycle)',
  'Dayavihar Degree College, Dayavihar, Gadasahi, Kanasa, Puri – 752017 (First Cycle)',
  'Deogarh College, Puranagarh, Deogarh – 768119 (Second Cycle)',
  'Dharanidhar Autonomous College, Kendujhar – 758001 (Second Cycle)',
  'Dhenkanal Autonomous College, Dhenkanal – 759001 (Second Cycle)',
  'Dhenkanal Mahila Mahavidyalaya, Deulasahi, Dhenkanal – 759001 (Second Cycle)',
  'Dinakrushna College, Dhansimulia, Jaleswar, Balasore – 756084 (Second Cycle)',
  'Dr. Jadunath College, Rasalpur, Balasore – 756021 (Second Cycle)',
  'Dunguripali College, Dunguripali, Sonepur – 767023 (First Cycle)',
  'Ghanteswar Degree College, Ghanteswar, Bansada, Bhadrak – 756129 (First Cycle)',
  'Ghess College, Ghess, Bargarh – 768034 (First Cycle)',
  'Gopabandhu Choudhury College, Ramachandrapur, Jajpur – 755003 (Second Cycle)',
  'Government Autonomous College, Kalahandi, Bhawanpatna – 766001 (Second Cycle)',
  'Government College (Autonomous), Hakimpada, Angul – 759143 (Second Cycle)',
  'Government College, Rangadhipa, Sundargarh – 770002 (Second Cycle)',
  'Government Science College, Chatrapur, Ganjam – 761020 (Second Cycle)',
  'Government Women’s College, Puri – 752002 (Second Cycle)',
  'Janata College, Kishoreganj, Boinda, Angul – 759127 (Second Cycle)',
  'Jatiya Kabi Bira Kishore Government College, Cuttack – 753003 (Second Cycle)',
  'Jawaharlal College, Patnagarh, Bolangir – 767025 (Second Cycle)',
  'Jawaharlal Nehru College, Kuanpal, Cuttack – 725204 (Second Cycle)',
  'Jiral College, Jiral, Dhenkanal – 759023 (Second Cycle)',
  'Kandarpur College, Siddheswarpur, Cuttack – 754100 (Second Cycle)',
  'Kaptipada College, Kaptipada, Mayurbhanj - 757040 (First Cycle)',
  'Kendrapara Autonomous College, Kendrapara – 754211 (Second Cycle)',
  'Khaira College, Balasore, Bhubaneswar – 756048 (Second Cycle)',
  'Kharasrota Mahavidyalaya, Singhpur, Jajpur – 755016 (Second Cycle)',
  'Kishore Nagar College, Kishore Nagar, Cuttack – 754131 (Second Cycle)',
  'Kshetramohan Science College, Narendrapur, Chamakhandi, Ganjam, Brahmapur – 760007 (First Cycle)',
  'Kuchinda College, Kuchinda, Sambalpur – 768222 (Second Cycle)',
  'Lakshmi Narayan Sahu Mahavidyalaya, Jagatpur, Cuttack – 754021 (Second Cycle)',
  'Larambha College, Larambha, Bargarh – 768102 (Second Cycle)',
  'Laxmi Narayan Mahavidyalaya, Jamsuli, Balasore, Baleshwar -756081 (Second Cycle)',
  'Lokanath Mohavidyalaya, Kendrapara – 754134 (First Cycle)',
  'Mahanga Women’s College, Pallisahi, Sungra, Cuttack – 754221 (First Cycle)',
  'Mahapurusha Hadidas Mahavidyalaya, Chhatia, Jajpur – 754023 (Second Cycle)',
  'Maharaja Purna Chandra (Autonomous) College, Takhatpur, Mayurbhanj, Baripada – 757003 (Third Cycle)',
  'Mahatma Gandhi Degree College, Bhukta, Bargarh – 768045 (First Cycle)',
  'Mahima Mahavidyalaya, Bhubaneswar – 759014 (Second Cycle)',
  'Malkangiri College, Malkangiri – 764048 (First Cycle)',
  'Malyagiri Mahavidyalaya, Pallahara, Angul – 759119 (Second Cycle)',
  'Mangala Mahavidyalaya, Kakatpur, Puri – 752108 (First Cycle)',
  'Marshaghai College, Marshaghai, Kendrapara – 754213 (Second Cycle)',
  'Mathakaragola Degree College, Mathakaragola, Dhenkanal, Bhuban – 759024 (First Cycle)',
  'Meghasan College, Nudadiha, Baripada - 757077 (Second Cycle)',
  'Mohan Subudhi College, Baramba, Cuttack – 754031 (Second Cycle)',
  'Motto + 3 Degree College, Motto, Bhadrak – 756132 (First Cycle)',
  'Municipal College, Rourkela – 769012 (Second Cycle)',
  'Narasinghpur College, Narasinghpur, Cuttack – 754032 (Second Cycle)',
  'Nayagarh Prajamandal Mahila Mahavidyalaya, Nayagarh – 752069 (First Cycle)',
  'Neelashaila Mahavidyalaya, Rourkela – 769042 (Second Cycle)',
  'Nilgiri College, Balasore, Baleshwar – 756040 (Second Cycle)',
  'Odapada Panchayat Samiti Mohavidyalaya, Dhenkanal – 759019 (Second Cycle)',
  'Olaver College, Kendrapara – 754227 (Second Cycle)',
  'P. S. College, Suliapada, Mayurbhanj, Baripada – 757022 (First Cycle)',
  'Panchayat College, Bargarh – 768028 (Second Cycle)',
  'Panchayat Degree College, Kantamal, Boudh – 762017 (First Cycle)',
  'Panchayat Prahallad College, Nischintakoili, Cuttack – 754207 (Second Cycle)',
  'Paradip College, Paradip Port, Jagatsinghpur – 754142 (Second Cycle)',
  'Parala Maharaja Engineering College, Sitalapalli, Tanganapalli, Berhampur – 761003 (First Cycle)',
  'Parala Maharaja Engineering College, Sitalapalli, Tanganapalli, Berhampur – 761003 (First Cycle)',
  'Pathani Samanta College, Baigunia, Khandapara, Fategarh, Nayagarh, Khordha – 752077 (First Cycle)',
  'Pipli College, Jaypurkillah, Pipli, Bhubaneswar – 752104 (First Cycle)',
  'Prananath College, Khordha – 752057 (Second Cycle)',
  'Radhakrishna Institute of Technology and Engineering, Barunei, Bhubaneswar – 752057 (First Cycle)',
  'Rairangpur College, Rairangpur, Mayurbhanj – 757043 (Second Cycle)',
  'Rajdhani College, Baramunda, Bhubaneswar – 751003 (Second Cycle)',
  'Remuna Degree College, Remuna, Baleshwar, Balasore – 756019 (First Cycle)',
  'Rural Institute of Higher Studies, Jaleswarpur, Balasore – 756036 (Second Cycle)',
  'Sadhu Goureswar College, Kanikapada, Jajpur – 755011 (Second Cycle)',
  'Sailendra Narayan College, Rajkanika, Kendrapara – 754220 (Second Cycle)',
  'Samanta Chandra Sekhar (Autonomous) College, Puri – 752001 (Second Cycle)',
  'Saraswata Mahavidyalaya, Anantapur, Balasore – 756046 (Second Cycle)',
  'Saraswata Snataka Mahavidyalaya, Kuamara, Mayurbhanj, Baripada – 757027 (First Cycle)',
  'Savitri Women’s College, Bhanjanagar, Ganjam – 761126 (Second Cycle)',
  'Science College (Autonomous), Hinjilicut, Ganjam – 761102 (Second Cycle)',
  'Seemanta Mahavidyalaya, Mayurbhanj, Jharpokharia – 757086 (Second Cycle)',
  'Shailabala Women’s College, Cuttack – 753001 (Second Cycle)',
  'Shashi Bhushan Rath Government Women’s Autonomous College, Ganjam, Berhampur – 760001 (Second Cycle)',
  'Shishu Ananta Mahavidyalaya, Balipatna, Khordha, Bhubaneswar – 752102 (Second Cycle)',
  'Shree Ram College, Rampur, Subarnapur, Bargarh – 767045 (First Cycle)',
  'Shree Shree Dhabaleswar Mahavidyalaya, Gurudijhatia, Cuttack – 754028 (First Cycle)',
  'Siddheswar College, Basta, Balasore – 756030 (Second Cycle)',
  'Sonepur College, Sonepur – 767017 (Second Cycle)',
  'Sri Bharata Pati Mahavidyalaya, Ganjam – 761053 (Second Cycle)',
  'Sri Jayadev College of Education and Technology, Naharkanta, Khurda, Bhubaneswar – 752101 (Second Cycle)',
  'Sri Maa Mahila Mahavidyalaya, Mayurbhanj, Baripada – 757001 (First Cycle)',
  'Sri Sri Baya Baba College, Mahakalapara, Kendrapara – 754224 (Second Cycle)',
  'Srusti Academy of Management, Bhubaneswar – 751031 (Second Cycle)',
  'Subarnarekha Mahavidyalaya, Devog, Singla, Balasore – 756023 (Second Cycle)',
  'Subhadra Mahatab Mahavidyalaya, Asureswar, Cuttack – 754209 (Second Cycle)',
  'Sushilavati Government Women’s College, Sector-2, Rourkela – 769006 (Second Cycle)',
  'Swami Vivekananda Memorial College, Jagatsinghpur – 754103 (Second Cycle)',
  'Talcher College, Talcher, Angul – 759100 (Second Cycle)',
  'Trident Academy of Technology, Chandrasekharpur, Bhubaneswar – 751024 (First Cycle)',
  'Udala College, Mayurbhanj, Baripada – 757041 (Second Cycle)',
  'Upendra Nath College, Nalagaja, Baripada – 757073 (Second Cycle)',
  'Upendranath College, Soro, Balasore – 756045 (Second Cycle)',
  'Upendranath Sarada Mohavidyalaya, Mugpal P.O., Kabirpur, Jajpur – 755009 (Second Cycle)',
  'Utkalmani Gopabandhu Mahavidyalaya, Angur, Khamar – 759118 (Second Cycle)',
  'Women’s College, Jharsuguda, 768201 (Second Cycle)',
  'Dr. Harekrushna Mahtab College, Kupari, Balasore – 756059 (First Cycle)',
  'Einstein Academy of Technology and Management,Baniatangi, Po-Bajapur, Dist-Khurda,Khordha - 752060 (First Cycle)',
  'ATTABIRA COLLEGE,ATTABIRA, PO-ATTABIRA,PS-ATTABIRA, DIST-BARGARH ODISHA, Bargarh , 768027 (Second Cycle)',
  'CHRIST COLLEGE,AT- CHANDI CHHAK PO-TULSIPUR DIST-CUTTACK PIN-753008,CUTTACK , 753008 (Second Cycle)',
  'RAAJDHANI ENGINEERING COLLEGE,Po- Mancheswar Rly. Colony,BHUBANESWAR , 751017 (Second Cycle)',
  'BRUNDABAN SUBUDHI COLLEGE,AT PO - Daspalla , Nayagarh,Daspalla , 752084 (First Cycle)',
  'GANDHI INSTITUTE FOR EDUCATION AND TECHNOLOGY,At-Baniatangi Po-Bajapur Dist-Khurda,Bhubaneswar , 752060 (First Cycle)',
  'BANKI COLLEGE (AUTONOMUS), BANKI,AT/PO/PS-BANKI, DIST-CUTTACK, STATE - ODISHA, PIN-754008,BANKI , 754008 (Second Cycle)',
  'GOVERNMENT AUTONOMOUS COLLEGE RORUKELA,Panposh, Rourkela, Sundargarh, Odisha,Rourkela , 769004 (Second Cycle)',
  'KHEMUNDI COLLEGE DIGAPAHANDI GANJAM,KHEMUNDI COLLEGE, DIGAPAHANDI AT-PLNPUR PO/PS-DIGAPAHANDI PIN-761012, GANJAM, ODISHA,DIGAPAHANDI DISTRICT GANJAM,Orissa,761012 (First Cycle)',
  'SARANKUL COLLEGE,Sarankul College,Sarankul, Dist-Nayagarh,SARANKUL,Orissa,752080 (First Cycle)',
  'CHIKITI MAHAVIDYALAYA, CHIKITI MAHAVIDYALAYA, CHIKITI AT/PO. CHIKITI DIST. GANJAM,CHIKITI,Orissa,761010 (Second Cycle)',
  'BOUDH PANCHAYAT COLLEGE , AT-BUDDHAVIHAR WARD NO-6 PO-BOUDH PIN-762014 DIST-BOUDH,BOUDH,Orissa,762014 (Second Cycle)',
  'FAKIR MOHAN AUTONOMOUS COLLEGE, BALASORE , PLOT NO.256 STREET NO. AZIMABAD DIST. BALASORE,BALASORE,Orissa,756001 (Third Cycle)',
  'NATIONAL COLLEGE NUAPADA,At-Nuapada PO-Nuapada Dist-Nuapada,NAWAPARA,Orissa,766105 (Second Cycle)',
  'Bishnu Samantaray College,Nuahat, Arakhapur, Sunguda ,Jajpur - 754296 (First Cycle)',
  'Bant Anchalika College,Bant,Bhadrak - 756114 (First Cycle)',
  "Sarbati Devi Women's College,Rajgangpur ,Sundargarh - 770017 (Second Cycle)",
  'Baji Rout Memorial College,,Bhuban Dhenkanal - 759017 (Second Cycle)',
  'Ranpur Degree College,Post - Rajranpur, Dist - Nayagarh,Ranpur - 752026 (First Cycle)',
  'Stewart Science College,Madhusudan Marg, Buxi Bazar,Cuttack - 753001 (Second Cycle)',
  'Neelamadhab Mahavidyalaya ,Nayagarh,Kantilo - 752078 (First Cycle)',
  'Laxminarayan College,Kalimandir Road,Jharsuguda - 768202 (Second Cycle)',
  'Arignar Anna Government Arts and Science College, Karaikal – 609605 (Second Cycle)',
  'Avvaiyar Government College for Women,Karaikal – 609602 (First Cycle)',
  'Dr. Sarvepalli Radhakrishnan Government Arts College,Yanam – 533464 (Second Cycle)',
  'Mahatma Gandhi Government Arts College, Challakkara, Mahe – 673311 (Second Cycle)',
  'Perunthalaivar Kamarajar Arts College, Kalitheerthalkuppam, 605107 (First Cycle)',
  'Pope John Paul II College of Education, Reddiarpalayam – 605010 (Second Cycle)',
  'Tagore Arts College, Lawspet, 605008 (Second Cycle)',
  'Indira Gandhi College of Arts and Science, Kathirkamam – 605009 (First Cycle)',
  'Kasthurba College for Women, Villianur – 605110 (First Cycle)',
  'Mother Theresa Post Graduate and Research Institute of Health Sciences, Indira Nagar, Gorimedu – 605006 (First Cycle)',
  'Rajiv Gandhi Arts and Science College, Thavalakuppam – 605007 (First Cycle)',
  'Saradha Gangadharan College, Velrampet – 605004 (First Cycle)',
  'Rajiv Gandhi College of Engineering and Technology, Kirumampakkam – 607403 (First Cycle)',
  'SRI MANAKULA VINAYAGAR ENGINEERING COLLEGE,23- MARIAMMAN KOIL STREET, MADAGADIPET,Puducherry , 605107 (Second Cycle)',
  'KANCHI MAMUNIVAR CENTRE FOR POST GRADUATE STUDIES,AIRPORT ROAD LAWSPET PUDUCHERRY 605 008, Puducherry , 605008 (Third Cycle)',
  'A. S. College, Khanna, Ludhiana – 141402 (Second Cycle)',
  'Akal College of Education for Women, Sangrur, 148001 (First Cycle)',
  'Akal Degree College for Women, Sangrur – 148001 (Second Cycle)',
  'Anglo Sanskrit College for Women, Khanna, Ludhiana – 141401 (Second Cycle)',
  'Baba Mangal Singh Institute of Education, Bughipura, Moga, 142001 (First Cycle)',
  'Baba Zorawar Singh Fateh Singh Khalsa Girls College, Morinda, Ropar – 140101 (First Cycle)',
  'Babbar Akali Memorial Khalsa College, Hoshiarpur – 144527 (Second Cycle)',
  'Beant College of Engineering and Technology, Gurdaspur - 143521 (First Cycle)',
  'D D Jain College of Education, Ludhiana, 141008 (First Cycle)',
  'D. A. V. College, Abohar – 152116 (Second Cycle)',
  'D.A.V. College, Amritsar, 143001 (Second Cycle)',
  'D.M. College of Education, Gita Bhawan Chownk, Moga, 142001 (First Cycle)',
  'Dasmesh Girls College, Mukerian, Hoshiarpur – 144211 (First Cycle)',
  'G. G. N. Khalsa College, Civil Lines, Ludhiana – 141001 (First Cycle)',
  'G. H. G. Khalsa College, Ludhiana – 141104 (Second Cycle)',
  'General Shivdev Singh Diwan Gurbachan Singh Khalsa College, Patiala, 147001 (Second Cycle)',
  'Giani Kartar Singh Memorial Government College, Dist. Hoshiarpur, 144203 (Second Cycle)',
  'Gobindgarh Public College, Dist. Ludhiana, 141401 (First Cycle)',
  'Government Brijindra College, Faridkot – 151203 (Second Cycle)',
  'Government College of Education, Patiala – 147001 (Second Cycle)',
  'Government College, Ajnala, Amritsar – 143102 (Second Cycle)',
  'Government College, Dera Bassi – 140507 (Second Cycle)',
  'Government College, Rara Sahib, Ludhiana – 141117 (Second Cycle)',
  'Government College, Ropar, Rupnagar – 140001 (Second Cycle)',
  'Government College, Sangrur, Malerkotla – 148023 (Second Cycle)',
  'Government Kirti College, Nial, Patran, Patiala – 147105 (First Cycle',
  'Government Mohindra College, Patiala – 147001 (Second Cycle)',
  'Government Ripudaman College, Patiala Dist, 147201 (Second Cycle)',
  'Government Shivalik College, Naya Nangal, Ropar – 140126 (Second Cycle)',
  'Govind National College, Dist. Ludhiana, 141203 (First Cycle)',
  'Guru Gobind Singh College of Education (For Women), Dist. Muktsar, Giddarbaha – 152101 (Second Cycle)',
  'Guru Gobind Singh College, Sanghere, Barnala – 148101 (First Cycle)',
  'Guru Nanak College, Sri Muktsar Sahib, Mandi Killianwali – 151211 (First Cycle)',
  'Guru Nanak College, Sukhchainana Sahib, Phagwara, Kapurthala – 144401 (First Cycle)',
  'Guru Nanak Dev Engineering College (Autonomous), Ludhiana, 141006 (First Cycle)',
  'Guru Nanak National College for Women, Nakodar – 144040 (First Cycle)',
  'Guru Nanak National College, Dist. Ludhiana, 141421 (First Cycle)',
  'Guru Tegh Bahadur National College, Ludhiana - 141002 (First Cycle)',
  'Jyoti B.Ed. College, Fazilka – 152123 (First Cycle)',
  'Khalsa College for Women, Dist. Ludhiana, 142024 (Second Cycle)',
  'Khalsa College, Garhdiwala, Hoshiarpur – 144207 (Second Cycle)',
  'Lajpat Rai DAV College, Jagraon – 142026 (First Cycle)',
  'Lyallpur Khalsa College for Women, Jalandhar – 144001 (Second Cycle)',
  'Mata Gujri College (Autonomous), Fatehgarh Sahib – 140406 (Second Cycle)',
  'Multani Mal Modi College, Patiala, 147001 (Second Cycle)',
  'Partap College of Education, Ludhiana – 141008 (Second Cycle)',
  'Pt. Mohan Lal S. D. College for Women, Gurdaspur – 143521 (Second Cycle)',
  'Public College, Samana – 147101 (First Cycle)',
  'S. C. D. Government College, Ludhiana – 141001 (Second Cycle)',
  'S. U. S. Government College, Sunam – 148028 (Second Cycle)',
  'Sant Prem Singh Karamsar Khalsa College, Begowal, Kapurthala – 144621 (First Cycle)',
  'Sh. Lal Bahadur Shastri Arya Mahila College, Barnala – 148101 (First Cycle)',
  'Shaheed Bhagat Singh State Technical Campus, Moga Road, Ferozepur, 152004 (First Cycle)',
  'Shaheed Darshan Singh Pheruman Memorial College for Women, Amritsar – 143112 (Second Cycle)',
  'Shri Vishwa Mitter Sekhri College of Education, Batala – 143505 (First Cycle)',
  'Sidana Institute of Education, Amritsar, 143109 (First Cycle)',
  'Sri Aurobindo College of Commerce and Management, Ludhiana – 142021 (First Cycle)',
  'Sri Guru Teg Bahadur Khalsa College, Anandpur Sahib, Ropar – 140118 (Second Cycle)',
  'Swami Premanand Mahavidyalaya, Mukerian, Hoshiarpur – 144211 (Second Cycle)',
  'Swami Swatantranand Memorial College, Dinanagar, Gurdaspur – 143531 (Second Cycle)',
  'Akal College of Physical Education, Mastuana Shahib, Sangrur – 148001 (First Cycle)',
  'Amritsar College of Engineering and Technology (An Autonomous College), Amritsar – 143001 (Second Cycle)',
  'Arjan Dass College, Dharamkot, Moga – 142042 (First Cycle)',
  'Babe - Ke College of Education, Mudki, Ferozpur – 140060 (Second Cycle)',
  'Babe - Ke College of Education, V. P. O. Daudhar, Moga – 142053 (Second Cycle)',
  'Babe Ke Ayurvedic Medical College and Hospital, Daudhar, Moga – 142053 (First Cycle)',
  'Banarsi Dass Arya Girls College, Jalandhar Cantt. – 144005 (Second Cycle)',
  'Bhag Singh Khalsa College for Women, Abohar – 152116 (First Cycle)',
  'Bhutta College of Education, Bhutta, Ludhiana – 141206 (Second Cycle)',
  'Cheema College of Education, Kishankot, Gurdaspur – 143515 (First Cycle)',
  'D. A. V. College of Education for Women, Amritsar – 143001 (Second Cycle)',
  'D. A. V. College, Malout Mandi, Sri Muktsar Sahib – 152107 (First Cycle)',
  'Dasmesh Girls College of Education, Badal, Malout, Sri Muktsar Sahib – 152113 (Second Cycle)',
  'DAV College for Women, Ferozepur Cantt. – 152001 (Second Cycle)',
  'DAV Institute of Engineering and Technology, Kabir Nagar, Jalandhar – 144008 (First Cycle)',
  'Devki Devi Jain Memorial College for Women, Kidwai Nagar, Ludhiana – 141008 (First Cycle)',
  'G. G. D. S. D. College, Hariana, Hoshiarpur – 144208 (Third Cycle)',
  'G. H. G. Harparkash College of Education for Women, Sidhwan Khurd, Ludhiana – 142024 (Second Cycle)',
  'G. H. G. Khalsa College of Education, Gurusar Sadhar, Ludhiana – 141104 (Second Cycle)',
  'Global Institute of Management and Emerging Technologies, Amritsar – 143501(First Cycle)',
  'Gopichand Arya Mahila College, Abohar – 152116 (First Cycle)',
  'Government College for Girls, Rakh Bagh, Ludhiana – 141001 (Second Cycle)',
  'Government College for Girls, Stadium Road, Patiala – 147001 (Second Cycle)',
  'Government College of Education, Ladowali Road, Jalandhar – 144001 (Second Cycle)',
  'Government College, Phase - 6, S. A. S. Nagar, Mohali – 160055 (Second Cycle)',
  'Government Rajindra College, Bathinda – 151001 (Second Cycle)',
  'Guru Gobind Singh College of Education, Mukerian, Hoshiarpur – 144211 (Second Cycle)',
  'Guru Gobind Singh College of Education, Theri, Bathinda Road, Malout, Shri Muktsar Sahib – 152107',
  'Guru Nanak College for Girls, Mukatsar – 152026 (Second Cycle)',
  'Guru Nanak College for Women, Banga, Nawanshahr – 144505 (Second Cycle)',
  'Guru Nanak College of Education for Women, Kapurthala – 144601 (Second Cycle)',
  'Guru Nanak College of Education, Hariana, Hoshiarpur – 144208 (Second Cycle)',
  'Guru Nanak College, Budhlada, Mansa – 151502 (First Cycle)',
  'Guru Nanak Khalsa College, Daroli Kalan, Jalandhar – 144104 (First Cycle)',
  'Guru Nanak Khalsa Girls College, Baba Sang Dhesian, Goraya, Jalandhar – 144409 (First Cycle)',
  'Guru Ram Dass B.Ed. College, Ferozepur, Jalalabad – 152024 (Second Cycle)',
  'Hindu College, Dhab Khatikan, Amritsar – 143002 (Second Cycle)',
  'Hindu Kanya College, Amritsar Road, Kapurthala – 144601 (Second Cycle)',
  'Hindu Kanya Mahavidyalaya, Dhariwal, Gurdaspur – 143519 (First Cycle)',
  'Innocent Hearts College of Education, Jalandhar – 144003 (First Cycle)',
  'Jagdish Chandra D. A. V. College, Dasuya, Hoshiarpur – 144205 (Second Cycle)',
  'Jawahar Lal Nehru Government College, Mandi Gobindgarh – 147301 (Second Cycle)',
  'K. R. M. D. A. V. College, Nakodar, Jalandhar – 144040 (First Cycle)',
  'Khalsa College for Women, Civil Lines, Ludhiana – 141001 (Second Cycle)',
  'Khalsa College for Women, G. T. Road, Amritsar – 143002 (Second Cycle)',
  'Khalsa College of Education, Amritsar – 143001 (Third Cycle) 7 Years Validity',
  'Khalsa College, G. T. Road, Amritsar – 143001 (Third Cycle)',
  'Mata Ganga Khalsa College for Girls, Gurudwara Manji Sahib, Kottan, Ludhiana – 141412 (First Cycle)',
  'MMD DAV College, Giddarbaha – 152101 (First Cycle)',
  'Moga College of Education for Girls, Moga – 142001 (Second Cycle)',
  'Nawab Jassa Singh Ahluwalia Government College, Kapurthala – 144601 (Second Cycle)',
  'Pathankot College of Education, Mamoon, Pathankot - 145001 (First Cycle)',
  'Prem Chand Markanda S. D. College for Women, Jalandhar – 144001 (Second Cycle)',
  'Pt. Mohan Lal S. D. College for Girls, Gurdaspur – 143602 (First Cycle)',
  'S. D. College for Women, Jawhar Nagar, Moga – 142001 (Second Cycle)',
  'S. D. P. College for Women, Ludhiana – 141008 (Second Cycle)',
  'S. G. G. S. Khalsa College, Mahilpur, Hoshiarpur – 146105 (Second Cycle)',
  'Sadbhavna College of Education for Women, Jalaldiwal, Ludhiana – 141109 (Second Cycle)',
  'Sai College of Education, Jadla, Nawanshahr, SBS Nagar – 144515 (Second Cycle)',
  'Sanmati Government College of Science Education and Research, Ludhiana – 142026',
  'Shaheed Kanshi Ram Memorial College, Bhagoo Majra, Kharar, SAS Nagar – 140301 (First Cycle)',
  'Shivalik College of Education, Mustafabad Jattan, Babehali, Gurdaspur – 143521 (First Cycle)',
  'Shri Sanatan Dharam Girls’ College, Bathinda – 151001 (First Cycle)',
  'Smt. Jawala Devi College of Education, Fatehgarh Sahib, Sanghol – 140802 (Second Cycle)',
  'Sri Guru Angad Dev College, Khadur Sahib, Tarn Taran – 143117 (First Cycle)',
  'Swami Ganga Giri Janta Girls College, Raikot, Ludhiana – 141109 (First Cycle)',
  'Baba Farid College of Education, Bathinda – 151001 (Second Cycle)',
  'Baring Union Christian College, Batala,Jalandhar Road,Batala - 143505 (First Cycle)',
  'S. D. College, Barnala ,K.C. Road, Near Railway Crossing,Barnala - 148101 (First Cycle)',
  'Government College, Gurdaspur,Trimmo Road,Gurdaspur - 143521 (Second Cycle)',
  'Apeejay College of Fine Arts,New Jawahar Nagar, Mahavir Marg,Jalandhar - 144001 (Third Cycle)',
  'ISF College of Pharmacy,GT Road, Ghal- Kalan,Moga - 142001 (First Cycle)',
  'Siri Guru Har Rai Sahib College for Women,Chabbewal,Hoshiarpur - 146102 (First Cycle)',
  'S.R.P.A ADARSH BHARTIYA COLLEGE,Jalandhar Dalhousie Bye Pass Road, Near Symbal Chowk,PATHANKOT , 145001 (First Cycle)',
  'TRINITY COLLEGE,Church Nagar, Guru Gobind Singh Avenue, Chogitti,JALANDHAR , 144009 (First Cycle)',
  'GURU NANAK PREM KARAMSAR COLLEGE, NADALA,Bholath Road, NADALA,Kapurthala , 144624 (First Cycle)',
  'AKAL DEGREE COLLEGE,MASTUANA NH-7, GURSAGAR MASTUANA SAHIB, DISTT. SANGRUR,SANGRUR , 148001 (First Cycle)',
  'DESH BHAGAT COLLEGE, Bardwal-Dhuri Distt. Sangrur(Punjab),Bardwal Dhuri , 148024 (First Cycle)',
  'SSSS COLLEGE OF COMMERCE FOR WOMEN,SSSS College of Commerce for Women, Mall Road Chowk, Majitha Road, Amritsar,Amritsar,Punjab,143001 (First Cycle)',
  'DAV COLLEGE BATHINDA,Bibiwala Road, Bathinda (Pb.) - 151001,Bathinda,Punjab,151001 (Second Cycle)',
  'Aishwarya College of Education Sansthan, Udaipur, 313001 (First Cycle)',
  'Arya Narayani Devi T.T. College, Ajmer, 305025 (First Cycle)',
  'Babu Shobha Ram Government Arts College, Alwar – 301001 (Second Cycle)',
  'Biyani Girls College, Jaipur – 302039 (First Cycle)',
  'Dr. Bhim Rao Ambedkar Government College, Sri Ganganagar – 335001 (Second Cycle)',
  'G. D. Government College for Women, Alwar – 301001 (Second Cycle)',
  'G. H. S. Government College, Churu District, Sujangarh – 331507 (Second Cycle)',
  'Geeta Co-Education Teacher Training College, New Gharsana, 335711 (Re-assessment, First Cycle)',
  'Government Bangur College, Didwana, Nagaur – 341303 (Second Cycle)',
  'Government Bangur P. G. College, Pali – 306401 (Second Cycle)',
  'Government College, Baheer Road, Tonk, 304001 (Second Cycle)',
  'Government College, Barmer – 344001 (Second Cycle)',
  'Government College, Dist. Alwar, Behror – 301701 (First Cycle)',
  'Government College, Hindaun City, Karauli – 322230 (Second Cycle)',
  'Government College, Karauli – 322241 (Second Cycle)',
  'Government College, Kekri, Ajmer – 305404 (Second Cycle)',
  'Government College, Kota Road, Bundi – 323001 (Second Cycle)',
  'Government College, Sirohi, 307001 (Second Cycle)',
  'Government College, Tiwary Bagh, Dholpur – 328001 (First Cycle)',
  'Government Commerce College, Talwandi, Kota – 324005 (Second Cycle)',
  'Government Girls College, Tonk, 304001 (First Cycle)',
  'Government Maharaj Acharya Sanskrit College, Gandhi Nagar, Jaipur – 302015 (First Cycle)',
  'Government Maharani Sudershan College for Women, Bikaner, 334001 (Second Cycle)',
  'Government P. G. College, Jhalawar – 326001 (Second Cycle)',
  'Government Rameshwari Devi Girls College, Bharatpur, 321001 (Second Cycle)',
  'Haridev Joshi Rajkiya Kanya Mahavidyalaya, Banswara – 327001 (Second Cycle)',
  'International School of Informatics and Management, Technical Campus, Mansarovar, Jaipur – 302020 (First Cycle)',
  "J. B. Teacher's Training Institute, Sadul Shahar, Sri Ganganagar – 335062 (First Cycle)",
  'Kanoria PG Mahila Mahavidyalaya, Jaipur – 302015 (First Cycle)',
  'Lachoo Memorial College of Science and Technology, Sector A, Shastri Nagar, Jodhpur – 342003 (Third Cycle',
  'Lal Bahadur Shastri Government P. G. College, Jaipur – 303108 (Second Cycle)',
  'M. L. V. Government College, Bhilwara – 311001 (Second Cycle)',
  'Motherland Girls Teacher Training College, Dist. Tonk, 304 001 (First Cycle)',
  'Navjyoti Shikshak Prashikshan Mahavidyalaya, Radhakishanpura, Sikar, 332001 (First Cycle)',
  'Nitya Leelastha Tilkayat Shri Govindlalji Maharaj Government Girls College, Dist. Rajsamand, 313301 (Second Cycle)',
  'Raj Rishi College, Alwar – 301001 (Second Cycle)',
  "Rajasthan Mahila Teachers' Training College, Udaipur – 313001 (First Cycle)",
  'Rama Krishna Women Teachers Training College, Jaipur – 302029 (First Cycle)',
  'S. B. D. Government College, Churu – 331403 (Second Cycle)',
  'S. M. C. C. Government College, Kesarganj, Aburoad, Sirohi – 307026 (Second Cycle)',
  'S. M. M. Government Girls College, Bhilwara – 311001 (Second Cycle)',
  'S.S. Jain Subodh Mahila Shikshak Prashikshan Mahavidyalaya, Jaipur, 302011 (First Cycle)',
  'Seth Mathura Das Binani Government P. G. College, Nathdwara – 313301 (Second Cycle)',
  'Seth Ranglal Kothari Government College, Rajsamand – 313326 (Second Cycle)',
  'Shri Agrasen Mahila Shikshak Prashikshan Sansthan, Karauli, Hindaun City – 322230 (Second Cycle)',
  'Shri Bhawani Niketan Teacher Training College, Jaipur, 302023 (First Cycle)',
  "St. Wilfred's Teachers Training College, Jaipur – 302020 (First Cycle)",
  "Vedanta P. G. Girls' College, Sikar – 332404 (First Cycle)",
  'Vedic Kanya P. G. Mahavidyalaya, Raja Park, Jaipur – 302004 (First Cycle)',
  'Veer Bala Kali Bai Government Girls College, Dungarpur, 314001 (First Cycle)',
  'Vidya Bharti B.Ed. College, Sikar – 332001 (First Cycle)',
  'Agrawal Kanya Mahavidyalaya, Gangapur City, Sawai Madhopur – 322201 (Second Cycle)',
  'Baba Gangadas Government Girls College, Shahpura, Jaipur – 303103 (First Cycle)',
  'Bhagwati Shikshak Prashikshan Mahavidyalaya, Gangapur City, Sawai Madhopur – 322201 (Second Cycle)',
  'Biyani Girls B.Ed. College, Sector 3, Vidhyadhar Nagar, Jaipur – 302023 (Second Cycle)',
  'Ch. Balluram Godara Government Girls College, Sri Ganganagar – 335001 (Second Cycle)',
  'D. R. J. Government Girls College, Balotra, Barmer – 344022 (Second Cycle)',
  'Dr. Bhimrao Ambedkar Government P. G. College, Nimbahera – 312601 (First Cycle)',
  'Gaurav College of Education, Chomu, Jaipur – 303702 (First Cycle)',
  'Government College, Ajmer Road, Malpura, Tonk – 304502 (First Cycle)',
  'Government College, Khetri, Neem Ka Thana Road, Jhunjhunu – 333503 (First Cycle)',
  'Government College, Mangrol Byepass, Baran – 325205 (Second Cycle)',
  'Government College, Merta City, Nagaur – 341510 (Second Cycle)',
  'Government College, Tehla Road, Rajgarh, Alwar – 301408 (Second Cycle)',
  "Government Girls' College, Ajmer – 305001 (Second Cycle)",
  'Government Girls College, Gandhi Nagar, Sector 4, Chittorgarh – 312001 (Second Cycle)',
  'Government Girls College, Hospital Road, Baran – 325205 (Second Cycle)',
  'Government Girls College, Moriza Road, Chomu – 303702 (First Cycle)',
  'Government Shakambhar P. G. College, Jaipur – 303604 (Second Cycle)',
  'Government Shastri Sanskrit College, Mahapura, Jaipur – 302026 (First Cycle)',
  'M. A. J. Government College, Deeg, Bharatpur – 321203 (Second Cycle)',
  'M. B. R. Government College, Balotra, Barmer – 344022 (Second Cycle)',
  'Maharaja Surajmal Teachers Training College, Bharatpur – 321001 (First Cycle)',
  'Maharana Pratap Government Post Graduate College, Chittorgarh – 312001 (Second Cycle)',
  'Maharshi Dayanand B.Ed. College, Jaipur – 302004 (First Cycle)',
  'Mahatma Jyotiba Fule Shikshak Prashikshan Mahavidyalaya, Chomu, Jaipur – 303702 (First Cycle)',
  "Multanmal Bhickchand Chajjer Government Girls' College, Barmer – 344001 (First Cycle)",
  'Parishkar College of Global Excellence, Shipra Path, Mansarovar, Jaipur – 302020 (First Cycle)',
  'Poddar International College, Jaipur – 302020 (First Cycle)',
  'Rajesh Pilot Government College, Dausa, Lalsot – 303503 (First Cycle)',
  'S. B. K. Government P. G. College, Jaisalmer – 345001 (Second Cycle)',
  'Samrat Prithviraj Chauhan Government College, Ajmer – 305001 (Third Cycle)',
  'Sanjay Teacher’s Training College, Jaipur – 302015 (Second Cycle)',
  'Shikshak Prashikshan Mahavidyalaya, Thana Rajaji, Rajgarh, Alwar – 301408 (First Cycle)',
  'Shree Agrasen Mahila Snatakottar Mahavidyalaya, Bharatpur – 321001 (First Cycle)',
  'Shri GuruNanak Khalsa Shikshak Prashikshan Mahavidyalaya, Sector 12, Hanumangarh – 335512 (First Cycle)',
  'Shri Bajrang Teacher Training College, Deeg, Bharatpur – 321203 (First Cycle)',
  'Shri Baldev Ram Mirdha Government College, Nagaur – 341001 (Second Cycle)',
  'Shri Bankey Bihari Khanhaiya Lal Mahila Teacher Training College, Deeg, Bharatpur – 321203 (First Cycle)',
  'Shri Govind Guru Government College, Banswara – 327001 (Second Cycle)',
  'Shri Govind Singh Gurjar Rajkiya Mahavidyalaya, Nasirabad, Ajmer – 305601 (Second Cycle)',
  'Shri Jain T. T. College, Alwar – 301001 (First Cycle)',
  'Shri Ratanlal Kanwarlal Patni Government P. G. College, Ajmer – 305802 (Second Cycle)',
  'Shri Shiv Charan Mathur Government College, Hoda, Mandalgarh, Bhilwara – 311604 (First Cycle)',
  'Shrimati Narbada Devi Bihani Government Post Graduate College, Hanumangarh, Nohar – 335523 (Second Cycle)',
  'Shrimati Panadevi Morijawala Rajkiya Kanya Mahavidyalaya, Kotputli, Jaipur – 303108 (First Cycle)',
  'Smt. Narayani Devi Verma Women’s Teacher Training College, Vijay Singh Pathik Nagar, Bhilwara – 311001 (First Cycle)',
  'Sri Sant Sundardas Government Girls College, Dausa – 303303 (First Cycle)',
  'Swargiya Rajesh Pilot Government College, Bandikui, Dausa – 303313 (Second Cycle)',
  'Deepshikha Teachers Training College, Sitapura, Jaipur – 302022 (First Cycle)',
  'Smt. G. D. S. Government Shastri Sanskrit College, Kaladera, Chomu, Jaipur – 303801 (First Cycle)',
  'Government College, Nadoti Road, Gangapur City, Sawai Madhopur – 322201 (Second Cycle)',
  'Ujas College of Education, Sanganer, Jaipur – 303905 (First Cycle)',
  'Veena Memorial College of Education, Padewa, Karauli – 322241 (Second Cycle)',
  'S. D. Government College, Beawar, Ajmer – 305901 (Third Cycle)',
  'Arya Mahila Shikshak Prashikshan Mahavidyalaya, Malviya Nagar, Alwar – 301002 (First Cycle)',
  'S. S. Jain Subodh (P.G.) College (Autonomous), Jaipur – 302004 (Third Cycle)',
  'Regional Institute of Education, Ajmer – 305004 (First Cycle)',
  'Apex College (First Cycle)',
  'RNT PG College (First Cycle)',
  'Government Dhuleshwar Acharya Sanskrit College ,Old Road ,Manoharpur Jaipur - 303104 (First Cycle)',
  'Government College, Jaitaran (Pali),NH 112, Nimaj Road Jaitaran ,Pali - 306302 (First Cycle)',
  'Shri Digambar Jain Acharya Sanskrit Mahavidyala,Veerodaya Nagar, Jain Nasiyan Road, Sanganer,Jaipur - 302029 (First Cycle)',
  'M.S.J.College, Bharatpur,Achnera Road ,Bharatpur - 321001 (Second Cycle)',
  'SW. PANDIT NAWAL KISHORE SHARMA GOVERNMENT P. G. COLLEGE, AGRA ROAD (OLD NH-11), DAUSA,DAUSA , 303303 (Second Cycle)',
  'AISHWARYA COLLEGE OF EDUCATION,A-9 EXTENSION 1 KAMLA NEHRU NAGAR ,JODHPUR (RAJASTHAN),Jodhpur , 342008 (First Cycle)',
  'JODHPUR INSTITUTE OF ENGINEERING AND TECHNOLOGY,IET UNIVERSE N.H. NO - 65 MOGRA PALI ROAD, JODHPUR,JODHPUR , 342802 (First Cycle)',
  'ARYA INSTITUTE OF ENGINEERING AND TECHNOLOGY,JAIPUR,SP-40, KUKAS INDUSTRIAL AREA (RIICO), DELHI ROAD, KUKAS, JAIPUR (RAJ), JAIPUR , 302028 (First Cycle)',
  'BIYANI INSTITUTE OF SCIENCE AND MANAGMENT , R-4, Sector-3, Vidyadhar Nagar,,Jaipur,Rajasthan,302039 (First Cycle)',
  'POORNIMA INSTITUTE OF ENGINEERING AND TECHNOLOGY,ISI-2, RIICO Institutional Area, Goner Road, Sitapura, Jaipur,JAIPUR,Rajasthan,302022 (First Cycle)',
  'Sikkim Government College, Tadong, Gangtok - 737102 (First Cycle)',
  'Harkamaya College of Education, Samdur, Tadong, Gangtok – 737102 (Second Cycle)',
  'GOVERNMENT COLLEGE RHENOCK,Rhenock - Rungdung, East Sikkim,RHENOCK , 737133 (First Cycle)',
  'SIKKIM GOVERNMENT COLLEGE GYALSHING,AARIGOAN, YANGTHANG, GYALSHING WEST SIKKIM,GYALSHING , 737111 (First Cycle)',
  'SIKKIM INSTITUTE OF HIGHER NYINGMA STUDIES (SHEDA), PANGTHANG, TAKTSE, GANGTOK, Pangthang, Taktse, Gangtok,Gangtok , 737103 (First Cycle)',
  'GOVT SANSKRIT MAHAVIDYALAYA,Samdong East Sikkim,Samdong , 737107 (First Cycle)',
  'NAMCHI GOVERNMENT COLLEGE,Upper Kamrang, Namchi , 737126 (First Cycle)',
  'A.S. College of Education, Madurai, 625514 (First Cycle)',
  'Adhiparasakthi Dental College and Hospital, Melmaruvathur, Kanchipuram – 603319 (First Cycle)',
  'Adhiparasakthi Engineering College,Kancheepuram Dist, 603319 (First Cycle)',
  'Aditanar College of Arts & Science, Thoothukudi, 628216 (Third Cycle)',
  'Aksheyaa College of Engineering, Puludivakkam,Kancheepuram Dist, 603314 (First Cycle)',
  'Ambai Arts College, Tirunelveli – 627401 (First Cycle)',
  'Annai College of Arts & Science, Kumbakonam, 612503 (First Cycle)',
  'Annai College of Education, Dharmapuri – 636903 (First Cycle)',
  'Annai College of Education, Kumbakonam,612503 (Re-assessment, First Cycle)',
  'Annai Meenakshi College of Education,Tirunelveli Dist, 627855 (First Cycle)',
  'Annai Violet Arts and Science College, Ambattur, Chennai, 600053 (First Cycle)',
  'Arasan Ganesan College of Preceptors, Sivakasi – 626123 (First Cycle)',
  'Aravindhar College of Education, Tiruvannamalai - 606751 (First Cycle)',
  'Arignar Anna Government Arts College for Women, Walajapet, Vellore – 632513 (Second Cycle)',
  'Arignar Anna Government Arts College, Tiruchirappalli Dist, 621211 (First Cycle)',
  'Arul Anandar College (Autonomous), Karumathur, Madurai Dist, 625514 (Third Cycle)',
  'Arulmigu Kalasalingam College of Education, Virudhunagar Dist, 626126 (First Cycle)',
  'Arulmigu Palaniandavar College of Arts and Culture, Dindigul – 624601 (Second Cycle)',
  'Arunai Engineering College, Tiruvannamalai, 606603 (Second Cycle)',
  'Ayya Nadar Janaki Ammal College (Autonomous) Sivakasi, Tamil Nadu (Third Cycle)',
  'Bannari Amman Institute of Technology (Autonomous), Erode Dist, 638401 (Second Cycle)',
  'Bapuji Memorial College of Education, Kanyakumari Dist, 629252 (First Cycle)',
  'Bharathi Women’s College (Autonomous), Chennai, 600108 (Third Cycle)',
  'Bishop Heber College (Autonomous), Tiruchirappalli, 620017 (Third Cycle)',
  'C. Abdul Hakeem College of Engineering & Technology, Vellore Dist, 632509 (First Cycle)',
  "Cardamom Planter's Association College, Bodinayakanur, Theni – 625513 (Second Cycle)",
  'Chettinad Dental College & Research Institute, Kanchipuram Dist, 603103 (First Cycle)',
  'Chezhian College of Education, Tiruvannamalai – 606751 (Second Cycle)',
  'Chikkanna Government Arts College, Tirupur, 641602 (Second Cycle)',
  'Christian College of Education, Marthandam – 629165 (First Cycle)',
  'Christian College of Education, Perambalur,621212 (First Cycle)',
  'CK College of Engineering and Technology, Cuddalore – 607003 (First Cycle)',
  'Coimbatore Institute of Engineering And Technology, Coimbatore, 641109 (First Cycle)',
  'Cosmopolitan College of Education, Kanchipuram – 602002 (First Cycle)',
  'D. K. M. College for Women, Vellore – 632001 (Third Cycle)',
  'Dhanalakshmi Srinivasan College of Education for Women, Perambalur – 621212 (Second Cycle)',
  'Dhanalakshmi Srinivasan College of Engineering & Technology, Chennai, 603104 (First Cycle)',
  'Dhanalakshmi Srinivasan Engineering College, Perambalur, 621212 (First Cycle)',
  'Dharmapuram Gnanambigai Government Arts College for Women, Nagapattinam – 609001 (Third Cycle)',
  'Dr. Ambedkar Government Arts College, Chennai – 600039 (Second Cycle)',
  'Dr. N. G. P. Arts and Science College, Coimbatore – 641048 (Second Cycle)',
  'Dr. N.G.P. Institute of Technology, Coimbatore, 641048 (First Cycle)',
  'Dr. R.K. Shanmugam College of Education, Villupuram Dist, 606213 (First Cycle)',
  'Dr. R.V. Arts and Science College, Coimbatore, 641104 (First Cycle)',
  'E. G. S. Pillay Engineering College, Nagapattinam – 611002 (First Cycle)',
  'Easwari Engineering College, Chennai, 600089 (First Cycle)',
  'Erode Sengunthar Engineering College, Erode, 638057 (First Cycle)',
  'Ethiraj College for Women (Autonomous), Egmore, Chennai, Tamil Nadu (Third Cycle)',
  'Fatima College (Autonomous), Madurai, Tamil Nadu (Third Cycle)',
  'G. Venkataswamy Naidu College,Kovilpatti – 628502 (Second Cycle)',
  'G.T.N. Arts College, Dindigul, 624005 (First Cycle)',
  "Ganadipathy Tulsi's Jain Engineering College,Vellore – 632102 (First Cycle)",
  'Gnanamani College of Technology, Pachal Post,Namakkal, 637018 (First Cycle)',
  'Gojan School of Business And Technology, Chennai, 600052 (First Cycle',
  'Gonzaga College of Arts and Science for Women, Krishnagiri – 635108 (First Cycle)',
  'Government Arts College (Autonomous), Kumbakonam – 612002 (Second Cycle)',
  'Government Arts College for Women, Krishnagiri – 635001 (Second Cycle)',
  'Government Arts College for Women, Sivaganga – 630562 (First Cycle)',
  'Government Arts College, Chengam Road, Tiruvannamalai – 606603 (Second Cycle)',
  'Government Arts College, Chidambaram – 608102 (Second Cycle)',
  'Government Arts College, Ramanathapuram, Paramakudi – 623707 (Second Cycle)',
  'Government Arts College, Udhagamandalam – 643002 (Second Cycle)',
  'Government College for Women (A), Kumbakonam, Thanjavur – 612001 (Third Cycle)',
  'Government College of Education for Women, Coimbatore – 641001 (Third Cycle)',
  'Government College of Education, Orathanad, Thanjavur – 614625 (Second Cycle)',
  'Guru Shree Shantivijai Jain College for Women, Chennai, 600007 (Second Cycle)',
  'Hindusthan College of Engineering and Technology, Coimbatore – 641032 (First Cycle)',
  'Hindusthan Institute of Technology, Coimbatore – 641032 (First Cycle)',
  'I.F.E.T. College of Engineering, Villupuram, 605108 (First Cycle)',
  'Indo-American College, Thiruvannamalai, Cheyyar – 604407 (Second Cycle)',
  'Institute of Advanced Studies in Education, Chennai – 600015 (Third Cycle)',
  'J. J. College of Education, Pudukkottai – 622422 (Second Cycle)',
  'J.J. College of Arts And Science (Autonomous), Pudukkottai, 622422 (Third Cycle)',
  'Jamal Mohamad College, Tiruchirappalli – 620020 (Third Cycle)',
  'Jay Shriram Group of Institutions, Tiruppur – 638660 (First Cycle)',
  'Jayalakshmi Narayanaswami College of Education, Chennai – 600113 (First Cycle)',
  'Jayam College of Engineering and Technology, Dharmapuri – 636813 (First Cycle)',
  'Jerusalem College of Engineering, Chennai – 600100 (Second Cycle)',
  'Justice Basheer Ahmed Sayeed College for Women (Autonomous) Chennai, Tamil Nadu (Third Cycle)',
  'K. Ramakrishnan College of Engineering, Tiruchirappalli – 621112 (First Cycle)',
  'Kamaraj College of Engineering and Technology, Virudhunagar – 626001 (First Cycle)',
  'Kamaraj College, Thoothukudi – 628003 (Second Cycle)',
  'Karpagam College of Engineering (Autonomous), Coimbatore – 641032 (First Cycle)',
  'Kathir College of Education, Coimbatore – 641062 (First Cycle)',
  'Kathir College of Engineering, Coimbatore – 641062 (First Cycle)',
  'KIT-Kalaignarkarunanidhi Institute of Technology, Coimbatore – 641402 (First Cycle)',
  'Kodaikanal Christian College (Autonomous), Kodaikanal, 624104 (First Cycle)',
  'Kongu Engineering College, Erode – 638052 (First Cycle)',
  'Koottalumoodu Arulmigu Bhadreswari Devasthanam College of Education,Kanniyakumari Dist, 629173 (First Cycle)',
  'KPR Institute of Engineering and Technology, Coimbatore – 641407 (First Cycle)',
  'Kumararani Meena Muthiah College of Arts & Science, Chennai, 600020 (Second Cycle)',
  'L. R. G. Government Arts College for Women, Tirupur – 641604 (Third Cycle)',
  'Lady Doak College (Autonomous), Madurai,Tamil Nadu (Third Cycle)',
  'Lady Willingdon Institute of Advanced Study in Education, Chennai – 600005 (Third Cycle)',
  'Loyola College (Autonomous), Chennai, Tamil Nadu (Third Cycle)',
  'M. Kumarasamy College of Engineering, Karur – 639113 (First Cycle)',
  'M. O. P. Vaishnav College for Women, Chennai – 600034 (Third Cycle)',
  'M.G.R. College, Hosur, 635109 (Second Cycle)',
  "Madurai Sivakasi Nadars Pioneer Meenakshi Women's College, Sivaganga – 630611 (First Cycle)",
  'Mahendra College of Engineering, Salem – 636106 (First Cycle)',
  'Mazharul Uloom College, Ambur, Vellore –635802 (Second Cycle)',
  'MEPCO Schlenk Engineering College (Autonomous), Virudhunagar Dist, 626005 (First Cycle)',
  'Meston College of Education (Autonomous), Chennai, 600014 (Third Cycle)',
  'Mohamed Sathak College of Arts and Science, Chennai – 600119 (Second Cycle)',
  'Muna College of Education, Parangipettai, Cuddalore – 608502 (First Cycle)',
  'Muqyyath Sha Sirguro Wakf Board College, Madurai – 625020 (Second Cycle)',
  'Muthayammal College of Arts & Science, Namakkal Dist, 637408 (First Cycle)',
  'Muthayammal Engineering College, Namakkal – 637408 (First Cycle)',
  'Muthurangam Government Arts College, Vellore – 632002 (Third Cycle)',
  'Nadar Saraswathi College of Arts & Science, Theni, 625531 (First Cycle)',
  'Namakkal Kavignar Ramalingam Government Arts College for Women, Namakkal – 637001 (Third Cycle)',
  'Nandha College of Nursing, Erode – 638052 (First Cycle)',
  'Nandha College of Physiotherapy, Pitchandampalayam Post, Erode – 638052 (First Cycle)',
  'Nandha College of Technology, Erode, 638052 (First Cycle)',
  'Nandha Engineering College (Autonomous), Erode, 638052 (First Cycle)',
  'Nirmala College for Women, Coimbatore – 641018 (Third Cycle)',
  'P. A. College of Education, Coimbatore – 642002 (First Cycle)',
  'P. S. G. College of Pharmacy, Coimbatore – 641004 (First Cycle)',
  'P.D.R. Vellachiammal College of Education, Dharmapuri Dist, 636902 (First Cycle)',
  'Paavai Engineering College, Namakkal, 637018 (First Cycle)',
  'Park College of Engineering and Technology, Coimbatore – 641659 (Second Cycle)',
  'Patrician College of Arts and Science, Chennai, 600020 (First Cycle)',
  'Periyar Arts College, Cuddalore, 607001 (Second Cycle)',
  'PGP College of Education, Namakkal, 637207 (Second Cycle)',
  'Pioneer College of Arts and Science, Jothipuram P.O., Periyanaickenpalayam, Coimbatore, 641047 (First Cycle)',
  "Pope's College, Thoothukudi Dist, 628251 (Second Cycle)",
  'Prathyusha Engineering College, Thiruvallur – 602025 (First Cycle)',
  'Providence College for Women, Coonoor – 643104 (Third Cycle)',
  'PSG College of Arts & Science (Autonomous), Civil Aerodrome Post, Coimbatore, 641014 (Third Cycle)',
  'PSGR Krishnammal College for Women (Autonomous), Peelamedu, Coimbatore, 641004 (Third Cycle)',
  'Quaid-E-Millat Government College For Women (Autonomous), Chennai, 600002 (Third Cycle)',
  "Queen Mary's College (Autonomous), Chennai – 600004 (Third Cycle)",
  'R. K. Samy College of Education, Ramanathapuram – 623527 (First Cycle)',
  'Raja Dorai Singam Government Arts College, Sivaganga – 630561 (Second Cycle)',
  'Rajah Serfoji Government College (Autonomous), Thanjavur – 613005 (Third Cycle)',
  'Rajalakshmi Engineering College, Chennai – 602105 (Second Cycle, Re-assessment)',
  'Rathinam College of Arts and Science (Autonomous), Coimbatore – 641021 (Second Cycle, Re-assessment)',
  'Roever College of Engineering and Technology, Perambalur – 621220 (First Cycle)',
  'RVS College of Engineering and Technology, Coimbatore – 641402 (First Cycle)',
  'S. K. R. Engineering College, Chennai – 600123 (First Cycle)',
  'S. V. I. College of Education, Tiruchirappalli – 620012 (First Cycle)',
  'S. Veerasamy Chettiar College of Engineering and Technology, Tirunelveli – 627855 (First Cycle)',
  'S.A. Engineering College, Chennai, 600077 (First Cycle)',
  'Sadakatullah Appa College,Rahmath Nagar, Tirunelveli – 627011 (Third Cycle)',
  'Sakthi College of Education for Women, Dindigul Dist, 624619 (First Cycle)',
  'Saraswathi Narayanan College, (Autonomous), Perungudi, Madurai – 625022 (Second Cycle)',
  'Sasurie College of Education, Tiruppur Dist, 638056 (First Cycle)',
  'SASURIE College of Engineering,Tiruppur – 638056 (First Cycle)',
  'Saveetha Engineering College, Saveetha Nagar, Chennai, 602105 (First Cycle)',
  "Sengamala Thayaar Educational Trust Women's College, Thiruvarur Dist, 614016 (First Cycle)",
  'Sengunthar Arts and Science College, Namakkal – 637205 (First Cycle)',
  'Sengunthar Engineering College, Namakkal District, Tiruchengode – 637205 (First Cycle)',
  'Sethu Institute of Technology,Virudhunagar – 626115 (First Cycle)',
  'Shrimati Indira Gandhi College, Tiruchirappalli, 620002 (Third Cycle)',
  'Sir Theagaraya College, Chennai, 600021 (Second Cycle)',
  'SNS College of Engineering, Coimbatore, 641107 (First Cycle)',
  "Sri Akilandewari Women's College, Vandavasi – 604408 (Second Cycle)",
  'Sri Eshwar College of Engineering, Coimbatore – 641202 (First Cycle)',
  'Sri K. Ramachandra Naidu College of Education, Sankarankoil – 627753 (First Cycle)',
  'Sri Kanyaka Parameswari Arts and Science College for Women, Chennai – 600001 (First Cycle)',
  'Sri Krishna Arts and Science College, Kuniamuthur P.O., Coimbatore – 641008 (Second Cycle)',
  'Sri Krishna College of Engineering And Technology (Autonomous), Coimbatore, 641008 (First Cycle)',
  'Sri Krishna College of Technology (Autonomous), Coimbatore, 641042 (First Cycle)',
  'Sri Ramakrishna College of Arts and Science for Women, Coimbatore – 641044 (First Cycle)',
  'Sri Ramakrishna Engineering College, Coimbatore – 641022 (First Cycle)',
  'Sri Ramakrishna Institute of Technology, Coimbatore – 641010 (First Cycle)',
  'Sri Ramakrishna Mission Vidyalaya College of Arts and Science (Autonomous), Coimbatore – 641020 (Third Cycle)',
  'Sri Ramakrishna Mission Vidyalaya Maruthi College of Physical Education, Coimbatore – 641020 (Second Cycle)',
  'Sri Sarada Niketan College for Women, Dist. Karaikudi, 630301 (First Cycle)',
  'Sri Vekkaliamman College of Education, Cuddalore Dist, 606304 (First Cycle)',
  'Sri Venkateshwara College of Education, Thanjavur Dist, 614804 (First Cycle)',
  'Sri Venkateswara College of Engineering,Sriperumbudur Taluk, Kancheepuram Dist, 602105 (Second Cycle)',
  'Sri Vidya Mandir Arts & Science College, Krishnagiri Dist, 636902 (First Cycle)',
  'St. Christopher’s College of Education (Autonomous), Vepery, Chennai, 600007 Tamil Nadu ( Third Cycle)',
  "St. Jude's College, Thoothoor, Kanyakumari District, Nagercoil – 629176 (Second Cycle)",
  "St. Xavier's College of Education (Autonomous), Palayamkottai, Tamil Nadu (Third Cycle)",
  'Stella Maris College (Autonomous), Cathedral Road, Chennai, 600086 (Third Cycle)',
  'Stella Matutina College of Education (Autonomous), Ashok Nagar, Chennai, 600083 Tamil Nadu ( Third Cycle)',
  'Tagore Engineering College, Chennai, 600127 (Second Cycle)',
  'Thavathiru Santhalinga Adigalar Arts, Science and Tamil College, Coimbatore – 641010 (First Cycle)',
  'The American College, Madurai – 625002 (Second Cycle)',
  'The New College, Chennai – 600014 (Third Cycle)',
  'The Quaide Milleth College for Men, Chennai – 600100 (Second Cycle)',
  'The Standard FireWorks Rajaratnam College for Women (Autonomous), Sivakasi, Virudhunagar , 602105 (Third Cycle)',
  'Thiagarajar College (Autonomous), Madurai, Tamil Nadu (Third Cycle)',
  'Thiru Kolanjiappar Government Arts College, Cuddalore – 606001 (Second Cycle)',
  'Thiruthangal Nadar College, Selavayal, Chennai – 600051 (First Cycle)',
  'Thiyagi Dharmakkan Amirtham College of Education, Ramanathapuram – 623135 (First Cycle)',
  'Valliammai Engineering College, Kancheepuram Dist, 603203 (First Cycle)',
  'Vel Tech Multi Tech Dr. Rangarajan Dr. Sakunthala Engineering College, Chennai – 600062 (First Cycle)',
  'Velammal College of Engineering and Technology, Madurai – 625009 (First Cycle)',
  'Velammal Engineering College, Chennai – 600066 (Second Cycle)',
  'Vellalar College For Women (Autonomous), Erode, 638012 (Third Cycle)',
  'Vickram College of Engineering, Sivaganga – 630561 (First Cycle)',
  "Vidhya Sagar Women's College, Chengalpattu – 603111 (First Cycle)",
  'Vivekananda College, Tiruvedakam West, Madurai – 625234 (Third Cycle)',
  'Vivekanandha College of Arts and Science for Women (Autonomous), Elayampalayam, Tiruchengode, Namakkal, 637205 (Second Cycle)',
  'Vivekanandha Institute of Engineering and Technology for Women, Namakkal – 637205(First Cycle)',
  'Vivekanandha Institute of Information and Management Studies, Namakkal – 637205 (First Cycle)',
  'A. D. M. College for Women (Autonomous), Velippalayam, Nagapattinam – 611001 (Third Cycle)',
  'Adhiparasakthi College of Pharmacy, Melmaruvathur, Kanchipuram – 603319 (Second Cycle)',
  'Adithya Institute of Technology, Kurumbapalayam Village, SS Kulum, Coimbatore – 641107 (First Cycle)',
  'Air Force Administrative College, Redfields, Coimbatore – 641018 (Second Cycle)',
  'Al-Ameen Engineering College, Karundevanpalayam, Nanjai Uthukkuli, Erode – 638104 (First Cycle)',
  'Alpha Arts and Science College, Porur, Chennai – 600116 (Second Cycle)',
  'Anna Adarsh College for Women, Anna Nagar, Chennai – 600040 (Second Cycle)',
  'Annai Theresa College of Education for Women, Pavithram, Thiruvannamalai – 606806 (First Cycle)',
  'Annai Velankanni College, Tholayavattam, Karungal, Kanyakumari – 629157 (First Cycle)',
  'Arignar Anna Government Arts College, Namakkal – 637002 (Second Cycle)',
  'Arignar Anna Government Arts College, Villupuram – 605602 (Second Cycle)',
  'Auxilium College (Autonomous), Vellore – 632006 (Third Cycle)',
  'Bhaktavatsalam Memorial College for Women, Periyar Nagar, Korattur, Chennai – 600080 (First Cycle)',
  'Bishop Appasamy College of Arts and Science, Coimbatore – 641018 (First Cycle)',
  'Bon Secours College of Education, Thanjavur – 613006 (Second Cycle)',
  'Caussanel College of Arts and Science, Angelo Nagar, Muthupettai, Ramanathapuram – 623523 (First Cycle)',
  'Cauvery College for Women, Annamalai Nagar, Tiruchirappalli – 620018 (Third Cycle)',
  'Chendhuran College of Engineering and Technology, Lenavilakku, Pilivalam, Thirumayam, Pudukottai – 622507 (First Cycle)',
  'Chennai Medical College Hospital and Research Centre, Irungalur, Mannachanallur, Tiruchirappalli – 621105 (First Cycle)',
  'Chikkaiah Naicker College, Erode – 638004 (First Cycle)',
  'CK College of Education, Jayaram Nagar, Chellankuppam, Cuddalore – 607003 (First Cycle)',
  'Dhirajlal Gandhi College of Technology, Sikkanampatti, Salem – 636309 (First Cycle)',
  'Dr. Sivanthi Aditanar College of Education, Tiruchendur, Thoothukudi – 628215 (Second Cycle)',
  'Dr. Umayal Ramanathan College for Women, Alagappapuram, Karaikudi – 630003 (First Cycle)',
  'Dr. Zakir Husain College, Ilayangudi, Sivagangai – 630702 (Third Cycle)',
  'E. M. Gopalakrishna Kone Yadava Women’s College, Thiruppalai, Madurai – 625014 (Third Cycle)',
  'Easwari Engineering College, Bharathi Salai, Ramapuram, Chennai – 600089 (First Cycle) Re-assessment',
  'Emerald Heights College for Women, Udhagamandalam - 643006 (Third Cycle)',
  'Er. Perumal Manimekalai College of Engineering, Hosur – 635117 (First Cycle)',
  "Erode Builder Educational Trust's Group of Institutions, Nathakkadaiyur, Kangayam, Tirupur – 638108 (First Cycle)",
  'Government Arts College (Men), Krishnagiri – 635001 (Second Cycle)',
  'Government Arts College For Women, Gorimedu, Salem – 636008 (Third Cycle)',
  'Government Arts College for Women, Sathyamoorthy Road, Pudukkottai – 622001 (Third Cycle)',
  'Government Arts College, Salem Main Road, Dharmapuri – 636705 (Second Cycle)',
  'Government Thirumagal Mills College, Gandhi Nagar, Gudiyattam, Vellore – 632602 (Second Cycle)',
  'Holy Cross Home Science College, Thoothukudi – 628003 (Second Cycle)',
  'Immanuel Arasar College of Education, Kanyakumari – 629195 (Second Cycle)',
  'Indhira College of Education, Pandur, Thiruvallur – 631203 (Second Cycle)',
  'Info Institute of Engineering, Kovilpalayam, Coimbatore – 641107 (First Cycle)',
  'JCT College of Engineering and Technology, Pitchanur, Coimbatore – 641105 (First Cycle)',
  'K. C. S. Kasi Nadar College of Arts and Science, R. K. Nagar, Chennai – 600021 (First Cycle)',
  'K. M. G. College of Arts and Science, Gudiyattam, Katpa(First Cycle) di, Vellore – 635803',
  'K. Ramakrishnan College of Technology, Tiruchirappalli – 621112 (First Cycle)',
  'K. S. R. College of Engineering, Tiruchengode, Namakkal – 637215 (First Cycle)',
  'K. S. Rangasamy College of Arts and Science (Autonomous), Tiruchengode – 637215 (Second Cycle)',
  'KG College of Arts and Science, Coimbatore – 641035 (First Cycle)',
  'Kings College of Engineering, Thanjavur – 613303 (First Cycle)',
  'Kings Engineering College, Irungattukottai, Sriperumbudur, Kancheepuram, Chennai – 602117 (First Cycle)',
  'Knowledge Institute of Technology, Kakapalayam, Salem – 637504 (First Cycle)',
  'Kongunadu College of Engineering and Technology, Tiruchirappalli – 621215 (First Cycle)',
  'Kovai Kalaimagal College of Arts and Science, Coimbatore – 641109 (Second Cycle)',
  'Kumaraguru College of Technology, Coimbatore – 641006 (Second Cycle)',
  'Loyola College of Education, Nungambakkam, Chennai – 600034 (Second Cycle)',
  'M. A. M. School of Engineering, Siruganur, Tiruchirappalli – 621105 (First Cycle)',
  'Mar Ephraem College of Engineering and Technology, Elavuvilai, Marthandam, Kanyakumari – 629171 (First Cycle)',
  'Meenatchi Physical Education College, Thathanur, Udayarpalayam, Ariyalur, Perambalur – 621804 (First Cycle)',
  'Nadar Mahajana Sangam S. Vellaichamy Nadar College, Nagamalai, Madurai – 625019 (Third Cycle)',
  'Nanjil Catholic College of Arts and Science, Nedumcode, Kaliyakkavilai, Kanyakumari, Nagercoil – 629153 (First Cycle)',
  'National College, Dindigul Road, Karmandapam, Tiruchirapalli – 620001 (Third Cycle)',
  'National Engineering College, Kovilpatti, Thoothukudi – 628503 (First Cycle, Re-assessment)',
  'Nehru College of Management, Thirumalayampalayam, Coimbatore – 641105 (First Cycle)',
  'Nehru Institute of Engineering and Technology, Thirumalayampalayam, Coimbatore – 641105 (First Cycle)',
  'New Prince Shri Bhavani College of Engineering and Technology, Gowrivakkam, Chennai – 600073 (First Cycle)',
  'P. A. College of Engineering and Technology, Pollachi – 642002 (First Cycle)',
  'P. R. Engineering College, Vallam, Thanjavur – 613403 (First Cycle)',
  "Park's College, Chinnakkarai, Tiruppur, Coimbatore – 641605 (Third Cycle)",
  'Paspo College of Education, Dharmapuri – 636807 (First Cycle)',
  'Periyar E. V. R. College (Autonomous), Tiruchirappalli – 620023 (Third Cycle)',
  'Pioneer Kumaraswamy College, Nagercoil – 629003 (First Cycle)',
  'PPG Institute of Technology, Saravanampatti, Coimbatore – 641035 (First Cycle)',
  'PSN College of Engineering and Technology, Melathediyoor, Palayamkottai, Tirunelveli – 627152 (Second Cycle)',
  'PSNA College of Engineering and Technology, Kothandaraman Nagar, Muthanampatti, Dindigul – 624622 (First Cycle)',
  'R. M. D. Engineering College, Kavaraipettai, Gummidipoondi, Thiruvallur, Chennai – 601206 (First Cycle)',
  'R. M. K. College of Engineering and Technology, Puduvoyal, Gummidipoondi, Tiruvallur, Chennai – 601206 (First Cycle)',
  'R. M. K. Engineering College, Kavaraipettai, Gummidipoondi, Thiruvallur, Chennai – 601206 (First Cycle)',
  'Ramakrishna Mission Vivekananda College, Sir P S Sivaswami Salai, Mylapore, Chennai – 600004 (Third Cycle)',
  'Ramya Sathianathan College of Education, Thanjavur – 613402 (First Cycle)',
  'Rani Anna Government College for Women, Gandhinagar, Tirunelveli – 627008 (Third Cycle)',
  'RVS Technical Campus, Kannampalayam, Coimbatore – 641402 (First Cycle)',
  'S. V. S. College of Engineering, Coimbatore – 642109 (First Cycle)',
  'Selvam College of Technology, Namakkal – 637003 (First Cycle)',
  'Servite College of Education for Women, Karur – 621313 (Second Cycle)',
  'Sethupathi Government Arts College, Achunthanvayal, Ramanathapuram – 623502 (Second Cycle)',
  'Shanmuganathan Engineering College, Pudukkottai – 622507 (First Cycle)',
  'Shrimathi Devkunvar Nanalal Bhatt Vaishnav College for Women, Chromepet, Chennai – 600044 (Third Cycle) 7 Years Validity',
  'SNS College of Technology, Vazhiyampalayam, Saravanampatti, Coimbatore – 641035 (Second Cycle)',
  'Sree Narayana Guru College, K. G. Chavadi, Coimbatore – 641105 (Second Cycle)',
  'Sree Shakthi Engineering College, Karamadai, Coimbatore – 641104 (First Cycle)',
  'Sri Balaji College of Education, Irumbedu, Arni, Tiruvannamalai – 632317 (Second Cycle)',
  'Sri Bharathi College of Education, Pudukkottai – 622303 (Second Cycle)',
  'Sri Parasakthi College for Women (Autonomous), Thirunelveli, Tenkasi – 627802 (Third Cycle)',
  'Sri Ram Nallamani Yadava College of Education, Tenkasi, Tirunelveli – 627804(First Cycle)',
  'Sri Ramakrishna Mission Vidyalaya College of Education (Autonomous), Perianaickenpalayam, Coimbatore – 641020 (Second Cycle)',
  'Sri S. Ramasamy Naidu Memorial College, Sadayampatty, Sattur, Virudhunagar – 626203 (Third Cycle)',
  'Sri Sarada College for Women, Tirunelveli – 627011 (Second Cycle)',
  'Sri Shanmugha College of Engineering and Technology, Pullipalayam, Morur, Sankari, Salem – 637304 (First Cycle)',
  'Sri Sivasubramaniya Nadar College of Engineering, Kalavakkam, Kanchipuram, Chennai – 603110 (Second Cycle)',
  'Sri Vijay Vidyalaya College of Arts and Science, Nallampalli, Dharmapuri – 636807 (First Cycle)',
  'Srimath Sivagnana Balaya Swamigal Tamil, Arts and Science College, Mailam, Tindivanam, Villupuram – 604304 (First Cycle)',
  "St. John's College of Education, Palayamkottai, Tirunelveli – 627002 (First Cycle)",
  'St. Joseph’s College of Arts and Science (Autonomous), Manjakuppam, Cuddalore – 607001 (Third Cycle)',
  "St. Peter's College of Engineering and Technology, Chennai – 600054 (First Cycle)",
  "St. Xavier's Catholic College of Engineering, Chunkakkadai, Nagercoil – 629003 (First Cycle)",
  'The Madras School of Social Work, Chennai – 600008 (Third Cycle)',
  'The Madura College (Autonomous), Vidya Nagar, Madurai – 625011 (Third Cycle)',
  'Thiruvalluvar College, Vickramasingapuram, Papanasam, Tirunelveli – 627425 (Second Cycle)',
  'Thiruvalluvar College, Vickramasingapuram, Papanasam, Tirunelveli – 627425 (Second Cycle)',
  'Thiruvalluvar Government Arts College, Rasipuram, Andagalur, Namakkal – 637401 (Third Cycle)',
  'United Institute of Technology, Coimbatore – 641020 (First Cyc e)',
  'V. O. Chidambaram College, Thoothukudi – 628008 (Third Cycle)',
  'V. S. B. Engineering College, Karur – 639111 (First Cycle)',
  'Vel Tech High Tech Dr. Rangarajan Dr. Sakunthala Engineering College, Chennai – 600062 (First Cycle)',
  'Velammal Institute of Technology, Panchetti, Ponneri, Chennai – 601204 (First Cycle)',
  'Vidyaa Vikas College of Engineering and Technology, Namakkal – 637214 (First Cycle)',
  'Vivekananda College of Education, Kummangudi, Adhikaram, Tirupathur, Sivagangai – 630207 (First Cycle)',
  'Vivekanandha College of Engineering for Women, Elayampalayam, Tiruchengode, Namakkal – 637205 (First Cycle)',
  'Vysya College, Salem – 636103 (Third Cycle)',
  'Women’s Christian College, Nagercoil – 629001 (Second Cycle)',
  'Annai Fathima College of Arts and Science (First Cycle)',
  'Dr. R. K. Shanmugam College of Arts and Science (First Cycle)',
  'A. V. C. College of Engineering (Second Cycle)',
  'Adhiyamaan College of Engineering (Autonomous) (Second Cycle)',
  'Coimbatore Institute of Management and Technology (Autonomous) (Second Cycle)',
  'Alagappa Government Arts College (Third Cycle)',
  'Government Arts College (Autonomous), Salem (Third Cycle)',
  "Kandaswami Kandar's College (Third Cycle)",
  'Kongu Arts and Science College (Third Cycle)',
  'V. V. Vanniaperumal College for Women (Autonomous) (Third Cycle)',
  'COIMBATORE INSTITUTE OF TECHNOLOGY, CIVIL AERODROME POST, AVINASHI ROAD, COIMBATORE , 641014 (First Cycle)',
  'PRESIDENCY COLLEGE (AUTONOMOUS), KAMARAJ SALAI, TRIPLICANE (Third Cycle)',
  'Sri Sathguru Sangeetha Vidyalayam,15A Gokhale Road Tallakulam,Madurai - 625002 (First Cycle)',
  'Government College of Technology, Coimbatore,Thadagam Road,Coimbatore - 641 013 (First Cycle)',
  'Prince Shri Venkateshwara Padmavathy Engineering College,Medavakkam-Mambakkam Main Road, Ponmar,Chennai - 600127 (First Cycle)',
  'National Institute for Empowerment of Persons with Multiple Disabilities (NIEPMD),Muttukadu, Kovalam Post, ECR,Chennai - 603112 (First Cycle)',
  'Dhaanish Ahmed College of Engineering,Dhaanish Nagar, Padappai,(Near Tambaram) Vanchuvancheri,Chennai - 601301 (First Cycle)',
  'Government College of Engineering, Salem,NH7, Bangalore Highways,Salem - 636011 (First Cycle)',
  'Dhanalakshmi College of Engineering,Manimangalam, Puducheri Road, Manimangalam Post, Sriperumbudur, Kanchipuram ,Chennai - 601301 (First Cycle)',
  'Sona College of Technology,Junction Main Road, Suramangalam,Salem - 636 005 (Second Cycle)',
  'Vivekananda College,Agasteeswaram,Kanyakumari - 629701 (Second Cycle)',
  'K. S. Rangasamy College of Technology (Autonomous),K. S. R. Kalvi Nagar, Thokkavadi (PO) Tiruchengode,Namakkal - 637215 (Second Cycle)',
  'Thanthai Hans Roever College,Elambalur,Perambalur - 621220 (Second Cycle)',
  'Guru Nanak College,Velachery,Chennai - 600042 (Third Cycle)',
  'Sree Saraswathi Thyagaraja College,Palani Road, Pollachi,Coimbatore - 642107 (Third Cycle)',
  'Sri Kumara Gurupara Swamigal Arts College,Padmanabhamangalam,Srivaikuntam - 628619 (Third Cycle)',
  'Dhanalakshmi Srinivasan College of Arts and Science for Women,,Perambalur - 621212 (Third Cycle)',
  'CMS College of Science and Commerce,Chinnavedampatty (Post),Coimbatore - 641049 (Third Cycle)',
  'Mannar Thirumalai Naicker College,Pasumalai,Madurai - 625004 (Third Cycle)',
  'Subbalakshmi Lakshmipathy College of Science,TVR Nagar, Aruppukottai Road,Madurai - 625022 (Fourth Cycle)',
  'Nadar Mahajana Sangam Sermathai Vasan College for Women,Periyar Nagar Main Road, Samanatham, Avaniyapuram,Madurai - 625012 (First Cycle)',
  'K.L.N.College of Engineering,Madurai-Nedunkulam Road, Pottapalayam ,Sivagangai - 630612 (First Cycle) ',
  'Gnanam School of Business,Trichy - Thanjavur Express Way, Sengipatti,Thanjavur - 613402 (First Cycle)',
  'Erode Arts and Science College,205, Chennimalai Road, Rangampalayam,Erode - 638009 (Third Cycle)',
  'Thassim Beevi Abdul Kader College for Women,Pearl Matriculation Hr Sec School Road Kilakarai ,Ramnad - 623517 (Third Cycle)',
  'SACRED HEART COLLEGE (AUTONOMOUS), Vaniyambadi Road, Tirupattur, Vellore District.,Tirupattur , 635601 (Fourth Cycle)',
  "VIRUDHUNAGAR HINDU NADARS' SENTHIKUMARA NADAR COLLEGE,Virudhunagar Hindu Nadars Senthikumara Nadar College, 3/151-1, College Road, Virudhunagar, Tamil Nadu., Virudhunagar , 626001 (Fourth Cycle)",
  'SREE DEVI KUMARI WOMENS COLLEGE, KUZHITHURAI,Thettivilai village, vilavancode Taluk, Kuzhithurai,Kuzhithurai , 629163 (Second Cycle)',
  'A.P.C.MAHALAXMI COLLEGE FOR WOMEN,Ettayapuram Road Thoothukudi,Thoothukudi , 628002 (Third Cycle)',
  'SAIVA BHANU KSHATRIYA COLLEGE,THOTTIYANKULAM ROAD ARUPPUKOTTAI 626101,ARUPPUKOTTAI , 626101 (Third Cycle)',
  'PSG COLLEGE OF TECHNOLOGY,Avinashi Road, Peelamedu,Coimbatore , 641004 (First Cycle)',
  'C. ABDUL HAKEEM COLLEGE,Hakeem Nagar, Melvisharam,Melvisharam , 632509 (Third Cycle)',
  'SOURASHTRA COLLEGE,Vilachery Main Road, Pasumalai Post, Madurai-4,Madurai , 625004 (Third Cycle)',
  'SRI KALISWARI COLLEGE,A. Meenakshipuram, Anaikuttam (P.O), Sivakasi , 626130 (Third Cycle)',
  'THEIVANAI AMMAL COLLEGE FOR WOMEN,VILLUPURAM , 605401 , Chennai - Trichy Trunk Road,VILLUPURAM , 605401 (Third Cycle)',
  'KUNTHAVAI NAACCHIYAAR GOVERNMENT ARTS COLLEGE FOR WOMEN (AUTONOMOUS),THANJAVUR- 613007,Thanjavur , 613007 (Fourth Cycle)',
  'SRI G.V.G. VISALAKSHI COLLEGE FOR WOMEN (AUTONOMOUS),Sri Venkatesa Mills Post, Palani Road, Udumalpet,Tiruppur , 642128 (Fourth Cycle)',
  'EXCEL ENGINEERING COLLEGE (Re-assessment) ,NH-544, SALEM MAIN ROAD, PALLAKAPALAYAM, KOMARAPALAYAM, NAMAKKAL DT -637303 (First Cycle)',
  "ISLAMIAH WOMEN'S ARTS AND SCIENCE COLLEGE,By Pass Road, Newtown VANIYAMBADI , 635752,VANIYAMBADI , 635752 (First Cycle)",
  'MAHENDRA INSTITUTE OF TECHNOLOGY,SALEM-TIRUCHENGODE HIGHWAY, MAHENDHIRAPURI, MALLASAMUDRAM,NAMAKKAL-637503 (First Cycle)',
  'RAMCO INSTITUTE OF TECHNOLOGY,North Venganallur village, Krishnapuram Panchayat, Rajapalayam - 626 117, Virudhunagar District, Tamil Nadu,Rajapalayam , 626117 (First Cycle)',
  "SRI ADI CHUNCHANAGIRI WOMEN'S COLLEGE, CUMBUM,Cumbum - Kumily Road Cumbum Theni District,CUMBUM 625516 (First Cycle)",
  "ST.JOSEPH'S COLLEGE FOR WOMEN, TIRUPUR,Kangeyam Road, Tirupur, Tirupur , 641604 (First Cycle)",
  'EDAYATHANGUDY G.S. PILLAY ARTS AND SCIENCE COLLEGE,Old Nagore Road, Thethi Village, Nagore Post, Nagapattinam,Nagapattinam , 611002 (First Cycle)',
  'HAJEE KARUTHA ROWTHER HOWDIA COLLEGE,Kombai Road, Uthamapalayam P.O.,Uthamapalayam , 625533 (Third Cycle)',
  'ARUMUGAM PILLAI SEETHAI AMMAL COLLEGE,ARUMUGAM PILLAI ROAD TIRUPPATTUR SIVAGANGAI DISTRICT, Tiruppattur , 630211 (Third Cycle)',
  'SREE AYYAPPA COLLEGE FOR WOMEN,Chunkankadai Nagercoil,Nagercoil , 629003 (Third Cycle)',
  'THIAGARAJAR COLLEGE OF ENGINEERING, Madurai - 625015, Tamil Nadu, Madurai - 625015, Tamil Nadu (First Cycle)',
  "ST. MARY'S COLLEGE(AUTONOMOUS),104, North Beach Road,Thoothukudi , 628001 (Fourth Cycle)",
  'ARIGNAR ANNA GOVERNMENT ARTS COLLEGE,ARIGNAR ANNA GOVERNMENT ARTS COLLEGE, CHEYYAR - 604407 (Third Cycle)',
  'SENTHAMIL COLLEGE,54, TAMIL SAGAM ROAD, MADURAI , 625001 (Second Cycle)',
  'GOVERNMENT ARTS COLLEGE,TRICHY MAIN ROAD MELUR - 625106 MADURAI DISTRICT,MELUR MADURAI,Tamil Nadu,625106 (Second Cycle)',
  'NALLAMUTHU GOUNDER MAHALINGAM COLLEGE,Nallamuthu Gounder Mahalingam College, 90 Palghat Road, Pollachi, Coimbatore District.,POLLACHI,Tamil Nadu,642001 (Third Cycle)',
  'NAZARETH COLLEGE OF ARTS AND SCIENCE,Nazareth College of Arts and Science Kovilpathagai Main Road, Kannadapalayam Avadi Chennai- 600062 Tamilnadu,CHENNAI,Tamil Nadu,600062 (Second Cycle)',
  "WOMEN'S CHRISTIAN COLLEGE,Womens Christian College 51 College Road Chennai 600006,CHENNAI,Tamil Nadu,600006 (Fourth Cycle)",
  'MOHAMED SATHAK ENGINEERING COLLEGE,East Coast Road, Mayakulam Panchayat, Kilakarai,RAMANATHAPURAM,Tamil Nadu,623806 (First Cycle)',
  'MARUDHAR KESARI JAIN COLLEGE FOR WOMEN,MARUDHAR NAGAR, CHINNAKALLUPALLI, VANIYAMBADI, VELLORE DISTRICT.,VANIYAMBADI,Tamil Nadu,635751 (Third Cycle) ',
  "ST. JOSEPH'S COLLEGE,Near Teppakulam Post Office,Tiruchirappalli,Tamil Nadu,620002 (Fourth Cycle, Seven Years Valid)",
  'SEETHALAKSHMI RAMASWAMI COLLEGE, Seethalakshmi Ramaswami College Sankaranpillai Road Tiruchirappalli,Tiruchirappalli,Tamil Nadu,620002 (Fourth Cycle)',
  'KRISHNASAMY COLLEGE OF SCIENCE, ARTS AND MANAGEMENT FOR WOMEN, Krishnasamy College of Science, Arts and Management For Women, Anand Nagar, Nellikuppam Main Road, S.Kumarapuram, Cuddalore - 607 109,Cuddalore,Tamil Nadu,607109 (First Cycle)',
  'J.K.K. NATARAJA COLLEGE OF ARTS AND SCIENCE, NH-544 (Salem to Coimbatore) Natarajapuram, Komarapalayam-638183,Namakkal,Tamil Nadu,638183 (First Cycle)',
  'ARIGNAR ANNA GOVERNMENT ARTS COLLEGE, ARIGNAR AMMA GOVERNMENT ARTS COLLEGE VADACHENNIMALAI POST ATTUR TK SALEM DT,SALEM,Tamil Nadu,636121 (Second Cycle)',
  'AGURCHAND MANMULL JAIN COLLEGE, Meenambakkam, Chennai,Chennai,Tamil Nadu,600114 (Third Cycle)',
  "ST. JOSEPH'S COLLEGE OF ENGINEERING, Old Mammallapuram road, Chennai,CHENNAI,Tamil Nadu,600119 (First Cycle)",
  'HOLY CROSS COLLEGE (AUTONOMOUS), Holy Cross College (Autonomous), Roch Nagar, Kurusady.,Nagercoil,Tamil Nadu,629004 (Fourth Cycle)',
  'V.R.S. COLLEGE OF ENGINEERING AND TECHNOLOGY , NH 45, Arasur Post, Ulundurpet Taluk, Villupuram District,Arasur,Tamil Nadu,607107 (Second Cycle)',
  "ST. XAVIER'S COLLEGE (AUTONOMOUS) , ST XAVIERS COLLEGE(AUTONOMOUS) 21 NORTH HIGHGROUND ROAD PALAYAMKOTTAI,Palayamkottai,Tamil Nadu,627002 (Fourth Cycle)",
  'TAGORE INSTITUTE OF ENGINEERING AND TECHNOLOGY,Salem-Chennai Main Road, Deviyakurichi (PO), Attur (TK), Salem (DT).,Salem , 636112 (First Cycle)',
  'KCG COLLEGE OF TECHNOLOGY,KCG College of Technology, KCG Nagar, Rajiv Gandhi Salai, Old Mahabalipuram Road (OMR), Karapakkam,Chennai,Tamil Nadu,600097 (First Cycle)',
  'GANESAR COLLEGE OF ARTS AND SCIENCE,Melaisivapuri, Ponnamaravathi Taluk, Pudukkottai District,Melaisivapuri Pudukkottai District,Tamil Nadu,622403 (First Cycle)',
  'MANGAYARKARASI COLLEGE OF ARTS AND SCIENCE FOR WOMEN,Mangayarkarasi Nagar,Madurai,Tamil Nadu,625402 (Second Cycle)',
  'T.J.S.ENGINEERING COLLEGE,T.J.S ENGINEERING COLLEGE, TJS NAGAR, PERUVOYAL, NEAR KAVARAIPETTAI, THIRUVALLUR DISTRICT.,Thiruvallur,Tamil Nadu,601206 (First Cycle)',
  'SMK FOMRA INSTITUTE OF TECHNOLOGY,SMK FOMRA INSTITUTE OF TECHNOLOGY FOMRA NAGAR RAJIV GANDHI SALAI, OMR (IT HIGHWAY) KELAMBAKKAM,CHENNAI,Tamil Nadu,603103 (First Cycle)',
  'CHEVALIER T. THOMAS ELIZABETH COLLEGE FOR WOMEN,No.16, St.Marys Road, Maryland, Sembium, Perambur,Chennai,Tamil Nadu,600011 (Second Cycle)',
  'MADURAI INSTITUTE OF SOCIAL SCIENCES,MADURAI INSTITUTE OF SOCIAL SCIENCES 9.ALAGR KOIL ROAD MADURAI,Madurai,Tamil Nadu,625002 (Third Cycle)',
  'CAPE INSTITUTE OF TECHNOLOGY,CAPE INSTITUTE OF TECHNOLOGY, LEVENGIPURAM RAJAKRISHNAPURAM POST, TIRUNELVELI DISTRICT,Levengipuram Tirunelveli District,Tamil Nadu,627114 (First Cycle)',
  'MADRAS CHRISTIAN COLLEGE,East Tambaram, Velachery Main Road,Chennai,Tamil Nadu,600059 (Third Cycle)',
  "NARASU'S SARATHY INSTITUTE OF TECHNOLOGY,POOSARIPATTY, KADAYAMPATTY TALUK, SALEM,POOSARIPATTY SALEM,Tamil Nadu,636305 (First Cycle)",
  'AALIM MUHAMMED SALEGH COLLEGE OF ENGINEERING,NIZARA EDUCATIONAL CAMPUS MUTHAPUDUPET AVADI I.A.F.,,CHENNAI,Tamil Nadu,600055 (First Cycle)',
  'DR.SNS RAJALAKSHMI COLLEGE OF ARTS AND SCIENCE (AUTONOMOUS),Principal Dr.SNS Rajalakshmi College of Arts and Science (Autonomous) 486,Thudiyalur - Saravanampatti Road Chinnavedampatti Post,Coimbatore,Tamil Nadu,641049 (Third Cycle)',
  'PALANISAMY COLLEGE OF ARTS,Palanisamy College of Arts, Erode Road, Perundurai,Perundurai,Tamil Nadu,638052 (First Cycle)',
  "RAJAPALAYAM RAJUS' COLLEGE,Mudangiar Road Rajapalayam-626117 Virudhunagar District,RAJAPALAYAM,Tamil Nadu,626117 (Third Cycle)",
  'Arasu Engineering College,Chennai Main Road, Thiruvisanallur, Kumbakonam, Koranattu Karuppur(PO), Thiruvidaimuruthur Taluk, Thanjavur,Kumbakonam - 612501 (First Cycle)',
  'C. Kandaswami Naidu College for Women,Nellikuppam Main Road, Semmandalam,Cuddalore - 607001 (First Cycle)',
  'Shri Shankarlal Sundarbai Shasun Jain College for Women,No.3, Madley Road, T.Nagar,Chennai - 600017 (Second Cycle)',
  'Dr. Mahalingam College of Engineering and Technology,Udumalai Road, Makkinaickenpatti Post, Pollachi,Coimbatore - 642003 (Second Cycle)',
  'Hindustan College of Arts and Science,Rajiv Gandhi Salai, Padur, Kelambakkam,Chennai - 603103 (Second Cycle)',
  'Scott Christian College,KP Road, Kanyakumari,Nagercoil - 629003 (Third Cycle)',
  'Dhanraj Baid Jain College,Rajiv Gandhi Salai, Jothi Nagar, Thorapakkam,Chennai - 600097 (Third Cycle)',
  'Rajeswari Vedachalam Government Arts College,G. S. T. Road,Chengalpattu - 603001 (Third Cycle)',
  'Sri Sairam Institute of Technology,Sai Leo Nagar, West Tambaram,Chennai - 600044 (First Cycle)',
  'Sri Shakthi Institute of Engineering and Technology,Sri Shakthi Nagar, L and T Bypass Road, Chinniyampalayam,Coimbatore - 641062 (First Cycle)',
  'Karpaga Vinayaga College of Engineering and Technology,GST Road, Chinna Kolambakkam, Palayanoor Post, Maduranthagam Taluk,Kancheepuram - 603308 (First Cycle)',
  'Sri Muthukumaran Institute of Technology,Chikkarayapuram, Near Mangadu,Chennai - 600069 (First Cycle)',
  'Sri Sarada Niketan College of Science for Women,Esanatham Road, Kodangipatti Village, Thanthonimalai Post,Karur - 639005 (Second Cycle)',
  'Navarasam Arts and Science College for Women,Arachalur ,Erode - 638101 (Second Cycle)',
  'Sree Ramu College of Arts and Science,N.M.Sungam, Vedasanthur (Post), Pollachi,Coimbatore - 642007 (Third Cycle)',
  'The Madurai Diraviyam Thayumanavar Hindu College,Pettai,Tirunelveli - 627010 (Third Cycle)',
  'Shri Nehru Maha Vidyalaya College of Arts and Science,Shri Gambhirmal Bafna Nagar, Malumachampatti,Coimbatore - 641050 (Third Cycle)',
  'Kalai Kaviri College of Fine Arts,No.18, Benwells Road Cantonment,Tiruchirappalli - 620001 (Third Cycle)',
  'Chellammal Womens College,112, Annasalai, Guindy,Chennai - 600032 (First Cycle)',
  'The Central Law College, Salem,Yearcaud Main Road, Kannankurichi Post,Salem - 636008 (First Cycle)',
  'Sri Sai Ram Engineering College,Sai Leo Nagar, Poonthandalam Village, Dharkast Post, West Tambaram,Kancheepuram - 600044 (First Cycle)',
  'Arulmigu Palaniandavar Arts College for Women,Chinnakalayamputhur,Palani - 624615 (Third Cycle)',
  'GOVERNMENT ATRS COLLEGE FOR MEN,329, ANNA SALAI, NANDANAM, CHENNAI 600 035,CHENNAI , 600035 (Third Cycle)',
  'ADHI COLLEGE OF ENGINEERING AND TECHNOLOGY,No.06, Munu Adhi Nagar,Puliyampakkam Post, Near Walajabad, Sankarapuram,Chennai , 631605 (First Cycle)',
  'GOVERNMENT ARTS COLLEGE FOR WOMEN,RAMANATHAPURAM,Sigil Raja Veethi, Ramanathapuram, RAMANATHAPURAM , 623501 (First Cycle)',
  'SSM INSTITUTE OF ENGINEERING AND TECHNOLOGY,Kuttathupatti Village, Sindalagundu Post, Palani Road, Dindigul - 624 002, Dindigul , 624002 (First Cycle)',
  'J. V. R. Government College, Sathupally, Khammam – 507303 (Second Cycle)',
  'Sri Sai College of Dental Surgery, Vikarabad – 501102 (First Cycle)',
  'Akarapu Sharath Chandrika Devi Memorial College for Women, Warangal – 506002 (Second Cycle)',
  'Annamacharya Institute of Technology & Science, Ranga Reddy Dist, 501512 (First Cycle)',
  'Army College of Dental Sciences, Secunderabad – 500087 (First Cycle)',
  'Babu Jagjivan Ram Government Degree College, Hyderabad, 500 001 (First Cycle)',
  'C. K. M. Arts and Science College, Desaipet, Warangal – 506006 (Second Cycle)',
  'Christu Jyothi Institute of Technology & Science, Warangal Dist, 506167 (First Cycle)',
  'CVR College of Engineering, Hyderabad - 501510 (First Cycle)',
  'Government Arts and Science College, Kamareddy, Nizamabad – 503111 (Second Cycle)',
  'Government Degree and P. G. College, Bhadrachalam, Khammam – 507111 (Second Cycle)',
  'Government Degree College for Women, Adilabad – 504001 (Second Cycle)',
  'Government Degree College for Women, Jagtial, Karimnagar – 505327 (First Cycle)',
  'Government Degree College for Women, Mahaboobnagar, Wanaparthy – 509103 (Second Cycle)',
  'Government Degree College for Women, Ramagiri, Nalgonda – 508001 (Second Cycle)',
  'Government Degree College for Women, Sangareddy, Medak – 502001 (Second Cycle)',
  'Government Degree College, Mahabubabad, Warangal – 506101 (Second Cycle)',
  'Government Degree College, Bichkunda, Nizamabad – 503306 (First Cycle)',
  'Government Degree College, Dist. Nizamabad, 503185 (Second Cycle)',
  'Government Degree College, Dist. Warangal, 506165 (First Cycle)',
  'Government Degree College, Huzurabad, Karimnagar – 505498 (Second Cycle)',
  'Government Degree College, Hyderabad, 500004 (Second Cycle)',
  'Government Degree College, Mancherial, Adilabad – 504208 (Second Cycle)',
  'Government Degree College, Manthani Mandal, Karimnagar – 505184 (First Cycle)',
  'Government Degree College, Medak Dist, 502220 (First Cycle)',
  'Government Degree College, Paloncha, Khammam – 507115 (First Cycle)',
  'Government Degree College, Sudimalla, Khammam, Yellandu – 507123 (Second Cycle)',
  'Government Degree College, Warangal Dist, 506132 (Second Cycle)',
  'Government Degree College, Dist. Nalgonda – 508113 (Second Cycle)',
  'Holy Mary Institute of Technology And Science, Ranga Reddy Dist, 501301 (First Cycle)',
  'Institute of Aeronautical Engineering, Hyderabad – 500043 (First Cycle)',
  'J. B. Institute of Engineering and Technology, Rangareddy – 500075 (Second Cycle)',
  'Jagruti Institute of Engineering & Technology, Ranga Reddy Dist, 501510 (First Cycle)',
  'K. R. R. Government Arts and Science College, Kodad, Nalgonda – 508206 (Second Cycle)',
  'Kamineni Institute of Dental Sciences, Nalgonda Dist, 508254 (Second Cycle)',
  'Kamineni Institute of Medical Sciences,Sreepuram, Narketpally, Nalgonda – 508254 (Second Cycle)',
  'Lords Institute of Engineering and Technology, Hyderabad – 500091 (First Cycle)',
  'M.A.L.D. Government Arts & Science College, Mahaboobnagar, 509125 (Second Cycle)',
  'Madhu Malancha Government Degree College, Nizamabad – 503180 (Second Cycle)',
  'Malla Reddy Engineering College (Autonomous), Maisammaguda, Secunderabad, 500100 (Second Cycle)',
  'Mamata Educational Society Mamata Dental College, Khammam – 507002 (Second Cycle)',
  'Mamata Medical College, Khammam, 507002 (Second Cycle)',
  'Marri Laxman Reddy Institute of Technology & Management, Dundigal, Hyderabad, 500043 (First Cycle)',
  'MLR Institute of Technology,Dundigal, Hyderabad – 500043 (First Cycle)',
  'Narsimha Reddy Engineering College, Secunderabad, 500014 (First Cycle)',
  'Osmania University College for Women (Autonomous), Hyderabad, 500095 (Third Cycle, Re-assessment)',
  'Ramnath Guljarilal Kedia College of Commerce, Hyderabad, 500027 (Second Cycle)',
  'S. R. N. K. Government Degree College, Banswada, Nizamabad – 503187 (First Cycle)',
  'S.K.N.R. Government Arts & Science College, Dist. Karimnagar, 505327 (Second Cycle)',
  'S.R. Engineering College, Dist. Warangal, 506371 (First Cycle)',
  'Sardar Patel College, Secunderabad, Hyderabad – 500025 (Second Cycle)',
  "Singareni Collieries Women's Degree College, Khammam Dist, 507101 (Second Cycle)",
  'Sphoorthy Engineering College, Ranga Reddy Dist, 501510 (First Cycle)',
  'Sri Lakshmi Narasimha Swamy College, Bhongir, Nalgonda – 508116 (First Cycle)',
  'Sri Venkateswara College, Nalgonda Dist, 508213 (Second Cycle)',
  'St. Ann’s College of Education (Autonomous), Secunderabad, 500003 (Third Cycle)',
  'Sujatha Degree and P.G. College for Women, Chapel Road, Abdis, Hyderabad, 500001 (First Cycle)',
  'Vidya Jyothi Institute of Technology, Hyderabad – 500075 (First Cycle)',
  'Vignana Bharathi Institute of Technology,Ranga Reddy Dist, 501301 (First Cycle)',
  'Vignana Jyothi Institute of Management,Hyderabad, 500090 (First Cycle)',
  'Vivekananda Government College, Hyderabad, 500044 (First Cycle)',
  "Women's College, Nizamabad – 503002 (First Cycle)",
  'ACE Engineering College, Ankushapur, Ghatkesar, RR District, Hyderabad – 501301 (First Cycle)',
  'Anurag Group of Institutions, Venkatapur, Ghatkesar, Medchal, Hyderabad – 500088 (First Cycle)',
  'Anwarul Uloom College (Autonomous), New Mallepally, Hyderabad – 500001 (Second Cycle)',
  'B. V. Raju Institute of Technology, Vishnupur, Medak – 502313 (Second Cycle)',
  'Chaitanya Bharathi Institute of Technology, Chaitanya Bharathi, Gandipet, Kokapet, Rajendranagar, Ranga Reddy, Hyderabad – 500075 (Second Cycle)',
  'Chaitanya Degree College (Autonomous), Kishanpura, Hanamkonda, Warangal – 506001 (Third Cycle)',
  'Chaitanya Postgraduate College (Autonomous), Kishanpura, Hanamkonda, Warangal – 506001 (Third Cycle)',
  'College of Defence Management, Hyderabad – 500094 (Second Cycle)',
  'Dr. B. R. R. Government Degree College, Jadcherla, Mahaboobnagar – 509301(Third Cycle)',
  'Geethanjali College of Engineering and Technology, Cheeryal, Keesara, Rangareddy – 501301 (First Cycle)',
  'Ghulam Ahmed College of Education, Banjara Hills, Hyderabad – 500034 (Second Cycle)',
  'Government Degree College for Women, Begumpet, Hyderabad – 500016 (Third Cycle)',
  'Government Degree College for Women, Near Fire Station, Kashmeergadda, Karimnagar – 505001 (Third Cycle)',
  'Government Degree College, Medak Road, Prashanthnagar, Siddipet – 502103 (Third Cycle)',
  'Guru Nanak Institutions Technical Campus, Khanapur, Ibrahimpatnam, Ranga Reddy, Hyderabad – 501506 (Second Cycle)',
  'Hindi Mahavidyalaya, Nallakunta, Hyderabad - 500044 (Third Cycle)',
  'Indian Institute of Management and Commerce, Khairatabad, Hyderabad – 500004 (Second Cycle)',
  'Kasturba Gandhi Degree and P. G. College for Women, Marredpally, Hyderabad – 500026 (Third Cycle)',
  'M. K. R. Government Degree College, Devarakonda, Nalgonda – 508248 (Second Cycle)',
  'MNR Dental College and Hospital, Fasalwadi, Sangareddy, Medak – 502294 (First Cycle)',
  'MNR Medical College and Hospital, Fasalwadi, Sangareddy – 502294 (First Cycle)',
  'Mother Teresa Institute of Science and Technology, Kothuru, Sathupally, Khammam – 507303 (First Cycle)',
  'Nishitha College of Engineering and Technology, Lemoor, Kandukur, Rangareddy – 501359 (First Cycle)',
  'Nishitha Degree College, Nizamabad – 503003 (First Cycle)',
  'Pingle Government College for Women, Waddepally, Hanamakonda, Warangal – 506370 (Third Cycle)',
  'S. R. and B. G. N. R. Government Arts and Science College, Khammam – 507002 (Third Cycle)',
  'S. R. R. Government Arts and Science College, Karimnagar – 505001 (Third Cycle)',
  'S. U. M. Government Degree College, Kondanagula, Balmoor, Mahabubnagar – 509401 (First Cycle)',
  'Shankerlal Dhanraj Signodia College of Arts and Commerce and P. G. Centre, Charkaman, Hyderabad – 500002 (Second Cycle)',
  'Sreyas Institute of Engineering and Technology, Bandlaguda, Nagole, Hyderabad – 500068 (First Cycle)',
  'St. Mary’s Engineering College, Pochampally, Yadadri, Hyderabad – 508284 (First Cycle)',
  "St. Peter's Engineering College, Gundlapochampally, Medchal, Hyderabad -500100 (First Cycle)",
  'Sweekaar Academy of Rehabilitation Sciences, Secunderabad, Hyderabad – 500003 (First Cycle)',
  'T K R College of Engineering and Technology, Medbowli, Meerpet, Saroornagar, Rangareddy, Hyderabad – 500097 (First Cycle)',
  'Vishnu Institute of Pharmaceutical Education and Research, Vishnupur, Narsapur, Medak – 502313 (First Cycle)',
  'Kommuri Pratap Reddy Institute of Technology, Ghanapur, Ghatkesar, Rangareddy, Hyderabad – 500008 (First Cycle)',
  'Nalla Malla Reddy Engineering College, Divyanagar, Kachivanisingaram, Ghatkesar, Medchal, Hyderabad – 500088 (First Cycle)',
  'St. Mary’s Integrated Campus Hyderabad, Hayathnagar, Nalgonda, Hyderabad – 508284 (First Cycle)',
  'Holy Mary Institute of Technology and Science, Bogaram, Keesara, Hyderabad – 501301 (First Cycle)(Re-Assessment)',
  'Balaji Institute of Technology and Science (First Cycle)',
  'CMR Institute of Technology (First Cycle)',
  'Joginpally B. R. Engineering College (First Cycle)',
  'Malla Reddy College of Engineering (First Cycle)',
  'Siddhartha Institute of Technology and Sciences (First Cycle)',
  'Swarna Bharathi Institute of Science and Technology (First Cycle)',
  'Vignana Bharathi Institute of Technology (Re-assessment) (First Cycle)',
  'Badruka College of Commerce and Arts',
  'Government Degree College for Women, Khammam',
  'Sarojini Naidu Vanita Maha Vidyalaya',
  'Avanthi Institute of Engineering & Technology,Gunthapally(V), Abdhullapurmet(M), R R Dist,Hyderabad - 501512 (First Cycle)',
  'Kakatiya Institute of Technology and Science,Opp Yerragattugutta, Bheemaram, Hasanparthy Mandal,Warangal - 506015 (First Cycle)',
  'Sri Indu College of Engineering and Technology,Sheriguda Village, Ibrahimpatnam Mandal, Ranga Reddy,Hyderabad - 501510 (First Cycle)',
  'Chaitanya College of Pharmacy Education and Research,Kishanpura, Hanamkonda,Warangal - 506001 (First Cycle)',
  "Aurora's Engineering College,Raigir, Bhongir, Yadadri,Bhuvanagiri - 508116 (First Cycle)",
  "Aurora's Scientific Technological and Research Academy,Bandlaguda, Kesavagiri Post, Chandrayangutta,Hyderabad - 500005 (First Cycle)",
  'Samskruti College of Engineering and Technology,Kondapur(V), Ghatkesar(M), Medchal,Hyderabad - 501301 (First Cycle)',
  'Malla Reddy Institute of Technology and Science,Maisammaguda,Dhulapally,Secunderabad - 500100 (First Cycle)',
  "Aurora's Post Graduate College (MBA),12-125/1, Ganesh Nagar, Ramanthapur,Hyderabad - 500013 (First Cycle)",
  "Aurora's Degree & PG College,H.No 1-8-168/2/1, 12th Lane, Chikkadpally,Hyderabad - 500020 (First Cycle)",
  'Bharat Institute of Engineering and Technology,Mangalpally (Village), Ibrahimpatnam (Mandal),Ranga Reddy - 501510 (First Cycle)',
  'Malla Reddy Institute of Engineering and Technology,Maisammaguda, Dhulapally, Medchal - Malkajgiri,Hyderabad - 500100 (First Cycle)',
  'St. Pious X Degree & PG College for Women,Snehapuri Colony, Opp. HMT Bus Stop, Behind IICT, Near Habsiguda, Nacharam Road,Hyderabad - 500076 (Second Cycle)',
  'Gokaraju Rangaraju Institute of Engineering and Technology,Bachupally, Kukatpally,Hyderabad - 500090 (Second Cycle)',
  "St. Ann's College for Women,Santoshnagar Colony Mehdipatnam,Hyderabad - 500028 (Third Cycle)",
  'Government City College (Autonomous) ,Nayapul, High Court Road,Hyderabad - 500002 (Third Cycle)',
  'Girraj Govt College (Autonomous), Nizamabad,Dubba Road,Nizamabad - 503001 (Third Cycle)',
  'Andhra Mahila Sabha Arts and Science College for Women,Durgabai Deshmukh Campus, O.U Campus,Hyderabad - 500007 (Third Cycle)',
  "Aurora's PG College (MCA), Hyderabad,12-125, Ganesh Nagar, Ramanthapur,Hyderabad - 500013 (First Cycle)",
  'Bharat Institute of Technology,Mangalpally (V) Ibrahimpatnam(M) RR-Dist,Hyderabad - 501510 (First Cycle)',
  "Aurora's PG College (MBA), Hyderabad,Door No.16-11-210, Moosarambagh,Hyderabad - 500036 (First Cycle)",
  'Avanthi Institute of Pharmaceutical Sciences,Gunthapally(V), Abdullapurmet(M) Ranga Reddy(D),Hyderabad - 501512 (First Cycle)',
  'AVN Institute of Engineering and Technology,M.P.Patelguda Ibrahimpatnam(Mdl) RangaReddy(Dt.),Hyderabad - 501510 (First Cycle)',
  'Mahatma Gandhi Institute of Technology, Hyderabad,Kokapet (Village and Gram Panchayat), Chaitanya Bharathi (P.O), Gandipet (Mandal) Ranga Reddy (District),Hyderabad - 500075 (First Cycle)',
  'Govt. Degree College for Women, Hussainialam, Hyderabad,H. No. 20-3-1060, Shahgunj, Hussainialam,Hyderabad - 500002 (Third Cycle)',
  'CMR TECHNICAL CAMPUS, Kandlakoya (V), Medchal Road, Hyderabad, Hyderabad , 501401 (First Cycle)',
  'STANLEY COLLEGE OF ENGINEERING AND TECHNOLOGY FOR WOMEN,Chapel Road, Abis, Hyderabad,Hyderabad , 500001 (First Cycle)',
  'NIZAM COLLEGE (AUTONOMOUS),Opposite L.B. Stadium, Basheerbagh,Hyderabad , 500001 (Third Cycle)',
  'ASHOKA INSTIUTE OF ENGINEERING AND TECHNOLOGY, Malkapur(V),Chotuppal(M),Yadadri Bhuvanagiri((D)-508252.,Bhuvanagiri((D)-508252 (First Cycle)',
  'NAWAB SHAH ALAM KHAN COLLEGE OF ENGINEERING AND TECHNOLOGY,MALAKPET HYDERABAD , 500024 , Door no. 16-4-1/A, New Malakpet,HYDERABAD , 500024 (First Cycle)',
  'SREE DATTHA INSTITUTE OF ENGINEERING AND SCIENCE,nagarjuna sagar road, sheriguda, ibrahimpatnam, Rangareddy district,Telangana state 501510 (First Cycle)',
  "ST.MARTIN'S ENGINEERING COLLEGE,Sy. No. 98 and 100, Dhulapally Road, Dhulapally, Near Kompally, Secunderabad - 500100. Telangana.,Secunderabad - 500100 (Re-assessment, First Cycle)",
  'MATURI VENKATA SUBBA RAO ENGINEERING COLLEGE,MVSR ENGINEERING COLLEGE NADERGUL BALAPUR MANDAL RANGA REDDY DISTRICT,HYDERABAD,Telangana,501510 (First Cycle)',
  'TALLA PADMAVATHI COLLEGE OF ENGINEERING,Somidi, Kazipet,Warangal. 506003,Warangal,Telangana,506003 (First Cycle)',
  'KAMALA INSTITUTE OF TECHNOLOGY AND SCIENCE, Kamala Institute of Technology and Science, Singapur, Huzurabad,KARIMNAGAR,Telangana,505468 (First Cycle)',
  "ST MARY'S COLLEGE, St Marys College, 8-3-229, Tahirville, Yousufguda (Near Checkpost),Hyderabad,Telangana,500045 (Third Cycle)",
  'ST. FRANCIS COLLEGE FOR WOMEN (AUTONOMOUS) , Street 6,Uma Nagar, Begumpet,Hyderabad,Telangana,500016 (Fourth Cycle)',
  'LOYOLA ACADEMY,Loyola Academy Old Alwal, Secunderabad 500010,SECUNDERABAD,Telangana,500010 (Third Cycle)',
  'VAAGDEVI COLLEGE OF ENGINEERING,Bollikunta, Khammam Road, Khila Warangal(Mandal),Warangal,Telangana,506005 (First Cycle)',
  'KESHAV MEMORIAL INSTITUTE OF TECHNOLOGY, 3-5-1026, NARAYANA GUDA,HYDERABAD,Telangana,500029 (First Cycle)',
  'TEEGALA KRISHNA REDDY ENGINEERING COLLEGE,SURVEY NO-56,57,MEDBOWLI,MEERPET,BALAPUR(MANDAL),HYDERABAD,Telangana,500097 (First Cycle)',
  'Vallurupalli Nageswara Rao Vignana Jyothi Institute of Engineering and Technology,Vignana Jyothi Nagar, Pragathi Nagar, Nizampet (S.O), Bachupally (M), Medchal,Hyderabad - 500090 (Second Cycle)',
  'Chaitanya Institute of Technology and Science,H.No 5-11-43/D Kishanpura, Nayeemnagar Hanamkonda,Warangal Urban - 506001 (First Cycle)',
  'K.G. Reddy College of Engineering and Technology,Chilkur Village, Moinabad Mandal, RR Dist.,Hyderabad - 501504 (First Cycle)',
  'CMR Engineering College,Kandlakoya, Medchal ,Secunderabad - 501401 (First Cycle)',
  'Samskruti College of Pharmacy,Kondapur(V), Ghatkesar(M), Medchal(Dist),Hyderabad - 501301 (First Cycle)',
  "Nalla Narasimha Reddy Education Society's Group of Institutions,Choudariguda Village, Korremula X Road, Ghatkesar Mandal, Medchal ,Hyderabad - 500088 (First Cycle)",
  "Aurora's Technological and Research Institute,Parvathapur Uppal ,Hyderabad - 500098 (First Cycle)",
  'Hyderabad Institute of Technology and Management,Gowdavelli (Village) Medchal (Mandal and District), Hyderabad - 501401 (First Cycle)',
  'Government Degree College, Nirmal ,Nirmal-Mancherial Highway, Housing Board Colony,Nirmal - 504106 (Third Cycle)',
  "Raja Bahadur Venkat Rama Reddy Women's College,3-4-527, Narayanguda,Hyderabad - 500027 (Fourth Cycle)",
  'Ambedkar College, Unakoti, 799290 (First Cycle)',
  'Dasaratha Deb Memorial College, Lalchera, Khowai – 799201 (First Cycle)',
  'Government Degree College, Hauraha, Dharmanagar, North Tripura – 799250 (First Cycle)',
  'Netaji Subhash Mahavidyalaya, Gomati Dist, 799120 (First Cycle)',
  'Ramkrishna Mahavidyalaya, Unakoti, 799277 (Second Cycle)',
  "Women's College, Agartala – 799001 (Second Cycle)",
  'Government Degree College, Garadtila, Kamalpur, Dhalai – 799285 (First Cycle)',
  'Maharaja Bir Bikram College, Agartala – 799004 (Second Cycle)',
  'Holy Cross College, Jubatara, Lembucherra, West Tripura, Agartala – 799210 (First Cycle)',
  'Bir Bikram Memorial College First Cycle)',
  'GOVERNMENT DEGREE COLLEGE, TELIAMURA,Khasiamangal Teliamura Khowai District,TELIAMURA,Tripura,799205 (First Cycle)',
  'SWAMI VIVEKANANDA MAHAVIDYALAYA,Mohanpur,Tripura,799210 (First Cycle)',
  'MICHAEL MADHUSUDAN DUTTA COLLEGE,Sabroom, South Tripura,Sabrrom , 799145 (First Cycle)',
  'RABINDRANATH THAKUR MAHAVIDYALAYA,Village - Harishnagar P.O. Bishalgarh Bishalgarh, Sepahijala, Tripura, Bishalgarh , 799102 (First Cycle)',
  'GOVERNMENT DEGREE COLLEGE, KANCHANPUR,Suknacherra, North Tripura,Kanchanpur,Tripura,799270 (First Cycle)',
  'KABI NAZRUL MAHAVIDYALAYA,Kabi Nazrul Mahavidyalaya Madhuban, Sonamura Sepahijala District Tripura, Pin 799131(First Cycle)',
  'A. K. (P.G.) College, Shikohabad, Firozabad – 283141 (Second Cycle)',
  'ABES Engineering College, Ghaziabad – 201009 (First Cycle)',
  'Ajay Kumar Garg Engineering College, Ghaziabad, 201009 (First Cycle)',
  'Al-Barkaat Institute of Education, Aligarh, 202122 (First Cycle)',
  'Army Institute of Education, Greater Noida – 201306 (First Cycle)',
  'Army Institute of Management & Technology, Greater Noida, Gautam Budh Nagar, 201306 (First Cycle)',
  'Arya Kanya Degree College, Hardoi – 241001 (First Cycle)',
  'Arya Kanya Degree College, Mutthiganj,Allahabad – 211003 (Second Cycle)',
  'Bipin Bihari College, Jhansi – 284001 (First Cycle)',
  'C. M. P. Degree College, Allahabad – 211002 (Second Cycle)',
  'Department of Teacher Education, Pandit Laxmi Narayan Memorial Mahavidyalaya, Aligarh, 202165 (First Cycle)',
  'Department of Teacher Education, R.K. College of Systems & Management, Firozabad, 283203 (First Cycle)',
  'Department of Teacher Education, Shri Dronacharya Degree College, Dist. Gautam Budh Nagar, 203201 (First Cycle)',
  'Department of Teacher Education, Sitapur Shiksha Sansthan, Sitapur, 261001 (First Cycle)',
  'Department of Teacher Education, Springdale Mahila Mahavidyalaya, Bareilly, 243202 (First Cycle)',
  'Digambar Jain College, Baraut – 250611 (First Cycle)',
  'Dr. B.R.A. Government Girls P.G. College, Fatehpur, 212601 (First Cycle)',
  'Dr. MPS Memorial College of Business Studies, Sikandra, Agra, 282007 (First Cycle)',
  'Gagan College of Management and Technology, Aligarh – 202001 (First Cycle)',
  'Gochar Mahavidyalaya, Rampur Maniharan, Saharanpur – 247451 (First Cycle)',
  "Government Women's Post Graduate College, Banda – 210001 (Second Cycle)",
  "Hamidia Girls' Degree College, Allahabad, 211003 (Second Cycle)",
  'Har Sahai PG College, Kanpur – 208012 (First Cycle)',
  'Hindustan Institute of Management and Computer Studies, Mathura – 281122 (First Cycle)',
  'Hiralal Ramniwas Post Graduate College, Sant Kabir Nagar – 272175 (Second Cycle)',
  'I. T. S. Engineering College, Greater Noida - 201308 (First Cycle)',
  'I.P.E.M. Law Academy, Ghaziabad, 201010 (First Cycle)',
  'IMS Engineering College, Ghaziabad, 201009 (Second Cycle)',
  'Institute of Management Studies, Noida, 201303 (First Cycle)',
  'Institute of Management Studies, C-238, B. S. Road, Lal Quan, Ghaziabad – 201009 (First Cycle)',
  'Institute of Management Studies, NH-24, Adhyatmik Nagar, Dasna, Ghaziabad – 201015 (First Cycle)',
  'Institute of Teacher Education, Dist. Ghaziabad, 201201 (Second Cycle)',
  'Institute of Technology and Science, Mohan Nagar, Ghaziabad – 201007 (First Cycle)',
  'Ismail National Mahila P.G. College, Meerut – 250001 (Second Cycle)',
  'Janta College, Bakewar, Etawah – 206124 (Second Cycle)',
  'KIET Group of Institutions, Ghaziabad – 201206 (First Cycle)',
  'Kulbhaskar Ashram P. G. College, Allahabad – 211001 (Second Cycle)',
  'Kutir Post Graduate College, Jaunpur – 222146 (First Cycle)',
  'Lajpat Rai College, Sahibabad, Ghaziabad – 201005 (Second Cycle)',
  'M. S. College, Saharanpur, 247001 (First Cycle)',
  'Mahamati Prannath Mahavidyalaya, Mau, Chitrakoot – 210209 (First Cycle)',
  'Mahanand Mission Harijan College, Ghaziabad, 201009 (Second Cycle)',
  'Maharaja Harishchandra Degree College,Lajpat Nagar, Moradabad, 244001 (First Cycle)',
  'Maharana Pratap P. G. College, Jungle Dhusan, Gorakhpur – 273014 (First Cycle)',
  'Neelkant Vidyapeeth, Modipuram, Meerut – 250110 (First Cycle)',
  'Nehru Memorial Shiv Narain Dass PG College, Budaun – 243601 (First Cycle)',
  'Netaji Subhash Chandra Bose Government Girls Post Graduate College, Lucknow, 226020 (Second Cycle)',
  'New Adarsh Institute of Education, Loni, Ghaziabad – 201102 (Second Cycle)',
  'Panchavati Institute of Education and Technology, Partapur, Meerut – 250005 (First Cycle)',
  'Post Graduate College, Ravindrapuri, Ghazipur – 233002 (Second Cycle)',
  'Pt. D. D. U. Government Degree College, Palahipatti, Varanasi – 221208 (First Cycle)',
  'Raja Harpal Singh Mahavidyalaya, Jaunpur, 222175 (First Cycle)',
  'Raja Sri Krishna Dutt Post Graduate College, Jaunpur – 222001 (First Cycle)',
  'Rajarshi Tandon Mahila Mahavidyalaya, Allahabad – 211003 (Second Cycle)',
  'Rajat Girls Degree College, Lucknow – 226028 (First Cycle)',
  'RKG Educational College, Lucknow – 226025(First Cycle)',
  'Sacred Heart Degree College, Sitapur, 261001(First Cycle)',
  "Sadanlal Sanwaldas Khanna Girls' Degree College, Allahabad, 211003 (Second Cycle)",
  'Saket Girls Degree College, Pratapgarh – 230001 (First Cycle)',
  'Saraswati College of Professional Studies, Ghaziabad – 201009 (Second Cycle)',
  'Saraswati Dental College, Lucknow – 226028 (First Cycle)',
  'Saubhagyawati Bai Dani Mahila Mahavidyalaya, Bijnaur – 246761 (First Cycle)',
  'Savitri Bai Fule Government P.G. College, Chandauli – 232103 (First Cycle)',
  'Shri Jai Narain Post Graduate College,Station Road, Charbagh, Lucknow, 226001 (First Cycle)',
  'Shri Ram College, Muzaffarnagar – 251001 (First Cycle)',
  'Shri Shakti Degree College, Kanpur – 209206 (First Cycle)',
  "St. Joseph's College for Women, Gorakhpur, 273009 (First Cycle)",
  'Vasanta College for Women, Rajghat Fort, Varanasi – 221001 (Second Cycle)',
  'Wilsonia Degree College, Moradabad – 244001 (First Cycle)',
  'School of Management Sciences, Khushipur, Bachhaon, Varanasi – 221011 (First Cycle)',
  'I. P. (P.G.) College, Campus-II, Dariyapur, Bulandshahr – 203001 (Second Cycle)',
  'I. T. S. Centre for Dental Studies and Research, Muradnagar, Ghaziabad - 201206(Second Cycle)',
  'Balwant Vidyapeeth Rural Institute, Bichpuri, Agra – 283105 (Second Cycle)',
  'BDS Gurukul of Education, Sector 8, Meerut – 250004 (Second Cycle)',
  'Birla Institute of Management Technology (BIMTECH), Greater Noida – 201306 (First Cycle)',
  'Bora Institute of Management Sciences, Lucknow – 226201 (First Cycle)',
  'Centre for Development of Advanced Computing, Noida – 201307 (First Cycle)',
  'D. A. V. College, Arya Samaj Road, Muzaffarnagar – 251001 (Second Cycle)',
  'D. R. A. Government Degree College, Bisauli, Budaun – 243720 (First Cycle)',
  'D. S. College, Aligarh – 202001 (Second Cycle)',
  'DAV PG College, Maharshi Dayanand Marg, Naharpura, Aushanganj, Varanasi – 221001 (Second Cycle)',
  'Doon College of Education for Women, Sunderpur, Behat, Saharanpur – 247662 (First Cycle)',
  'Dr. B. R. Ambedkar Law College, Girwan Banda, Banda – 210001 (First Cycle)',
  'Dr. Ram Manohar Lohiya Government Degree College, Aonla, Bareilly – 243301 (Second Cycle)',
  'Feroze Gandhi College, Rae Bareli – 229001 (Second Cycle)',
  'Gautam Buddha Degree College, Bijnaur, Lucknow – 226002 (First Cycle)',
  'Goswami Tulsidas Government P. G. College, Karwi, Chitrakoot – 210205 (Second Cycle)',
  'Government Girls Degree College, Bindki, Fatehpur – 212635 (First Cycle)',
  'Government Girls Degree College, Near FCI, DLW East Gate, Varanasi – 221004 (First Cycle',
  'Government Girls P. G. College, Aamghat, Ghazipur – 233001 (Second Cycle)',
  'Government P. G. College, Sector 39, G. B. Nagar, Noida – 201301 (Second Cycle)',
  'Hakeem Mehtab Uddin Hashmi College of Law, Amroha – 244221 (First Cycle)',
  'Hindu Degree College, Zamania – 232331 (First Cycle)',
  'IILM Graduate School of Management, Greater Noida – 201306 (First Cycle)',
  'Institute of Management Education (IME), Ghaziabad – 201005 (Second Cycle)',
  'Institute of Technology and Science, Mohan Nagar, Ghaziabad – 201007 (Second Cycle)',
  'Jaipuria Institute of Management, Sector 62, Noida – 201309 (Second Cycle)',
  'Jaipuria Institute of Management, Vineet Khand, Gomtinagar, Lucknow – 226010 (Second Cycle)',
  'Jawahar Lal Nehru Degree College, Etah – 207001 (Second Cycle)',
  'Juhari Devi Girls Post Graduate College, Kanpur – 208004 (Second Cycle)',
  'K. N. Government P. G. College, Gyanpur, Bhadohi, Varanasi – 221304 (First Cycle)',
  'Kanoharlal Snatakottar Mahila Mahavidyalaya, Meerut – 250002 (Second Cycle)',
  "Karamat Husain Muslim Girls' P. G. College, Nishatganj, Lucknow – 226007 (First Cycle)",
  'Karma Kshetra Post Graduate College, Etawah – 206001 (Second Cycle)',
  'Kisan Post Graduate College, Bahraich – 271801 (Second Cycle)',
  'Lalta Singh Rajkiya Mahila Snatkottar Mahavidyalaya, Adalhat, Mirzapur – 231302 (First Cycle)',
  'Maharana Pratap Government Post Graduate College, Bilsi, Badaun – 243633 (First Cycle)',
  'Mahatma Gandhi Balika Vidhyalaya (PG) College, Firozabad – 283203 (First Cycle)',
  'Mahatma Gandhi Memorial Degree College, Sambhal – 244302 (First Cycle)',
  'Modern College of Professional Studies, Ghaziabad – 201007 (First Cycle)',
  'Munna Lal and Jai Narayan Khemka Girls College, Saharanpur – 247001 (Second Cycle)',
  'National Post Graduate College, Barhalganj, Gorakhpur – 273402 (First Cycle)',
  'Navyug Kanya Mahavidyalaya, Deen Dayal Marg, Rajendra Nagar, Lucknow – 226004 (First Cycle)',
  'Noida Institute of Engineering and Technology, Greater Noida – 201306 (First Cycle)',
  'Pratap Bahadur Post Graduate College, Pratapgarh – 230002 (Second Cycle)',
  'Pt. Jawahar Lal Nehru College, Banda – 210001 (First Cycle)',
  "R. C. A. Girls' (PG) College, Mathura – 281003 (Second Cycle)",
  "Raghunath Girls' Post Graduate College, Meerut – 250001 (Third Cycle)",
  'Raja Balwant Singh College, Khandari, Agra – 282002 (Second Cycle)',
  'Rajkiya Mahavidyalaya, Babrala, Gunnaur, Junawai, Sambhal – 243722 (First Cycle)',
  'Ram Lalit Singh Snatkottar Mahavidyalaya, Kailhat, Panchevera, Chunar, Mirzapur – 231305 (First Cycle)',
  'Rama Devi Kanya Mahavidyalaya, Sector 61, Noida – 201301 (Second Cycle)',
  'Ramabai Government Mahila Post Graduate College, Akbarpur, Ambedkar Nagar – 224122 (Second Cycle)',
  'S S Law College (Swami Shukdevanand Law College), Shahjahanpur – 242226 (First Cycle)',
  'Sant Gadinath Government P. G. College, Muhammadabad, Gohna, Mau – 276403 (First Cycle)',
  'Saraswati Mahila Mahavidyalaya, Vijay Nagar, Kanpur – 208005 (First Cycle',
  'Satyam Fashion Institute, Sector 62, Noida – 201309 (First Cycle)',
  'School of Management Sciences, Kasimpur, Lucknow – 226501 (First Cycle)',
  'Shaheed Mangal Pandey Government Girls Post Graduate College, Sector - 2, Madhavpuram, Meerut – 250002 (Second Cycle)',
  'Shri Shaligram Sharma Smarak (P.G.) College, Rasna, Meerut – 250502 (First Cycle)',
  'Shrinath Sanskrit Mahavidyalaya, Hata, Kushinagar – 274203 (First Cycle)',
  'Sitaram Samarpan Mahavidyalay, Banda – 210129 (First Cycle)',
  'St. John’s College, Agra – 282002 (Second Cycle)',
  'St. Joseph’s Girls Degree College, Meerut – 250342 (First Cycle)',
  'Swami Karpatri Ji Maharaj Government Degree College, Pure Gosai, Ranisanj, Pratapgarh – 230304 (First Cycle)',
  'Swami Vivekanand Mahila Mahavidyalya, Lucknow – 226025 (First Cycle)',
  'Vardhaman College, Bijnor – 246701 (Second Cycle)',
  'Vasant Kanya Mahavidyalaya, Kamachha, Varanasi – 221010 (Second Cycle)',
  'Veerangana Rani Awanti Bai Lodhi Rajkiya Mahila Mahavidyalaya, Bareilly – 243001 (First Cycle)',
  'Vikramajit Singh Sanatan Dharma College, Kanpur – 208002 (Second Cycle)',
  'Vivek College of Education, Agri, Bijnaur – 246701 (Second Cycle)',
  'Vivekanand Gramodyog Mahavidyalaya, Dibiyapur – 206244 (Second Cycle)',
  'Government Girls Degree College, Near Sanjay Colony, Behat, Saharanpur – 247121 (First Cycle)',
  'National P. G. College, Bhongaon, Mainpuri – 205262 (First Cycle)',
  'R. P. P. G. College, Dharsada, Ghorawal Sonebhadra, Robertsganj – 231210 (First Cycle)',
  'Ram Khelawan Singh P. G. College, Kalwaari Khurd, Marihan, Mirzapur – 231001 (First Cycle)',
  'I I M T College of Engineering (First Cycle)',
  'Sakaldiha PG College,Vill- Nagepur, Post- Sakaldiha Bazar Distt. ,Chandauli - 232109 (First Cycle)',
  'Chaudhary Chhotu Ram Post-Graduate College, Muzaffarnagar,Circular Road ,Muzaffarnagar - 251001 (First Cycle)',
  'Atarra Post Graduate College,Banda Road(National Highway-35), Atarra,Banda - 210201 (First Cycle)',
  'Mahatma Gandhi Post Graduate College,,Gorakhpur - 273001 (Second Cycle)',
  'Vidya Mandir Degree College,Kampil Road, Farrukhabad,Kaimganj - 209502 (Second Cycle)',
  'Udai Pratap College, Varanasi,Bhojubeer,Varanasi - 221002 (Third Cycle)',
  'DR. GAUR HARI SINGHANIA INSTITUTE OF MANAGEMENT AND RESEARCH,Kamla Nagar, Kanpur - 208005 (Uttar Pradesh),Kanpur , 208005 (First Cycle)',
  'KALICHARAN DEGREE COLLEGE,HARDOI ROAD, CHOWK, LUCKNOW, LUCKNOW , 226003 (First Cycle)',
  'R.S.D. ACADEMY,Ram Ganga Vihar Phase II Moradabad, Moradabad , 244001 (Second Cycle)',
  'GOVERNMENT RAZA POST GRADUATE COLLEGE,Khushro Bagh Road Rampur-244901 (UP),Rampur , 244901 (Third Cycle)',
  'NANAKCHAND ANGLO SANSKRIT COLLEGE, MEERUT,Eastern Kutchery Road, Meerut,MEERUT , 250001 (Second Cycle)',
  'SRI TIKA RAM KANYA MAHAVIDYALAYA,Near Gandhi Eye Hospital Ramghat Road,ALIGARH , 202001 (Second Cycle)',
  'CHANDRA BHANU GUPTA KRISHI SNATKOTTAR MAHAVIDYALAYA,Bakshi Ka Talab Lucknow,LUCKNOW , 226201 (First Cycle)',
  'INDERPRASTHA ENGINEERING COLLEGE, Site - IV, 63, Sahibabad Industrial Area, Suryanagar Flyover Road, Sahibabad, Ghaziabad, Uttar Pradesh - 201010 (First Cycle)',
  "Bhavan's Mehta Mahavidyalaya, Bharwari, Kaushambi, U.P., India,Mehta Road, Bharwari, Kaushambi,Bharwari Kaushambi , 212201 (Second Cycle)",
  'KANPUR VIDYA MANDIR MAHILA MAHAVIDYALAYA,Swaroop Nagar kanpur, Kanpur , 208002 (Second Cycle)',
  'CHANDRAKANTI RAMAWATI DEVI ARYA MAHILA P.G. COLLEGE GORAKHPUR,Diwan Bazar Gorakhpur,Gorakhpur , 273001 (First Cycle)',
  "PANDIT DEEN DAYAL UPADHYAY GOVERNMENT GIRLS' DEGREE COLLEGE,Takkhu ki Bauli, Sewapuri,VARANASI , 221403 (Second Cycle)",
  'SANT VINOBA POST GRADUATE COLLEGE,DEORIA, New Colony, Deoria, U.P.,Deoria , 274001 (First Cycle)',
  'KAMLA NEHRU INSTITUTE OF PHYSICAL AND SOCIAL SCIENCES, Village- Ratanpur, Post- KNI (Faizabad Road) Sultanpur, 228118 (Second Cycle)',
  'GINNI DEVI MODI GIRLS PG COLLEGE,GINNI DEVI MODI GIRLS P.G COLLEGE,MODINAGAR DISTT. GHAZIABAD,MODINAGAR,Uttar pradesh,201204 (Second Cycle)',
  'ROYAL COLLEGE OF LAW, DELHI HAPUR BYPASS ROAD DASNA POST ADHYATMIK NAGAR,GHAZIABAD,Uttar pradesh,201302 (First Cycle)',
  "K PM GOVERNMENT WOMEN'S DEGREE COLLEGE AURAI BHADOHI , K P M Government Women Degree College Aurai Bhadohi UP 221301,Sant Ravidas Nagar Bhadohi,Uttar pradesh,221301 (First Cycle)",
  'RANI BHAGYAWATI DEVI MAHILA MAHAVIDYALAYA, BIJNOR,Opp. B.S.N.L. Office, Meerut Road, Bijnor,BIJNOR,Uttar pradesh,246701 (Second Cycle)',
  'VIVEK COLLEGE OF EDUCATION, BIJNOR,MORADABAD ROAD POST AGRI DISTT BIJNOR UP 246701,BIJNOR,Uttar pradesh,246701 (First Cycle)',
  'Govt Degree College, Manikpur, Chitrakoot,Manikpur ,Chitrakoot - 210208 (First Cycle)',
  'Shri Bhawanand Sanskrit Mahavidyalaya,Punarjee, Jahanaganj,Azamgarh - 276131 (First Cycle)',
  'Lala Kishan Chand Rajkiya Mahavidhalaya, Gangoh,Gangoh,Saharanpur - 247341 (First Cycle)',
  'Bapu Post Graduate College, Pipiganj, Gorakhpur ,Near Railway Crossing, Sisai Road, Pipiganj ,Gorakhpur - 273165 (First Cycle)',
  'Meerut Institute of Engineering and Technology,NH-58, Delhi Roorkee Highway, Bahgpat Road, Bypass Crossing,Meerut - 250005 (First Cycle)',
  'Rajadevi Degree College,Naraini Road Badokhar Khurd,Banda - 210001 (First Cycle)',
  'Brahmanand Post Graduate College,Brahmanand College, The Mall, Kanpur,Kanpur - 208004 (Second Cycle)',
  'Isabella Thoburn College,7- Faizabad Road,Lucknow - 226007 (Third Cycle)',
  'Noida College of Physical Education,Jawahar Navodaya Vidalya Road, Dhoom Manikpur, Dadri,Gautam Budh Nagar - 203207 (First Cycle)',
  'B.N.V. College,Mahoba Road, Rath ,Hamirpur - 210431 (First Cycle)',
  'Baikunthi Devi Kanya Mahavidyalaya,Parolia Nagar, Baluganj,Agra - 282001 (Second Cycle)',
  'Meerut College ,,Meerut - 250001 (Third Cycle)',
  'Chinmaya Degree College, Ranipur, Haridwar – 249403 (Second Cycle)',
  'Department of Teacher Education, Dr. P.D.B. Himalayan Government Post Graduate College, Dist. Pauri Garhwal, 246149 (First Cycle)',
  'Dr. P.D.B. Himalayan Government Post Graduate College, Dist. Pauri Garhwal, 246149 (First Cycle)',
  'Government Degree College, Pauri Garhwal, Lansdowne – 246139 (Second Cycle)',
  'Government Post Graduate College, Almora – 263653 (Second Cycle)',
  'Government Post Graduate College, Chamoli, Gopeshwar – 246401 (Second Cycle)',
  'Mahadevi Kanya Pathshala (P.G.) College, Dehradun, 248001 (Second Cycle)',
  'P.N.G. Government Post Graduate',
  'Sardar Bhagat Singh Government Post Graduate College, Udham Singh Nagar, 263153 (Second Cycle)',
  'Shri Guru Ram Rai (P.G.) College, Dehradun – 248001 (Second Cycle)',
  'SOS J. N. Kaul Institute of Education, Nainital – 263136 (First Cycle)',
  'Sri Sanatan Dharam Prakash Chand Kanya Snatkottar Mahavidyalaya, Roorkee – 247667 (First Cycle)',
  'Government Degree College, Manila, Almora – 263667 (Second Cycle)',
  'Government Degree College, Syalde, Almora – 263661 (Second Cycle)',
  'Government Post Graduate College, Narayan Nagar, Didihat, Pithoragarh – 262550 (First Cycle)',
  'Indira Priyadarshi Government Girls P. G. College of Commerce, Haldwani, Nainital – 263141 (Second Cycle)',
  'Mahila Vidyalaya Degree College, Satikund, Kankhal, Haridwar – 249408 (First Cycle)',
  'Modern Institute of Technology, Rishikesh – 249202 (First Cycle)',
  'S. V. Government P. G. College, Lohaghat, Champawat – 262524 (Second Cycle)',
  'Veer Shaheed Kesari Chand Rajkiya Snatkottar Mahavidyalaya, Dakpathar (Vikasnagar), Dehradun – 248125 (First Cycle)',
  'R.C.U Govt. P.G College,Vishwanath Mandir Marg,Uttarkashi - 249193 (Third Cycle)',
  'GOVERNMENT POST GRADUATE COLLEGE,POST OFFICE BERINAG DISTRICT PITHORAGARH UTTARAKHAND PIN 262531,Berinag , 262531 (Second Cycle)',
  'RADHEY HARI GOVERNMENT P.G. COLLEGE,RADHEY HARI GOVERNMENT POST GRADUATE COLLEGE, KASHIPUR BAZPUR ROAD, KASHIPUR,UDHAM SINGH NAGAR,Uttarakhand,244713 (Third Cycle)',
  'D.B.S. (P.G.) College Dehradun,D.B.S. (P.G.) College Dehradun,Dehradun,Uttarakhand,248001 (Third Cycle)',
  'MOTI RAM BABU RAM GOVERNMENT POST GRADUATE COLLEGE, Bhotia Paraw, Nainital Road,HALDWANI,Uttarakhand,263139 (Third Cycle)',
  'APB GOVERNMENT POST GRADUATE COLLEGE, AGASTYAMUNI,A.P.B. Govt. Post Graduate College, Agastyamuni,Agastyamuni,Uttarakhand,246421 (Second Cycle)',
  'D.A.V.(P.G.) COLLEGE, KARANPUR, DEHRADUN-248001 (Second Cycle)',
  'LAXMAN SINGH MEHAR GOVT. POST GRADUATE COLLEGE, DISTRICT-PITHORAGARH, UTTARAKHAND,G.I.C. ROAD, PITHORAGARH-262502,UTTARAKHAND,PITHORAGARH , 262502 (First Cycle)',
  'Army Institute of Management, Kolkata, 700027 (First Cycle)',
  "Bagnan Teachers' Training College, Howrah, 711312 (First Cycle)",
  'Bajkul Milani Mahavidyalaya, Dist. Purba Medinipur, 721655 (Second Cycle)',
  'Bankim Sardar College, South 24 Parganas, 743329 (Second Cycle)',
  'Bankura Zilla Saradamani Mahila Mahavidyapith, Bankura, 722101 (Second Cycle)',
  'Barasat Government College, Barasat – 700124 (Second Cycle)',
  'Behala College, Kolkata, 700060 (Second Cycle)',
  'Bejoy Narayan Mahavidyalaya, Hooghly, 712147 (Second Cycle)',
  'Belda College, Paschim Medinipur, 721424 (Second Cycle)',
  'Bethune College, Kolkata, 700006 (Second Cycle)',
  'Bhairab Ganguly College, Belgharia, Kolkata – 700056 (Second Cycle)',
  'Bhangar Mahavidyalaya, Dist, South 24 Parganas, 743502 (Second Cycle)',
  'Bhatter College, Dist. Paschim Medinipur, 721426 (Second Cycle)',
  'Bidhan Chandra College, Rishra, Hooghly – 712248 (First Cycle)',
  "Bijoy Krishna Girls' College, Howrah – 711101 (Second Cycle)",
  "Deshapran College of Teachers' Education, Dist. Purba Medinipur, 721427 (First Cycle)",
  'Dr. Gour Mohan Roy College, Bardhaman, Burdwan – 713145 (First Cycle)',
  'Dr. Kanailal Bhattacharyya College, Howrah, 711104 (Third Cycle)',
  'Dumkal Institute of Engineering & Technology, Dist. Murshidabad, 742406 (First Cycle)',
  "East Calcutta Girls' College, Kolkata, 700089 (Second Cycle)",
  'Egra Sarada Shashi Bhusan College, Purba Medinipur, 721429 (Second Cycle)',
  "Gokhale Memorial Girls' College, Kolkata – 700020 (Second Cycle)",
  'Gopal Chandra Memorial College of Education, Kolkata – 743276 (Second Cycle)',
  'Government College of Engineering & Ceramic Technology, Kolkata, 700010 (First Cycle)',
  'Guru Nanak Institute of Pharmaceutical Science and Technology, Kolkata – 700114 (First Cycle)',
  'Institute of Education, Dist. Purba Medinipur, 721635 (First Cycle)',
  'Islampur College, Islampur – 733202 (First Cycle)',
  'Jamini Roy College, Beliatore, Bankura – 722203 (First Cycle)',
  'JIS College of Engineering (Autonomous), Nadia, 741235 (Second Cycle)',
  'Kabi Sukanta Mahavidyalaya, Dist. Hooghly, 712221 (Second Cycle)',
  'Krishnagar Government College, Nadia, 741101 (Second Cycle)',
  'Loreto College Kolkata, West Bengal ( Third Cycle)',
  'Mahadevananda Mahavidyalaya, Kolkata – 700120 (Second Cycle)',
  'Malda College, P.O. & Dist. Malda, 732101 (First Cycle)',
  'Nabagram Hiralal Paul College, Hooghly – 712246 (Second Cycle)',
  'Netaji Mahavidyalaya, Arambagh, Hooghly, 712601 (Second Cycle)',
  'Panchakot Mahavidyalaya, Dist. Purulia, 723121 (First Cycle)',
  'Pingla Thana Mahavidyalaya, Dist.-Paschim Medinipur, 721140 (Second Cycle)',
  'Prabhat Kumar College, Dist. Purbamedinipur, 721401 (Second Cycle)',
  'Prabhu Jagatbandhu College, Howrah, 711302 (Second Cycle)',
  'Raghunathpur College, Dist. Purulia, 723133 (Second Cycle)',
  'Ramakrishna Mission Brahmananda College of Education, Kolkata, 700118 (First Cycle)',
  'Ramakrishna Mission Sikshanamandira (Autonomous), Howrah, 711202 (Second Cycle)',
  'Ramananda College, Bankura, 722122 (Second Cycle)',
  'Ramnagar College, Depal Purba Medinipur, Contai – 721453 (First Cycle)',
  "Rani Birla Girls' College, Kolkata, 700017 (Second Cycle)",
  'Sarojini Naidu College for Women, Kolkata – 700028 (Second Cycle)',
  'Sarsuna College, Kolkata – 700061 (First Cycle)',
  "Serampore Girls' College, Serampore, Hooghly – 712201 (Second Cycle)",
  'Seth Anandram Jaipuria College, Kolkata, 700005 (First Cycle)',
  'Shibpur Dinobundhoo Institution (College), Howrah, 711102 (Second Cycle)',
  'Shimurali Sachinandan College of Education, Krishnanagar – 741248 (First Cycle)',
  'Siliguri B.Ed. College, Darjeeling, Siliguri – 734011 (Second Cycle)',
  'Southfield College, Darjeeling – 734101 (Second Cycle)',
  'Sri Krishna College, Dist. Nadia, 741502 (Second Cycle)',
  "St. Joseph's College, Darjeeling, 734104 (Second Cycle)",
  'Sudhiranjan Lahiri Mahavidyalaya, Dist. Nadia, 741507 (Second Cycle)',
  'Sundarban Mahavidyalaya, South 24 Parganas, 743347 (First Cycle)',
  "Surendra Lal Das Teachers' Training College (B.Ed.) , Anandanagar, Howrah, 711227 (First Cycle)",
  'Tarakeswar Degree College, Hooghly, 712410 (Second Cycle)',
  'The Bhawanipur Education Society College, Kolkata, 700020 (First Cycle)',
  'Vivekananda Mahavidyalaya, Hooghly, 712405 (Second Cycle)',
  'Vivekananda Mission Mahavidyalaya, Dist. Purba Medinipur, 721645 (Second Cycle)',
  'Vivekananda Satavarshiki Mahavidyalaya, Manikpara, Jhargram, Paschim Medinipur – 721513 (First Cycle)',
  'Gobinda Prasad Mahavidyalaya, Amarkanan, Gangajal Ghati, Bankura – 722133 (First Cycle)',
  'Pailan College of Education, Pailan, Bishnupur, South 24 Parganas, Kolkata – 700104 (First Cycle)',
  'Pandit Raghunath Murmu Smriti Mahavidyalaya, Bargari, Jamboni, Sarenga, Bankura – 722150 (Second Cycle)',
  'Acharya Brojendranath Seal College, Cooch Behar – 736101 (Second Cycle)',
  'Acharya Jagadish Chandra Bose College, Kolkata – 700020 (Second Cycle)',
  'Acharya Prafulla Chandra College, New Barrackpore, North 24 Parganas, Kolkata – 700131 (Second Cycle)',
  'Alipurduar College, Alipurduar – 736122 (First Cycle)',
  'Ananda Chandra College, Jalpaiguri – 735101 (Second Cycle)',
  'Ananda Chandra Training College, Nayabasti, Jalpaiguri – 735101 (First Cycle)',
  'Ananda Mohan College, Raja Rammohan Sarani, Kolkata – 700009 (Second Cycle)',
  'Asannagar Madan Mohan Tarkalankar College, Assannagar, Nadia, Krishnanagar – 741161 (First Cycle)',
  'Asansol Girls’ College, Asansol, Burdwan – 713304 (Second Cycle)',
  'Asutosh College, Kolkata – 700026 (Second Cycle)',
  'Balagarh Bijoy Krishna Mahavidyalaya, Hooghly – 712501 (Second Cycle)',
  'Bamanpukur Humayun Kabir Mahavidyalaya, Bamanpukur – 743425 (First Cycle)',
  'Bangabasi College, Kolkata – 700009 (Second Cycle)',
  'Bangabasi Evening College, Kolkata – 700009 (Second Cycle)',
  'Bangabasi Morning College, Kolkata – 700009 (Second Cycle)',
  'Bankura Sammilani College, Bankura – 722102 (Second Cycle)',
  'Barjora College, Barjora, Bankura – 722202 (First Cycle)',
  'Bengal School of Technology, Sugandha, Chinsurah, Hooghly – 712102 (First Cycle)',
  "Berhampore Girls' College, Berhampore, Murshidabad – 742101(Second Cycle)",
  'Bidhan Chandra College, Asansol, Burdwan – 713304 (First Cycle)',
  'Bidhannagar College, Saltlake, Sector 1, Kolkata – 700064 (Second Cycle)',
  'Birpara College, Birpara – 735204 (First Cycle)',
  'Bolpur College, Birbhum – 731204 (First Cycle)',
  'Brahmananda Keshab Chandra College, Bon Hooghly, Kolkata – 700108 (First Cycle)',
  'Budge Budge College, Kolkata – 700137 (Second Cycle)',
  'Budge Budge Institute of Technology, Kolkata – 700137 (First Cycle)',
  'Burdwan Raj College, Bardhaman – 713104(First Cycle)',
  "Calcutta Girls' College, Kolkata – 700013 (Second Cycle)",
  'Chakdaha College, Chakdaha, Nadia – 741222 (Second Cycle)',
  'Chandernagore College, Chandernagore, Hooghly – 712136 (Second Cycle)',
  'Chandidas Mahavidyalaya, Birbhum – 731215 (Second Cycle)',
  'Chandraketugarh Sahidullah Smriti Mahavidyalaya, Debalaya, North 24 Parganas, Berachampa – 743424 (First Cycle)',
  'Chandrapur College, Bardhaman – 713145(First Cycle)',
  'Charuchandra College, Kolkata – 700029 (Second Cycle)',
  'City College of Commerce and Business Administration, Kolkata – 700012 (First Cycle)',
  'Cooch Behar College, Cooch Behar – 736101(Second Cycle)',
  'Debra Thana Sahid Kshudiram Smriti Mahavidyalaya, Gangaramchak, Debra, Paschim Medinipur – 721124 (First Cycle)',
  'Derozio Memorial College, Kolkata – 700136 (Second Cycle)',
  'Deshabandhu Mahavidyalaya, Chittaranjan, Burdwan – 713331 (Second Cycle)',
  'Deshbandhu College for Girls, Kolkata – 700026 (Second Cycle)',
  'Dhruba Chand Halder College, Kolkata – 743372 (Second Cycle)',
  'Dinabandhu Andrews College, 24 Parganas (S), Kolkata – 700084 (Second Cycle)',
  'Dinabandhu Mahavidyalaya, Bongaon – 743235 (Second Cycle)',
  'Dinhata College, Dinhata, Cooch Behar – 736135 (First Cycle)',
  'Dr. B. R. Ambedkar College, Betai, Nadia – 741163 (Second Cycle)',
  'Dukhulal Nibaran Chandra College, Aurangabad, Murshidabad, Jangipur – 742201 (Second Cycle)',
  'Dum Dum Motijheel College, Kolkata – 700074 (Second Cycle)`',
  'Dum Dum Motijheel Rabindra Mahavidyalaya, Kolkata – 700074 (Second Cycle)',
  'Dumkal College, Basantapur, Dumkal, Murshidabad – 742406 (First Cycle)',
  'Durgapur Government College, Durgapur, Burdwan – 713214 (Second Cycle)',
  "Durgapur Women's College, Durgapur, Burdwan – 713209 (First Cycle)",
  'Dwijendralal College, Nadia, Krishnagar – 741101 (Second Cycle)',
  'Fakir Chand College, South 24 Parganas, Diamond Harbour – 743331 (Second Cycle)',
  'Falakata College, Alipurduar, Falakata – 735211 (First Cycle)',
  'Gandhi Centenary B. T. College, Ashokenagar – 743268 (Second Cycle)',
  'Ghatal Rabindra Satabarsiki Mahavidyalaya, Ghatal, Paschim Medinipur – 721212 (Second Cycle)',
  'Gobardanga Hindu College, P. O. Khantura, Gobardanga – 743273 (Second Cycle)',
  'Goenka College of Commerce and Business Administration, Kolkata – 700012 (Second Cycle)',
  'Gour Mahavidyalaya, Malda – 732142 (Second Cycle)',
  'Gour Mohan Sachin Mandal Mahavidyalaya, Ghateswar – 743336 (Second Cycle)',
  'Gushkara Mahavidyalaya, Burdwan – 713128 (Second Cycle)',
  'Haldia Government College, Debhog, Haldia, Purba Medinipur – 721657 (Second Cycle)',
  'Haldia Institute of Management, Hatiberia, Haldia, Purba, Medinipur – 721657 (First Cycle)',
  'Haldia Institute of Technology, Haldia – 721657 (Second Cycle)',
  'Haringhata Mahavidyalaya, Subarnapur, Nadia, Haringhata – 741249 (Second Cycle)',
  'Heramba Chandra College, Kolkata – 700029 (Second Cycle)',
  'Heritage Institute of Technology, Anandapur, Kolkata – 700107 (First Cycle)',
  'Hiralal Bhakat College, Birbhum – 731220 (Second Cycle)',
  'Hiralal Mazumdar Memorial College for Women, Dakshineswar, Kolkata – 700035 (Second Cycle)',
  "Hooghly Women's College, Hooghly – 712103 (Second Cycle)",
  'Institute of Engineering and Management, Sector V, Salt Lake, Kolkata – 700091 (First Cycle)',
  'Jangipur College, Jangipur, Murshidabad – 742213 (Second Cycle)`',
  'Jatindra Rajendra Mahavidyalaya, Murshidabad, Amtala – 742121 (Second Cycle)',
  'Jogesh Chandra Chaudhuri College, Kolkata – 700033 (Second Cycle)',
  'Joypur Panchanan Roy College, Howrah – 711401 (Second Cycle)',
  'K. D. College of Commerce and General Studies, Khudiram Nagar, Medinipur – 721101 (Second Cycle)',
  'K. K. Das College, Kolkata – 700084 (First Cycle)',
  'Kaliachak College, Sultanganj, Malda – 732201(Second Cycle)',
  'Kalimpong College, Darjeeling – 734301(Second Cycle)',
  'Kaliyaganj College, Uttar Dinajpur, Kaliyaganj – 733129 (Second Cycle)',
  'Kandra Radha Kanta Kundu Mahavidyalaya, Kandra, Ketugram, Burdwan – 713129 (First Cycle)',
  'Kashipur Michael Madhusudan Mahavidyalaya, Kashipur, Panchakote Raj, Purulia, Adra – 723132 (First Cycle)',
  'Khalisani Mahavidyalaya, Chandannagar – 712138 (Second Cycle)',
  'Kharagpur College, Paschim Medinipur, Kharagpur – 721305 (Second Cycle)',
  'Khatra Adibasi Mahavidyalaya, Khatra, Bankura – 722140 (Second Cycle)',
  'Khudiram Bose Central College, Kolkata – 700006 (Second Cycle)',
  'Kidderpore College, Kolkata – 700023 (Second Cycle)',
  'Kolkata Teachers’ Training College, Panpur, Narayanpur, 24 Parganas (N) – 743126 (Second Cycle)',
  'Krishnagar Women’s College, Nadia, Krishnanagar – 741101 (Second Cycle)',
  'Krishnath College, Murshidabad, Berhampore – 742101 (Second Cycle)',
  'Lalgola College, Murshidabad, Lalgola – 742148 (First Cycle)',
  'Madhyamgram B.Ed. College, Madhyamgram – 700128 (First Cycle)',
  'Maharaja Srischandra College, Kolkata – 700003 (First Cycle)',
  'Mahatma Gandhi College, Purulia – 723101 (Second Cycle)',
  'Maheshtala College, Kolkata – 700141 (Second Cycle)',
  'Mahishadal Raj College, Purba Medinapur – 721628 (Second Cycle)',
  "Malda Women's College, Santi Gopal Sen Sarani, Pirojpur, Malda – 732101 (Second Cycle)",
  'Manbhum Mahavidyalaya, Purulia – 723131(Second Cycle)',
  'Mankar College, Mankar, Burdwan – 713144',
  'Maulana Azad College, Kolkata – 700013 (Second Cycle)',
  'Maynaguri College, Jalpaiguri, Mainaguri - 735224 (Second Cycle)',
  'MCKV Institute of Engineering, Liluah, Howrah – 711204 (First Cycle)',
  'Michael Madhusudan Memorial College, Durgapur, Burdwan – 713216 (Second Cycle)',
  'Midnapore College, Medinipur – 721101 (Third Cycle)',
  'Moyna College, Moyna, Purba Medinipur, Tamluk – 721629 (First Cycle)',
  'Mrinalini Datta Mahavidyapith, Birati, Kolkata – 700051 (Second Cycle)',
  "Muralidhar Girls' College, Kolkata – 700029(Second Cycle)",
  'Naba Ballygunge Mahavidyalaya, Kolkata – 700042 (Second Cycle)',
  'Nabadwip Vidyasagar College, Nabadwip, Nadia – 741302',
  'Narasinha Dutt College, Howrah – 711101 (Second Cycle)',
  'Netaji Nagar College for Women, Kolkata – 700092 (Second Cycle)',
  'Netaji Nagar College, Kolkata – 700092 (Second Cycle)',
  'Netaji Nagar Day College, Kolkata – 700092 (Second Cycle)',
  'Netaji Subhas Mahavidyalaya, Haldibari, Cooch Behar – 735122 (Second Cycle)',
  'New Alipore College, Kolkata – 700053 (Second Cycle)',
  'Nikhil Banga Sikshan Mahavidyalaya, Bankura – 722122 (First Cycle)',
  'Nistarini College, Purulia – 723101 (First Cycle)',
  'OmDayal Group of Institutions, Uluberia, Howrah – 711316 (First Cycle)',
  'P. N. Das College, North 24 Parganas, Palta – 743122 (First Cycle)',
  'Panchmura Mahavidyalaya, Bankura – 722156 (Second Cycle)',
  'Panskura Banamali College, Purba Medinipur – 721152 (Second Cycle)',
  'Parimal Mitra Smriti Mahavidyalaya, Jalpaiguri, Mal – 735221 (First Cycle)',
  'Polba Mahavidyalaya, Polba, Chinsura, Hooghly – 712148 (First Cycle)',
  'Prafulla Chandra College, Kolkata – 700029 (Second Cycle)',
  'Prasannadeb Women’s College, Jalpaiguri – 735101 (Second Cycle)',
  'Purash-Kanpur Haridas Nandi Mahavidyalaya, Kanpur, Howrah – 711410 (Second Cycle)',
  "Purnidevi Chowdhury Girls' College, Bolpur, Birbum – 731204 (First Cycle)",
  'Rabin Mukherjee College, Kolkata – 700060 (First Cycle)',
  'Rabindra Mahavidyalaya, Champadanga, Hugli-Chuchura, Hooghly – 712401 (Second Cycle)',
  'Raidighi College, Raidighi – 743383',
  'Raiganj Surendranath Mahavidyalaya, Sudarshanpur, Raiganj, Dinajpur – 733134 (First Cycle)',
  "Raja Narendralal Khan Women's College, Medinipur – 721102 (Third Cycle)",
  'Raja Rammohun Roy Mahavidyalaya, Hooghly – 712406 (Second Cycle)',
  'Rajendra Academy for Teachers’ Education, Gopalpur, Kanksa, Durgapur – 713212 (First Cycle)',
  'Ramakrishna Sarada Mission Vivekananda Vidyabhavan, Dum Dum, Kolkata – 700055 (Second Cycle)',
  'Ramananda Centenary College, Laulara, Purulia – 723151 (Second Cycle)',
  'Rammohan College, Kolkata – 700009 (Second Cycle)',
  'Rani Dhanya Kumari College, Jiaganj, Murshidabad – 742123 (Second Cycle)',
  'Raniganj Girls’ College, Searsole Rajbari, Raniganj – 713358 (First Cycle)',
  'Rishi Bankim Chandra College for Women, North 24 Parganas, Naihati – 743165 (Second Cycle)',
  'Rishi Bankim Chandra College, Naihati – 743165 (Second Cycle)',
  'Rishi Bankim Chandra Evening College, North 24 Parganas, Naihati – 743165 (Second Cycle)',
  'Saheed Anurup Chandra Mahavidyalaya, Kolkata – 743318 (Second Cycle)',
  'Saheed Kshudiram College, Kamakhyaguri, Alipurduar – 736202 (First Cycle)',
  'Sailajananda Falguni Smriti Mahavidyalaya, Birbhum – 731125 (First Cycle)',
  'Saldiha College, Bankura, Saldiha – 722173(Second Cycle)',
  'Sambhunath College, Birbhum – 731303 (Second Cycle)',
  'Sammilani Mahavidyalaya, Baghajatin, E.M. Bypass, Kolkata – 700094 (Second Cycle)',
  'Santal Bidroha Sardha Satabarshiki Mahavidyalaya, Goaltore, Paschim Medinipur, Medinipur – 721128 (First Cycle)',
  'Sarat Centenary College, Dhaniakhali, Hooghly, Hugli-Chuchura – 712302 (Second Cycle)',
  'Seth Soorajmull Jalan Girls’ College, Kolkata – 700073 (Second Cycle)',
  'Sewnarayan Rameswar Fatepuria College, Beldanga, Murshidabad – 742133 (First Cycle)',
  'Shree Agrasen Mahavidyalaya, Dalkhola – 733201 (First Cycle)',
  'Shri Shikshayatan College, Kolkata – 700071 (Third Cycle)',
  'Sir Gurudas Mahavidyalaya, Kolkata – 700067 (First Cycle)',
  'Sivanath Sastri College, Kolkata – 700029 (Second Cycle)',
  'Sonamukhi College, Bankura – 722207 (First Cycle)',
  'South Calcutta Girls’ College, Kolkata – 700025 (Second Cycle)',
  'Sovarani Memorial College, Jagatballavpur, Howrah – 711408 (Second Cycle)',
  'Sree Chaitanya College, Habra – 743268 (Second Cycle)',
  'Sree Chaitanya Mahavidyalaya, Habra – 743268 (Second Cycle)',
  'Sripat Singh College, Murshidabad – 742123 (Second Cycle)',
  'St. Xavier’s College (Autonomous), Mother Teresa Sarani (Park Street), Kolkata – 700016 (Third Cycle) 7 Years Validity',
  'Sundarban Hazi Desarat College, South 24 Parganas, Canning – 743611 (First Cycle)',
  'Surendranath College for Women, Kolkata – 700009 (Second Cycle)',
  'Surendranath College, Kolkata – 700009 (Second Cycle)',
  'Surendranath Evening College, Kolkata – 700009 (Second Cycle)',
  'Suri Vidyasagar College, Birbhum, Suri – 731101(Second Cycle)',
  "Swami Niswambalananda Girls' College, Hooghly – 712232 (Second Cycle)",
  'Syamsundar College, Bardhaman – 713424 (Second Cycle)',
  'Tamralipta Mahavidyalaya, Abasbari, Tamluk, Purba Medinipur – 721636 (Second Cycle)',
  'Tara Devi Harakh Chand Kankaria Jain College, Kolkata – 700002 (First Cycle)',
  'Trivenidevi Bhalotia College, Raniganj, Asansol, Burdwan – 713347 (First Cycle)',
  'Tufanganj Mahavidyalaya, Cooch Behar – 736160 (Second Cycle)',
  'Turku Hansda Lapsa Hemram Mahavidyalay, Madian, Mallarpur, Ganpur, Birbhum – 731216 (First Cycle)',
  'Udaynarayanpur Madhabilata Mahavidyalaya, Howrah – 711226 (First Cycle)',
  'Union Christian Training College, Berhampore – 742101 (Second Cycle)',
  'Victoria Institution (College), Kolkata – 700009 (Second Cycle)',
  'Vidyanagar College, South 24 Parganas, Kolkata – 743503 (Second Cycle)',
  'Vidyasagar College for Women, Kolkata – 700006 (Second Cycle)',
  'Vidyasagar College, Kolkata – 700006 (Second Cycle)',
  'Vidyasagar Evening College, Kolkata – 700006 (First Cycle)',
  'Vidyasagar Mahavidyalaya, Suchia, Hooghly, Hugli-Chuchura – 712701 (Second Cycle)',
  'Vijaygarh Jyotish Ray College, Bejoygarh, Jadavpur, Kolkata – 700032 (Second Cycle)',
  'Vivekananda College for Women, Kolkata – 700008 (Second Cycle)',
  'Vivekananda College, Madhyamgram, Kolkata – 700129 (First Cycle)',
  'Vivekananda College, Thakurpukur, Kolkata – 700063 (Second Cycle)',
  'Vivekananda Mahavidyalaya, Burdwan – 713103 (Second Cycle)',
  'Women’s College, Kshirode Vidyavinode Avenue, Kolkata – 700003 (Second Cycle)',
  'Yogoda Satsanga Palpara Mahavidyalaya, Purba Medinapur – 721458 (Second Cycle)',
  'Eastern Dooars B.Ed. Training College, Dakshinayan, Bhatibari, Alipurduar – 736121 (First Cycle)',
  'Samsi College, Kandaran (Samsi), Chanchal, Malda – 732139 (First Cycle)',
  'Shree Ramakrishna B. T. College, Darjeeling – 734101 (First Cycle)',
  'Sitananda College, Nandigram, Purba Medinipur – 721631 (First Cycle)',
  'Balurghat B.Ed. College, Mangalpur, Balurghat, Dakshin Dinajpur – 733101 (Second Cycle)',
  'Balurghat Mahila Mahavidyalaya, Daksin Dinajpur, Balurghat – 733101 (Second Cycle)',
  'Banipur Mahila Mahavidyalaya (First Cycle)',
  'Institute of Genetic Engineering (First Cycle)',
  'Krishna Chandra College (First Cycle)',
  'PRASANTA CHANDRA MAHALANOBIS MAHAVIDYALAYA,111/3, B.T. Road, Bon-Hooghly, KOLKATA , 700108 (Second Cycle)',
  'BANKURA CHRISTIAN COLLEGE,College Road, Bankura,Bankura , 722101 (Third Cycle)',
  'CALCUTTA INSTITUTE OF ENGINEERING AND MANAGEMENT,Prasanta Sur Campus Twenty Four by One-A Chandi Ghosh Road South Twenty Four Parganas,Kolkata , 700040 (First Cycle)',
  'ALIPURDUAR MAHILA MAHAVIDYALAYA,Newtown P.O. and Dist. Alipurduar,Alipurduar , 736121 (First Cycle)',
  'NETAJI SUBHASH ENGINEERING COLLEGE,Panchpota, Garia, Kolkata 700152,Kolkata 700152 (First Cycle)',
  'SWAMI VIVEKANANDA INSTITUTE OF SCIENCE AND TECHNOLOGY, Dakshin Gobindapur, P.S.- Sonarpur, Kolkata - 700145,Kolkata - 700145 (First Cycle)',
  'NSHM KNOWLEDGE CAMPUS, DURGAPUR - GROUP OF INSTITUTIONS,Arrah, Shibtala, Via Muchipara,Durgapur , 713212 (First Cycle)',
  'MUGBERIA GANGADHAR MAHAVIDYALAYA, Bhupatinar, Purba Medinipur-721425 West Bengal, India,Contai , 721425 (Third Cycle)',
  "WOMEN'S CHRISTIAN COLLEGE,6, Greek Church Row, Kolkata 700026. West Bengal.,Kolkata , 700026 (Third Cycle)",
  'DURGAPUR INSTITUTE OF ADVANCED TECHNOLOGY AND MANAGEMENT, G.T.Road, Rajbandh (near IOCL depot),Durgapur , 713212 (First Cycle)',
  'DREAM INSTITUTE OF TECHNOLOGY,Dream Institute of Technology Thakurpukur, B.H. Road, Kolkata-700104,KOLKATA,West Bengal,700104 (First Cycle)',
  'SURYA SEN MAHAVIDYALAYA,Surya Sen Colony, Block - B, P.O. Siliguri Town,SILIGURI,West Bengal,734004 (First Cycle)',
  'NETAJI SATABARSHIKI MAHAVIDYALAYA, Sahidbag P.O. Haripur, 24 Parganas(N),Ashoknagar,West Bengal,743223 (First Cycle)',
  "MAHISHADAL GIRLS' COLLEGE , VILL.-RANGIBASAN, P.O. MAHISHADAL, DIST. PURBA MEDINIPUR,HALDIA,West Bengal,721628 (Second Cycle)",
  'SANKRAIL ANIL BISWAS SMRITI MAHAVIDYALAYA , Vill- Kutikri, PO- Kultikri, PS- Sankrail,Jhargram,West Bengal,721135 (First Cycle)',
  'ABHEDANANDA MAHAVIDYALAYA,College Road , Sainthia, Birbhum,Sainthia,West Bengal,731234 (First Cycle)',
  'PANIHATI MAHAVIDYALAYA,Barasat Road, P.O. Sodepur,Kolkata,West Bengal,700110 (Second Cycle)',
  'BARRACKPORE RASTRAGURU SURENDRANATH COLLEGE,Eighty Five, Middle Road and Six, Riverside Road, Barrackpore, North Twenty Four Parganas, Kolkata, West Bengal,Barrackpore Kolkata,West Bengal,700120 (Fourth Cycle)',
  'CHAPRA BANGALJHI MAHAVIDYALAYA, P.O - Bangaljhi, P.S - Chapra District - Nadia, PIN - 741123 (First Cycle)',
  'BANWARILAL BHALOTIA COLLEGE,B.B.COLLEGE ROAD, USHAGRAM,,Asansol,West Bengal,713303 (Second Cycle)',
  "ST. PAUL'S CATHEDRAL MISSION COLLEGE, 33/1 Raja Rammohan Roy Sarani,Kolkata,West Bengal,700009 (Third Cycle)",
  'SRI RAMKRISHNA SARADA VIDYA MAHAPITHA,Vill.-Kamarpukur, P.O. Kamarpukur, Dist.-Hooghly,West Bengal,712612 (Second Cycle)',
  'BALARAMPUR COLLEGE,P.O.RANGADIH,P.S-BALARAMPUR,DIST-PURULIA,West Bengal,723143 (First Cycle)',
  'Basanti Devi College,147B, Rash Behari Avenue ,Kolkata - 700029 (Third Cycle)',
  'Darjeeling Government College,19, Lebong Cart Road,Darjeeling - 734101 (First Cycle)',
  'Regent Education and Research Foundation Group of Institutions,Bara Kanthalia, Sewli Telini Para, Titagarh, North 24 Parganas ,Barrackpore - 700121 (First Cycle)',
  'Taki Government College,Hasnabad, North 24 Parganas,Taki - 743429 (First Cycle)',
  'Narajole Raj College,Narajole, Daspur ,Paschim Medinipur - 721211 (First Cycle)',
  'Ranaghat College ,P.O. Ranaghat,Nadia - 741201 (Second Cycle)',
  "M.U.C.Women's College Burdwan,B. C. Road ,Burdwan - 713104 (Third Cycle)",
  'Indian Institute of Legal Studies,Dagapur, Salbari,Siliguri - 734002 (First Cycle)',
  'Kalyani Mahavidyalaya,City Centre Complex, Nadia ,Kalyani - 741235 (First Cycle)',
  'Khandra College,P.O.- Khandra, P.S. Andal, Dist. - Paschim Bardhaman,Durgapur - 713363 (Second Cycle)',
  'Katwa College,Dukbanglow Road, Purba Bardhaman,Katwa - 713130 (Second Cycle)',
  'NSHM Knowledge Campus, Kolkata - Group of Institutions,124 B L Saha Road ,Kolkata - 700053 (First Cycle)',
  'SAHEED NURUL ISLAM MAHAVIDYALAYA,GOKULPUR-HARISHPUR, PO- TENTULIA, PS- SWARUPNAGAR, DIST- NORTH 24 PARGANAS,SWARUPNAGAR , 743703 (First Cycle)',
  'SALESIAN COLLEGE,SONADA PO SONADA DARJEELING,SONADA SILIGURI , 734209',
  'Others',
].map((el) => {
  return {
    label: el,
    value: el,
  };
});
